/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://wx-static.keruyun.com/wx-ui/prod/static/dist-5da4c6ff22f4548b486e/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1825);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(138), __esModule: true };

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(6);
var normalizeHeaderName = __webpack_require__(185);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(103);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(103);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var settle = __webpack_require__(186);
var buildURL = __webpack_require__(100);
var buildFullPath = __webpack_require__(188);
var parseHeaders = __webpack_require__(191);
var isURLSameOrigin = __webpack_require__(192);
var createError = __webpack_require__(104);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(193);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(187);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(70);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(210)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(217);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = vendor;

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(240);


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(24);
var toObject = __webpack_require__(33);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.runInRootWhenMiniPrograme = runInRootWhenMiniPrograme;

var _commonHelper = __webpack_require__(3);

var _const = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wxminiProgramHelper = {
  _jssdkUrl: 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js',

  _init: function _init() {
    var _this = this;

    if (!this.isMiniProgramMode() || !this.isNewMiniprogram()) {
      return _promise2.default.reject(new Error('not in wxmini'));
    }

    if (this.inited) {
      return _promise2.default.resolve(window.wx);
    }

    return new _promise2.default(function (resolve, _reject) {
      var script = document.createElement('script');

      // other version js loaded;
      delete window.wx;
      delete window.jWeixin;

      script.onload = function () {
        _this.inited = true;
        resolve(window.wx);
      };

      script.src = _this._jssdkUrl;
      document.body.appendChild(script);
      script = null;
    });
  },
  isMiniProgramMode: function isMiniProgramMode() {
    return (0, _commonHelper.isWechatMiniProgramBrowser)();
  },
  isNewMiniprogram: function isNewMiniprogram() {
    return sessionStorage.getItem(_const.NEW_MINI_PROGRAM_NAME_KEY) === _const.NEW_MINI_PROGRAM_NAME_VALUE;
  },
  call: function call(method) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this._init().then(function (wx) {
      if (!wx || !wx.miniProgram) {
        throw new Error('wx jssdk unload');
      }

      var fn = wx.miniProgram[method];
      if (!fn) {
        throw new Error('miniProgram do not contains the method of ' + method);
      }

      return fn.apply(wx.miniProgram, args);
    }).catch(function (e) {
      console.warn(e.message);
    });
  },
  navigateTo: function navigateTo(url, params) {
    this.route('navigateTo', url, params);
  },
  redirectTo: function redirectTo(url, params) {
    this.route('redirectTo', url, params);
  },
  route: function route(method, url, params) {
    var nextUrl = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);

    this.call(method, { url: nextUrl });
  }
};

function saveMidToCookie() {
  var _getUrlParams = (0, _commonHelper.getUrlParams)(),
      mid = _getUrlParams.mid,
      brandId = _getUrlParams.brandId;

  if (brandId) {
    sessionStorage.setItem('currentBrandId', brandId);
  }

  if (!mid || !brandId) {
    return;
  }

  (0, _commonHelper.setCookie)('mid_' + brandId, mid);
}

function saveMiniProgramName() {
  var params = (0, _commonHelper.getUrlParams)();
  var miniProgramName = params[_const.NEW_MINI_PROGRAM_NAME_KEY];

  if (miniProgramName) {
    sessionStorage.setItem(_const.NEW_MINI_PROGRAM_NAME_KEY, miniProgramName);
  }
}

function saveAliUserId() {
  var _getUrlParams2 = (0, _commonHelper.getUrlParams)(),
      userid = _getUrlParams2.userid;

  if (userid) {
    localStorage.setItem('userid', userid);
  }
}

function runInRootWhenMiniPrograme() {
  if ((0, _commonHelper.isAlipayMiniProgramBrowser)()) {
    // 将支付宝 userid存入localStorage
    saveAliUserId();
    saveMidToCookie();
    return;
  }
  if (!wxminiProgramHelper.isMiniProgramMode()) {
    return;
  }

  saveMidToCookie();
  saveMiniProgramName();
}

exports.default = wxminiProgramHelper;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(98);

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(223);

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(229), __esModule: true };

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  weixinBrowserError: {
    id: 'errorMessages.weixinBrowserError',
    defaultMessage: '请在微信、微信小程序或者支付宝浏览器中打开'
  },
  noTableError: {
    id: 'errorMessages.noTableError',
    defaultMessage: '非常抱歉，店里当前爆满，无可用桌台'
  },
  noTableUseError: {
    id: 'errorMessages.noTableUseError',
    defaultMessage: '没有可用桌台'
  },
  cantScanPlaceOrderError: {
    id: 'errorMessages.cantScanPlaceOrderError',
    defaultMessage: '商户配置错误, 无法扫码下单'
  },
  identifyQRCodeError: {
    id: 'errorMessages.identifyQRCodeError',
    defaultMessage: '无法识别该二维码'
  },
  operateFailError: {
    id: 'errorMessages.operateFailError',
    defaultMessage: '操作失败'
  },
  alipayConfigFailError: {
    id: 'errorMessages.alipayConfigFailError',
    defaultMessage: '支付宝配置失败...'
  },
  getQRCodeFailError: {
    id: 'errorMessages.getQRCodeFailError',
    defaultMessage: '获取二维码失效'
  },
  scanResultEmptyError: {
    id: 'errorMessages.scanResultEmptyError',
    defaultMessage: '扫码结果为空'
  },
  choosePlaceOrderError: {
    id: 'errorMseeage.choosePlaceOrderError',
    defaultMessage: '请选择需要的下单操作...'
  },
  goingServiceCardError: {
    id: 'errorMessage.goingServiceCardError',
    defaultMessage: '正在跳转到服务卡界面...'
  },
  pleaseHaveDinnerError: {
    id: 'errorMessage.pleaseHaveDinnerError',
    defaultMessage: '请点餐'
  },
  netWorkError: {
    id: 'errorMessage.netWorkError',
    defaultMessage: '网络出问题了...'
  },
  intoTableError: {
    id: 'errorMessage.intoTableError',
    defaultMessage: '进入桌台...'
  },
  alreadyPlaceOrderError: {
    id: 'errorMessage.alreadyPlaceOrderError',
    defaultMessage: '{user}已经下单, 自动跳转中...'
  },
  socketLinkError: {
    id: 'errorMessage.socketLinkError',
    defaultMessage: '协同点餐异常，请刷新页面'
  },
  noConfigServiceBellError: {
    id: 'errorMessage.noConfigServiceBellError',
    defaultMessage: '还没有配置服务噢...'
  },
  noBindTableError: {
    id: 'errorMessage.noBindTableError',
    defaultMessage: '未绑定桌台哦，小二会迷路呢'
  },
  waiterIsComingError: {
    id: 'errorMessage.waiterIsComingError',
    defaultMessage: '小二正在火速赶来的路上...'
  },
  chooseServiceError: {
    id: 'errorMessage.chooseServiceError',
    defaultMessage: '请选择服务'
  },
  collCartError: {
    id: 'errorMessage.collCartError',
    defaultMessage: '协同购物车错误'
  },
  orderIsInvalided: {
    id: 'errorMessage.orderIsInvalided',
    defaultMessage: '订单已作废，请重新下单'
  },
  orderIsRefused: {
    id: 'errorMessage.orderIsRefused',
    defaultMessage: '订单已拒绝，请重新下单'
  },
  orderIsCanceled: {
    id: 'errorMessage.orderIsCanceled',
    defaultMessage: '订单已取消，请重新下单'
  },
  unopenedOnlinePayment: {
    id: 'errorMessage.unopenedOnlinePayment',
    defaultMessage: '未开通线上支付无法结账'
  },
  completeTheInvoice: {
    id: 'errorMessage.completeTheInvoice',
    defaultMessage: '请把发票填写完整'
  },
  youAreInvoicing: {
    id: 'errorMessage.youAreInvoicing',
    defaultMessage: '别着急,正在开票中'
  },
  tasteScore: {
    id: 'errorMessage.tasteScore',
    defaultMessage: '请评价口味！'
  },
  serviceScore: {
    id: 'errorMessage.serviceScore',
    defaultMessage: '请评价服务！'
  },
  environmentScore: {
    id: 'errorMessage.environmentScore',
    defaultMessage: '请评价环境！'
  },
  commentSuccess: {
    id: 'errorMessage.commentSuccess',
    defaultMessage: '订单评价成功'
  },
  commentSuccessButNoCoupon: {
    id: 'errorMessage.commentSuccessButNoCoupon',
    defaultMessage: '订单评价成功，优惠券已赠完'
  },
  commentSuccessAndGetCoupon: {
    id: 'errorMessage.commentSuccessAndGetCoupon',
    defaultMessage: '订单评价成功，恭喜获得{sendCoupInfo}'
  },
  orderIsCommented: {
    id: 'errorMessage.orderIsCommented',
    defaultMessage: '该订单已评价'
  },
  orderIsNotSupportCommented: {
    id: 'errorMessage.orderIsNotSupportCommented',
    defaultMessage: '当前订单不支持评价'
  },
  commentAgainForNetwork: {
    id: 'errorMessage.commentAgainForNetwork',
    defaultMessage: '网络原因评价失败，请重新评价'
  },
  notMobileStore: {
    id: 'errorMessage.notMobileStore',
    defaultMessage: '当前门店未开通移动门店，请联系商户'
  },
  connectingCollCart: {
    id: 'loading.connectingCollCart',
    defaultMessage: '正在连接协同购物车...'
  },
  connecting: {
    id: 'loading.connecting',
    defaultMessage: '正在连接...'
  },
  beingInTheVoucher: {
    id: 'loading.beingInTheVoucher',
    defaultMessage: '正在领券中...'
  },
  onlyStockLeft: {
    id: 'errorMessage.onlyStockLeft',
    defaultMessage: '抱歉，库存仅剩{numTotal}'
  },
  enteredUpTo5digits: {
    id: 'errorMessage.enteredUpTo5digits',
    defaultMessage: '最多可输入5位数'
  },
  notLowerThanDishIncreaseUnit: {
    id: 'errorMessage.notLowerThanDishIncreaseUnit',
    defaultMessage: '不能低于起卖份数{dishIncreaseUnit}份'
  },
  dishChangeRule: {
    id: 'errorMessage.dishChangeRule',
    defaultMessage: '该商品起卖份数为{dishIncreaseUnit},增量为{stepNum},故修改份数为{dishChange}'
  },
  successGetCoupon: {
    id: 'errorMessage.successGetCoupon',
    defaultMessage: '成功领取优惠券'
  },
  failedGetCoupon: {
    id: 'errorMessage.failedGetCoupon',
    defaultMessage: '领取失败请重试'
  },
  onlyForDigital: {
    id: 'errorMessage.onlyForDigital',
    defaultMessage: '只能输入数字'
  },
  maxSupportUserNum: {
    id: 'errorMessage.maxSupportUserNum',
    defaultMessage: '最多支持{maximum}人'
  },
  minInputUserNum: {
    id: 'errorMessage.minInputUserNum',
    defaultMessage: '至少输入{minimum}人'
  },
  unknown: {
    id: 'errorMessage.unknown',
    defaultMessage: '未知'
  },
  netError: {
    id: 'errorMessage.netError',
    defaultMessage: '网络出错'
  },
  waiterWillCome: {
    id: 'callMessage.waiterWillCome',
    defaultMessage: '客官稍等，服务员马上就来'
  },
  sendFail: {
    id: 'errorMessage.sendFail',
    defaultMessage: '非常抱歉，发送失败了'
  },
  requestAPIFail: {
    id: 'errorMessage.requestAPIFail',
    defaultMessage: '请求接口失败'
  },
  tryAgainForGet: {
    id: 'errorMessage.tryAgainForGet',
    defaultMessage: '非常抱歉，领取失败，请重试'
  },
  cantCallTableQRCode: {
    id: 'errorMessage.cantCallTableQRCode',
    defaultMessage: '不能调起桌台扫码'
  },
  clearedCart: {
    id: 'toast.clearedCart',
    defaultMessage: '已清空购物车'
  },
  submittedOrder: {
    id: 'toast.submittedOrder',
    defaultMessage: '已提交本桌订单'
  },
  entringOrderDetailPage: {
    id: 'toast.entringOrderDetailPage',
    defaultMessage: '正在进入订单详情页...'
  },
  modifyNumOnCartPage: {
    id: 'toast.modifyNumOnCartPage',
    defaultMessage: '{invalidDishList}的数量有误，请在购物车界面修改商品数量'
  },
  networkFailTryRefresh: {
    id: 'errorMessage.networkFailTryRefresh',
    defaultMessage: '当前网络环境差，请刷新后重试'
  },
  phoneValidateError: {
    id: 'errorMessage.phoneValidate',
    defaultMessage: '请输入正确的手机号'
  },
  disconnected: {
    id: 'errorMessage.disconnected',
    defaultMessage: '连接已断开'
  },
  errorAndReconnect: {
    id: 'errorMessage.errorAndReconnect',
    defaultMessage: '连接异常, 正在重新连接...'
  }
});

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(125);

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(276);

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { getOSVersionInfo } from '../../helper/common-helper.js';

function protocolIsHttps() {
  return location.protocol === 'https:';
}

function getImageHttpsProtocolUrl(src) {
  if (!src) {
    return src;
  }
  var prevOldCdn = 'http://kry-official.qiniudn.com'; // 最老的cdn
  var oldCdn = 'https://img.keruyun.net'; // 七牛cdn
  var newCdn = 'https://img-static.keruyun.com'; // 阿里cdn
  var url = src;

  if (/^http:\/\/img\.keruyun\.(net|com)/i.test(url)) {
    url = url.replace('http://', 'https://');
  }

  if (url.indexOf(prevOldCdn) === 0) {
    url = url.replace(prevOldCdn, newCdn);
  }

  if (url.indexOf(oldCdn) === 0) {
    url = url.replace(oldCdn, newCdn);
  }

  return url;
}

var HttpsProtocolImage = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(HttpsProtocolImage, _React$Component);
  (0, _createClass3.default)(HttpsProtocolImage, null, [{
    key: 'getFinalImageUrl',
    value: function getFinalImageUrl(url) {
      if (!protocolIsHttps()) {
        return url;
      }

      /*
      const osInfo = getOSVersionInfo();
      if (osInfo.os === 'iphone' && osInfo.version >= 10) {
        return getImageHttpsProtocolUrl(url);
      }
       return url;
      */
      return getImageHttpsProtocolUrl(url);
    }
  }]);

  function HttpsProtocolImage(props) {
    (0, _classCallCheck3.default)(this, HttpsProtocolImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HttpsProtocolImage.__proto__ || (0, _getPrototypeOf2.default)(HttpsProtocolImage)).call(this, props));

    Object.defineProperty(_this, 'handleImageLoadError', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var target = event.target;
        var loadErrorImageSrc = _this.props.loadErrorImageSrc;


        if (_this._loadedImages.indexOf(target.src) !== -1) {
          return;
        }

        _this._loadedImages.push(target.src);
        if (loadErrorImageSrc) {
          target.src = loadErrorImageSrc;
        }
      }
    });

    _this._loadedImages = [];
    return _this;
  }

  (0, _createClass3.default)(HttpsProtocolImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          alt = _props.alt,
          className = _props.className,
          style = _props.style,
          role = _props.role,
          bgImg = _props.bgImg;

      var finalUrl = HttpsProtocolImage.getFinalImageUrl(src);

      if (!finalUrl) {
        return _react2.default.createElement('span', { className: className, style: style });
      }

      if (bgImg) {
        return _react2.default.createElement('div', {
          className: className,
          alt: alt,
          onError: this.handleImageLoadError,
          role: role,
          style: (0, _assign2.default)(style, { backgroundImage: 'url(' + finalUrl + ')' })
        });
      }

      return _react2.default.createElement('img', {
        className: className,
        src: finalUrl,
        alt: alt,
        onError: this.handleImageLoadError,
        style: style,
        role: role
      });
    }
  }]);
  return HttpsProtocolImage;
}(_react2.default.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    src: _react2.default.PropTypes.string,
    alt: _react2.default.PropTypes.string,
    role: _react2.default.PropTypes.string,
    className: _react2.default.PropTypes.string,
    loadErrorImageSrc: _react2.default.PropTypes.string,
    style: _react2.default.PropTypes.object,
    bgImg: _react2.default.PropTypes.bool
  }
}), _temp);
exports.default = HttpsProtocolImage;

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(128);

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _commonHelper = __webpack_require__(3);

var _config = __webpack_require__(13);

var _wxMiniprogramHelper = __webpack_require__(113);

var _wxMiniprogramHelper2 = _interopRequireDefault(_wxMiniprogramHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var interceptor = {
  handlers: {},

  add: function add(url, handler) {
    var _this = this;

    var urls = [].concat(url);

    urls.forEach(function (item) {
      _this.handlers[item] = handler;
    });
  },
  exec: function exec(url, params) {
    var fixedUrl = url.replace(/^https?:\/\//, '').split('/').slice(1).join('/');

    var handler = this.handlers['/' + fixedUrl];
    if (!handler || !_wxMiniprogramHelper2.default.isMiniProgramMode() || !_wxMiniprogramHelper2.default.isNewMiniprogram()) {
      return false;
    }

    for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    handler.apply(undefined, [url, params].concat(rest));

    return true;
  }
};

// 支付页
interceptor.add('/shop/payDetail', function (url, params) {
  _wxMiniprogramHelper2.default.navigateTo('/pages/pay/checkout', params);
});

// 登录页
interceptor.add(['/user/notLogin', '/user-login.html'], function (url, params) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'navigateTo';

  _wxMiniprogramHelper2.default[method]('/pages/login/index', params);
});

var pageHelper = {
  navigateTo: function navigateTo(url, params) {
    // TODO: 暂时屏蔽掉拦截器。所有都还是走h5
    if (interceptor.exec(url, params) === true) {
      return;
    }
    console.log('--------navigateTo', url);
    location.href = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);
  },
  redirectWhenInit: function redirectWhenInit() {
    var params = (0, _commonHelper.getUrlParams)();

    return interceptor.exec(location.pathname, params, 'redirectTo');
  },
  navigateToLoginPage: function navigateToLoginPage(params) {
    try {
      // 此处接入支付宝小程序
      if ((0, _commonHelper.isAlipayMiniProgramBrowser)()) {
        __webpack_require__(126).aliPageHelper.navigateToLoginPage(params);
        return;
      }

      var tableId = sessionStorage.getItem('tableId');
      var tableQuery = '';
      if (tableId) {
        tableQuery = '&tableId=' + tableId;
      }

      var finalParams = (0, _extends3.default)({
        returnUrl: encodeURIComponent('' + location.href + tableQuery)
      }, params);

      this.navigateTo(_config.logAddressURL, finalParams);
    } catch (ex) {
      console.log('--------navigateToLoginPage ex', ex);
    }
  }
};

exports.default = pageHelper;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageTypeFromUrl = undefined;

var _regenerator = __webpack_require__(110);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _divolte = __webpack_require__(242);

var _divolte2 = _interopRequireDefault(_divolte);

var _divolteCommonInfo = __webpack_require__(247);

var _commonHelper = __webpack_require__(3);

var _globalBuryingPoint = __webpack_require__(248);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isGldOrTestOrDevEvn() {
  return (/^(ci)?test/i.test(location.hostname) || /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(location.hostname) || /^(dev|gld)/i.test(location.hostname)
  );
}
/*
  暂时只统计pageview事件, 屏蔽所有的点击事件统计
*/

var configs = [{ xpath: 'none' }];

var EXCLUDE_EVENT = ['error', 'click', 'performance-timing', 'resource-timing'];
var EVN_SCRIPT_MAP = {
  prod: {
    // url: 'https://divolte.keruyun.com/portal/divolte.js',
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    validator: function validator() {
      return (/^weixin/i.test(location.hostname)
      );
    }
  },
  test: {
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    // url: 'https://citestbigdata-kry-divolte-private.shishike.com/portal/divolte.js',
    validator: function validator() {
      return (/^(ci)?test/i.test(location.hostname) || /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(location.hostname)
      );
    }
  },
  dev: {
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    // url: 'https://citestbigdata-kry-divolte-private.shishike.com/portal/divolte.js',
    validator: function validator() {
      return (/^(dev|gld)/i.test(location.hostname)
      );
    }
  }
};
var DEV_MODE = "production" === 'development';

var LOAD_STATUS = {
  willLoad: 'willLoad',
  loaded: 'loaded',
  loadError: 'loadError'
};

var buryingPointConfig = { enableDebug: DEV_MODE, excludeEvent: EXCLUDE_EVENT };

/**
 * 埋点工具
 */

var BuryingPoint = function () {
  function BuryingPoint() {
    (0, _classCallCheck3.default)(this, BuryingPoint);

    this.isGldOrTestOrDevEvn = isGldOrTestOrDevEvn();
    this.dynamicDefaultParamFun = function () {};
    this.setDynamicDefaultParam(_divolteCommonInfo.getDynamicInfo);
    this.setFixedDefaultParam((0, _divolteCommonInfo.getFixedInfo)());
    this.defaultParam = {};
    this._init();
  }

  (0, _createClass3.default)(BuryingPoint, [{
    key: '_init',
    value: function _init() {
      var _this = this;

      this.loadStatus = LOAD_STATUS.willLoad;
      // 三个参数。
      // configs 配置信息。配置一些要监听的事件
      // defaultParam {
      //  enableDebug,是否开启调试模式
      //  excludeEvent,排除的监听的默认事件
      // }
      // scriptObj:根据环境加载divolte的script
      var info = this.getDefaultCommonInfo();
      var divoltePromise = (0, _divolte2.default)(configs, (0, _extends3.default)({}, info, buryingPointConfig), EVN_SCRIPT_MAP);
      if (!divoltePromise || !divoltePromise.then) {
        console.error('kry-divolte必须高于1.2.3');
        this.loadStatus = LOAD_STATUS.loadError;
        return null;
      }
      this.divoltePromise = divoltePromise.then(function (data) {
        _this.loadStatus = LOAD_STATUS.loaded;
      }).catch(function (ex) {
        _this.loadStatus = LOAD_STATUS.loadError;
        console.error(ex);
      });
    }
  }, {
    key: 'getToolObj',
    value: function getToolObj() {
      if (this.loadStatus === LOAD_STATUS.willLoad) {
        return this.divoltePromise;
      } else if (this.loadStatus === LOAD_STATUS.loaded) {
        return _promise2.default.resolve();
      }
      return _promise2.default.reject(new Error('无法加载divolte对象'));
    }
    /**
     * 获取默认信息
     * 1、界面固定的信息
     * 2、界面可能发生变化的信息
     * 3、界面路径带的参数（为了和kry-divolte保持一致）
     */

  }, {
    key: 'getDefaultCommonInfo',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var fixedInfo, dynamicInfo, urlParams;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fixedInfo = this.defaultFixedParam || {};

                if (!this.dynamicDefaultParamFun) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return this.dynamicDefaultParamFun();

              case 4:
                _context.t0 = _context.sent;
                _context.next = 8;
                break;

              case 7:
                _context.t0 = {};

              case 8:
                dynamicInfo = _context.t0;
                urlParams = (0, _commonHelper.getUrlParams)() || {};
                return _context.abrupt('return', (0, _extends3.default)({}, urlParams, fixedInfo, dynamicInfo));

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDefaultCommonInfo() {
        return _ref.apply(this, arguments);
      }

      return getDefaultCommonInfo;
    }()

    /**
     * 发送信息
     * @param {*} eventType
     * @param {*} param
     */

  }, {
    key: 'send',
    value: function send(eventType) {
      var _this2 = this;

      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.getToolObj().then(function (data) {
        return _this2.getDefaultCommonInfo();
      }).then(function (info) {
        var sendInfo = (0, _extends3.default)({}, info, param || {}, { eventType: eventType });
        if (_this2.isGldOrTestOrDevEvn) {
          console.group('触发埋点');
          console.log('事件', eventType);
          console.log('参数', sendInfo);
          console.groupEnd();
        }
        window.divolte.signal(eventType, sendInfo);
      }).catch(function (ex) {
        console.error(ex);
      });
    }
    /**
     * 设置默认传递的参数,固定（界面打开后不会再变化）
     * @param {*} info
     */

  }, {
    key: 'setFixedDefaultParam',
    value: function setFixedDefaultParam(info) {
      this.defaultFixedParam = info;
    }
  }, {
    key: 'setDynamicDefaultParam',
    value: function setDynamicDefaultParam(fun) {
      this.dynamicDefaultParamFun = fun;
    }
  }]);
  return BuryingPoint;
}();

var buryingPoint = new BuryingPoint();
(0, _globalBuryingPoint.allBuryingPoint)(buryingPoint);

exports.default = buryingPoint;
exports.getPageTypeFromUrl = _divolteCommonInfo.getPageTypeFromUrl;

/***/ }),

/***/ 125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aliPageHelper = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _commonHelper = __webpack_require__(3);

var _config = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var aliminiProgramHelper = {
  _jssdkUrl: 'https://appx/web-view.min.js',

  _init: function _init() {
    var _this = this;

    if (!this.isMiniProgramMode()) {
      return _promise2.default.reject(new Error('not in ali'));
    }

    if (this.inited) {
      return _promise2.default.resolve(window.my);
    }

    return new _promise2.default(function (resolve, _reject) {
      var script = document.createElement('script');

      // other version js loaded;
      delete window.my;

      script.onload = function () {
        _this.inited = true;
        resolve(window.my);
      };

      script.src = _this._jssdkUrl;
      document.body.appendChild(script);
      script = null;
    });
  },
  isMiniProgramMode: function isMiniProgramMode() {
    return (0, _commonHelper.isAlipayMiniProgramBrowser)();
  },
  call: function call(method) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this._init().then(function (my) {
      if (!my || !my[method]) {
        throw new Error('ali jssdk unload');
      }

      var fn = my[method];
      if (!fn) {
        throw new Error('miniProgram do not contains the method of ' + method);
      }
      return fn.apply(my, args);
    }).catch(function (e) {
      // alert(e.message);
      console.warn(e.message);
    });
  },
  navigateTo: function navigateTo(url, params) {
    this.route('navigateTo', url, params);
  },


  // redirectTo在小程序中不会保留页面栈 不能用my.navigateBack返回  但navigateTo可以
  redirectTo: function redirectTo(url, params) {
    this.route('redirectTo', url, params);
  },
  route: function route(method, url, params) {
    var nextUrl = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);

    this.call(method, { url: nextUrl });
  },
  postMessage: function postMessage() {
    this.call('postMessage');
  },
  onMessage: function onMessage(cb) {
    this._init().then(function (my) {
      my.onMessage = cb;
    });
  }
};

exports.default = aliminiProgramHelper;


var interceptor = {
  handlers: {},

  add: function add(url, handler) {
    var _this2 = this;

    var urls = [].concat(url);

    urls.forEach(function (item) {
      _this2.handlers[item] = handler;
    });
  },
  exec: function exec(url, params) {
    var fixedUrl = url.replace(/^https?:\/\//, '').split('/').slice(1).join('/');

    var handler = this.handlers['/' + fixedUrl];
    if (!handler || !aliminiProgramHelper.isMiniProgramMode()) {
      return false;
    }

    for (var _len2 = arguments.length, rest = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }

    handler.apply(undefined, [url, params].concat(rest));

    return true;
  }
};

// 支付页
// interceptor.add('/shop/payDetail', (url, params) => {
//   aliminiProgramHelper.navigateTo('/pages/pay/pay', params);
// });

// 登录页
interceptor.add(['/user/notLogin', '/user-login.html'], function (url, params) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'navigateTo';

  aliminiProgramHelper[method]('/pages/login/login', params);
});

var aliPageHelper = {
  navigateTo: function navigateTo(url, params) {
    // TODO: 暂时屏蔽掉拦截器。所有都还是走h5
    if (interceptor.exec(url, params) === true) {
      return;
    }
    console.log('--------navigateTo', url);
    location.href = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);
  },
  redirectWhenInit: function redirectWhenInit() {
    var params = (0, _commonHelper.getUrlParams)();

    return interceptor.exec(location.pathname, params, 'redirectTo');
  },
  navigateToLoginPage: function navigateToLoginPage(params) {
    try {
      var tableId = sessionStorage.getItem('tableId');
      var tableQuery = '';
      if (tableId) {
        tableQuery = '&tableId=' + tableId;
      }
      var finalParams = (0, _extends3.default)({
        returnUrl: encodeURIComponent('' + location.href + tableQuery)
      }, params);
      this.navigateTo(_config.logAddressURL, finalParams);
    } catch (ex) {
      console.log('--------navigateToLoginPage ex', ex);
    }
  }
};

exports.aliPageHelper = aliPageHelper;

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(35);

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var call = __webpack_require__(90);
var isArrayIter = __webpack_require__(91);
var anObject = __webpack_require__(12);
var toLength = __webpack_require__(53);
var getIterFn = __webpack_require__(64);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(53);
var toAbsoluteIndex = __webpack_require__(130);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiBase = void 0;
var apiFintech = void 0;
var requestOptions = void 0;
var syncOrderDinnerSocketUrl = void 0;
var sockJsUncheckUrl = void 0;
var apiAdsgroup = void 0;
var apiStatistics = void 0;
var loyaltyHost = void 0;
var adHost = void 0;
function getHostNameWithProtocol(hostname) {
  if ((typeof location === 'undefined' ? 'undefined' : (0, _typeof3.default)(location)) === 'object') {
    return location.protocol + '//' + hostname;
  }

  return 'http://' + hostname;
}

switch ("production") {
  case 'production':
    apiBase = getHostNameWithProtocol("weixin.keruyun.com");
    apiStatistics = getHostNameWithProtocol("pbc.keruyun.com");
    apiFintech = "fintech.keruyun.com/eip";
    syncOrderDinnerSocketUrl = "wxws.keruyun.com";
    sockJsUncheckUrl = "pws.keruyun.com";
    apiAdsgroup = "cdn-ad-static.keruyun.com";
    loyaltyHost = getHostNameWithProtocol("loyalty.keruyun.com");
    adHost = getHostNameWithProtocol("ad.keruyun.com/ad-srs");

    requestOptions = {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json'
      }
    };
    break;
  default:
    apiBase = getHostNameWithProtocol(Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).DEV_HOST) + ':3001'; // 本地环境
    apiStatistics = getHostNameWithProtocol(Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).DEV_HOST) + ':3001'; // 本地环境
    adHost = 'https://citestad.shishike.com/ad-srs';
    // 仅在本地前后端联调使用
    if (Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).API_HOST) {
      apiBase = Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).API_HOST;
    }

    apiFintech = 'https://test-fintech.shishike.com/eip/'; // 对接Fintech的环境
    syncOrderDinnerSocketUrl = 'testwxws.shishike.com';
    sockJsUncheckUrl = 'citestpws.shishike.com';
    apiAdsgroup = 'http://172.16.30.3:8087';
    loyaltyHost = 'loyalty.keruyun.com';

    requestOptions = {
      method: 'GET',
      mod: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json'
      }
    };
}

module.exports = {
  // API
  queryTaxRateByGoodsApi: apiBase + '/taxRate/queryTaxRateByGoods.json', // 通过菜品查询消费税税率
  getIndustryApi: apiBase + '/brand/industry.json', // 获取业态信息
  deliveryOrderAPI: apiBase + '/order/deliveryOrderList.json',
  takeawayDishListAPI: apiBase + '/takeaway/dishAll.json',
  getGoodsDetailAPI: apiBase + '/orderall/goodsDetail.json',
  takeawayShopInfoAPI: apiBase + '/takeaway/orderPageInfo.json',
  orderallDishListAPI: apiBase + '/orderall/dishAll.json',
  orderAllYDListAPI: apiBase + '/prepare/dishAll.json',
  orderallShopInfoAPI: apiBase + '/orderall/orderPageInfo.json',
  orderDineInAPi: apiBase + '/orderall/dishBox.json',
  orderDineInTableListAPI: apiBase + '/orderall/tableInfoList.json',
  orderTakeAwayAPi: apiBase + '/takeaway/dishBox.json',
  orderCouponsAPI: apiBase + '/coupon/getCanUseCoupons.json',
  orderNewCouponsAPI: apiBase + '/coupon/getNewCanUseCoupons.json',
  orderWeixinGiftCardsAPI: apiBase + '/coupon/getWeixinGiftCards.json',
  orderDiscountInfoAPI: apiBase + '/shop/discountInfo.json',
  orderDinnerStatementAPI: apiBase + '/orderall/settlement4Dinner.json',
  orderDinnerStatementZeroAPI: apiBase + '/pay/pay4Zero.json',
  submitTSOrderAPI: apiBase + '/orderall/subOrder.json',
  submitWMOrderAPI: apiBase + '/takeaway/subOrder.json',
  userAddressAPI: apiBase + '/user/addressList.json',
  submitDinnerOrderAPI: apiBase + '/orderall/tradeBilling.json',
  orderedDishBenefitAPI: apiBase + '/marketplan/dishPrivilegeList.json', // 单商品优惠
  multiDishBenefitAPI: apiBase + '/marketplan/multiDishPrivilegeInfo.json', // 多商品优惠
  orderAddOnAPI: apiBase + '/marketplan/addOnOderPlanInfo.json', // 凑单商品列表
  orderCouponsCountAPI: apiBase + '/coupon/getCanUseCouponCnt.json', // 个人中心优惠券总计数量
  orderPurchaseBenefitAPI: apiBase + '/marketplan/markUpPlanInfo.json', // 加价-满额换购接口
  discountCardListApi: apiBase + '/rightsCard/queryCanUseCardList.json', // 折扣卡列表
  getRightsCardsListApi: apiBase + '/rightsCard/getRightsCardsList.json', // 商城折扣卡列表
  getLimitedPrivilegeApi: apiBase + '/marketplan/limitedPrivilege.json', // 茶百道限免优惠
  getOrderMemo: apiBase + '/order/orderMemoConfig.json', // 订单备注列表
  orderAgain: apiBase + '/takeaway/orderagain.json', // 再来一单

  individualAPI: apiBase + '/user/individual.json', // 获取用户基本信息(我的页面)
  individualviewAPI: apiBase + '/user/individualView.json', // 获取用户基本信息(设置页面)
  freePaymentCodeAPI: apiBase + '/member/noPwdPayCode.json', // 免密支付二维码
  logoutAPI: apiBase + '/user/logout.json', // 注销用户页面
  individualupdateAPI: apiBase + '/user/individualUpdate.json', // 设置页面 更新信息
  getUserAddressListAPI: apiBase + '/user/getAddressList.json',
  getAllAddressListAPI: apiBase + '/user/addressList.json',
  customerAddressAPI: apiBase + '/user/address.json',
  saveAddressAPI: apiBase + '/user/saveAddress.json',
  deleteAddressAPI: apiBase + '/user/delAddress.json',
  getOrderAddressInfoAPI: apiBase + '/user/getAddressInfo.json',
  submitTSOrderCartAPI: apiBase + '/orderall/subOrderDinner.json',
  placeCheckOrderAPI: apiBase + '/place/placeCheckOrder.json',
  mustOrderDishListAPI: apiBase + '/orderall/queryMustDishList.json',
  getIParkSecretAPI: apiBase + '/orderall/thirdPlatform/getIParkSecret.json', // 获取美食岛秘钥

  userLoginAPI: apiBase + '/user/login.json',
  userLoginWXURL: apiBase + '/user/login4WX',
  userLoginAlipayURL: apiBase + '/user/login4Alipay',
  aliapiAuthURL: apiBase + '/aliapi/authByAlipay',
  getMerchantsBankInfoAPI: apiBase + '/blank/getInfo.json',
  getUserLoginSupportAPI: apiBase + '/user/supportTypes.json',
  getServiceStatusHaveTableAPI: apiBase + '/orderall/serviceStatusHaveTable.json', // 获取基本信息(带桌台)
  getServiceStatusNoTableAPI: apiBase + '/orderall/serviceStatusNoTable.json', // 获取基本信息(不带桌台)
  getIsShowButtonAPI: apiBase + '/orderall/isShowButton.json', // 按钮是否显示
  getTableInfoAPI: apiBase + '/orderall/tableInfo.json', // 获取tableInfo
  getOtherTableIdAPI: apiBase + '/orderall/getTableId.json', // 获取用户是否在其他桌台下单
  getOrderTableTypeAPI: apiBase + '/orderall/orderTableType.json', // 获取tableInfo
  callServiceAPI: apiBase + '/orderall/callService.json', // 获取tableId
  memberIndexAPI: apiBase + '/member/index.json', // 获取会员基本信息
  grownLevelxAPI: apiBase + '/member/customerLevel.json', // 会员页面
  getCouponListAPI: apiBase + '/coupon/getCouponList.json', // 优惠券列表
  getBrandCouponNum: apiBase + '/coupon/brandCouponNum.json', // 优惠券使用张数
  // 跳转URL
  dishMenu4DinnerURL: apiBase + '/orderall/selectDish', // 堂食点餐页，后端会进行重定向，决定正餐、快餐跳转
  dishMenu4takeoutURL: apiBase + '/takeaway/getWMPageTpl', // 外卖和零售点餐页中转页面
  dishMenu4RealtakeoutURL: apiBase + '/takeaway/selectDish', // 真实的外卖点餐页

  bookingURL: apiBase + '/booking/book', // YD
  queueInfoURL: apiBase + '/queue/info', // PD
  paySuccessURL: apiBase + '/shop/paySuccess', // 支付成功页面
  // 点金计划
  goldenPlan: apiBase + '/shop/goldenplan', // 点金计划页
  blankJump: apiBase + '/shop/blankjump', // 空白跳转页
  goldenplanhint: apiBase + '/shop/goldenplanhint', // 错误提示页
  // 门店列表页
  shopTSListURL: apiBase + '/shop/list',
  shopWMListURL: apiBase + '/shop/wmList',
  cooksListAPI: apiBase + '/cook/cookList.json',

  editUserAddressURL: apiBase + '/user/address',
  editBakeAddressURL: apiBase + '/retail/address-edit',

  // evaluationURL: 'https://gldpartner.keruyun.com/gateway-fronend/mobile.html#/commentH5', // 评价页面
  evaluationURL: 'https://partner.keruyun.com/gateway-fronend/mobile.html#/commentH5', // 评价页面

  brandIndexURL: apiBase + '/brand/index', // 品牌首页
  shopDetailURL: apiBase + '/shop/detail', // 门店首页
  bakeDishMenuURL: apiBase + '/retail/', // 烘焙点餐页
  mineIndexURL: apiBase + '/integration/personal-center', // 个人中心页面
  mineCardMallURL: apiBase + '/integration/card-mall', // 个人中心 - 折扣卡商城页面
  mineSettingURL: apiBase + '/user/individualView', // 设置页面
  bindMobileURL: apiBase + '/user/bindMobile', // 绑定手机页面
  bindWXURL: apiBase + '/user/bindOpenid', // 绑定微信页面
  bindAlipayURL: apiBase + '/user/bindAlipay', // 绑定支付宝页面
  registerMemberURL: apiBase + '/member/register', // 注册会员
  logAddressURL: apiBase + '/user/notLogin', // 登录页面
  integralURL: apiBase + '/member/integral', // 我的积分
  valueCardURL: apiBase + '/member/valueCard', // 我的余额
  memberIndexURL: apiBase + '/member/index', // 会员页面
  grownLevelxURL: apiBase + '/member/grownLevel', // 会员页面
  growthValueURL: apiBase + '/member/growthValue', // 成长明细页面
  rechargeURL: apiBase + '/shop/recharge', // 充值页面
  orderallListURL: apiBase + '/order/orderallList', // 订单列表
  getCouponListURL: apiBase + '/coupon/getCouponList', // 优惠券
  addressListURL: apiBase + '/user/addressList', // 地址管理
  modifyPwdURL: apiBase + '/member/modifyPwd', // 修改密码
  tradeDetailUncheckURL: apiBase + '/order/tradeDetailUncheck', // 堂食正餐订单详情页 结算前
  dishCart4DinnerURL: apiBase + '/orderall/dishCart4Dinner', // 购物车详情页
  dishCart4DinnerPayFirst: apiBase + '/orderall/dishCart4DinnerPayFirst', // 购物车详情页
  settlement4DinnerURL: apiBase + '/orderall/settlement4Dinner', // 正餐结算页面
  takeout4DinnerURL: apiBase + '/takeaway/dishBox', // 外卖结算页面
  orderall4DinnerURL: apiBase + '/orderall/dishBox', // 快餐结算页面
  takeOutDetailURL: apiBase + '/order/takeOutDetail', // 外卖订单详情页面
  orderallDetailURL: apiBase + '/order/orderallDetail', // 堂食订单详情页面
  takeOutRefundDetailURL: apiBase + '/order/takeOutRefundDetail', // 部分退详情页面
  dishMenu4DinnerChoosePeopleURL: apiBase + '/orderall/dishMenu4DinnerChoosePeople', // 堂食正餐点餐选择人数
  changeMobileSucURL: apiBase + '/user/changeMobileSuc', // 修改绑定手机成功页
  changeMobileURL: apiBase + '/user/changeMobileInfo', // 修改绑定手机页
  valueCardDetailURL: apiBase + '/member/valueCardDetail',
  cooksListURL: apiBase + '/cook/cookList',
  cookPersonalIndexURL: apiBase + '/cook/cookInfo',
  validBindMobileURL: apiBase + '/user/validBindMobile', // 绑定手机验证码校验：是否会员/是否和其他微信绑定
  bookingDetailURL: apiBase + '/booking/bookingDetail', // 预定详情
  bookCheckOrderURL: apiBase + '/prepare/dishBoxBooking', // 预定下单页面
  isQueueURL: apiBase + '/queue/queueCheck.json', // 是否已排队
  queueDetailURL: apiBase + '/queue/success', // 排队详情
  queueCheckOrderURL: apiBase + '/prepare/dishBoxQueue', // 排队下单页面
  goodsDetailURL: apiBase + '/orderall/goodsDetail', // 商品详情页面
  exceptionLinkURL: apiBase + '/orderall/tableError', // 异常页面(链接无效)
  commodityfeLinkURL: function commodityfeLinkURL(shopId) {
    return apiBase + '/commodityfe/?shopId=' + shopId + '&/#/';
  }, // 新零售页面
  payDetailURL: apiBase + '/shop/payDetail',
  takeoutTrackURL: apiBase + '/order/deliveryOrderList',
  prepaidCodeUrl: apiBase + '/integration/prepaid-code',

  addPrepaidCodesAPI: apiBase + '/prepay/addPrepayCodes.json',
  couponReceivedInfoAPI: apiBase + '/coupon/query/presentCouponNote.json',
  queryMarketShareStatusAPI: apiBase + '/coupon/queryMarketShareStatus.json',

  getQryCommercialConfig: apiBase + '/commodity/qryCommercialConfig', // 零售配置导航接口
  getQueuePredictWaitTimeAPI: apiBase + '/queue/predictWaitTime.json', // 排队等待时间
  getDefaultSendArea: apiBase + '/user/getDefaultSendArea.json',
  queryDeliveryTime: apiBase + '/takeaway/queryDeliveryTime.json', // 点单页显示配送时间
  getOrderInLineAPI: apiBase + '/queue/info.json',
  submitOrderInLineAPI: apiBase + '/queue/add.json',
  checkQueueAPI: apiBase + '/queue/queueCheck.json',
  placeOrderAPI: apiBase + '/booking/book.json',
  payPlaceOrderAPI: apiBase + '/booking/getBookingDeposit.json',
  getCheckTableAvaliable: apiBase + '/booking/getTableByAreaAndNum.json',
  getPlaceOrderTablesAPI: apiBase + '/booking/getTables.json',
  submitPlaceOrderAPI: apiBase + '/booking/addBooking.json',
  confirmBookingAPI: apiBase + '/booking/confirmBooking.json', // 确认预定
  cancelBookingAPI: apiBase + '/booking/cancelBooking.json', // 取消预定

  checkMobileBindedAPI: apiBase + '/user/checkMobileBinded.json', // 发送验证码之前 验证手机号是否已经绑定
  checkMobileOccupyAPI: apiBase + '/user/checkMobileOccupy.json', // 发送验证码之前 验证手机号是否已经绑定
  sendCodeAPI: apiBase + '/user/sendCode.json', // 发送验证码
  bindPhoneAPI: apiBase + '/user/bindMobile.json', // 绑定手机
  changeMobileAPI: apiBase + '/user/changeMobile.json', // 修改已经绑定的手机号
  wxOauthAPI: apiBase + '/openapi/weixinOauthUrl', // 获取微信 openid
  bindWXAPI: apiBase + '/user/bindOpenid.json', // 绑定微信
  bindAlipayAPI: apiBase + '/user/bindAlipay.json', // 绑定支付宝
  getWXInfoAPI: apiBase + '/user/weixinUserInfo.json', // 获取微信信息
  getAlipayInfoAPI: apiBase + '/user/alipayUserInfo.json', // 获取支付宝信息

  getCurrentCountryList: apiBase + '/brand/getCurrencyList.json',

  registerInfoAPI: apiBase + '/member/register.json', // 获取用户信息
  registerAPI: apiBase + '/member/addMember.json', // 申请会员
  checkCodeAvaliableAPI: apiBase + '/user/validMobile.json',
  tradeDetailUncheckAPI: apiBase + '/order/tradeDetailUncheck.json', // 订单详情（结算前）
  tradeDetailUncheckPayFirstAPI: apiBase + '/order/tradeDetailDinnerPayFirst.json', // 订单详情（结算前，正餐先付）
  getWXAuthInfoAPI: apiBase + '/openapi/jsApiTicket.json',
  getWXCardAPI: apiBase + '/weixinapi/wxCardTicket.json', // 领取微信卡券
  getTableIdFromQRCodeAPI: apiBase + '/orderall/tableExt.json',
  getMainOrderAPI: apiBase + '/orderall/getMainOrder.json',
  validBindMobileAPI: apiBase + '/user/validBindMobile.json', // 绑定手机验证码校验：是否会员/是否和其他微信绑定
  validBindMobileActiveAPI: apiBase + '/user/validBindMobileActive.json', // 绑定手机验证码校验(会员卡激活)：是否会员/是否和其他微信绑定
  verifyMemberCodeAPI: apiBase + '/member/verifyMemberCode.json', // 验证核销会员码
  validateMemberCodeAPI: apiBase + '/member/validateMemberCode.json', // 验证会员码
  aliPayEnvelopeAPI: apiBase + '/aliapi/alipayMarketing.json', // 手机领取支付宝红包
  getInvoiceStatus: apiBase + '/order/invoiceStatus.json', // 开票状态接口
  getInvoiceUrl: apiBase + '/order/invoiceUrl.json', // 发票路径

  getBalanceInfoAPI: apiBase + '/member/valueCard.json', // 会员卡余额信息
  getBalanceShopDetailListAPI: apiBase + '/member/valueCardList.json', // 会员卡余额信息详情
  getCommercialGroupAPI: apiBase + '/user/getCommercialGroup.json',
  getIntegralDetailAPI: apiBase + '/member/integralDetail.json', //
  getGrownDetailAPI: apiBase + '/member/grownDetail.json', //
  getRechargeInfoAPI: apiBase + '/shop/recharge.json', // 会员卡充值信息
  addRechargeAPI: apiBase + '/member/addRecharge.json', // 会员卡充值
  storePayAPI: apiBase + '/member/storePay.json', // 储值并支付
  rechargeShopListAPI: apiBase + '/shop/allShopList.json', // 储值选择门店
  indexAPI: apiBase + '/brand/index.json',
  brandShopList: apiBase + '/shop/brandShopList.json', // 品牌下的门店列表
  modifyPwd: apiBase + '/member/modifyPwd.json', // 修改密码
  resetPassword: apiBase + '/member/resetPassword.json', // 重置密码
  getResetPasswordUserInfoAPI: apiBase + '/member/resetPwd.json', // 取密码重置用户信息

  cancelQueueAPI: apiBase + '/queue/cancel.json', // 取消排队
  supportBusinessTypesAPI: apiBase + '/order/supportBusinessTypes.json', // 订单列表
  orderListAPI: apiBase + '/order/orderallList.json', // 订单列表
  orderListMoreAPI: apiBase + '/order/historyOrderallList.json', // 十五天前的订单列表
  takeOutListAPI: apiBase + '/order/takeOutList.json', // 外卖列表
  takeOutRefundDetailAPI: apiBase + '/order/takeOutRefundDetail.json', // 部分退详情
  takeOutListMoreAPI: apiBase + '/order/historyTakeOutList.json', // 十五天前的外卖列表
  bookListAPI: apiBase + '/order/bookingList.json', // 预订列表
  queueListAPI: apiBase + '/queue/queueList.json', // 排队列表
  bakeListAPI: apiBase + '/bakingOrder/bakingOrderAllList.json', // 烘焙订单列表
  getDinnerDetailAPI: apiBase + '/order/orderallDetail.json', // 堂食结算后订单详情
  getHistoryDinnerDetailAPI: apiBase + '/order/historyOrderallDetail.json', // 历史订单堂食结算后订单详情
  getDishMarketInfosAPI: apiBase + '/orderall/dishMarketInfos.json',
  saveMarkRecordAPI: apiBase + '/order/saveMarkRecord.json', // 评分
  getRemindOrderAPI: apiBase + '/takeaway/remindOrder.json', // 催单次数

  getBookDetailAPI: apiBase + '/booking/bookingDetail.json', // 预订详情
  getQueueDetailAPI: apiBase + '/queue/success.json', // 排队详情
  bookingMyPreOrderAPI: apiBase + '/prepare/bookingMyPreOrder.json', // 预定我的菜单
  queueMyPreOrderAPI: apiBase + '/prepare/myPreOrder.json', // 排队我的菜单
  bookingSubOrderAPI: apiBase + '/prepare/bookingSubOrder.json',
  queueSubOrderAPI: apiBase + '/prepare/subOrder.json',

  getOrderPotTime: apiBase + '/order/getOrderPotTime.json', // 外卖 - 预约收锅时间获取
  setOrderPotTime: apiBase + '/order/orderPot.json', // 外卖 - 预约收锅时间设置
  getPotTimeList: apiBase + '/takeaway/genePotTimeList.json',
  getTakeoutDetailAPI: apiBase + '/order/takeOutDetail.json', // 外卖结算后订单详情
  getHistoryTakeoutDetailAPI: apiBase + '/order/historyTakeOutDetail.json', // 历史订单结算后订单详情
  getCurrIntegralRuleAPI: apiBase + '/member/currIntegralRule.json', // 获取当前积分信息
  getCurrGrownRuleAPI: apiBase + '/member/currGrownRule.json', // 获取当前成长值信息

  getPosLoginInfoAPI: apiBase + '/user/loginPosScanCode.json', // pos扫码信息
  loginWxByPosAPI: apiBase + '/user/loginWxByPos.json', // pos扫码登录
  getPayDetailAPI: apiBase + '/shop/payDetail.json',
  getEbuAPI: apiBase + '/pay/elmPay.json', // ebu 支付
  baiduPayAPI: apiBase + '/pay/baiduPay.json',
  weixinPayAPI: apiBase + '/pay/weixinPay.json',
  ccbPayAPI: apiBase + '/pay/ccbPay.json',
  balancePayAPI: apiBase + '/pay/valueCardPay.json',
  balancePayOmitPasswordAPI: apiBase + '/pay/valueCardPayOmitPassword.json',
  balancePayBrandAPI: apiBase + '/pay/qrcodeValueCardPay.json',
  balancePayBrandOmitPasswordAPI: apiBase + '/pay/qrcodeValueCardOmitPasswordPay.json',
  wxPayAPI: apiBase + '/pay/wxPay.json',
  aliPayAPI: apiBase + '/pay/aliPay.json',
  alipayJsAPI: apiBase + '/pay/alipayJsapi.json',
  uePayApi: apiBase + '/pay/uePay.json',
  bocPayApi: apiBase + '/pay/bocPay.json',
  touchngoPayApi: apiBase + '/pay/touchngoPay.json',
  mPayApi: apiBase + '/pay/mPay.json',

  cancelOrderAPI: apiBase + '/order/tradeCancel.json', // 取消订单
  shopListTSAPI: apiBase + '/shop/list.json', // 堂食门店列表 全部门店
  shopListTSNearAPI: apiBase + '/shop/nearByShopList.json', // 堂食门店列表 附近门店
  nearShopListAPI: apiBase + '/shop/nearShopList.json',
  takeawayAllShopListAPI: apiBase + '/shop/takeawayAllShopList.json',
  takeawayInfoAPI: apiBase + '/shop/takeawayInfo.json', // 外卖信息
  fetchCouponAPI: apiBase + '/coupon/fetchCoupon.json', // 点餐页获取优惠券
  sendCouponsAPI: apiBase + '/coupon/sendCoupon.json', // 点餐页获取优惠券新接口
  thirdPlatformLogin: apiBase + '/user/thirdPlatformLogin.json', // 第三方登录（目前美食岛）
  getPaymentIdByTradeId: apiBase + '/pay/iParkPay.json', // 通过orderId获取paymentId

  fakeSocketDataAPI: apiBase + '/fakeSocketData.json',

  shareCouponPage: apiBase + '/coupon/queryMarketSharePage',
  getShareCouponPage: apiBase + '/coupon/getShareCouponPage',
  queryMarketShareAPI: apiBase + '/coupon/queryMarketShare.json',
  shareCouponEventAPI: apiBase + '/coupon/shareEvent.json',
  shareCreateCoupInstanceAPI: apiBase + '/coupon/shareCreateCoupInstance.json',
  dishMenu4DinnerChoosePeopleAPI: apiBase + '/orderall/dishMenu4DinnerChoosePeople.json', // 选择人数
  shareRandomPriviledgeAPI: apiBase + '/marketplan/shareRandomPriviledge.json',
  shareSuccessAPI: apiBase + '/orderall/shareSuccess.json',
  switchUrlBeforeGetServiceStatusAPI: apiBase + '/shop/getRealUrl.json',

  getAdGroupAdsJsUrl: apiAdsgroup + '/ad-js-static/adWebSdk.min.js',

  rewardIndexAPI: apiBase + '/reward/index.json',
  cookIndexAPI: apiBase + '/cook/cookInfo.json',
  tableWayAPI: apiBase + '/shop/tableWay.json',
  cityListAPI: apiBase + '/shop/cityList.json',
  orderFromCurTabeAPI: apiBase + '/order/orderFromCurTable.json',
  activeOrderAPI: apiBase + '/order/activeOrder.json',
  serviceCardAPI: apiBase + '/shop/serviceCard.json',
  brandInfoAPI: apiBase + '/brand/type.json',
  becomeNoPasswordAPI: apiBase + '/pay/becomeNoPassword.json',
  recommendDishAPI: apiBase + '/orderall/recommendDishList.json',
  getRetailAPI: apiBase + '/takeaway/getWMPageTpl.json',
  updateBookingLockAPI: apiBase + '/booking/updateBookingLock.json',

  getProfessionalCommercialAPI: apiBase + '/brand/professionalCommercial.json',
  getCommericalInfoAPI: apiBase + '/shop/getCommericalInfo.json',
  getShopMinConsumeConfAPI: apiBase + '/shop/getShopMinConsumeConf.json',
  requestOptions: requestOptions,
  syncOrderDinnerSocketUrl: syncOrderDinnerSocketUrl,
  sockJsUncheckUrl: sockJsUncheckUrl,

  apiBase: apiBase,
  apiFintech: apiFintech,
  apiAdsgroup: apiAdsgroup,
  env: "production",

  recommendDishStatisticsAPI: apiStatistics + '/behavior/recommendDishScanRecord', // 推荐菜品埋点统计
  getShopBaseConfAPI: apiBase + '/shop/getShopBaseConf.json',
  integralMallURL: loyaltyHost + '/loyalty-mobile/#/', // 积分商城界面
  integralExchangeDetailUrl: loyaltyHost + '/loyalty-mobile/#/', // 积分商城兑换详情页面
  discountCardPurchaseDetail: 'exchangeDetail', // 折扣卡购买成功后跳转页面

  dataRecoveryURL: apiBase + '/integration/data-recovery', // 茶百道数据修复
  loginInCCBAppAPI: apiBase + '/user/ccb/login.json', // 建行无感登录
  decodeCipherTextForCCB: apiBase + '/member/ccb/decrypt.json', // 建行解密

  getMobilesByEuid: apiBase + '/order/getMobilesByEuid.json', // 饿了么通过euid获取手机号
  elmLogin: apiBase + '/user/elmLogin.json', // 饿了么静默登录

  shopHealthCodeInfoAPI: apiBase + '/shop/getShopHealthCodeInfo.json',

  getPayForGiftCoupon: apiBase + '/coupon/listPayGiftCoupon.json', // 获取支付有礼数据
  getNowPayForGiftCoupon: apiBase + '/coupon/payGiftReceiveCoupon.json', // 领取支付有礼券接口

  // golden-plan
  getAdTypeAPI: adHost + '/adgold/plan/material', // 获取物料以及展示形势
  postAdInfo: adHost + '/adgold/plan/statistic', // 上报相关信息
  postAdError: adHost + '/adgold/plan/statistic/error',

  // 外卖点餐页
  takeawaySelectDish: apiBase + '/takeaway/selectDish',

  getOrderComment: apiBase + '/order/getOrderComment.json', // 查询订单是否已评价

  mergeSwitchAPI: apiBase + '/brand/invoice/merge/switch.json', // 获取是否是嘉旺品牌
  batchInvoiceOrderListAPI: apiBase + '/order/batchInvoiceOrderList.json', // 获取嘉旺品牌下订单列表
  batchInvoiceOrderListURL: apiBase + '/order/batchInvoiceOrderList',
  batchInvoiceShopListAPI: apiBase + '/brand/getShopList.json', // 获取嘉旺品牌下的门店
  invoiceBatchUrl: apiBase + '/order/invoiceBatchUrl.json' // 获取批量开发票跳转链接
};

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(54);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(23);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(45)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(24);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(31)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
module.exports = __webpack_require__(1).Object.keys;


/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(33);
var $keys = __webpack_require__(36);

__webpack_require__(81)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(256);

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139);
module.exports = __webpack_require__(1).Object.assign;


/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(140) });


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 会员优惠类型
var MemberPrivTypes = exports.MemberPrivTypes = {
  DISCOUNT: 1, // 折扣
  REDUCE: 2, // 立减
  UNIFIED_DISCOUNT: 3 // 统一折扣
};

// 但商品优惠类型
var SiglePrivTypes = exports.SiglePrivTypes = {
  REDUCE: 1, // 立减
  DISCOUNT: 2 // 折扣
};

// 优惠劵使用类型
var CouponUseTypes = exports.CouponUseTypes = {
  ALL: 1, // 全部
  PART: 2, // 部分可用
  EXCEPTION: 3 // 部分不可用
};

// 优惠劵优惠类型
var CouponPrivTypes = exports.CouponPrivTypes = {
  REDUCE: 1, // 立减,
  DISCOUNT: 2 // 折扣
};

// 进位规则
var CarryTypes = exports.CarryTypes = {
  ROUND: 1, // 四舍五入
  CEIL: 2, // 无条件进位
  FLOOR: 3, // 无条件舍去
  THREE_SEVEN: 4 // 37进位
};

// 堂食就餐类型
var DinnerForms = exports.DinnerForms = {
  DINNER: 0, // 正餐
  FAST: 1 // 快餐
};

// 订单详情开票功能
var Invoice = exports.Invoice = {
  OPEN: 1, // 开通
  CLOSE: 0 // 关闭
};

// 开票状态
var InvoiceStatus = exports.InvoiceStatus = {
  DOWNLOAD: 1, // 下载状态
  OPEN: 0, // 申请开票状态
  LOADING: 2 // 正在开票中状态
};

var CouponTypes = exports.CouponTypes = {
  OFFERVALUE: 1, // 减满券
  ZKVALUE: 2, // 折扣券
  GIFTVALUE: 3, // 礼品券
  FACEVALUE: 4 // 代金券
};

var DeliveryWay = exports.DeliveryWay = {
  ALL: 0, // 外卖+自提
  SEND: 1, // 外卖
  SELF: 2 // 自提
};

// 非定时送达
var OnlyPromptlyDelivery = exports.OnlyPromptlyDelivery = {
  OPEN: 1, // 开启
  CLOSE: 0 // 不开启
};

// U鼎品牌编号
var UdingBrandId = exports.UdingBrandId = '41173';

// 海底捞品牌编号
var HDLBrandId = exports.HDLBrandId = '32467';

// cookie 品牌编号名
var kryApiBrandId = exports.kryApiBrandId = 'kry-api-brand-id';

// 单商品优惠类型
var SinglePrivTypes = exports.SinglePrivTypes = {
  BENEFIT: 1,
  MEMBER: 3 // 会员
};

// 订单子来源
var OrderChildSource = exports.OrderChildSource = {
  WX: 32,
  ALIPAY: 34,
  KOUBEI: 36,
  OTHER: 43,
  HDL: 37,
  HDLHOT: 38,
  HDLWS: 39,
  HDLCOOPERATION: 900,
  HDLBACKUPONE: 901,
  HDLBACKUPTWO: 902,
  HDLBACKUPTHREE: 1135,
  HDLBACKUPFOUR: 1136,
  HDLBACKUPFIVE: 1137,
  CMB: 28,
  WX_MINI: 35,
  ALIPAY_MINI: 42,
  CCB_APP: 54, // TODO: 随便写的，估计后面订单组会指定一个值
  EBU: 162 // ebu 饿了么企餐
};

/**
 * 订单子来源参数
 */

var HDLPublicParm = exports.HDLPublicParm = {
  HDLHOT: 1,
  HDLWS: 2,
  HDLCOOPERATION: 3,
  HDLBACKUPONE: 4,
  HDLBACKUPTWO: 5,
  HDLBACKUPTHREE: 6,
  HDLBACKUPFOUR: 7,
  HDLBACKUPFIVE: 8
};

var DinnerType = exports.DinnerType = {
  TAKEOUT: 'WM',
  DINNERHALL: 'TS'
};

/**
 * 成长类型
 */
var StoreGrownTypes = exports.StoreGrownTypes = {
  STOREDVALUE: 1, // 储值消费获取成长值
  RECHARGE: 2, // 充值时获取成长值
  CONSUME: 3 // 普通消费获取成长值
};

/**
 * 折扣后的最小金额
 */
var MinDiscountedAmount = exports.MinDiscountedAmount = 0.01;

/**
 * 快餐选择人数开关类型
 */
var InputSnackTableCounts = exports.InputSnackTableCounts = {
  MUST: 2, // 必须选人数
  CANT: 0, // 不能选人数
  ABLE: 1 // 非强制选人数
};

/**
 * 人数限制范围
 */
var MaxCustomerCount = exports.MaxCustomerCount = 99;

/**
 * mine-coupon-list pageSize
 */
var MineCouponListPageSize = exports.MineCouponListPageSize = 10;

/**
 * 单菜品最大可点份数
 */
var MaxOrderedDishCount = exports.MaxOrderedDishCount = 99999;

/**
 * 折扣项 calcWay
 */
var CalcWay = exports.CalcWay = {
  DISCOUNT: 1,
  PEOPLE: 2,
  REGULAR: 3,
  STAGE: 7 // 阶梯计费
};

/**
 * 订单状态
 * tradeStatus: 2, // 1:待确认 2:挂单 3:已确认 4:已完成(全部支付) 5:已退货 6:已作废 7：已拒绝 8:取消
 * tradePayStatus: 2, // 1:未支付 2：支付中 3:已支付 4：退款中 5: 已退款 6：退款失败, 7: 已支付确认
 */
var TradeStatus = exports.TradeStatus = {
  AWAIT: 1,
  HANGUP: 2,
  ASSURE: 3,
  FINISH: 4,
  RETURNED: 5,
  INVALID: 6,
  REFUSED: 7,
  CANCEL: 8
};

var TradePayStatus = exports.TradePayStatus = {
  NOTPAY: 1,
  PAYING: 2,
  PAID: 3,
  REFUND: 4,
  REFUNDED: 5,
  REFUNDFAIL: 6,
  CONFIRMED: 7
};

var OrderStatusText = exports.OrderStatusText = {
  '0': '待收锅',
  '1': '收锅中',
  '2': '收锅完成'
};

/**
 * 优惠券保存类型
 */
var CouponSubmitDataTypes = exports.CouponSubmitDataTypes = {
  SYSTEM: 1, // 系统券
  WECHAT: 2 // 微信卡券
};

/**
 * BookOrderStatus
 * 订单状态(未封装), -1:用户未到店,1:用户到店,2:用户离店,9:已取消,-2:未处理,-3:已拒绝,-4:逾期未到店
 */
var BookOrderStatus = exports.BookOrderStatus = {
  USERNOTARRIVAL: -1, // 未到店
  USERARRIVAL: 1, // 用户到店
  USERLEAVESHOP: 2, // 用户离店
  CANCEL: 9, // 已取消
  NOTDEAL: -2, // 未处理
  REFUSE: -3, // 已拒绝
  TIMEOUT: -4, // 逾期未到店
  ASSURE: 3 // 已确认
};

/**
 * BookingStatus
 * 解析之后的book状态
 */
var BookingStatus = exports.BookingStatus = {
  BOOKNOTARRIVAL: 'book-not-arrival', // 未到店
  BOOKSUCCESS: 'book-success', // 预定成功
  BOOKFAIL: 'book-fail', // 预定失败
  BOOKUNPAID: 'book-unpaid', // 未支付
  BOOKCONFIRMING: 'book-confirming', // 确认中
  BOOKCANCEL: 'book-cancel', // 取消预订
  BOOKARRIVALED: 'book-arrived', // 已到店
  BOOKSURE: 'book-sure', // 已确认
  BOOKREFUSED: 'book-refused' // 已拒绝
};

/**
 * QueueOrderStatus
 * 排队状态 0:排队中;1:入场;-1作废;-2取消
 */
var QueueOrderStatus = exports.QueueOrderStatus = {
  QUEUING: 0, // 排队中
  ENTER: 1, // 入场
  DUMP: -1, // 作废
  CANCEL: -2 // 取消
};

/**
 * applyProductType 整单商品优惠
 * 1: '所有商品可用', 2: '部分商品可用', 3: '部分商品不可用',
 */
var ApplyProductType = exports.ApplyProductType = {
  ALLPRODUCT: 1, // 所有商品可用
  PARTPRODUCT: 2, // 部分商品可用
  NOTPARTPRODUCT: 3 // 部分商品不可用
};

/**
 * 换购活动类型，换购还是赠送
 * 1: '赠送', 2: '加价换购'
 */
var PurchasedType = exports.PurchasedType = {
  PRESENT: 1,
  PURCHASE: 2
};

/*
 * WmPageTpl 外卖业态
 */
var WmPageTpl = exports.WmPageTpl = {
  WM: 'wm',
  XLS: 'xls'
};

/*
 * 外卖门店取餐方式
 */
var TakeoutMethod = exports.TakeoutMethod = {
  OPEN: 1, // 开启
  CLOSE: 0 // 关闭
};

/**
 * effectType 是否加入订单 1 加入  2 不加入
 */
var EffectType = exports.EffectType = {
  ADD: 1,
  NOADD: 2
};

/**
 * EffectDiscountType 税率计算金额来源 1 实付金额 2 菜品总价 + 各种附加费
 */
var EffectDiscountType = exports.EffectDiscountType = {
  AFTER: 1,
  BEFORE: 2
};

/**
 * 支付方式
 */
var PayWay = exports.PayWay = {
  ONLINE: '2', // 在线支付
  OFFLINE: '1' // 线下支付
};

/*
 * 正餐制作状态
 */
var DishMakeStatus = exports.DishMakeStatus = {
  AWAIT: 0,
  CUT: 1,
  MAKE: 2,
  DONE: 3,
  OBSOLETE: 4
};

/**
 * 正餐状态
 */
var DishStatus = exports.DishStatus = {
  UNCHECK: 1,
  CHECKED: 2,
  REFUSED: 3
};

/*
 * 菜品子属性类别
 */
var DishPropertyTypes = exports.DishPropertyTypes = {
  PRACTICE: 1, // 做法
  CUSTOMLABEL: 2, // 自定义标签
  REMARK: 3, // 备注
  SPECIFICATION: 4 // 规格
};

/*
 * 支付方式排序
 */
var PaymentMethodsSort = exports.PaymentMethodsSort = {
  BALANCEPAY: 1,
  STOREANDPAY: 2,
  WEIXINPAY: 3,
  ALIPAY: 4,
  BAIDUPAY: 5,
  ANTCREDITPAY: 5, // 花呗
  UEPAY: 6,
  BOCPAY: 7, // bocPay
  TOUCHNGOPAY: 8, // touchngoPay
  MPAY: 9
};

/*
 * 后端返回已经支付的记录
 * https://conf.shishike.com/pages/viewpage.action?pageId=18908207
 */
var PaidRecordMethod = exports.PaidRecordMethod = {
  BALANCEPAY: -1,
  WEIXINPAY: -5,
  ALIPAY: -6,
  PREPAY: -42
};

/*
 * 服务卡状态
 */
var ShopCardOrderStatus = exports.ShopCardOrderStatus = {
  AWAITCOMMERCIALCONFIRM: 1, // 等待商户确认
  ORDERCONFIRMED: 3, // 订单已确认
  AWAITCOMMERCIALCONFIRMADDDISH: 300, // 等待商户确认加菜
  ORDERDONE: 4, // 订单已完成
  ORDEROBSOLETE: 6, // 订单被作废
  ORDERREFUSED: 7 // 订单被拒绝
};

/*
 * 储值方式 1 正常储值 2 小额储值
 */
var StoreType = exports.StoreType = {
  NORMALSTORE: 1,
  SMALLSTORE: 2
};

/*
 * 储值赠送方式 1 赠送固定金额 2 赠送百分比
 */
var SendStoreType = exports.SendStoreType = {
  SENDFIXVALUE: 1,
  SENDPERCENTVALUE: 2
};

/**
 * 微信分享来源 1 门店首页 2 商品详情页 3 会员注册页 4 品牌首页
 */
var WxSharEventEntry = exports.WxSharEventEntry = {
  SHOP: 1,
  DETAIL: 2,
  MEMBER: 3,
  BRAND: 4
};
/*
 * 优惠券入口 1 点餐页 2 订单详情页 3 自动发券页
 */
var CouponEntry = exports.CouponEntry = {
  DISH: 1,
  DISHDETAIL: 2,
  RECEIVED: 3
};

/**
 * 海外环境判定
 */
var isOversea = exports.isOversea = undefined === 'oversea';

/**
 * 点餐页模板
 */
var DishTheme = exports.DishTheme = {
  DEFAULT: 'default',
  // BIG: 'BIG',
  BIG: 'big',
  HUGE: 'huge',
  TEA: 'tea'
};

var INDUSTRY = exports.INDUSTRY = {
  NORMAL: 'normal',
  TEA: 'tea'
};

/**
 * 运行环境.
 * 告知后台查询门店列表用
 */
var runEnv = exports.runEnv = {
  GENERAL: 1, // 普通浏览器(除此之外的其他环境)
  WEIXIN: 2, // 微信
  WEIXINMINI: 3, // 微信小程序
  ALI: 4 // 支付宝
};

/**
 * 折扣卡类型
 * 1 可用，2 不可用
 */
var DISCOUNT_CARD_STATUS = exports.DISCOUNT_CARD_STATUS = {
  VALID: 1,
  INVALID: 2
};

// 几种促销的类型定义
var MULTI_PROMOTIONS = exports.MULTI_PROMOTIONS = 'multiPromotions'; // 多商品促销
var MEMBER_PRICE = exports.MEMBER_PRICE = 'memberPrice'; // 会员价
var SINGLE_PROMOTIONS = exports.SINGLE_PROMOTIONS = 'singlePromotions'; // 单商品促销
var FULL_PROMOTIONS = exports.FULL_PROMOTIONS = 'fullPromotions'; // 买赠促销
var FULL_COUNT_PROMOTIONS = exports.FULL_COUNT_PROMOTIONS = 'fullCountPromotions'; // 下一份折扣
var LIMIT_PROMOTIONS = exports.LIMIT_PROMOTIONS = 'limitPromotions'; // 限免优惠

// 订单详情页-核销码 1 待取餐 2 已取餐
var TAKE_MEAL_STATUS = exports.TAKE_MEAL_STATUS = {
  MEAL_TOKEN: 2,
  NO_MEAL: 1
};
var DISCOUNT_CARDS = exports.DISCOUNT_CARDS = 'discountCards';

// 消费税模式（1 附加模式，2 包含模式）
var TAX_MODE = exports.TAX_MODE = {
  ADDITIONAL: 1,
  INCLUDE: 2
};
// 排队类型
var LINE_STATUS = exports.LINE_STATUS = {
  TABLE: 1, // 显示排队桌数
  POS_ERR: 2, // pos err
  NET_ERR: 3 // net err
};

// 第三方登录 source 值
var thirdPlatformLoginSource = exports.thirdPlatformLoginSource = {
  I_PARK_LOGIN_SOURCE: 20
};

var ACCESS_FROM = exports.ACCESS_FROM = {
  CCB_APP: 'ccbApp', // 建设银行app
  EBU: 'ebu' // 饿了么
};

// 建行标识
var CCB_INFO = exports.CCB_INFO = {
  CCB_PARAM_SJ: 'CCB_PARAM_SJ', // 建行登录密文
  CCB_USER_INFO: 'CCB_USER_INFO', // localstorge中存入建行userid和mobile
  CCB_HEADER: 'CloudMercWebView-User-Agent', // 建行header标志
  CCB_HEADER_IOS: 'iphone',
  CCB_HEADER_ANDROID: 'android'
};
// 饿了么标识
var EBU_INFO = exports.EBU_INFO = {
  EBU_EUID: 'euid' // 饿了么euId
};
// 饿了么登录公钥
var PUBLIC_KEY = exports.PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+s6CloIRGm0kJwvkMbjj2+AL9VMn4YJo6b7H5WFeZA72oa0A7WI/DrBfLrTLx2BTo4iRshYTtETwyv52YcSQN617J9RY9zjZN7rKP8PQmCPgmQ/lobayfia3gPqUxRtaE//i9tDGgtyRraBfE0EhYgJoDyS091l0C4U2SC12h6wIDAQAB';

var NEW_MINI_PROGRAM_NAME_KEY = exports.NEW_MINI_PROGRAM_NAME_KEY = 'wxminiprogramname';
var NEW_MINI_PROGRAM_NAME_VALUE = exports.NEW_MINI_PROGRAM_NAME_VALUE = 'portal-wx-miniprogram';

var MAP_TYPE = exports.MAP_TYPE = {
  B_MAP: 1, // 百度
  A_MAP: 2, // 高德
  G_MAP: 3 // 谷歌
};

// 业态
var BUSINESS_TYPE = exports.BUSINESS_TYPE = {
  FAST: 1, // 快餐
  DINNER: 2, // 正餐
  TAKEOUT: 3, // 外卖
  STORE: 4, // 储值
  BAKE: 18, // 烘焙
  DISCOUNT_CARDS: 24, // 折扣卡
  INTEGRAL: 25 // 积分商城
};

// 开台必点策略
var STRATEGY_TYPE = exports.STRATEGY_TYPE = {
  TABLE: 1, // 按桌台带入
  PEOPLE: 2, // 按人数带入
  SELFCHOOSE: 3 // 开台自选
};

var SYNC_CART_UNAVAILABLE = exports.SYNC_CART_UNAVAILABLE = 'sync_cart_unavailable';
var RECONNECTION_ATTEMPTS = exports.RECONNECTION_ATTEMPTS = 3; // 协同购物车重连次数

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(15);
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(61);
var pIE = __webpack_require__(42);
var toObject = __webpack_require__(33);
var IObject = __webpack_require__(78);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(31)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var core = __webpack_require__(1);
var dP = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(15);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(37);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(97).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProtectPosition", function() { return ProtectPosition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/**
 * 服务端响应错误字典
 */
var serverErrorMap = new Map([[400, '请求错误(400)'], [401, '未授权(401)'], [403, '拒绝访问(403)'], [404, '地址不存在(404)'], [408, '请求超时(408)'], [500, '服务器错误(500)'], [501, '服务未实现(501)'], [502, '网络错误(502)'], [503, '服务不可用(503)'], [504, '网络超时(504)'], [505, 'HTTP版本不受支持(505)'], [999, '连接服务器失败'], [90001, '响应数据结构不合法']]);

/**
 * 服务端响应错误字典
 */
var serverErrorMap$1 = new Map([[400, '请求错误(400)'], [401, '未授权(401)'], [403, '拒绝访问(403)'], [404, '地址不存在(404)'], [408, '请求超时(408)'], [500, '服务器错误(500)'], [501, '服务未实现(501)'], [502, '网络错误(502)'], [503, '服务不可用(503)'], [504, '网络超时(504)'], [505, 'HTTP版本不受支持(505)'], [999, '连接服务器失败'], [90001, '响应数据结构不合法']]);

/*
 * @Author: snail
 * @Date: 2019-07-26 10:48:30
 * @Last Modified by: snail
 * @Last Modified time: 2020-01-13 16:28:09
 *
 * 请求错误类。
 * 1.提供错误码字典
 * 2.将axios错误对象处理为系统统一的ResponseError
 */

var defaultServerErrorPrefix = '连接出错';
var ERROR_DATA_STRUCT = 90001;
/**
 * 将axios的错误对象转换成ResponseError对象
 * @param err
 */

function axiosError2ResponseError(err) {
  var code = !!err && err.response ? err.response.status : 999;
  var msg = serverErrorMap$1.get(code) || "".concat(defaultServerErrorPrefix, "(").concat(code, ")");
  return {
    code: code,
    msg: msg
  };
}

var SUCCESS_CODE = '200';

var fetchResponseResolve = function fetchResponseResolve(res) {
  var _res$data = res.data,
      json = _res$data === void 0 ? {} : _res$data;
  var _json$code = json.code,
      code = _json$code === void 0 ? ERROR_DATA_STRUCT : _json$code,
      _json$msg = json.msg,
      msg = _json$msg === void 0 ? serverErrorMap.get(ERROR_DATA_STRUCT) : _json$msg,
      data = json.data;

  if (code === SUCCESS_CODE || code === Number(SUCCESS_CODE)) {
    return Promise.resolve(data);
  }

  var responseError = {
    code: code,
    msg: msg
  };
  return Promise.reject(responseError);
};

/**
 * Add integers, wrapping at 2^32.
 * This uses 16-bit operations internally to work around bugs in interpreters.
 *
 * @param {number} x First integer
 * @param {number} y Second integer
 * @returns {number} Sum
 */
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/**
 * Bitwise rotate a 32-bit number to the left.
 *
 * @param {number} num 32-bit number
 * @param {number} cnt Rotation count
 * @returns {number} Rotated number
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} q q
 * @param {number} a a
 * @param {number} b b
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
/**
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 *
 * @param {Array} x Array of little-endian words
 * @param {number} len Bit length
 * @returns {Array<number>} MD5 Array
 */


function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/**
 * Convert an array of little-endian words to a string
 *
 * @param {Array<number>} input MD5 Array
 * @returns {string} MD5 string
 */


function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;

  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
  }

  return output;
}
/**
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 *
 * @param {string} input Raw input string
 * @returns {Array<number>} Array of little-endian words
 */


function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;

  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }

  var length8 = input.length * 8;

  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
  }

  return output;
}
/**
 * Calculate the MD5 of a raw string
 *
 * @param {string} s Input string
 * @returns {string} Raw MD5 string
 */


function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}
/**
 * Calculates the HMAC-MD5 of a key and some data (raw strings)
 *
 * @param {string} key HMAC key
 * @param {string} data Raw input string
 * @returns {string} Raw MD5 string
 */


function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  ipad[15] = opad[15] = undefined;

  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }

  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }

  var hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}
/**
 * Convert a raw string to a hex string
 *
 * @param {string} input Raw input string
 * @returns {string} Hex encoded string
 */


function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;

  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
  }

  return output;
}
/**
 * Encode a string as UTF-8
 *
 * @param {string} input Input string
 * @returns {string} UTF8 string
 */


function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}
/**
 * Encodes input string as raw MD5 string
 *
 * @param {string} s Input string
 * @returns {string} Raw MD5 string
 */


function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
/**
 * Encodes input string as Hex encoded string
 *
 * @param {string} s Input string
 * @returns {string} Hex encoded string
 */


function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
/**
 * Calculates the raw HMAC-MD5 for the given key and data
 *
 * @param {string} k HMAC key
 * @param {string} d Input string
 * @returns {string} Raw MD5 string
 */


function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
/**
 * Calculates the Hex encoded HMAC-MD5 for the given key and data
 *
 * @param {string} k HMAC key
 * @param {string} d Input string
 * @returns {string} Raw MD5 string
 */


function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}
/**
 * Calculates MD5 value for a given string.
 * If a key is provided, calculates the HMAC-MD5 value.
 * Returns a Hex encoded string unless the raw argument is given.
 *
 * @param {string} string Input string
 * @param {string} [key] HMAC key
 * @param {boolean} [raw] Raw output switch
 * @returns {string} MD5 output
 */


function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }

    return rawMD5(string);
  }

  if (!raw) {
    return hexHMACMD5(key, string);
  }

  return rawHMACMD5(key, string);
} // if (typeof define === 'function' && define.amd) {
//   define(function () {
//     return md5
//   })
// } else if (typeof module === 'object' && module.exports) {
//   module.exports = md5
// } else {
//   $.md5 = md5
// }

/*
 * @Author: snail
 * @Date: 2020-04-28 16:08:54
 * @Last Modified by: snail
 * @Last Modified time: 2020-05-11 13:38:35
 * 生成相关参数信息，用于防篡改和防重放
 */

function randomString(len) {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/

  var maxPos = $chars.length;
  var pwd = '';

  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
}
/**
 * 获取保护API参数信息
 */


function getProtectInfo() {
  var kryTimestamp = new Date().getTime();
  var kryNoncestr = kryTimestamp + randomString(15);
  var krySignature = md5(kryTimestamp + kryNoncestr);
  return {
    kryTimestamp: kryTimestamp,
    kryNoncestr: kryNoncestr,
    krySignature: krySignature
  };
}

var methodMap = {
  get: 'enableProtectByGet',
  post: 'enableProtectByPost'
};

function isGetProtectParamInfo(method, instanceEnableProtect) {
  var enableProtect = this.enableProtect;
  var methodEnableProtect = this[methodMap[method]];
  if (instanceEnableProtect === null) return enableProtect && methodEnableProtect;
  return instanceEnableProtect;
}
/**
 * 获取API 保护参数
 */


function getProtectParamInfo(method, instanceEnableProtect) {
  if (isGetProtectParamInfo.bind(this, method, instanceEnableProtect)()) {
    return getProtectInfo();
  }

  return null;
}

var ProtectPosition;

(function (ProtectPosition) {
  ProtectPosition["HEAD"] = "head";
  ProtectPosition["PARAM"] = "param";
})(ProtectPosition || (ProtectPosition = {}));

var SerializeTypes;

(function (SerializeTypes) {
  SerializeTypes["ARRAY"] = "array";
  SerializeTypes["REPEAT"] = "repeat";
})(SerializeTypes || (SerializeTypes = {}));

var defaultInstanceConfig = {
  enableDefaultResponseResolve: true,
  enableDefaultResponseErrorResolve: true,
  enableProtect: null
};

function toQueryString(object, serializeType) {
  if (!object) return '';
  return Object.keys(object).reduce(function (ret, item) {
    var prefix = !ret ? '' : "".concat(ret, "&");
    var before = "".concat(prefix).concat(encodeURIComponent(item), "=");
    var curVal = object[item];

    if (!Array.isArray(curVal)) {
      return "".concat(before).concat(encodeURIComponent(curVal));
    } // from key:[1, 2] to key=1&key=2


    if (serializeType === SerializeTypes.ARRAY) {
      var params = curVal.reduce(function (r, d) {
        return "".concat(!r ? '' : "".concat(r, "&")).concat(encodeURIComponent(item), "=").concat(encodeURIComponent(d));
      }, '');
      return "".concat(prefix).concat(params);
    } // from key:[1, 2] to key=1,2


    return "".concat(before).concat(encodeURIComponent(curVal.map(function (d) {
      return JSON.stringify(d);
    }).join(',')));
  }, '');
}

function responseInterceptor(response) {
  return fetchResponseResolve(response);
}

function responseErrorInterceptor(error) {
  return Promise.reject(axiosError2ResponseError(error));
} // Global settings


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
var fetch = {
  protectPosition: ProtectPosition.HEAD,
  enableProtect: true,
  enableProtectByGet: true,
  enableProtectByPost: true,

  /**
   * 发起get请求
   * @param url
   * @param queries
   * @param config
   */
  get: function get(url, queries, config) {
    var finallyUrl = url;
    var headers = undefined;
    var newQueries = Object.assign({}, queries);

    var _Object$assign = Object.assign({}, defaultInstanceConfig, config),
        enableDefaultResponseResolve = _Object$assign.enableDefaultResponseResolve,
        enableDefaultResponseErrorResolve = _Object$assign.enableDefaultResponseErrorResolve,
        enableProtect = _Object$assign.enableProtect;

    var protectInfo = getProtectParamInfo.bind(this, 'get', enableProtect)();

    if (protectInfo) {
      if (this.protectPosition === ProtectPosition.PARAM) {
        Object.assign(newQueries, protectInfo);
      } else {
        var kryTimestamp = protectInfo.kryTimestamp,
            kryNoncestr = protectInfo.kryNoncestr,
            krySignature = protectInfo.krySignature;
        headers = {
          'kry-timestamp': kryTimestamp,
          'kry-noncestr': kryNoncestr,
          'kry-signature': krySignature
        };
      }
    }

    if (newQueries) {
      var queryString = toQueryString(newQueries, SerializeTypes.REPEAT);
      finallyUrl = (finallyUrl || '').indexOf('?') !== -1 ? "".concat(finallyUrl, "&").concat(queryString) : "".concat(finallyUrl, "?").concat(queryString);
    }

    var axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

    if (!enableDefaultResponseResolve || !enableDefaultResponseErrorResolve) {
      axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
      axiosObj.interceptors.response.use(!enableDefaultResponseResolve ? null : responseInterceptor, !enableDefaultResponseErrorResolve ? null : responseErrorInterceptor);
    }

    var requestConfig = {
      method: 'get',
      url: finallyUrl,
      headers: headers
    };
    return axiosObj(requestConfig).then(function (data) {
      return data;
    }); // return axiosObj.get(finallyUrl, config as object, header);
  },

  /**
   * 发起post请求
   * @param url
   * @param queries
   * @param config
   */
  post: function post(url, queries, config) {
    var newQueries = Object.assign({}, queries);
    var headers = undefined;

    var _Object$assign2 = Object.assign({}, defaultInstanceConfig, config),
        enableDefaultResponseResolve = _Object$assign2.enableDefaultResponseResolve,
        enableDefaultResponseErrorResolve = _Object$assign2.enableDefaultResponseErrorResolve,
        enableProtect = _Object$assign2.enableProtect;

    var protectInfo = getProtectParamInfo.bind(this, 'post', enableProtect)();

    if (this.protectPosition === ProtectPosition.PARAM) {
      Object.assign(newQueries, protectInfo);
    } else {
      var kryTimestamp = protectInfo.kryTimestamp,
          kryNoncestr = protectInfo.kryNoncestr,
          krySignature = protectInfo.krySignature;
      headers = {
        'kry-timestamp': kryTimestamp,
        'kry-noncestr': kryNoncestr,
        'kry-signature': krySignature
      };
    }

    var axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

    if (!enableDefaultResponseResolve || !enableDefaultResponseErrorResolve) {
      axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
      axiosObj.interceptors.response.use(!enableDefaultResponseResolve ? null : responseInterceptor, !enableDefaultResponseErrorResolve ? null : responseErrorInterceptor);
    } // return axiosObj.post(url, newQueries, config as object);


    var requestConfig = {
      method: 'post',
      url: url,
      headers: headers,
      data: newQueries
    };
    return axiosObj(requestConfig).then(function (data) {
      return data;
    });
  },

  /**
   * 设置默认请求参数
   * @param options
   */
  setDefaults: function setDefaults(options) {
    if (options) {
      var keys = Object.keys(options);
      keys.forEach(function (key) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults[key] = options[key];
      });
    }
  },

  /**
   * 设置请求拦截器
   * @param onFulfilled
   * @param onRejected
   */
  setRequestInterceptor: function setRequestInterceptor(onFulfilled, onRejected) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(onFulfilled, onRejected);
  },

  /**
   * 设置响应拦截器
   * @param onFulfilled
   * @param onRejected
   */
  setResponseInterceptor: function setResponseInterceptor(onFulfilled, onRejected) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(onFulfilled, onRejected);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (fetch);



/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function padStart(source, maxLength, fillString) {
  return source.padStart(maxLength, fillString);
}

module.exports = padStart;

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(332);

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(287);

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(149), __esModule: true };

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(40);
module.exports = __webpack_require__(155);


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(31)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(151);
var step = __webpack_require__(137);
var Iterators = __webpack_require__(34);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(85)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 151:
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(63);
var descriptor = __webpack_require__(39);
var setToStringTag = __webpack_require__(47);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(23)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(12);
var getKeys = __webpack_require__(36);

module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(54);
var defined = __webpack_require__(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(60);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(34);
module.exports = __webpack_require__(1).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(157), __esModule: true };

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(40);
module.exports = __webpack_require__(158);


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var get = __webpack_require__(64);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(7),
    IntlProvider = _require.IntlProvider;

var config = __webpack_require__(13);
var commonHelper = __webpack_require__(3);

// const Sentry = require('@sentry/browser');
var Cookies = __webpack_require__(79);

var intl = null;
exports.initSingletonIntl = function (_ref) {
  var locale = _ref.locale,
      _ref$messages = _ref.messages,
      messages = _ref$messages === undefined ? {} : _ref$messages;

  var intlProvider = new IntlProvider({ locale: locale, messages: messages });

  intl = intlProvider.getChildContext().intl;
  return intl;
};

exports.formatMessage = function () {
  if (!intl) {
    // throw new Error('intl instance must be initialized before using it');
    return 'Intl is not yet initialized.';
  }
  var text = '';

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  try {
    var _intl;

    text = (_intl = intl).formatMessage.apply(_intl, args);
  } catch (e) {
    text = args.backup || '';
    // Sentry.captureException(e);
  }

  return text;
};

exports.getIntl = function () {
  return intl;
};

function loadCurrencyCSS(currency) {
  var style = document.createElement('style');

  style.textContent = '\n    .price::before {\n      content: "' + currency + '";\n    }\n\n    .discount::before {\n      content: "-' + currency + '";\n    }\n  ';

  document.body.appendChild(style);
}

exports.getShopBaseConf = function (loadFunc, applicationName) {
  var shopId = commonHelper.getUrlParam('shopId');
  sessionStorage.setItem('currency', '');
  _fetchHelper2.default.get(config.getShopBaseConfAPI + '?shopId=' + shopId, null, { enableDefaultResponseResolve: false }).then(function () {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var res = response.data;
    var currency = '';
    var locale = 'zh_CN';
    // 读取本地用户设置
    var localLanguageSwitch = sessionStorage.getItem('language_switch');

    if (res && res.code === '200' && res.data) {
      console.log('res.data', res.data);
      var _res$data = res.data,
          _res$data$brandLangua = _res$data.brandLanguageDefault,
          brandLanguageDefault = _res$data$brandLangua === undefined ? locale : _res$data$brandLangua,
          _res$data$brandLangua2 = _res$data.brandLanguages,
          brandLanguages = _res$data$brandLangua2 === undefined ? [] : _res$data$brandLangua2,
          dateFormat = _res$data.dateFormat,
          dinningForm = _res$data.dinningForm,
          _res$data$languageSwi = _res$data.languageSwitch,
          languageSwitch = _res$data$languageSwi === undefined ? false : _res$data$languageSwi,
          currencySymbol = _res$data.currencySymbol,
          _res$data$showSaleNum = _res$data.showSaleNum,
          showSaleNum = _res$data$showSaleNum === undefined ? false : _res$data$showSaleNum,
          _res$data$brandId = _res$data.brandId,
          brandId = _res$data$brandId === undefined ? '' : _res$data$brandId,
          _res$data$commercialN = _res$data.commercialName,
          commercialName = _res$data$commercialN === undefined ? '' : _res$data$commercialN,
          _res$data$userProtoca = _res$data.userProtocal,
          userProtocal = _res$data$userProtoca === undefined ? '' : _res$data$userProtoca,
          _res$data$privacyProt = _res$data.privacyProtocal,
          privacyProtocal = _res$data$privacyProt === undefined ? '' : _res$data$privacyProt,
          _res$data$protocalSta = _res$data.protocalStatus,
          protocalStatus = _res$data$protocalSta === undefined ? 0 : _res$data$protocalSta;

      currency = currencySymbol;
      sessionStorage.setItem('currency', currency);
      sessionStorage.setItem('dateFormat', dateFormat);
      sessionStorage.setItem('diningForm', dinningForm); // 注意这里的 dinningForm，后端字段拼写错误多了一个n
      sessionStorage.setItem('showSaleNum', showSaleNum); // 是否开启了商品余量展示开关
      sessionStorage.setItem('brandId', brandId);
      sessionStorage.setItem('commercialName', commercialName);
      sessionStorage.setItem('userProtocal', userProtocal); // 后端返回的自定义用户协议
      sessionStorage.setItem('privacyProtocal', privacyProtocal); // 后端返回的自定义隐私协议
      sessionStorage.setItem('protocalStatus', protocalStatus);
      if (brandLanguages.length === 0) {
        brandLanguages.push(brandLanguageDefault); // 容错处理
      }
      // 将语言写入cookie
      var cookieLanguage = Cookies.get('language_switch_' + brandId);
      if (!cookieLanguage || cookieLanguage === 'undefined' || cookieLanguage === 'null' || !brandLanguages.includes(cookieLanguage) || !languageSwitch) {
        Cookies.set('language_switch_' + brandId, brandLanguageDefault, { expires: 90 }); // 90天有效期
      }
      var localBrandLanguages = sessionStorage.getItem('brandLanguages');
      locale = Cookies.get('language_switch_' + brandId) || brandLanguageDefault; // 如果重新写入了cookie或者用户修改过，需要重新读取
      // 如果语言开关开启
      if (languageSwitch.toString() !== localLanguageSwitch) {
        sessionStorage.setItem('language_switch', languageSwitch);
      }

      if (localBrandLanguages !== brandLanguages.join(',')) {
        sessionStorage.setItem('brandLanguages', brandLanguages.join(','));
      }
    }
    loadCurrencyCSS(currency);
    sessionStorage.setItem('locale', locale);
    loadFunc(locale);
  }).catch(function () {
    sessionStorage.setItem('currency', '');
  });
};

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86);
__webpack_require__(40);
__webpack_require__(46);
__webpack_require__(161);
__webpack_require__(165);
__webpack_require__(166);
module.exports = __webpack_require__(1).Promise;


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(38);
var global = __webpack_require__(4);
var ctx = __webpack_require__(32);
var classof = __webpack_require__(60);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(44);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(128);
var speciesConstructor = __webpack_require__(92);
var task = __webpack_require__(93).set;
var microtask = __webpack_require__(163)();
var newPromiseCapabilityModule = __webpack_require__(65);
var perform = __webpack_require__(94);
var userAgent = __webpack_require__(164);
var promiseResolve = __webpack_require__(95);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(132)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(47)($Promise, PROMISE);
__webpack_require__(141)(PROMISE);
Wrapper = __webpack_require__(1)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(96)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var macrotask = __webpack_require__(93).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(37)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(8);
var core = __webpack_require__(1);
var global = __webpack_require__(4);
var speciesConstructor = __webpack_require__(92);
var promiseResolve = __webpack_require__(95);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(65);
var perform = __webpack_require__(94);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(168), __esModule: true };

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40);
__webpack_require__(46);
module.exports = __webpack_require__(66).f('iterator');


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(170), __esModule: true };

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(82);
var toPrimitive = __webpack_require__(56);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
__webpack_require__(86);
__webpack_require__(173);
__webpack_require__(174);
module.exports = __webpack_require__(1).Symbol;


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(4);
var has = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(15);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(88);
var META = __webpack_require__(133).KEY;
var $fails = __webpack_require__(31);
var shared = __webpack_require__(58);
var setToStringTag = __webpack_require__(47);
var uid = __webpack_require__(45);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(66);
var wksDefine = __webpack_require__(67);
var enumKeys = __webpack_require__(172);
var isArray = __webpack_require__(142);
var anObject = __webpack_require__(12);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(33);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(56);
var createDesc = __webpack_require__(39);
var _create = __webpack_require__(63);
var gOPNExt = __webpack_require__(143);
var $GOPD = __webpack_require__(98);
var $GOPS = __webpack_require__(61);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(36);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(97).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(42).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(38)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(61);
var pIE = __webpack_require__(42);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('asyncIterator');


/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('observable');


/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(76);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40);
__webpack_require__(177);
module.exports = __webpack_require__(1).Array.from;


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(32);
var $export = __webpack_require__(8);
var toObject = __webpack_require__(33);
var call = __webpack_require__(90);
var isArrayIter = __webpack_require__(91);
var toLength = __webpack_require__(53);
var createProperty = __webpack_require__(178);
var getIterFn = __webpack_require__(64);

$export($export.S + $export.F * !__webpack_require__(96)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(39);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(180);

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = common;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var bind = __webpack_require__(99);
var Axios = __webpack_require__(181);
var mergeConfig = __webpack_require__(105);
var defaults = __webpack_require__(102);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(106);
axios.CancelToken = __webpack_require__(194);
axios.isCancel = __webpack_require__(101);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(195);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var buildURL = __webpack_require__(100);
var InterceptorManager = __webpack_require__(182);
var dispatchRequest = __webpack_require__(183);
var mergeConfig = __webpack_require__(105);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 1825:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1826);


/***/ }),

/***/ 1826:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1827);

var _index2 = _interopRequireDefault(_index);

var _application = __webpack_require__(1828);

var _application2 = _interopRequireDefault(_application);

var _rootApplication = __webpack_require__(250);

var _rootApplication2 = _interopRequireDefault(_rootApplication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _rootApplication2.default)(_react2.default.createElement(_application2.default, null), _index2.default);

/***/ }),

/***/ 1827:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Immutable = __webpack_require__(77);
module.exports = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.from({
    errorMessage: null,
    phoneNum: null,
    loadingInfo: {
      ing: false,
      text: ''
    },
    supportInfo: {
      mobile: true,
      isxeq: false,
      weixin: false,
      alipay: false
    },
    timestamp: null,
    loginInfo: {
      loginData: {},
      url: ''
    }
  });
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case 'SET_ERROR_MSG':
      return state.set('errorMessage', payload);
    case 'SET_LOADING_INFO':
      return state.set('loadingInfo', payload);
    case 'SET_SUPPORT_INFO':
      return state.set('supportInfo', payload);
    case 'SET_TIMESTAMP':
      return state.set('timestamp', payload);
    case 'SET_USER_PHONE':
      return state.set('phoneNum', payload);
    case 'SET_LOGIN_INFO':
      return state.set('loginInfo', payload);
    default:
  }
  return state;
};

/***/ }),

/***/ 1828:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _BDWX = __webpack_require__(1829);

var _BDWX2 = _interopRequireDefault(_BDWX);

var _iconAlipay = __webpack_require__(1830);

var _iconAlipay2 = _interopRequireDefault(_iconAlipay);

var _commonHelper = __webpack_require__(3);

var _toast = __webpack_require__(1831);

var _toast2 = _interopRequireDefault(_toast);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _pageHelper = __webpack_require__(123);

var _pageHelper2 = _interopRequireDefault(_pageHelper);

var _aliMiniprogramHelper = __webpack_require__(126);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _part = __webpack_require__(416);

var _part2 = _interopRequireDefault(_part);

var _part3 = __webpack_require__(496);

var _part4 = _interopRequireDefault(_part3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(125);
__webpack_require__(1832);

var React = __webpack_require__(2);
var connect = __webpack_require__(115).connect;
var actions = __webpack_require__(1833);
var InternationalPhoneVerificationCode = __webpack_require__(709);
var Toast = __webpack_require__(266);
var Loading = __webpack_require__(413);

var MessageDialog = __webpack_require__(479);
var KryProtocol = __webpack_require__(1834);


var fromAppBtn = (0, _commonHelper.getUrlParam)('fromApp');

var UserLoginApplication = React.createClass({
  displayName: 'UserLoginApplication',
  propTypes: {
    errorMessage: React.PropTypes.string,
    phoneNum: React.PropTypes.string,
    loadingInfo: React.PropTypes.object,
    supportInfo: React.PropTypes.object,
    setErrorMsg: React.PropTypes.func,
    fetchVerificationCode: React.PropTypes.func.isRequired,
    fetchLoginPhone: React.PropTypes.func.isRequired,
    fetchSupportInfo: React.PropTypes.func.isRequired,
    login: React.PropTypes.func,
    loginInfo: React.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      isDialogShow: false,
      logoUrl: '',
      isFromApp: false,
      showProtocolModal: false,
      checkbox: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.none = _pageHelper2.default.redirectWhenInit() || _aliMiniprogramHelper.aliPageHelper.redirectWhenInit();
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        fetchLoginPhone = _props.fetchLoginPhone,
        fetchSupportInfo = _props.fetchSupportInfo;

    fetchLoginPhone();
    fetchSupportInfo();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.supportInfo && this.props.supportInfo !== nextProps.supportInfo) {
      this.setState({ logoUrl: nextProps.supportInfo.brandIcon ? nextProps.supportInfo.brandIcon : _toast2.default });
    }
  },
  onGetVerificationCode: function onGetVerificationCode(phoneNum, nationTelCode) {
    this.props.fetchVerificationCode(phoneNum, nationTelCode);
  },
  onLogin: function onLogin() {
    console.log(this.state);
    if (!this.state.checkbox) {
      return;
    }
    var info = this.refs.verificationCode.refs.verificationCode.getInputInfo();
    var _props2 = this.props,
        setErrorMsg = _props2.setErrorMsg,
        login = _props2.login;


    if (!info.validation.valid) {
      setErrorMsg(info.validation.msg);
      return;
    }

    this.refs.verificationCode.refs.verificationCode.refs.phoneVerificationCode.blur();
    this.refs.verificationCode.refs.verificationCode.refs.phoneVerificationCode.blur();
    login(info.data, this.handleLoginSuccess);
  },
  createThirdPartyLoginButton: function createThirdPartyLoginButton(thirdPartyInfo, loginParam) {
    var _this = this;

    if (fromAppBtn) {
      return;
    }

    return React.createElement(
      'div',
      { className: 'oauth' },
      React.createElement(
        'h3',
        { className: 'o-text-divider oauth__title' },
        React.createElement(
          'span',
          { className: '' },
          React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationLoginWithThirdPart)
        )
      ),
      React.createElement(
        'button',
        {
          className: 'o-btn o-btn--block o-btn--oval o-btn--' + thirdPartyInfo.btnClassName + '-outline o-btn--h44 oauth__btn',
          onTouchTap: function onTouchTap() {
            return _this.loginWithThirdParty(loginParam);
          }
        },
        React.createElement(_httpsProtocolImage2.default, { role: 'presentation', src: thirdPartyInfo.icon, style: { width: 27, marginRight: 8 } }),
        React.createElement(
          'span',
          null,
          thirdPartyInfo.text,
          ' ',
          React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationLogin)
        )
      ),
      React.createElement(
        'p',
        { className: 'oauth__tips' },
        (0, _helper.formatMessage)(_part2.default.userLoginPNLoginPrompt, { text: thirdPartyInfo.text }),
        React.createElement('br', null),
        (0, _helper.formatMessage)(_part2.default.userLoginBindPNAfterLogin)
      )
    );
  },
  createWechatLoginButton: function createWechatLoginButton() {
    var wechatLoginInfo = {
      text: (0, _helper.formatMessage)(_part4.default.PayDetailApplicationWX),
      btnClassName: 'wechat',
      icon: _BDWX2.default
    };

    return this.createThirdPartyLoginButton(wechatLoginInfo, { isWeixin: true });
  },
  createAlipayLoginButton: function createAlipayLoginButton() {
    var alipayLoginInfo = {
      text: (0, _helper.formatMessage)(_part4.default.PayDetailApplicationAlipay),
      btnClassName: 'alipay',
      icon: _iconAlipay2.default
    };

    return this.createThirdPartyLoginButton(alipayLoginInfo, { isAlipay: true });
  },
  loginWithThirdParty: function loginWithThirdParty(loginParam) {
    this.props.login(loginParam);
  },
  clearErrorMessage: function clearErrorMessage() {
    this.props.setErrorMsg('');
  },
  handleLoginSuccess: function handleLoginSuccess(data) {
    var isDialogShow = this.state.isDialogShow;

    if (data && data.cleartextPassword && data.firstLoginFlag && !isDialogShow) {
      this.setState({ isDialogShow: true });
    } else {
      // location.href = decodeURIComponent(data.returnUrl);
      location.href = data.returnUrl;
    }
  },
  handleLoginConfirm: function handleLoginConfirm() {
    var loginInfo = this.props.loginInfo;

    location.href = decodeURIComponent(loginInfo.url);
  },
  showProtocolModal: function showProtocolModal(type) {
    var _this2 = this;

    this.setState({ showProtocolModal: type }, function () {
      _this2.preventScrollIntoScroll = (0, _commonHelper.preventScrollIntoScroll)('.login-protocal-modal', ['.login-protocal-modal-content']);
      _this2.preventScrollIntoScroll.addMethod();
    });
  },
  hideProtocolModal: function hideProtocolModal() {
    this.preventScrollIntoScroll.cancelMethod();
    this.setState({ showProtocolModal: false });
  },
  renderElement: function renderElement() {
    var _this3 = this;

    var _props3 = this.props,
        supportInfo = _props3.supportInfo,
        phoneNum = _props3.phoneNum;

    var weixinInfo = (0, _commonHelper.getWeixinVersionInfo)();
    var isAlipay = (0, _commonHelper.isAlipayBrowser)() && supportInfo.alipay;
    var isWechat = weixinInfo.weixin && supportInfo.weixin;
    var wechatBtn = this.createWechatLoginButton();
    var alipayBtn = this.createAlipayLoginButton();

    var checkboxChange = function checkboxChange(event) {
      _this3.setState({
        checkbox: event.target.checked
      });
    };
    return React.createElement(
      'div',
      null,
      React.createElement(InternationalPhoneVerificationCode, {
        className: 'phone-verification-code--login',
        hasForeignZone: supportInfo.xiangEQ,
        onGetVerificationCode: this.onGetVerificationCode,
        ref: 'verificationCode',
        phoneNum: phoneNum || ''
      }),
      React.createElement(
        'button',
        {
          disabled: !this.state.checkbox,
          className: 'o-btn o-btn--block o-btn--oval o-btn--h49 o-btn--linear p-login-btn',
          ref: 'loginBtn',
          onTouchTap: this.onLogin
        },
        fromAppBtn ? (0, _helper.formatMessage)(_part2.default.userLoginBindPNToOrder) : (0, _helper.formatMessage)(_part2.default.UserLoginApplicationLogin)
      ),
      isWechat && wechatBtn,
      isAlipay && alipayBtn,
      React.createElement(
        'p',
        { className: 'login-desc' },
        React.createElement('input', { id: 'input', className: 'checkbox', type: 'checkbox', checked: this.state.checkbox, onChange: checkboxChange }),
        React.createElement(
          'label',
          { id: 'label', htmlFor: 'input' },
          React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationView)
        ),
        React.createElement(
          'span',
          { className: 'protocol-name', onTouchTap: function onTouchTap() {
              return _this3.showProtocolModal('service');
            } },
          React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationServiceAgreement)
        ),
        React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationAnd),
        React.createElement(
          'span',
          { className: 'protocol-name', onTouchTap: function onTouchTap() {
              return _this3.showProtocolModal('privacy');
            } },
          React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationPrivacyPolicy)
        ),
        React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationAutoRegister)
      )
    );
  },
  render: function render() {
    if (this.none) {
      return null;
    }
    var _props4 = this.props,
        errorMessage = _props4.errorMessage,
        loadingInfo = _props4.loadingInfo,
        supportInfo = _props4.supportInfo,
        loginInfo = _props4.loginInfo;
    var _state = this.state,
        isDialogShow = _state.isDialogShow,
        logoUrl = _state.logoUrl,
        showProtocolModal = _state.showProtocolModal;

    var weixinInfo = (0, _commonHelper.getWeixinVersionInfo)();
    var isAlipay = (0, _commonHelper.isAlipayBrowser)() && supportInfo.alipay;
    var isWechat = weixinInfo.weixin && supportInfo.weixin;
    var loginHeaderImgStyle = {
      height: 100
    };

    if (_toast2.default !== logoUrl) {
      (0, _assign2.default)(loginHeaderImgStyle, { width: 100, borderRadius: '50%' });
    }

    return React.createElement(
      'div',
      { className: 'o-credit p-login-container o-bg-grey-linear', style: (isWechat || isAlipay) && !fromAppBtn ? { paddingTop: '7.5vh' } : {} },
      React.createElement(
        'header',
        { className: 'p-login-header' },
        React.createElement(_httpsProtocolImage2.default, { className: 'p-login-header__img', style: loginHeaderImgStyle, src: logoUrl, alt: '' }),
        React.createElement(
          'h1',
          { className: 'p-login-header__title' },
          React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationWelcome),
          supportInfo.brandName
        )
      ),
      this.renderElement(),
      errorMessage ? React.createElement(Toast, { errorMessage: errorMessage, clearErrorMsg: this.clearErrorMessage }) : false,
      loadingInfo.ing ? React.createElement(Loading, { word: loadingInfo.text }) : false,
      isDialogShow && React.createElement(
        MessageDialog,
        { onConfirm: this.handleLoginConfirm, btnText: (0, _helper.formatMessage)(_part2.default.UserLoginApplicationiKnown) },
        React.createElement(
          'div',
          { className: 'login-pwd-holder' },
          React.createElement(
            'p',
            { className: 'login-pwd-item', style: { fontSize: '20px', margin: '10px 0' } },
            React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationbecameVip)
          ),
          React.createElement(
            'p',
            { className: 'login-pwd-item' },
            (0, _helper.formatMessage)(_part2.default.userLoginDefaultPW)
          ),
          React.createElement(
            'p',
            { className: 'login-pwd-item' },
            (0, _helper.formatMessage)(_part2.default.userLoginSixDigRePN)
          )
        )
      ),
      showProtocolModal && React.createElement(
        'div',
        { className: 'login-protocal-modal' },
        React.createElement(
          'div',
          { className: 'login-protocal-modal-content' },
          showProtocolModal && React.createElement(KryProtocol, { type: showProtocolModal })
        ),
        React.createElement('div', { className: 'protocol-gradient' }),
        React.createElement(
          'div',
          { className: 'protocol-button' },
          React.createElement(
            'button',
            { className: 'o-btn o-btn--block o-btn--oval o-btn--h44 o-btn--primary', onTouchTap: this.hideProtocolModal },
            React.createElement(
              'span',
              null,
              React.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationiKnown)
            )
          )
        )
      )
    );
  }
});
module.exports = connect(function (state) {
  return state;
}, actions)(UserLoginApplication);

/***/ }),

/***/ 1829:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/BDWX.svg";

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var transformData = __webpack_require__(184);
var isCancel = __webpack_require__(101);
var defaults = __webpack_require__(102);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 1830:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/icon-alipay.svg";

/***/ }),

/***/ 1831:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/toast.svg";

/***/ }),

/***/ 1832:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _helper = __webpack_require__(16);

var _part = __webpack_require__(468);

var _part2 = _interopRequireDefault(_part);

var _part3 = __webpack_require__(412);

var _part4 = _interopRequireDefault(_part3);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__(13);
var createAction = __webpack_require__(265).createAction;
__webpack_require__(72);
__webpack_require__(71);

var getUrlParam = __webpack_require__(43).getUrlParam;
var getSendCodeParamStr = __webpack_require__(424).getSendCodeParamStr;
var shopId = getUrlParam('shopId');

var setErrorMsg = exports.setErrorMsg = createAction('SET_ERROR_MSG', function (error) {
  return error;
});
var setLoadingInfo = exports.setLoadingInfo = createAction('SET_LOADING_INFO', function (info) {
  return info;
});
var setSupportInfo = createAction('SET_SUPPORT_INFO', function (info) {
  return info;
});
var setTimeStamp = createAction('SET_TIMESTAMP', function (timestamp) {
  return timestamp;
});
var setUserPhone = createAction('SET_USER_PHONE', function (phone) {
  return phone;
});
var setLoginInfo = createAction('SET_LOGIN_INFO', function (loginInfo) {
  return loginInfo;
});
var condition = ['fromShopHome', 'fromBrand=false', 'queryMarketSharePage'];

var isInclude = function isInclude(returnUrlDecode) {
  return condition.find(function (item) {
    return returnUrlDecode.indexOf(item) > -1;
  });
};

exports.fetchLoginPhone = function () {
  return function (dispatch, getState) {
    var loginPhone = localStorage.getItem('loginPhone');
    dispatch(setUserPhone(loginPhone));
  };
};

exports.login = function (info, successCallback) {
  return function (dispatch, getState) {
    var fromBrand = 1;
    if (!shopId) {
      dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actionshopIdCannotBeNull)));
      return false;
    }

    var originReturnUrl = getUrlParam('returnUrl') || encodeURIComponent('/brand/index' + location.search);
    var returnUrlDecode = decodeURIComponent(originReturnUrl);
    var returnUrl = encodeURIComponent(returnUrlDecode);
    var returnUrlPath = returnUrlDecode.substring(0, returnUrlDecode.indexOf('?'));
    var contain = isInclude(returnUrlDecode);

    // 如果是从门店相关的页面跳转过来的
    // 那么，fromBrand 设置为 0
    var isFromShopPages = /dishBox|Dinner|queue|prepare/.test(returnUrlPath);

    // fromShopHome 表示从门店首页跳转过来
    // 需要将 fromBrand 设置为 0
    // 如果 url 中的 fromBrand 为 false，那么 fromBrand 为 0
    // 如果 url 中存在 queryMarketSharePage, 那么 fromBrand 为 0
    if (isFromShopPages || contain) {
      fromBrand = 0;
    }

    if (info.isWeixin) {
      location.href = config.userLoginWXURL + '?shopId=' + shopId + '&returnUrl=' + returnUrl + '&fromBrand=' + fromBrand;
      return false;
    }

    if (info.isAlipay) {
      location.href = config.userLoginAlipayURL + '?shopId=' + shopId + '&returnUrl=' + returnUrl + '&fromBrand=' + fromBrand;
      return false;
    }

    dispatch(setLoadingInfo({ ing: true, text: (0, _helper.formatMessage)(_part2.default.actionsysInProcessing) }));
    var timestamp = getState().timestamp || new Date().getTime();
    var nationTelCode = sessionStorage.getItem('nationTelCode');
    var url = config.userLoginAPI + '?shopId=' + shopId + '&nationTelCode=' + nationTelCode + '&mobile=' + info.phoneNum + '&code=' + info.code + '&timeStamp=' + timestamp + '&fromBrand=' + fromBrand + '&returnUrl=' + returnUrl;
    return _fetchHelper2.default.get(url).then(function () {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setLoadingInfo({ ing: false }));
      // 大数据埋点将获取customerId，为了防止未登录从而导致高频调用后端APi。再登录成功后，即删除这个缓存。
      sessionStorage.removeItem('alreadyInvokeCustomerIdAndError');
      // dispatch(setLoginInfo({ loginData: result.data, url: returnUrl }));
      dispatch(setLoginInfo({ loginData: result, url: result.returnUrl }));
      successCallback(result || {});
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg(err.msg || (0, _helper.formatMessage)(_part2.default.actionloginFailed)));
      dispatch(setLoadingInfo({ ing: false }));
      throw new Error(err);
    });
  };
};

exports.fetchVerificationCode = function (phoneNum, nationTelCode) {
  return function (dispatch, getState) {
    var obj = (0, _assign2.default)({}, { shopId: shopId, mobile: phoneNum, nationTelCode: nationTelCode, timestamp: new Date().getTime() });
    var paramStr = getSendCodeParamStr(obj);
    var url = config.sendCodeAPI + '?' + paramStr;
    dispatch(setLoadingInfo({ ing: true, text: (0, _helper.formatMessage)(_part2.default.actionSending) }));
    return _fetchHelper2.default.get(url, null, { enableDefaultResponseResolve: false }).then(function (response) {
      var result = response.data || {};
      dispatch(setLoadingInfo({ ing: false }));
      if (result.code === '200') {
        dispatch(setTimeStamp(result.data.timeStamp));
        localStorage.removeItem('loginPhone');
      } else {
        dispatch(setErrorMsg(result.msg));
        if (result.code === '10100') {
          localStorage.setItem('loginPhone', phoneNum);
          setTimeout(function () {
            location.reload(true);
          }, 1500);
        }
      }
    }).catch(function (err) {
      throw new Error(err);
    });
  };
};

exports.fetchSupportInfo = function () {
  return function (dispatch, getState) {
    var url = config.getUserLoginSupportAPI + '?shopId=' + shopId;
    dispatch(setLoadingInfo({ ing: true, text: (0, _helper.formatMessage)(_part4.default.actionLoading) }));
    return _fetchHelper2.default.get(url).then(function (result) {
      dispatch(setLoadingInfo({ ing: false }));
      dispatch(setSupportInfo(result));
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setLoadingInfo({ ing: false }));
      dispatch(setErrorMsg(err.msg));
      throw new Error(err);
    });
  };
};

/***/ }),

/***/ 1834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);

__webpack_require__(1835);

var serviceProtocalUrl = 'https://s.keruyun.com/protocols/userService';
var privacyProtocalUrl = 'https://s.keruyun.com/protocols/privacy_p';

var KryProtocol = React.createClass({
  displayName: 'KryProtocol',
  propTypes: {
    type: React.PropTypes.string
  },

  render: function render() {
    var type = this.props.type;

    var userProtocal = sessionStorage.getItem('userProtocal');
    var privacyProtocal = sessionStorage.getItem('privacyProtocal');

    var url = type === 'service' ? userProtocal || serviceProtocalUrl : privacyProtocal || privacyProtocalUrl;
    var overflowStyle = navigator.userAgent.match(/android/i) ? 'hidden' : 'auto';

    return React.createElement(
      'div',
      { className: 'protocol', style: { 'overflow': overflowStyle } },
      React.createElement('iframe', { scrolling: 'auto', src: url + '?lang=' + sessionStorage.getItem('locale') })
    );
  }
});

module.exports = KryProtocol;

/***/ }),

/***/ 1835:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(104);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(189);
var combineURLs = __webpack_require__(190);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(160), __esModule: true };

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(106);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(197);
var parse = __webpack_require__(208);
var formats = __webpack_require__(70);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(198);
var utils = __webpack_require__(107);
var formats = __webpack_require__(70);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68);
var callBound = __webpack_require__(204);
var inspect = __webpack_require__(206);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(200);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(43);

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(69);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68);

var callBind = __webpack_require__(205);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(69);
var GetIntrinsic = __webpack_require__(68);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(207);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 207:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(107);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 209:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(211), src$en$$ = __webpack_require__(216);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(109), src$es5$$ = __webpack_require__(212), src$compiler$$ = __webpack_require__(213), intl$messageformat$parser$$ = __webpack_require__(214);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(109);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(215)['default'];
exports['default'] = exports;


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(219)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(224);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(220);
var en_1 = __webpack_require__(223);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(116);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(108);
var diff_1 = __webpack_require__(221);
var es5_1 = __webpack_require__(222);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(253);

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var emojiList = ['😀', '😉', '😁', '😆', '😅', '😂', '🤣', '😊', '🙂', '😄', '🙃', '😇', '😃', '😚', '🥰', '😙', '☺', '😍', '😗', '🥲', '😘', '🤩', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤔', '🤭', '🤗', '🤫', '😐', '😶', '🤨', '😬', '😏', '😑', '😒', '🙄', '🤐', '🤥', '😌', '😔', '😪', '😴', '🤤', '🥶', '🤧', '😷', '🤯', '🥴', '😵', '🤒', '🥵', '🤮', '🤕', '🤢', '🥸', '🤠', '🥳', '🤓', '😎', '🧐', '😕', '😖', '😧', '🥺', '😫', '😱', '😞', '😯', '😮', '😭', '😟', '😓', '😩', '😢', '😲', '😨', '🥱', '😳', '🙁', '😥', '😣', '😦', '☹', '😰', '☠', '😤', '😈', '😡', '💀', '👿', '🤬', '😠', '💩', '🤡', '🤖', '👽', '👾', '👻', '👺', '👹', '🙀', '😽', '😸', '😿', '😾', '😻', '😺', '😼', '😹', '🙉', '🙊', '🙈', '🗯', '🕳', '🗨', '🧡', '💟', '💭', '🤎', '💞', '🤍', '💌', '🖤', '💢', '💓', '💯', '💕', '💋', '💨', '💦', '💫', '💗', '💔', '💘', '💚', '💙', '💜', '💛', '💥', '💖', '💬', '💣', '💤', '❤', '❣', '💝', '🤚', '🖖', '👋', '🖐', '✋', '🤙', '🤞', '🤟', '🤘', '🤌', '🤏', '👌', '✌', '🖕', '👆', '👇', '👈', '👉', '☝', '🤛', '🤜', '👍', '✊', '👊', '👎', '👐', '🤝', '👏', '🤲', '🙏', '🙌', '✍', '🤳', '💅', '🫁', '🫀', '👁', '👄', '👅', '👂', '👃', '🦴', '👀', '🦶', '🦵', '🦻', '🦷', '🦿', '🦾', '💪', '🧠', '🧓', '🧑', '🧒', '👩', '👦', '👧', '👨', '👱', '👶', '👴', '👵', '🧔', '🙋', '🙍', '🙇', '🙎', '🧏', '🤦', '🙆', '💁', '🤷', '🙅', '👲', '👷', '💂', '🥷', '🧕', '🕵', '👸', '👳', '👰', '👮', '🤱', '🤰', '🤴', '🤵', '🧛', '🧚', '🎅', '🧞', '🧙', '👼', '🧜', '🧝', '🤶', '🧟', '🦹', '🦸', '🕴', '🧍', '💆', '💇', '💃', '👯', '🕺', '🏃', '🚶', '🧎', '🧗', '🧖', '🤹', '🤸', '🤺', '🤼', '🤾', '🚣', '🚵', '🚴', '🤽', '⛷', '🏋', '⛹', '🏌', '🏂', '🏇', '🏊', '🏄', '🧘', '🛌', '🛀', '💏', '👬', '👪', '👭', '👫', '💑', '🫂', '👤', '👣', '🗣', '👥', '🏽', '🏼', '🏻', '🏾', '🏿', '🦳', '🦲', '🦰', '🦱', '🐿', '🐮', '🐭', '🐫', '🐪', '🐯', '🦏', '🦍', '🦌', '🦊', '🦒', '🐀', '🐨', '🦘', '🦇', '🐎', '🐐', '🐏', '🐒', '🐑', '🐕', '🐖', '🐗', '🦓', '🐱', '🦣', '🦛', '🐰', '🦝', '🐩', '🦔', '🐁', '🐄', '🐵', '🐆', '🐅', '🐇', '🐈', '🦄', '🐘', '🐃', '🐴', '🐂', '🐶', '🐷', '🦡', '🦥', '🦧', '🦦', '🦙', '🦨', '🐹', '🦫', '🦮', '🐽', '🐾', '🐼', '🐻', '🐺', '🦁', '🦬', '🐣', '🐔', '🐤', '🕊', '🦩', '🐥', '🦢', '🦤', '🐧', '🐦', '🐓', '🦜', '🦚', '🦃', '🦅', '🦉', '🪶', '🦆', '🐸', '🐍', '🦎', '🐢', '🐊', '🦕', '🦖', '🐉', '🐲', '🦭', '🐋', '🦈', '🐚', '🐳', '🐟', '🐙', '🐬', '🐡', '🐠', '🦋', '🦗', '🦟', '🦠', '🪱', '🪲', '🪳', '🦂', '🪰', '🐝', '🐞', '🐛', '🐜', '🕸', '🐌', '🕷', '🌹', '💮', '🌷', '🌺', '🏵', '🌼', '🌻', '💐', '🥀', '🌸', '🌲', '🌳', '🌴', '🌵', '🌾', '🍀', '🌱', '🍂', '🍃', '🍁', '🌿', '☘', '🪴', '🥝', '🥥', '🫐', '🍓', '🍒', '🥭', '🍑', '🍋', '🍊', '🍉', '🫒', '🍍', '🍈', '🍎', '🍇', '🍅', '🍌', '🍏', '🍐', '🧄', '🫑', '🥜', '🌰', '🥑', '🥕', '🧅', '🥔', '🥒', '🥬', '🌶', '🥦', '🍆', '🍄', '🌽', '🍳', '🧈', '🧇', '🍲', '🧆', '🫓', '🌯', '🌮', '🌭', '🧀', '🧂', '🫔', '🫕', '🥯', '🍕', '🍖', '🍔', '🥪', '🥫', '🍗', '🍿', '🥖', '🥗', '🥙', '🥘', '🥞', '🥚', '🥓', '🍟', '🍞', '🥨', '🥩', '🥐', '🥣', '🥡', '🍚', '🍙', '🍘', '🍱', '🥠', '🍛', '🍠', '🥮', '🍢', '🍡', '🍤', '🍣', '🍥', '🍝', '🍜', '🥟', '🦞', '🦪', '🦀', '🦑', '🦐', '🍫', '🍦', '🍧', '🍬', '🍩', '🍪', '🍨', '🍯', '🧁', '🍭', '🥧', '🍮', '🍰', '🎂', '🥃', '🥂', '🍺', '🧉', '☕', '🥤', '🧃', '🍾', '🥛', '🫖', '🍹', '🍵', '🍻', '🧊', '🍼', '🧋', '🍶', '🍷', '🍸', '🍴', '🥄', '🔪', '🥢', '🏺', '🍽', '🌏', '🧭', '🌎', '🗺', '🗾', '🌍', '🌐', '🏜', '🌋', '🏖', '🏝', '🗻', '🏔', '⛰', '🏞', '🏕', '🗽', '🏭', '🏬', '🏦', '🏥', '🗼', '🏩', '🏪', '🏫', '🏘', '🏚', '🏛', '🏤', '🏟', '🏗', '💒', '🏨', '🏢', '🏡', '🪨', '🏠', '🏣', '🏰', '🧱', '🏯', '🪵', '🛖', '🕌', '🕋', '🕍', '⛪', '⛩', '🛕', '🎡', '⛺', '🎢', '💈', '🌇', '🌉', '🌅', '🌆', '🌃', '🌄', '♨', '🎪', '🌁', '🏙', '🎠', '⛲', '🚧', '🚥', '🚃', '🚘', '🚲', '🚈', '🚇', '🚆', '🚅', '🚄', '🛢', '🚚', '🚜', '🚉', '🚂', '🚗', '🚊', '🚙', '🚋', '🚛', '🚌', '🚝', '🚍', '🚎', '🚏', '🛑', '🚐', '🛣', '🚑', '🚦', '🚒', '🚨', '🚓', '🏎', '🚔', '🏍', '🚕', '⛽', '🚖', '🛴', '🚞', '🛹', '🛤', '🛻', '🛺', '🛵', '🛼', '🦼', '🦽', '🚤', '🚢', '⛵', '⚓', '🛳', '🛶', '⛴', '🛥', '🛩', '🚡', '🛫', '🚀', '🚁', '🛰', '✈', '🚟', '🛬', '🛸', '🚠', '🪂', '💺', '🧳', '🛎', '⏱', '⌛', '⏰', '⌚', '⏲', '🕧', '🕦', '🕔', '🕤', '⏳', '🕥', '🕢', '🕣', '🕠', '🕡', '🕞', '🕟', '🕜', '🕝', '🕕', '🕓', '🕚', '🕰', '🕘', '🕙', '🕖', '🕗', '🕛', '🕒', '🕑', '🕐', '⚡', '🔥', '🌊', '🌑', '⭐', '🌂', '☂', '☔', '💧', '🌒', '☃', '🌀', '⛄', '🌈', '⛅', '🌌', '☁', '☀', '🪐', '☄', '🌠', '🌓', '🌧', '🌟', '🌫', '🌙', '🌚', '⛱', '🌝', '🌨', '⛈', '❄', '🌔', '🌥', '🌪', '🌩', '🌦', '🌤', '🌕', '🌡', '🌖', '🌬', '🌗', '🌞', '🌘', '🌛', '🌜', '🎆', '🎁', '🎃', '✨', '🎇', '🎀', '🎉', '🎟', '🎈', '🎋', '🎊', '🎗', '🎫', '🎑', '🎍', '🎏', '🧧', '🎎', '🎐', '🎄', '🧨', '🏆', '🎖', '🏅', '🥇', '🥉', '🥈', '🤿', '🥌', '🏀', '🏓', '🎣', '🏑', '🏐', '🎽', '🎾', '🎿', '⚽', '🏒', '🥎', '⛸', '🥏', '⚾', '🥊', '🥍', '🏈', '🥋', '🏏', '🥅', '🏉', '🎳', '⛳', '🛷', '🏸', '♣', '♥', '♦', '🕹', '♠', '♟', '🔮', '🧩', '🃏', '🎴', '🀄', '🎱', '🎲', '🎰', '🪆', '🪅', '🎮', '🪁', '🪄', '🪀', '🧿', '🧸', '🎯', '🎨', '🪢', '🧵', '🖼', '🧶', '🎭', '🪡', '🎓', '👗', '👙', '👛', '🧢', '⛑', '👞', '👟', '👝', '👜', '🦺', '🪖', '🧣', '👕', '👡', '👑', '💄', '🧤', '👚', '👢', '💍', '🧥', '👘', '💎', '🧦', '🕶', '👓', '🎩', '👖', '🛍', '🩰', '🎒', '🥻', '🩴', '🥾', '🩱', '👔', '🥼', '🩲', '🥿', '🩳', '👠', '📿', '🥽', '👒', '📢', '🔇', '🔈', '📣', '📯', '🔊', '🔔', '🔕', '🔉', '📻', '🎛', '🎙', '🎤', '🎚', '🎶', '🎼', '🎵', '🎧', '🎻', '🪕', '🎺', '🎷', '🪗', '🥁', '🪘', '🎹', '🎸', '📞', '📠', '📱', '📟', '☎', '📲', '🖱', '🖲', '🖥', '🖨', '🧮', '⌨', '🔋', '🔌', '📀', '💿', '💾', '💽', '💻', '📹', '📸', '📷', '🎥', '💡', '🎬', '🪔', '🏮', '📺', '🕯', '🔎', '📼', '🎞', '🔍', '🔦', '📽', '🏷', '📑', '📓', '📃', '📕', '📒', '📗', '📔', '📙', '📖', '🔖', '📘', '📜', '📚', '📄', '🗞', '📰', '💸', '💷', '💹', '💶', '💵', '🪙', '💴', '💳', '💰', '🧾', '📪', '📫', '📬', '📭', '📧', '📤', '📥', '🗳', '📦', '📨', '📩', '✉', '📮', '📝', '🖍', '🖋', '🖌', '✒', '🖊', '✏', '🗄', '🗃', '🗂', '✂', '📈', '🖇', '📌', '🗓', '📊', '🗑', '📐', '📋', '📉', '📏', '🗒', '📁', '📍', '💼', '📅', '📆', '📇', '📂', '📎', '🔓', '🔒', '🔑', '🔐', '🔏', '🗝', '🗜', '⚙', '🗡', '🏹', '🪝', '🪜', '🛡', '⛓', '🛠', '⛏', '🪓', '🪚', '🧲', '🪃', '🦯', '🧰', '🔧', '🔗', '🔩', '🔨', '⚔', '🔫', '⚖', '⚒', '🪛', '🔭', '🔬', '📡', '🧪', '🧫', '🧬', '⚗', '🩺', '🩹', '💉', '🩸', '💊', '🪥', '🛁', '🪤', '🛗', '🛋', '🧴', '🪣', '🛒', '🪠', '🚿', '🛏', '🧯', '🪟', '🧷', '🪞', '🧺', '🪑', '🧹', '🧼', '🪒', '🧽', '🚽', '🧻', '🚪', '⚱', '🚬', '⚰', '🪧', '🗿', '🪦', '♿', '🚼', '🚻', '🚺', '🚹', '🚮', '🚰', '🏧', '🛅', '🛄', '🛃', '🛂', '🚾', '☢', '⚠', '☣', '🚷', '🚳', '🚸', '⛔', '📵', '🚫', '🚱', '🚯', '🚭', '🔞', '↔', '↩', '↕', '↖', '↗', '↘', '↪', '↙', '🔝', '🔃', '⬇', '🔚', '🔙', '🔜', '🔛', '⬅', '⬆', '⤵', '⤴', '➡', '🔄', '⚛', '🔯', '✝', '☪', '☦', '☯', '☮', '🕎', '🛐', '🕉', '✡', '☸', '♉', '♋', '♐', '♑', '♏', '♒', '♓', '♍', '♈', '♌', '♎', '⛎', '♊', '📳', '▶', '⏸', '◀', '⏯', '⏩', '⏪', '⏮', '⏫', '⏬', '⏺', '⏭', '📴', '🔅', '🔆', '🔁', '🔂', '🎦', '🔀', '🔼', '🔽', '⏹', '⏏', '📶', '⚧', '♀', '♂', '➕', '➖', '➗', '♾', '✖', '⁉', '〰', '❓', '❔', '❕', '❗', '‼', '💱', '💲', '❌', '⭕', '❎', '®', '™', '♻', '➰', '☑', '🔰', '🔱', '✅', '➿', '©', '〽', '⚕', '✔', '⚜', '📛', '✴', '❇', '✳', '🔟', '🈯', '🈲', '🈚', '🈳', '㊙', '🈹', '🆚', '🆙', '🈁', '🔠', '🈴', '🅰', '🆓', '🈵', '🆘', '🆔', '🆎', '🔡', '🆕', '🈸', '🉐', '🉑', '🈺', '🆖', '🆗', 'ℹ', '🈶', '㊗', '🈷', '🆑', '🈂', '🔢', '🅿', '🔤', '🅾', '🆒', '🅱', 'Ⓜ', '🔣', '🔴', '⚫', '⚪', '🔵', '🔶', '🔷', '◼', '▫', '◻', '▪', '🔻', '🔺', '🔳', '◽', '🔲', '◾', '🔹', '🔸', '🔘', '🟪', '🟩', '🟡', '💠', '🟠', '🟨', '🟤', '⬜', '🟥', '🟫', '🟧', '🟣', '🟢', '🟦', '⬛', '🏳', '🎌', '🏁', '🏴', '🚩', '🏁', '🚩', '🎌', '🏴', '🏳️', '🏳️‍🌈', '🏴‍☠️', '🇦🇨', '🇦🇩', '🇦🇪', '🇦🇫', '🇦🇬', '🇦🇮', '🇦🇱', '🇦🇲', '🇦🇴', '🇦🇶', '🇦🇷', '🇦🇸', '🇦🇹', '🇦🇺', '🇦🇼', '🇦🇽', '🇦🇿', '🇧🇦', '🇧🇧', '🇧🇩', '🇧🇪', '🇧🇫', '🇧🇬', '🇧🇭', '🇧🇮', '🇧🇯', '🇧🇱', '🇧🇲', '🇧🇳', '🇧🇴', '🇧🇶', '🇧🇷', '🇧🇸', '🇧🇹', '🇧🇻', '🇧🇼', '🇧🇾', '🇧🇿', '🇨🇦', '🇨🇨', '🇨🇩', '🇨🇫', '🇨🇬', '🇨🇭', '🇨🇮', '🇨🇰', '🇨🇱', '🇨🇲', '🇨🇳', '🇨🇴', '🇨🇵', '🇨🇷', '🇨🇺', '🇨🇻', '🇨🇼', '🇨🇽', '🇨🇾', '🇨🇿', '🇩🇪', '🇩🇬', '🇩🇯', '🇩🇰', '🇩🇲', '🇩🇴', '🇩🇿', '🇪🇦', '🇪🇨', '🇪🇪', '🇪🇬', '🇪🇭', '🇪🇷', '🇪🇸', '🇪🇹', '🇪🇺', '🇫🇮', '🇫🇯', '🇫🇰', '🇫🇲', '🇫🇴', '🇫🇷', '🇬🇦', '🇬🇧', '🇬🇩', '🇬🇪', '🇬🇫', '🇬🇬', '🇬🇭', '🇬🇮', '🇬🇱', '🇬🇲', '🇬🇳', '🇬🇵', '🇬🇶', '🇬🇷', '🇬🇸', '🇬🇹', '🇬🇺', '🇬🇼', '🇬🇾', '🇭🇰', '🇭🇲', '🇭🇳', '🇭🇷', '🇭🇹', '🇭🇺', '🇮🇨', '🇮🇩', '🇮🇪', '🇮🇱', '🇮🇲', '🇮🇳', '🇮🇴', '🇮🇶', '🇮🇷', '🇮🇸', '🇮🇹', '🇯🇪', '🇯🇲', '🇯🇴', '🇯🇵', '🇰🇪', '🇰🇬', '🇰🇭', '🇰🇮', '🇰🇲', '🇰🇳', '🇰🇵', '🇰🇷', '🇰🇼', '🇰🇾', '🇰🇿', '🇱🇦', '🇱🇧', '🇱🇨', '🇱🇮', '🇱🇰', '🇱🇷', '🇱🇸', '🇱🇹', '🇱🇺', '🇱🇻', '🇱🇾', '🇲🇦', '🇲🇨', '🇲🇩', '🇲🇪', '🇲🇫', '🇲🇬', '🇲🇭', '🇲🇰', '🇲🇱', '🇲🇲', '🇲🇳', '🇲🇴', '🇲🇵', '🇲🇶', '🇲🇷', '🇲🇸', '🇲🇹', '🇲🇺', '🇲🇻', '🇲🇼', '🇲🇽', '🇲🇾', '🇲🇿', '🇳🇦', '🇳🇨', '🇳🇪', '🇳🇫', '🇳🇬', '🇳🇮', '🇳🇱', '🇳🇴', '🇳🇵', '🇳🇷', '🇳🇺', '🇳🇿', '🇴🇲', '🇵🇦', '🇵🇪', '🇵🇫', '🇵🇬', '🇵🇭', '🇵🇰', '🇵🇱', '🇵🇲', '🇵🇳', '🇵🇷', '🇵🇸', '🇵🇹', '🇵🇼', '🇵🇾', '🇶🇦', '🇷🇪', '🇷🇴', '🇷🇸', '🇷🇺', '🇷🇼', '🇸🇦', '🇸🇧', '🇸🇨', '🇸🇩', '🇸🇪', '🇸🇬', '🇸🇭', '🇸🇮', '🇸🇯', '🇸🇰', '🇸🇱', '🇸🇲', '🇸🇳', '🇸🇴', '🇸🇷', '🇸🇸', '🇸🇹', '🇸🇻', '🇸🇽', '🇸🇾', '🇸🇿', '🇹🇦', '🇹🇨', '🇹🇩', '🇹🇫', '🇹🇬', '🇹🇭', '🇹🇯', '🇹🇰', '🇹🇱', '🇹🇲', '🇹🇳', '🇹🇴', '🇹🇷', '🇹🇹', '🇹🇻', '🇹🇼', '🇹🇿', '🇺🇦', '🇺🇬', '🇺🇲', '🇺🇳', '🇺🇸', '🇺🇾', '🇺🇿', '🇻🇦', '🇻🇨', '🇻🇪', '🇻🇬', '🇻🇮', '🇻🇳', '🇻🇺', '🇼🇫', '🇼🇸', '🇽🇰', '🇾🇪', '🇾🇹', '🇿🇦', '🇿🇲', '🇿🇼', '🏴󠁧󠁢󠁥󠁮󠁧󠁿', '🏴󠁧󠁢󠁳󠁣󠁴󠁿', '🏴󠁧󠁢󠁷󠁬󠁳󠁿'];

var emojiRegStr = emojiList.map(function (e) {
  var emojistr = '';
  for (var i = 0; i <= e.length - 1; i++) {
    emojistr += '\\u' + e.charCodeAt(i).toString(16);
  }

  return '(' + emojistr + ')';
}).join('|');

exports.default = emojiRegStr;

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(270);

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(230);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(39);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(232);
module.exports = __webpack_require__(1).Object.getPrototypeOf;


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(33);
var $getPrototypeOf = __webpack_require__(112);

__webpack_require__(81)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235);
module.exports = __webpack_require__(1).Object.setPrototypeOf;


/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(236).set });


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(12);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(32)(Function.call, __webpack_require__(98).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(238), __esModule: true };

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
var $Object = __webpack_require__(1).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(63) });


/***/ }),

/***/ 24:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(241);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ 241:
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _divolte = __webpack_require__(243);

/**
 * @namespace kryfe-divolte
 */
exports.default = _divolte.init;

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDivolteScriptUrl = exports.getUrlParams = exports.init = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getDistinctID = __webpack_require__(244);

var _registerEventsHandler = __webpack_require__(245);

var _registerEventsHandler2 = _interopRequireDefault(_registerEventsHandler);

var _utils = __webpack_require__(246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// get divolte script url, depends on environment
function getDivolteScriptUrl(options) {
  var defaultOptions = {
    dev: {
      url: 'http://devdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return (/^dev/i.test(location.hostname)
        );
      }
    },
    test: {
      url: 'http://testdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return (/^test/i.test(location.hostname)
        );
      }
    },
    prod: {
      url: 'http://devdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return true;
      }
    }
  };

  var opts = Object.assign({}, defaultOptions, options);
  var env = Object.keys(opts).find(function (item) {
    return opts[item].validator();
  });

  return env ? opts[env].url : null;
}

// get url params
function getUrlParams() {
  var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.substr(1);

  var ret = {};

  if (queryString) {
    queryString.split('&').forEach(function (item) {
      var data = item.split('=');
      ret[data[0]] = data[1];
    });
  }

  return ret;
}

// trigger custom events
function triggerCustomEvents(customEvents, defaultParams, e) {
  var eventName = e.eventName,
      content = e.content,
      target = e.target;

  // only 'error' and 'load' events has 'eventName',

  var customEvent = eventName ? { eventName: eventName } : customEvents.find(function (_ref) {
    var xpath = _ref.xpath;

    if (xpath instanceof Array) {
      return xpath.find(function (path) {
        var node = document.querySelector(path);
        return node && node.contains(target);
      });
    } else if (typeof xpath === 'string') {
      var node = document.querySelector(xpath);
      return node && node.contains(target);
    }
    return null;
  });

  if (customEvent && customEvent.eventName) {
    // eslint-disable-next-line no-unused-vars
    var enableDebug = defaultParams.enableDebug,
        excludeEvent = defaultParams.excludeEvent,
        willSendDefaultParams = _objectWithoutProperties(defaultParams, ['enableDebug', 'excludeEvent']);

    var params = Object.assign(content ? _extends({}, content) : {}, willSendDefaultParams, getUrlParams());

    if (target && target.className) {
      params.clickEventSource = target.className;
    }
    if (defaultParams && defaultParams.enableDebug) {
      /* eslint-disable no-console */
      console.group('divolte will send info');
      console.log('customEvent', customEvent);
      console.log('param', params);
      console.groupEnd();
      /* eslint-enable no-console */
    }
    divolte.signal(customEvent.eventName, params);
  }
}

// init, inject a script into document
function init(customEvents) {
  var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var urlOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return new Promise(function (resolve, reject) {
    if (!(0, _utils.isArray)(customEvents) || customEvents.length === 0) {
      throw new Error("customEvents must be an array, and please make sure it's not empty!");
    }

    if (!(0, _utils.isPlainObject)(defaultParams)) {
      throw new Error('defaultParams must be an object!');
    }
    Object.assign(defaultParams);

    if (!(0, _utils.isPlainObject)(urlOptions)) {
      throw new Error('urlOptions must be an object!');
    }
    var script = null;
    try {
      script = document.createElement('script');
      script.id = 'divolte-collection';
      script.src = getDivolteScriptUrl(urlOptions);
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } catch (ex) {
      reject(ex);
    }
    // add click event on body, after loaded divolte js file
    script.addEventListener('load', function () {
      if (defaultParams.distinctID) {
        (0, _registerEventsHandler2.default)(triggerCustomEvents.bind(null, customEvents, defaultParams), defaultParams);
        return;
      }

      (0, _getDistinctID.getDistinctID)().then(function (distinctID) {
        Object.assign(defaultParams, {
          distinctID: distinctID
        });
        (0, _registerEventsHandler2.default)(triggerCustomEvents.bind(null, customEvents, defaultParams), defaultParams);
      });

      // release memory
      script = null;
      resolve();
    });

    script.addEventListener('error', function (ex) {
      reject(ex);
    });
  });
}

exports.init = init;
exports.getUrlParams = getUrlParams;
exports.getDivolteScriptUrl = getDivolteScriptUrl;

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISTINCE_ID = undefined;
exports.getDistinctID = getDistinctID;

var _jsCookie = __webpack_require__(79);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FINGERPRINT_ID = 'fingerprintjs2Script';
var DISTINCE_ID = exports.DISTINCE_ID = 'DISTINCE_ID';

function loadFingerprint() {
  return new Promise(function (resolve, reject) {
    if (!!document.querySelector('#' + FINGERPRINT_ID)) resolve();

    var script = document.createElement('script');
    script.id = FINGERPRINT_ID;
    script.src = '//wx-static.keruyun.com/cdn/fingerprintjs2/1.5.1/fingerprint2.min.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    script.addEventListener('load', function () {
      script = null;
      resolve();
    });

    script.addEventListener('error', function () {
      reject(new Error('加载fingerprintjs2失败'));
    });
  });
}

function getDistinctID() {
  return new Promise(function (resolve) {
    var distinctID = _jsCookie2.default.get(DISTINCE_ID);
    if (distinctID) {
      resolve(distinctID);
    }

    loadFingerprint().then(function () {
      var fp = new Fingerprint2();
      fp.get(function (id) {
        _jsCookie2.default.set(DISTINCE_ID, id);
        resolve(id);
      });
    });
  });
}

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var eventMap = {
  click: function click(handler) {
    document.body.addEventListener('click', function (e) {
      // trigger default event, while handle custom-events
      handler(e);

      // trigger global 'click' event
      handler({
        eventName: 'click',
        target: e.target,
        content: {
          pageX: e.pageX,
          pageY: e.pageY
        }
      });
    }, false);
  },
  error: function error(handler) {
    window.addEventListener('error', function (e) {
      var error = e.error;


      handler({
        eventName: 'error',
        content: {
          // will change property name
          content: error && error.stack
        }
      });
    }, false);
  },
  load: function load(handler) {
    var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    window.addEventListener('load', function () {
      var _defaultParams$exclud = defaultParams.excludeEvent,
          excludeEvent = _defaultParams$exclud === undefined ? [] : _defaultParams$exclud;

      if (!Array.isArray(excludeEvent)) excludeEvent = [];
      if (window.performance) {
        var timing = window.performance.timing;
        if (timing) {
          var navigation = window.performance.navigation;

          var firstPaintTime = null;
          if (window.chrome && window.chrome.loadTimes) {
            var loadTimes = window.chrome.loadTimes();
            firstPaintTime = loadTimes.firstPaintTime - loadTimes.startLoadTime;
          } else if (timing.msFirstPaint) {
            firstPaintTime = timing.msFirstPaint - timing.navigationStart;
          }

          if (!excludeEvent.includes('performance-timing')) {
            handler({
              eventName: 'performance-timing',
              content: {
                duration: timing.responseEnd - timing.navigationStart,
                redirect: timing.redirectEnd - timing.redirectStart,
                appCache: timing.domainLookupStart - timing.fetchStart,
                dnsTime: timing.domainLookupEnd - timing.domainLookupStart,
                connect: timing.connectEnd - timing.connectStart,
                fetchFirstByte: timing.responseStart - timing.navigationStart,
                firstPaintTime: firstPaintTime,
                requestTime: timing.responseStart - timing.requestStart,
                responseTime: timing.responseEnd - timing.responseStart,
                domReady: timing.domInteractive - timing.navigationStart,
                onLoadTime: timing.loadEventEnd - timing.navigationStart,
                navigationType: navigation ? navigation.type : null,
                navigationRedirectCount: navigation ? navigation.redirectCount : null
              }
            });
          }
        }

        if (window.performance.getEntriesByType && !excludeEvent.includes('resource-timing')) {
          var resourceTimingList = window.performance.getEntriesByType('resource');
          if (resourceTimingList && resourceTimingList.length > 0) {
            var supportedTypes = ['script', 'link', 'css'];

            resourceTimingList.filter(function (item) {
              return supportedTypes.indexOf(item.initiatorType) !== -1;
            }).map(function (item) {
              return {
                initiatorType: item.initiatorType,
                size: item.transferSize,
                duration: item.duration,
                redirect: item.redirectEnd - item.redirectStart,
                appCache: item.domainLookupStart - item.fetchStart,
                dnsTime: item.domainLookupEnd - item.domainLookupStart,
                connect: item.connectEnd - item.connectStart,
                fetchFirstByte: item.responseStart - item.startTime,
                requestTime: item.responseStart - item.requestStart,
                responseTime: item.responseEnd - item.responseStart
              };
            }).forEach(function (content) {
              return handler({
                eventName: 'resource-timing',
                content: content
              });
            });
          }
        }
      }
    }, false);
  },
  hashchange: function hashchange(handler) {
    window.addEventListener('hashchange', function () {
      handler({ eventName: 'hashchange' });
    }, false);
  },
  popstate: function popstate(handler) {
    window.addEventListener('popstate', function () {
      handler({ eventName: 'popstate' });
    }, false);
  }
};

// register 'click', 'error' and 'load' events
function registerEventsHandler(handler) {
  var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _defaultParams$exclud2 = defaultParams.excludeEvent,
      excludeEvent = _defaultParams$exclud2 === undefined ? [] : _defaultParams$exclud2;

  if (!Array.isArray(excludeEvent)) {
    excludeEvent = [];
  }
  Object.keys(eventMap).forEach(function (key) {
    if (excludeEvent.includes(key)) return;
    eventMap[key](handler, defaultParams);
  });
}

exports.default = registerEventsHandler;

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toString = [].toString;
var hasOwn = Object.prototype.hasOwnProperty;
var types = {
  '[object Boolean]': 'bool',
  '[object Number]': 'number',
  '[object String]': 'string',
  '[object Object]': 'object',
  '[object Array]': 'array',
  '[object Function]': 'function',
  '[object Date]': 'date',
  '[object RegExp]': 'regExp'
};
var type = function type(obj) {
  return obj === null ? String(obj) : types[toString.call(obj)] || 'object';
};
var isWindow = function isWindow(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && 'setInterval' in obj;
};
var isArray = Array.isArray || function (obj) {
  return type(obj) === 'array';
};

var isPlainObject = function isPlainObject(obj) {
  if (!obj || type(obj) !== 'object' || isWindow(obj) || obj.nodeType) {
    return false;
  }
  try {
    if (obj.constructor && !hasOwn.call(obj, 'constructor') && !hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
      return false;
    }
  } catch (e) {
    return false;
  }
  var key = void 0;
  // eslint-disable-next-line
  for (key in obj) {}
  return key === undefined || hasOwn.call(obj, key);
};

exports.isPlainObject = isPlainObject;
exports.isArray = isArray;

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(110);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getInfoByFieldsAsync = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fields) {
    var res, i, l, field, fieldFunName, funName, val;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            res = {};
            i = 0, l = fields.length;

          case 2:
            if (!(i < l)) {
              _context.next = 15;
              break;
            }

            field = fields[i];
            fieldFunName = field.charAt(0).toUpperCase() + field.slice(1);
            funName = 'get' + fieldFunName;
            val = '';

            if (!(commonInfoUtils.hasOwnProperty(funName) && typeof commonInfoUtils[funName] === 'function')) {
              _context.next = 11;
              break;
            }

            _context.next = 10;
            return commonInfoUtils[funName]();

          case 10:
            val = _context.sent;

          case 11:
            res[field] = val;

          case 12:
            i++;
            _context.next = 2;
            break;

          case 15:
            return _context.abrupt('return', res);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getInfoByFieldsAsync(_x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getFixedInfo = getFixedInfo;
exports.getDynamicInfo = getDynamicInfo;
exports.getPageTypeFromUrl = getPageTypeFromUrl;

var _commonHelper = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function randomString() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;

  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678oOLloOLlVvUuI1';
  var maxPos = $chars.length;
  var actualLength = len - 13;
  actualLength = actualLength > 0 ? actualLength : 5;
  var pwd = '';
  for (var i = 0; i < actualLength; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd + new Date().getTime();
}

// 获取埋点工具的session id
/*
 * @Author: snail
 * @Date: 2020-02-27 16:58:09
 * @Last Modified by: snail
 * @Last Modified time: 2020-03-26 15:36:53
 */
var getStatisticsSessionId = function getStatisticsSessionId() {
  var statisticsSessionId = sessionStorage.getItem('statisticsSessionId');
  if (!statisticsSessionId) {
    statisticsSessionId = Math.random().toString(36).substring(2) + Date.now();
    sessionStorage.setItem('statisticsSessionId', statisticsSessionId);
  }
  return statisticsSessionId;
};
/**
 * 获取公共信息的集合
 */
// const fixedCommonInfoFields = ['sessionId', 'shopId'];
// const fixedCommonInfoFields = ['sessionId', 'shopId'];
// const dynamicCommonInfoFields = ['customerId', 'timestamp', 'recomdFiled', 'pageTitle', 'eventId'];
var fixedCommonInfoFields = ['shopId'];
var dynamicCommonInfoFields = ['customerId', 'timestamp', 'recomFiled', 'recomMark', 'pageTitle'];
var commonInfoUtils = {
  getEventId: function getEventId() {
    return randomString(48);
  },
  getRecomMark: function getRecomMark() {
    return '';
  },

  /**
   * 是否是推荐栏目
   */
  getRecomFiled: function getRecomFiled() {
    return location.href.indexOf('#hot-dish') !== -1 ? '1' : '0';
  },

  /**
   * 获取用户id
   */
  getCustomerId: function getCustomerId() {
    return (0, _commonHelper.getCustomerIdNew)();
  },

  /**
   * 获取时间戳
   */
  getTimestamp: function getTimestamp() {
    return new Date().getTime();
  },

  /**
   * 获取sessionId
   */
  getSessionId: function getSessionId() {
    return getStatisticsSessionId();
  },

  /**
   * 获取页面名称
   */
  getPageTitle: function getPageTitle() {
    return document.title.toString();
  },

  /**
   * 门店ID
   */
  getShopId: function getShopId() {
    return (0, _commonHelper.getUrlParam)('shopId');
  }
};

function getInfoByFieldsSync(fields) {
  var res = {};
  fields.forEach(function (field) {
    var fieldFunName = field.charAt(0).toUpperCase() + field.slice(1);
    var funName = 'get' + fieldFunName;
    var val = '';
    if (commonInfoUtils.hasOwnProperty(funName) && typeof commonInfoUtils[funName] === 'function') {
      val = commonInfoUtils[funName]();
    }
    res[field] = val;
  });
}

function getFixedInfo() {
  return getInfoByFieldsSync(fixedCommonInfoFields);
}

function getDynamicInfo() {
  return getInfoByFieldsAsync(dynamicCommonInfoFields);
}

var pathMapPageType = {
  '/takeaway/selectDish': '外卖点餐页',
  '/orderall/dishMenu4Quik': '快餐点餐页',
  '/orderall/dishMenu4Dinner': '堂食点餐页'
};

/**
 * 根据界面路径，获取埋点的pageType字段
 */
function getPageTypeFromUrl() {
  return pathMapPageType[location.pathname] || document.title || '';
}

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allBuryingPoint = allBuryingPoint;
function getPathStr(path) {
  var xPath = [];
  if (Array.isArray(path)) {
    path.forEach(function (node) {
      if (node.tagName) {
        var str = (node.tagName || '').toLocaleLowerCase();
        var id = !!node.id ? '#' + node.id : '';
        var className = !!node.className ? '.' + node.className.split(' ').join('.') : '';
        xPath.push('' + str + id + className);
      }
    });
  }
  return xPath.reverse().join('>');
}

function getTagUrl(node) {
  return node.src || node.href || '';
}

function allBuryingPoint(buryingPoint) {
  /**
   * 界面元素点击事件埋点
   */
  document.body.addEventListener('click', function (event) {
    var e = event || window.event;
    var _e$target = e.target,
        target = _e$target === undefined ? {} : _e$target,
        _e$path = e.path,
        path = _e$path === undefined ? [] : _e$path;

    var _ref = target || {},
        _ref$id = _ref.id,
        id = _ref$id === undefined ? '' : _ref$id,
        _ref$tagName = _ref.tagName,
        tagName = _ref$tagName === undefined ? '' : _ref$tagName,
        _ref$textContent = _ref.textContent,
        textContent = _ref$textContent === undefined ? '' : _ref$textContent,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$nodeType = _ref.nodeType,
        nodeType = _ref$nodeType === undefined ? '' : _ref$nodeType;

    var param = {
      objectId: id,
      objectName: (tagName || '').toLocaleLowerCase(),
      objectContent: textContent,
      objectClassName: className,
      objectType: nodeType,
      objectSelector: getPathStr(path),
      objectTargetUrl: getTagUrl(target)
    };
    buryingPoint.send('ObjectClick', param);
  }, false);
}

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(75);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

__webpack_require__(146);

__webpack_require__(147);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(114);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _redux = __webpack_require__(122);

var _reactRedux = __webpack_require__(115);

var _reactIntl = __webpack_require__(7);

var _en = __webpack_require__(251);

var _en2 = _interopRequireDefault(_en);

var _zh = __webpack_require__(252);

var _zh2 = _interopRequireDefault(_zh);

var _th = __webpack_require__(253);

var _th2 = _interopRequireDefault(_th);

var _reduxThunk = __webpack_require__(254);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactTapEventPlugin = __webpack_require__(228);

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _commonHelper = __webpack_require__(3);

var _helper = __webpack_require__(16);

var _PermissionProvider = __webpack_require__(255);

var _PermissionProvider2 = _interopRequireDefault(_PermissionProvider);

var _helper2 = __webpack_require__(256);

var _wxMiniprogramHelper = __webpack_require__(113);

var _wxMiniprogramHelper2 = _interopRequireDefault(_wxMiniprogramHelper);

var _topNavigator = __webpack_require__(258);

var _topNavigator2 = _interopRequireDefault(_topNavigator);

var _navigator = __webpack_require__(260);

var _navigator2 = _interopRequireDefault(_navigator);

__webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import logger from './helper/logger';

// import sg from 'react-intl/locale-data/sg';
var isScanCodeFromConf = (0, _commonHelper.getUrlParam)('scan'); // 如果页面带入此参数，代表是符合微信扫码活动

// import initSentry from './helper/sentry';
window.Intl = __webpack_require__(262);

(0, _reactTapEventPlugin2.default)();
// initSentry();

/**
 * 重要提示
 * 此处新增了语言类型，需要在 /src/helper/const/supportLanguage.js 中新增对应的语言类型
 * 同时在 src/helper/const/languages.js 中新增对应的语言资源
 */

(0, _reactIntl.addLocaleData)([].concat((0, _toConsumableArray3.default)(_en2.default), (0, _toConsumableArray3.default)(_zh2.default), (0, _toConsumableArray3.default)(_th2.default)));
(0, _reactIntl.addLocaleData)({ locale: 'zh_CN', parentLocale: 'zh' });
(0, _reactIntl.addLocaleData)({ locale: 'en_GB', parentLocale: 'en' });
(0, _reactIntl.addLocaleData)({ locale: 'zh_TW', parentLocale: 'zh' });
(0, _reactIntl.addLocaleData)({ locale: 'th_TH', parentLocale: 'th' });

var baseUrl = (0, _commonHelper.getWebpackHashFromScriptUrl)();

// 装载对应语言包
function loadLanguage(languageDefault) {
  var script = document.createElement('script');
  var current = languageDefault;

  (0, _assign2.default)(script, {
    type: 'text/javascript',
    src: baseUrl + '/lang/' + current + '/index.js'
  });

  document.body.appendChild(script);

  return new _promise2.default(function (resolve, reject) {
    script.onload = function () {
      resolve(this, languageDefault);
    };

    script.onerror = function (error) {
      reject(error);
    };
  });
}

var addReduxDevTools = function addReduxDevTools(composeList) {
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    composeList.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
};

function injectTopNavigator() {
  var div = document.createElement('div');
  document.body.appendChild(div);

  _reactDom2.default.render(_react2.default.createElement(_topNavigator2.default, { text: '\u8FD4\u56DE' }), div);

  div = null;
}
function topNavigator() {
  if (history.length > 1) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    _reactDom2.default.render(_react2.default.createElement(_navigator2.default, null), div);
  }
}

var createRootApplication = function createRootApplication(applicationName, reducer) {
  // 支付宝平台小程序添加蚂蚁能量 判断条件 1.是支付宝小程序环境下 2.点餐类型type==="TS" 3.在平台版后加fromPlatform==='1'用于区分平台版和模板
  if ((0, _commonHelper.isAlipayMiniProgramBrowser)() && (0, _commonHelper.getUrlParam)('type') === 'TS' && (0, _commonHelper.getUrlParam)('fromPlatform') === '1') {
    localStorage.setItem('antsEnergy', true);
  }
  // 海底捞模板小程序
  if ((0, _commonHelper.getUrlParam)('wxminiprogramname') === 'h5WxApp' || (0, _commonHelper.getUrlParam)('hdlScence') === '2') {
    sessionStorage.setItem('ISHDL', '1');
  }
  if (!reducer || typeof reducer !== 'function') {
    _reactDom2.default.render(applicationName, document.getElementById('app-placeholder'));
    return;
  }

  var composeList = [];

  if (false) {
    // composeList.push(applyMiddleware(thunkMiddleware, logger));
    composeList.push((0, _redux.applyMiddleware)(_reduxThunk2.default));

    addReduxDevTools(composeList);
  } else {
    composeList.push((0, _redux.applyMiddleware)(_reduxThunk2.default));
  }

  var store = _redux.compose.apply(undefined, composeList)(_redux.createStore)(reducer);

  var render = function render(messages, languageDefault) {
    var sessionIsScanCodeFromConf = sessionStorage.isScanCodeFromConf === 'true';
    // 因为原有逻辑判定是否是扫码点餐部分，session中存入isScanCode
    // 此处如果初次进入页面带入的参数&scan=true,session中存入isScanCodeFromConf
    if (isScanCodeFromConf === 'true' && !sessionIsScanCodeFromConf) {
      // 避免频繁写入
      sessionStorage.isScanCodeFromConf = true;
    }
    var intlCfg = { messages: messages, locale: languageDefault };
    var elem = document.getElementById('app-placeholder');
    var rootCls = (' locale--' + intlCfg.locale).toLocaleLowerCase();

    (0, _helper.initSingletonIntl)(intlCfg);
    // 切换语言之后，将原来的 ‘local--’删除
    // 因为语言类名肯定在最后，所以采用如下方法
    var localeClassIndex = elem.className.indexOf('locale--');
    if (localeClassIndex !== -1) {
      elem.className = elem.className.slice(0, localeClassIndex);
    }
    elem.className += rootCls; // 将新的语言类名填上
    (0, _wxMiniprogramHelper.runInRootWhenMiniPrograme)();

    _reactDom2.default.render(_react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactIntl.IntlProvider,
        intlCfg,
        _react2.default.createElement(
          _PermissionProvider2.default,
          { permissions: (0, _helper2.getPermissions)() },
          applicationName
        )
      )
    ), elem);

    var topNavSelf = applicationName.type.topNavSelf;

    if (sessionStorage.getItem('ISHDL') === '1') {
      // 海底捞模板小程序
      topNavigator();
    } else if (_wxMiniprogramHelper2.default.isMiniProgramMode() && !topNavSelf) {
      injectTopNavigator();
    }
  };

  var loadFunc = function loadFunc(languageDefault) {
    loadLanguage(languageDefault).then(function () {
      render(window.__LANG_MESSAGES__, languageDefault);
    }).catch(function () {
      render({});
    });
  };
  exports.reload = loadFunc;

  (0, _helper.getShopBaseConf)(loadFunc, applicationName);
};

exports.default = createRootApplication;

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.th=t())}(this,function(){"use strict";return[{locale:"th",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},"year-short":{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ใน {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},month:{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} เดือน"},past:{other:"{0} เดือนที่ผ่านมา"}}},"month-short":{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ใน {0} เดือน"},past:{other:"{0} เดือนที่แล้ว"}}},day:{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ในอีก {0} วัน"},past:{other:"{0} วันที่ผ่านมา"}}},"day-short":{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ใน {0} วัน"},past:{other:"{0} วันที่แล้ว"}}},hour:{displayName:"ชั่วโมง",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ในอีก {0} ชั่วโมง"},past:{other:"{0} ชั่วโมงที่ผ่านมา"}}},"hour-short":{displayName:"ชม.",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ใน {0} ชม."},past:{other:"{0} ชม. ที่แล้ว"}}},minute:{displayName:"นาที",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ในอีก {0} นาที"},past:{other:"{0} นาทีที่ผ่านมา"}}},"minute-short":{displayName:"น.",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ใน {0} นาที"},past:{other:"{0} นาทีที่แล้ว"}}},second:{displayName:"วินาที",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ในอีก {0} วินาที"},past:{other:"{0} วินาทีที่ผ่านมา"}}},"second-short":{displayName:"วิ",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ใน {0} วินาที"},past:{other:"{0} วินาทีที่แล้ว"}}}}}]});


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(257);

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionProvider = (_temp = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(PermissionProvider, _React$PureComponent);

  function PermissionProvider(props, context) {
    (0, _classCallCheck3.default)(this, PermissionProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PermissionProvider.__proto__ || (0, _getPrototypeOf2.default)(PermissionProvider)).call(this, props, context));

    _this.permissions = props.permissions;
    return _this;
  }

  (0, _createClass3.default)(PermissionProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var permissions = this.permissions;


      return {
        viewable: function viewable(key) {
          return permissions[key.toLowerCase()] !== false;
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.Children.only(this.props.children);
    }
  }]);
  return PermissionProvider;
}(_react2.default.PureComponent), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    permissions: _react2.default.PropTypes.object
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    permissions: {}
  }
}), Object.defineProperty(_class, 'childContextTypes', {
  enumerable: true,
  writable: true,
  value: {
    viewable: _react2.default.PropTypes.func
  }
}), _temp);
exports.default = PermissionProvider;

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPLOY_AREA = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.getPermissions = getPermissions;

var _oversea = __webpack_require__(257);

var _oversea2 = _interopRequireDefault(_oversea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEPLOY_AREA = exports.DEPLOY_AREA = {
  OVERSEA: 'oversea'
};

var isOversea = undefined === DEPLOY_AREA.OVERSEA;
function getPermissions() {
  var result = {};

  if (isOversea) {
    result = (0, _extends3.default)({}, _oversea2.default);
  }

  return result;
}

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 海外版功能模块权限
 */

exports.default = {
  'entry.wm': true, // 外卖
  'entry.yd': true, // 预订
  'entry.hy': false, // 会员
  'entry.pd': true, // 排队
  'vip.charge': false, // 充值
  'vip.address': false, // 地址
  'order.checkout': true, // 结账
  'order.submit': false // 提交订单
};

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TopNavigator(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? '返回' : _ref$text;

  if (history.length <= 2) {
    return null;
  }

  var handleBtnTouchTap = function handleBtnTouchTap() {
    history.back();
  };

  return _react2.default.createElement('button', {
    title: text,
    className: 'top-navigator',
    onTouchTap: handleBtnTouchTap
  });
}

exports.default = TopNavigator;

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(78);
var defined = __webpack_require__(52);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TopNavigator(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? '返回' : _ref$text;

  if (history.length <= 1) {
    return null;
  }

  var handleBtnTouchTap = function handleBtnTouchTap() {
    history.back();
  };

  return _react2.default.createElement('button', {
    title: text,
    className: 'top-navigator',
    onTouchTap: handleBtnTouchTap
  });
}

exports.default = TopNavigator;

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(263);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(264);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(258);

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var toastIcon = __webpack_require__(267);

module.exports = React.createClass({
  displayName: 'Toast',
  propTypes: {
    clearErrorMsg: React.PropTypes.func.isRequired,
    errorMessage: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]).isRequired,
    tapHidden: React.PropTypes.bool,
    timeout: React.PropTypes.number,
    isShowIcon: React.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return { timeout: 1500, isShowIcon: true };
  },
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        clearErrorMsg = _props.clearErrorMsg,
        timeout = _props.timeout;

    if (timeout === -1) {
      return;
    }
    this.timeout = setTimeout(function () {
      clearErrorMsg();
    }, timeout);
  },
  componentDidMount: function componentDidMount() {
    if (this.refs && this.refs.toast) {
      this.refs.toast.focus();
    }
  },
  tapToast: function tapToast(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    var _props2 = this.props,
        tapHidden = _props2.tapHidden,
        clearErrorMsg = _props2.clearErrorMsg;


    if (tapHidden) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      clearErrorMsg();
    }
  },
  render: function render() {
    var _this = this;

    var _props3 = this.props,
        errorMessage = _props3.errorMessage,
        isShowIcon = _props3.isShowIcon;


    if ((typeof errorMessage === 'undefined' ? 'undefined' : (0, _typeof3.default)(errorMessage)) === 'object' && !React.isValidElement(errorMessage)) {
      return false;
    }

    return React.createElement(
      'div',
      { className: 'c-toast', onTouchTap: function onTouchTap(evt) {
          return _this.tapToast(evt);
        }, ref: 'toast', tabIndex: '-1' },
      React.createElement(
        'div',
        { className: 'c-toast__content' },
        isShowIcon && React.createElement('img', { src: toastIcon, style: { width: 28 }, alt: '' }),
        errorMessage
      )
    );
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/warning-white.svg";

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(167);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(169);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _commonHelper = __webpack_require__(3);

__webpack_require__(419);

var React = __webpack_require__(2);


module.exports = React.createClass({
  displayName: 'Dialog',
  propTypes: {
    theme: React.PropTypes.string,
    className: React.PropTypes.string,
    zIndexTop: React.PropTypes.bool,
    children: React.PropTypes.any,
    buttons: React.PropTypes.array,
    onClose: React.PropTypes.func,
    noPreventScrollClassNameList: React.PropTypes.array,
    needPreventScrollDefault: React.PropTypes.bool,
    closable: React.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      theme: 'default',
      closable: true
    };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        noPreventScrollClassNameList = _props.noPreventScrollClassNameList,
        needPreventScrollDefault = _props.needPreventScrollDefault;

    this.refs.modal.focus();

    if (!needPreventScrollDefault) {
      return;
    }
    this.preventScrollIntoScroll = (0, _commonHelper.preventScrollIntoScroll)('.modal', noPreventScrollClassNameList);
    this.preventScrollIntoScroll.addMethod();
  },
  componentWillUnmount: function componentWillUnmount() {
    var needPreventScrollDefault = this.props.needPreventScrollDefault;


    if (!needPreventScrollDefault) {
      return;
    }
    this.preventScrollIntoScroll.cancelMethod();
  },
  onClose: function onClose(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }

    if (this.props.onClose) {
      this.props.onClose();
    }
  },
  render: function render() {
    var _props2 = this.props,
        title = _props2.title,
        buttons = _props2.buttons,
        theme = _props2.theme,
        className = _props2.className,
        closable = _props2.closable,
        zIndexTop = _props2.zIndexTop;

    var buttonElems = (buttons || []).map(function (button, index) {
      var btnCls = button.className || 'dialog-footer-btn-default';
      return React.createElement(
        'button',
        {
          key: index,
          className: btnCls,
          onTouchTap: button.onClick
        },
        button.text
      );
    });

    var style = {
      // maxHeight: window.innerHeight - 44 - (buttonElems.length ? 49 : 0) - 40,
      maxHeight: 400
    };
    return React.createElement(
      'div',
      { className: 'modal ' + (zIndexTop && 'modal-index-top'), ref: 'modal', tabIndex: '-1' },
      React.createElement('div', { className: 'mask', onTouchTap: this.onClose }),
      React.createElement(
        'div',
        { className: 'dialog ' + theme + ' ' + (className || '') },
        React.createElement(
          'div',
          { className: 'dialog-header' },
          React.createElement(
            'p',
            { className: 'dialog-title' },
            title
          ),
          closable && React.createElement('button', { className: 'btn dialog-btn-close', onTouchTap: this.onClose })
        ),
        React.createElement(
          'div',
          { className: 'dialog-body', style: style },
          this.props.children
        ),
        React.createElement(
          'div',
          { className: 'dialog-footer' },
          buttonElems
        )
      )
    );
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(231), __esModule: true };

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _toArray2 = __webpack_require__(175);

var _toArray3 = _interopRequireDefault(_toArray2);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _httpRequestHelper = __webpack_require__(84);

var _httpRequestHelper2 = _interopRequireDefault(_httpRequestHelper);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _pageHelper = __webpack_require__(123);

var _pageHelper2 = _interopRequireDefault(_pageHelper);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

var _const = __webpack_require__(14);

var _getEmojiReg = __webpack_require__(227);

var _getEmojiReg2 = _interopRequireDefault(_getEmojiReg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var padStart = __webpack_require__(145);
var config = __webpack_require__(13);

var _require = __webpack_require__(14),
    WmPageTpl = _require.WmPageTpl,
    BookOrderStatus = _require.BookOrderStatus,
    TradePayStatus = _require.TradePayStatus,
    BookingStatus = _require.BookingStatus,
    StoreType = _require.StoreType,
    SendStoreType = _require.SendStoreType;

exports.getFetchPostParam = function (params) {
  var requestOptions = (0, _assign2.default)({}, config.requestOptions, {
    method: 'POST',
    body: (0, _stringify2.default)(params)
  });
  return requestOptions;
};

var getUrlParams = exports.getUrlParams = function () {
  var r = window.location.search.replace(/\?/, '');
  if (!r) {
    return null;
  }

  var items = r.split('&');
  if (!items.length) {
    return null;
  }

  var params = {};
  items.forEach(function (item) {
    var paramItem = item.split('=');
    if (paramItem.length < 2) {
      return;
    }

    var _paramItem = (0, _toArray3.default)(paramItem),
        key = _paramItem[0],
        value = _paramItem.slice(1);

    params[key] = value.join('=');
  });

  return params;
};

// 获取url参数
var getUrlParam = exports.getUrlParam = function (param) {
  var params = getUrlParams() || {};

  return params[param] || null;
};

// 将多个url参数组成字符串
exports.formatObjToParamStr = function (paramObj) {
  if (!paramObj) {
    return '';
  }

  return (0, _keys2.default)(paramObj).map(function (key) {
    var value = paramObj[key];
    return value == null ? null : key + '=' + value;
  }).filter(function (item) {
    return item !== null;
  }).join('&');
};

// 设置cookie
exports.setCookie = function (name, value) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';

  var Days = 30;
  var exp = new Date();

  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);

  document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';path=' + path;
};

// 获取cookie
var getCookie = exports.getCookie = function (name) {
  var con = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));

  return con != null ? decodeURI(unescape(con[2], 'utf-8')) : null;
};

// 删除cookie
exports.delCookie = function (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var nameT = getCookie(name);

  if (nameT != null) {
    document.cookie = name + '=' + nameT + ';expires=' + exp.toGMTString() + ';path=/';
  }
};

// 删除指定域下面的指定cookie
exports.delAppointDomainCookie = function (cookieObj) {
  var name = cookieObj.name,
      value = cookieObj.value,
      path = cookieObj.path,
      domain = cookieObj.domain;

  var exp = new Date();
  exp.setTime(exp.getTime() - 1);

  if (name != null) {
    document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';path=' + path + ';domain=' + domain;
  }
};

// 校验手机号
exports.phoneNumber = function (phone) {
  /* const rule = /(^1([358][0-9]{9})|^1([7][3678][0-9]{8})|^1([4][57][0-9]{8})|(^09[0-9]{8}))$/; */
  var rule = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$/; // 大陆 + 港澳
  return rule.test(phone);
};

exports.replaceEmojiWith = function (value, str) {
  if (!value || typeof value !== 'string') {
    return value;
  }

  var rule = new RegExp(_getEmojiReg2.default, 'g');
  return value.replace(rule, str || '');
};

// 校验emoji表情
exports.checkEmojiWith = function (value) {
  if (!value || typeof value !== 'string') {
    return value;
  }
  var rule = new RegExp(_getEmojiReg2.default);
  return !rule.test(value);
};

// 去掉非法字符
exports.replaceInvalidSymbol = function (value, str) {
  if (!value || typeof value !== 'string') {
    return value;
  }
  return value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g, str || '');
};

// 校验非法字符只包含中文、英文、数字
exports.checkInvalidSymbol = function (value) {
  if (!value || typeof value !== 'string') {
    return value;
  }
  var rule = /^[a-zA-Z0-9\u4E00-\u9FA5]+$/;
  return rule.test(value);
};

var isWechatMiniProgramBrowser = exports.isWechatMiniProgramBrowser = function () {
  var ua = navigator.userAgent.toLowerCase();
  return (/micromessenger/i.test(ua) && /miniProgram/i.test(ua)
  );
};

var getWeixinVersionInfo = exports.getWeixinVersionInfo = function () {
  var result = {
    weixin: false,
    version: 0
  };
  if (isWechatMiniProgramBrowser()) {
    return result;
  }
  var match = /micromessenger\/([\d.]+)/i.exec(navigator.userAgent);
  if (match) {
    result.weixin = true;
    result.version = match[1];
  }
  return result;
};

exports.getOSVersionInfo = function () {
  var result = {
    os: '',
    version: 0,
    versionString: ''
  };

  var userAgent = navigator.userAgent;
  var items = [{ descript: 'android', reg: /(android) (\d+(?:\.\d+)*)/i }, { descript: 'ios', reg: /(iPhone) OS (\d+(?:_\d+)*)/i }];

  items.forEach(function (item) {
    var reg = item.reg;

    var match = reg.exec(userAgent);
    if (!match) {
      return;
    }

    var _match = (0, _slicedToArray3.default)(match, 3),
        os = _match[1],
        versionSource = _match[2];

    var versionString = versionSource.replace(/\D/g, '.');

    (0, _assign2.default)(result, {
      os: os.toLowerCase(),
      versionString: versionString,
      version: parseFloat(versionString, 10)
    });
  });

  return result;
};

var isAlipayBrowser = exports.isAlipayBrowser = function () {
  var ua = navigator.userAgent.toLowerCase();
  return (/AliApp|AlipayDefined|AlipayClient/i.test(ua) && !/DingTalk/i.test(ua)
  );
};

var isDingTalkBrowser = exports.isDingTalkBrowser = function () {
  var ua = navigator.userAgent.toLowerCase();
  return (/DingTalk/i.test(ua)
  );
};
// 判断支付宝小程序
exports.isAlipayMiniProgramBrowser = function () {
  // return isAlipayBrowser();
  var ua = navigator.userAgent.toLowerCase();
  return isAlipayBrowser() && /miniProgram/i.test(ua);
};

exports.interValSetting = function (num, timerEnd) {
  var cnum = num;
  var timer = setInterval(function () {
    cnum = cnum - 1;
    if (cnum === 0) {
      timerEnd();
      clearInterval(timer);
    }
    sessionStorage.setItem('callBellTime', cnum > 0 ? cnum : '');
  }, 1000);
};

/* 日期 */
exports.dateUtility = {
  format: function format(date) {
    var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';

    if (!date) {
      return date;
    }

    if (typeof date === 'string') {
      date = this.parse(date);
    }
    if (!(date instanceof Date)) {
      return date;
    }

    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var result = formatStr.replace(/yyyy/, year.toString()).replace(/(M+)/, function (str, $1) {
      return padStart(month.toString(), $1.length, '0');
    }).replace(/(d+)/, function (str, $1) {
      return padStart(date.getDate().toString(), $1.length, '0');
    }).replace(/(H+)/, function (str, $1) {
      return padStart(hours.toString(), $1.length, '0');
    }).replace(/(m+)/, function (str, $1) {
      return padStart(minutes.toString(), $1.length, '0');
    }).replace(/(s+)/, function (str, $1) {
      return padStart(seconds.toString(), $1.length, '0');
    });
    return result;
  },
  parse: function parse(str) {
    if (!str || typeof str !== 'string') {
      return str;
    }

    var _str$split = str.split(/\s+/),
        _str$split2 = (0, _slicedToArray3.default)(_str$split, 2),
        datePart = _str$split2[0],
        _str$split2$ = _str$split2[1],
        timePart = _str$split2$ === undefined ? '00:00:00' : _str$split2$;

    var _datePart$split = datePart.split(/\D+/),
        _datePart$split2 = (0, _slicedToArray3.default)(_datePart$split, 3),
        year = _datePart$split2[0],
        _datePart$split2$ = _datePart$split2[1],
        month = _datePart$split2$ === undefined ? 1 : _datePart$split2$,
        _datePart$split2$2 = _datePart$split2[2],
        day = _datePart$split2$2 === undefined ? 1 : _datePart$split2$2;

    if (!year) {
      return null;
    }

    var _timePart$split = timePart.split(/\D+/),
        _timePart$split2 = (0, _slicedToArray3.default)(_timePart$split, 3),
        _timePart$split2$ = _timePart$split2[0],
        hours = _timePart$split2$ === undefined ? 0 : _timePart$split2$,
        _timePart$split2$2 = _timePart$split2[1],
        minutes = _timePart$split2$2 === undefined ? 0 : _timePart$split2$2,
        _timePart$split2$3 = _timePart$split2[2],
        seconds = _timePart$split2$3 === undefined ? 0 : _timePart$split2$3;

    var result = new Date(year, month - 1, day, hours, minutes, seconds);
    return isNaN(+result) ? null : result;
  }
};

var formatPrice = exports.formatPrice = function (price) {
  if (!price) {
    return 0;
  }

  if (price.toString().indexOf('.') < 0) {
    return price;
  }

  if (price.toString().split('.')[1].length > 2) {
    return parseFloat(Number(price).toFixed(2));
  }

  return price;
};

// 判断时间是否满一天
exports.renderTime = function (startTime, endTime) {
  if (!startTime || !endTime) {
    return '';
  }
  var formatStartTime = startTime.substring(0, 5);
  var formatEndTime = endTime.substring(0, 5);
  var period = Number(formatEndTime.substring(0, 2) * 60) + Number(formatEndTime.substring(3, 5)) - (Number(formatStartTime.substring(0, 2) * 60) + Number(formatStartTime.substring(3, 5))) + 1;

  if (period / 60 < 24) {
    return formatStartTime + '-' + formatEndTime + '\uFF0C';
  }

  return '';
};

// 优惠券可用day展示
exports.renderDay = function (week) {
  if (!week) return false;

  var regDay = /1{1,}/g; // 匹配一个1或多个1
  var periDay = '';
  var strDay = '';
  var dayIndex = '';
  var days = '';
  // 数据重组
  var str1 = week.substring(0, 1);
  var str2 = week.substr(1, 6);
  var weekFormat = str2 + str1;

  var formatDay = function formatDay(day) {
    switch (day) {
      case 1:
        return (0, _helper.formatMessage)(_global2.default.monday);
      case 2:
        return (0, _helper.formatMessage)(_global2.default.tuesday);
      case 3:
        return (0, _helper.formatMessage)(_global2.default.wednesday);
      case 4:
        return (0, _helper.formatMessage)(_global2.default.thursday);
      case 5:
        return (0, _helper.formatMessage)(_global2.default.friday);
      case 6:
        return (0, _helper.formatMessage)(_global2.default.saturday);
      case 7:
        return (0, _helper.formatMessage)(_global2.default.sunday);
      default:
        return '';
    }
  };

  if (weekFormat === '1111111') {
    return '';
  }

  while (periDay != null) {
    periDay = regDay.exec(weekFormat);
    if (periDay) {
      dayIndex = periDay.index;
      days = periDay[0];

      if (days.length > 1) {
        strDay += '' + formatDay(dayIndex + 1) + (0, _helper.formatMessage)(_global2.default.to) + formatDay(dayIndex + days.length) + '\uFF0C';
      } else {
        strDay += formatDay(dayIndex + 1) + '\uFF0C';
      }
    }
  }

  if (strDay.indexOf('周一到周五') !== -1) {
    return strDay.replace(/周一到周五/g, '工作日');
  }

  if (strDay === '' + (0, _helper.formatMessage)(_global2.default.saturday) + (0, _helper.formatMessage)(_global2.default.to) + (0, _helper.formatMessage)(_global2.default.sunday) + '\uFF0C') {
    return (0, _helper.formatMessage)(_global2.default.weekend) + '\uFF0C';
  }

  return strDay;
};

// 获取用户昵称
exports.getUserName = function (userInfo) {
  return userInfo.name;
};

// 获取用户头像
exports.getUserAvatar = function (userInfo) {
  return userInfo.iconUri;
};

// 保留两位小数的jsPriceCalc (折扣)
exports.jsPriceCalc = function (totalPrice, discount) {
  var value = Number((totalPrice * (1 - discount)).toFixed(3));

  return parseFloat(value.toFixed(2));
};

// 获取当前JS所包含的hash值
exports.getWebpackHashFromScriptUrl = function () {
  var file = (document.currentScript || {}).src || '';
  var substr = file.match(/dist-(\S*)\//);
  var length = 0;

  if (substr && substr[1]) {
    length = substr[1].length + file.indexOf(substr[1]);
    return file.substring(0, length);
  }

  return '';
};

// 验证手机号 新增加199 198 166类型
exports.getPhoneNumberValidate = function () {
  var phoneReg = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$/; // 大陆 + 港澳
  return phoneReg;
};

/**
 * 拼接Url以及参数
 * @param {*} url
 * @param {*} param
 */
var combinationUrl = exports.combinationUrl = function (url, param) {
  if (!param) {
    return url;
  }

  var paramInit = (0, _keys2.default)(param).reduce(function (paramStr, paramItemName) {
    return paramStr + '&' + paramItemName + '=' + param[paramItemName];
  }, '');

  var paramAllStr = paramInit.substring(1);

  return url + '?' + paramAllStr;
};

/**
 * 存储cook以及过期时间
 */
var setCook = function setCook(obj) {
  var day = obj.day,
      name = obj.name,
      value = obj.value,
      type = obj.type;

  var exp = new Date();
  exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000); // 过期时间
  document.cookie = name + '=' + value + ',type=' + type + ';expires=' + exp.toGMTString() + ';path=/';
};

/**
 * 存储cookie不同的类型，针对堂食点餐页和外卖点餐页
 * @params {*} obj
 */
exports.setCookieTime = function (obj) {
  var couponType = obj.couponType,
      type = obj.type,
      shopId = obj.shopId;

  var name_ = '';
  if (couponType === 'dishWM') {
    if (type === 'TS') {
      name_ = 'shopId_WM-TS';
    } else if (type === 'WM') {
      name_ = 'shopId_WM';
    }
  } else if (couponType === 'dishTS') {
    name_ = 'shopId_TS';
  }

  setCook({
    day: 0.003,
    name: name_,
    value: shopId,
    type: type
  });
};
/* 链接百度地图导航地址
 * @param {当前位置坐标} curPosition
 * @param {目的地坐标} desPosition
 */
exports.getBaiduAPI = function (curPosition, desPosition) {
  if (!curPosition) {
    // 没有开启定位的情况
    return;
  }

  if (curPosition.latlng === 'undefined,undefined') {
    return;
  }

  var destination_ = null;

  if (desPosition.latlng !== ',' && desPosition.commercialAdress) {
    destination_ = 'latlng:' + desPosition.latlng + '|name:' + desPosition.commercialAdress;
  } else if (desPosition.latlng === ',' && desPosition.commercialAdress) {
    destination_ = desPosition.commercialAdress;
  }
  // 定位到当前位置的情况
  var baiduWeb = combinationUrl('http://api.map.baidu.com/direction', {
    origin: 'latlng:' + curPosition.latlng + '|name:\u5F53\u524D\u4F4D\u7F6E',
    destination: destination_,
    mode: 'driving',
    output: 'html',
    origin_region: curPosition.city,
    destination_region: desPosition.city,
    src: 'yourCompanyName|yourAppName'
  });
  location.href = baiduWeb + '?vt=map';
};

/**
 * getOrderStatus
 * @param { status }
 */
exports.getOrderStatus = function (status) {
  var orderStatus = ['已完成', '已确认', '待配送', '正在配送', '配送完成', '已清账', '配送中', '美团外卖', '饿了么', '海底捞App', '已取餐'];

  return orderStatus.includes(status);
};

/* 改变url 参数 */
exports.changeUrlParam = function (url, name, value) {
  var newUrl = '';
  var reg = new RegExp('(^|)' + name + '=([^&]*)(|$)');
  var tmp = name + '=' + value;
  if (url.match(reg) != null) {
    newUrl = url.replace(reg, tmp);
  } else {
    if (url.match('[?]')) {
      newUrl = url + '&' + tmp;
    } else {
      newUrl = url + '?' + tmp;
    }
  }
  return newUrl;
};

/* 广告组广告引入 */
exports.includeAdGroupAdsJS = function (callback) {
  var time = new Date().getTime();
  var scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = config.env === 'production' ? 'https://' + config.getAdGroupAdsJsUrl + '?v=' + time : config.apiAdsgroup + '/static/adWebSdk.min.js?v=' + time;
  var x = document.getElementsByTagName('head')[0];
  x.appendChild(scriptEle);

  scriptEle.onload = function () {
    // 回调
    callback();
  };
};

/* 引入支付宝JSAPI */
exports.includeAlipayJSApi = function (callback) {
  var scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = 'https://a.alipayobjects.com/g/h5-lib/alipayjsapi/3.0.2/alipayjsapi.min.js';
  var x = document.getElementsByTagName('head')[0];
  x.appendChild(scriptEle);

  scriptEle.onload = function () {
    // 回调
    callback();
  };
};

/**
 * 缓存参数设置
 */
exports.setParamToSession = function (param) {
  var sessionParam = getUrlParam(param);

  if (!sessionParam || sessionStorage.getItem(param)) {
    return;
  }

  sessionStorage.setItem(param, sessionParam);
};

/**
 * 获取指定缓存参数
 */
exports.getParamFromSession = function (param) {
  return sessionStorage.getItem(param);
};

/* 判断门店是否可用 */
exports.getCommericalInfo = function (setErrorMsg, callback) {
  var shopId = getUrlParam('shopId');
  return _fetchHelper2.default.get('' + config.getCommericalInfoAPI, { shopId: shopId }).then(function (res) {
    if (res) {
      callback({ enableOnlineCharge: res.enableOnlineCharge, enablePortalStore: res.enablePortalStore });
    }
  }).catch(function () {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    setErrorMsg(err.msg || (0, _helper.formatMessage)(_errorMessage2.default.requestAPIFail));
    console.log(err);
  });
};

/** 计算保留两位小数
 * @param num 传入值
 * @description 使用toFixed(2) 无法四舍五入 75.975这个数字
 */
var fomatFloat = exports.fomatFloat = function (num) {
  if (isNaN(num)) return;
  if (Math.floor(num) === num) {
    return num;
  }

  var _num$toString$split = num.toString().split('.'),
      _num$toString$split2 = (0, _slicedToArray3.default)(_num$toString$split, 2),
      intNum = _num$toString$split2[0],
      dec = _num$toString$split2[1];

  if (dec.length <= 2) {
    return num;
  }

  var _dec$split = dec.split(''),
      _dec$split2 = (0, _slicedToArray3.default)(_dec$split, 3),
      fir = _dec$split2[0],
      sec = _dec$split2[1],
      thi = _dec$split2[2];

  if (thi > 4) {
    sec = Number(sec) + 1;
  }
  if (sec >= 10) {
    sec = 0;
    fir = Number(fir) + 1;
  }
  if (fir >= 10) {
    fir = 0;
    intNum = Number(intNum) + 1;
  }
  var val = intNum + '.' + fir + sec;
  return Number(val);
};

/* 计算储值+赠送金额 */
exports.getTotalRestorePrice = function (storeItem, ruleInfo) {
  var fullValue = storeItem.fullValue,
      storeType = storeItem.storeType,
      sendValue = storeItem.sendValue,
      rate = storeItem.rate;
  var isFullSend = ruleInfo.isFullSend,
      sendType = ruleInfo.sendType;

  var storePriceTotal = fullValue;

  switch (storeType) {
    case StoreType.SMALLSTORE:
      {
        // 小额储值
        // storePriceTotal = Math.ceil(orderPrice * (sendValue * 0.01 + 1));
        storePriceTotal = sendValue + fullValue;
        break;
      }
    default:
      {
        // 正常储值
        // 是否有优惠
        if (isFullSend === 0) {
          if (sendType === SendStoreType.SENDFIXVALUE) {
            // 赠送固定金额
            storePriceTotal = sendValue + fullValue;
          } else if (sendType === SendStoreType.SENDPERCENTVALUE) {
            // 赠送百分比
            storePriceTotal = fullValue + rate * fullValue / 100;
          }
        }
        break;
      }
  }

  // 四舍五入 保留两位小数
  storePriceTotal = Number(fomatFloat(storePriceTotal));
  return storePriceTotal;
};

/**
 * 根据nationTelCode选择手机号校验规则
 */
exports.getCurrentPhoneReg = function (nationTelCode) {
  var countryList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var currentReg = countryList.filter(function (item) {
    return item.areaCode === nationTelCode;
  })[0];
  return (0, _extends3.default)({}, currentReg, { areaCode: nationTelCode, isAllowSendCode: true });
};

/* 获取推荐菜品 */
exports.getRecommendDish = function (businessType, scene) {
  var shopId = getUrlParam('shopId');
  return _fetchHelper2.default.post(config.recommendDishAPI + '?shopId=' + shopId, { shopId: shopId, businessType: businessType, scene: scene }).then(function () {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var dishList = res.dishList || [];
    return dishList;
  }).catch(function () {
    return [];
  });
};

/**
 * 判定session取出来的数据，是否需要parse
 */
exports.sessionParseData = function (value) {
  if (!value) {
    return;
  }
  var parseValue = JSON.parse(value);

  if (!value) {
    return;
  }

  if ((typeof parseValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(parseValue)) === 'object') {
    return parseValue;
  }

  return value;
};

/* 连接菜品和猜你喜欢 */
exports.concatGoodsDetailWithRecommendList = function (recommendDishList, dishesDataDuplicate, includeStatus) {
  var dishesDataDuplicateNew = [];
  var recommendDishListNew = Array.prototype.slice.call(recommendDishList);
  if (!includeStatus) {
    recommendDishList.forEach(function (item) {
      var findObj = dishesDataDuplicate.find(function (itemt) {
        return itemt.id === item.id;
      });
      if (findObj) {
        dishesDataDuplicateNew.push((0, _assign2.default)({}, item, { order: findObj.order }));
      } else {
        dishesDataDuplicateNew.push(item);
      }
    });
  } else {
    dishesDataDuplicate.forEach(function (item) {
      var findObj = recommendDishListNew.find(function (itemt) {
        return itemt.id === item.id;
      });
      if (findObj) {
        var pos = recommendDishListNew.indexOf(findObj);
        recommendDishListNew.splice(pos, 1);
      }
    });

    dishesDataDuplicateNew = dishesDataDuplicate.concat(recommendDishListNew);
  }
  return dishesDataDuplicateNew;
};

/**
 * getTransferConfig 获取零售跳转链接后缀配置
 */
var getTransferConfig = exports.getTransferConfig = function (shopId) {
  _httpRequestHelper2.default.get(config.getQryCommercialConfig, { shopId: shopId }).then(function (result) {
    if (!result || !result.data) {
      return;
    }

    if (result.data.showScan) {
      _httpRequestHelper2.default.goto(config.commodityfeLinkURL(shopId) + 'scanShopping');
      return;
    }

    _httpRequestHelper2.default.goto(config.commodityfeLinkURL(shopId));
  });
};

/**
 * getTransferURL 获取跳转链接
 */
exports.getTransferURL = function (param) {
  var shopId = param.shopId,
      rest = (0, _objectWithoutProperties3.default)(param, ['shopId']);

  var params = (0, _extends3.default)({ shopId: shopId, type: 'WM' }, rest);

  _httpRequestHelper2.default.get(config.getRetailAPI, { shopId: shopId }).then(function (res) {
    if (!res || !res.data) {
      return;
    }

    if (res.data.wmPageTpl === WmPageTpl.XLS) {
      getTransferConfig(shopId, params);
      return;
    }

    _httpRequestHelper2.default.goto(config.dishMenu4RealtakeoutURL, params);
  });
};

/* 限制输入input textarea */
exports.limitInputAndTextareaMethod = function (str) {
  var reg = /[^\u4e00-\u9fa5_a-zA-Z0-9^%&',，。;=?$\x22\s\t\n\r]+/g;
  // const regBlank = /\s+/g;
  if (reg.test(str)) {
    return str.replace(reg, '');
  }
  return str;
};

/* 临时方法： 修复cityList数据 */
exports.formatCitylist = function (cityList) {
  cityList.forEach(function (item) {
    if (item.name === '长沙') {
      item.pinyin = 'ChangSha';
    }
  });

  return cityList;
};

// 获取用户id
exports.getCustomerId = function () {
  var shopId = getUrlParam('shopId');
  var customerIdKey = 'customerId';
  var customerId = sessionStorage.getItem(customerIdKey);

  if (customerId) return customerId;

  _httpRequestHelper2.default.get(config.getServiceStatusNoTableAPI + '?shopId=' + shopId, {}).then(function (res) {
    if (res.code === '200' && res.data.memberVO) {
      sessionStorage.setItem(customerIdKey, res.data.memberVO.customerId);
    }
  });

  return null;
};

/**
 * 获取用户id new
 * 目前大数点埋点
 * 防止高频触发，加一个flag，标识一下。
 */
exports.getCustomerIdNew = function () {
  var shopId = getUrlParam('shopId');
  var customerIdKey = 'customerId';
  var customerId = sessionStorage.getItem(customerIdKey);
  var alreadyInvokeAndError = sessionStorage.getItem('alreadyInvokeCustomerIdAndError');
  if (!shopId) return _promise2.default.resolve(null);
  if (customerId) return _promise2.default.resolve(customerId);
  if (alreadyInvokeAndError === 'true') return _promise2.default.resolve(null);
  return _httpRequestHelper2.default.get(config.individualAPI + '?shopId=' + shopId, {}).then(function (res) {
    if (res && res.code === '200' && res.data && res.data.customerId) {
      sessionStorage.setItem(customerIdKey, res.data.customerId);
      return res.data.customerId;
    }
    sessionStorage.setItem('alreadyInvokeCustomerIdAndError', 'true');
    return null;
  });
};

// 阻止页面的双重滚动
exports.preventScrollIntoScroll = function (holder, noPreventScrollClassNameList) {
  var startY = 0;
  var noPreventMoveFunc = function noPreventMoveFunc(item) {
    event.stopPropagation(); // 阻止冒泡
    var shouldPrevent = true;
    if (item.scrollHeight > item.offsetHeight) {
      var endY = event.changedTouches[0].pageY;
      var distanceY = endY - startY;
      var scrollTop = item.scrollTop;
      var scrollHeight = item.scrollHeight;
      var offsetHeight = item.offsetHeight;
      if (scrollTop === 0 && distanceY < 0 || scrollTop + offsetHeight === item.scrollHeight && distanceY > 0 || scrollTop > 0 && scrollTop + offsetHeight < scrollHeight) {
        shouldPrevent = false;
      }
    }
    if (!shouldPrevent) {
      return;
    }
    event.preventDefault();
  };

  var noPreventStartFunc = function noPreventStartFunc() {
    startY = event.changedTouches[0].pageY;
  };

  var holderMoveFunc = function holderMoveFunc() {
    event.preventDefault();
  };

  var addnoPreventScrollClassNameListMethod = function addnoPreventScrollClassNameListMethod() {
    noPreventScrollClassNameList.forEach(function (item) {
      [].slice.call(document.querySelectorAll(holder + ' ' + item)).forEach(function (itemt, indext) {
        itemt.addEventListener('touchmove', function (event) {
          return noPreventMoveFunc(itemt);
        }, false);
        itemt.addEventListener('touchstart', noPreventStartFunc, false);
      });
    });
  };

  var cancelnoPreventScrollClassNameListMethod = function cancelnoPreventScrollClassNameListMethod() {
    noPreventScrollClassNameList.forEach(function (item) {
      [].slice.call(document.querySelectorAll(holder + ' ' + item)).forEach(function (itemt, indext) {
        itemt.removeEventListener('touchmove', function (event) {
          return noPreventMoveFunc(itemt);
        }, false);
        itemt.removeEventListener('touchstart', noPreventStartFunc, false);
      });
    });
  };

  var addMethod = function addMethod() {
    document.querySelector(holder).addEventListener('touchmove', holderMoveFunc, false);
    cancelnoPreventScrollClassNameListMethod();
    addnoPreventScrollClassNameListMethod();
  };

  var cancelMethod = function cancelMethod() {
    document.querySelector(holder).removeEventListener('touchmove', holderMoveFunc, false);
    cancelnoPreventScrollClassNameListMethod();
  };

  return { addMethod: addMethod, cancelMethod: cancelMethod };
};

// 去支付页面
exports.gotoPayUrl = function (params) {
  var brandId = sessionStorage.getItem('currentBrandId');
  var mid = getCookie('mid_' + brandId);
  if (mid) {
    params.mid = mid;
  }

  _pageHelper2.default.navigateTo(config.payDetailURL, params);
};

/**
 * validateForeignAreaCode 校验外国区号
 * @param {*} areaCode
 */
exports.validateForeignAreaCode = function (areaCode) {
  if (!areaCode) {
    return;
  }

  return String(areaCode) === '86' ? '' : '+' + areaCode + ' ';
};

/**
 * 整合bookStatus返回的方法
 */
exports.getTranslateBookStatus = function (bookStatus, orderTime, tradePayStatus) {
  var currentTime = new Date().getTime();
  var translateBookStatus = '';

  switch (bookStatus) {
    case BookOrderStatus.TIMEOUT:
      {
        if (orderTime < currentTime) {
          translateBookStatus = BookingStatus.BOOKNOTARRIVAL;
          break;
        }
        translateBookStatus = BookingStatus.BOOKSUCCESS;
        break;
      }
    case BookOrderStatus.REFUSE:
      {
        translateBookStatus = BookingStatus.BOOKREFUSED;
        break;
      }
    case BookOrderStatus.NOTDEAL:
      {
        if (tradePayStatus === TradePayStatus.NOTPAY) {
          translateBookStatus = BookingStatus.BOOKUNPAID;
          break;
        }

        translateBookStatus = BookingStatus.BOOKCONFIRMING;
        break;
      }
    case BookOrderStatus.USERNOTARRIVAL:
      {
        if (orderTime < currentTime) {
          translateBookStatus = BookingStatus.BOOKNOTARRIVAL;
          break;
        }

        translateBookStatus = BookingStatus.BOOKSUCCESS;
        break;
      }
    case BookOrderStatus.USERLEAVESHOP:
      {
        translateBookStatus = BookingStatus.BOOKSUCCESS;
        break;
      }
    case BookOrderStatus.CANCEL:
      {
        translateBookStatus = BookingStatus.BOOKCANCEL;
        break;
      }
    case BookOrderStatus.USERARRIVAL:
      {
        translateBookStatus = BookingStatus.BOOKARRIVED;
        break;
      }
    case BookOrderStatus.ASSURE:
      {
        translateBookStatus = BookingStatus.BOOKSURE;
        break;
      }

    default:
      break;
  }

  return translateBookStatus;
};

/* 临时修改：根据情况判断一些特殊的 none null undefined 类型的字符串 */
exports.filterNoneString = function (type, str) {
  if (!str) {
    return null;
  }
  var reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
  switch (type) {
    case 'url':
      {
        // url网址
        if (!reg.test(str)) {
          return null;
        }
        return str;
      }
    case 'word':
      {
        // 文字
        var strTolowerCase = str.toLowerCase();
        if (strTolowerCase === 'none' || strTolowerCase === 'undefined' || strTolowerCase === 'null') {
          return null;
        }
        return str;
      }
    default:
      return str;
  }
};

exports.getRunEnv = function () {
  var isWeixin = getWeixinVersionInfo().weixin;

  if (isWeixin) return _const.runEnv.WEIXIN;

  var isWeixinMini = isWechatMiniProgramBrowser();

  if (isWeixinMini) return _const.runEnv.WEIXINMINI;

  var isAlipay = isAlipayBrowser();

  if (isAlipay) return _const.runEnv.ALI;

  return _const.runEnv.GENERAL;
};

// 判断是否是正餐，包括先付和后付
exports.isFormalMeal = function (form) {
  return form === 0 || form === 2;
};

/**
 * 获取登录用户信息
 * 如果返回false 表示未登录
 */
exports.getLoginUserInfo = function () {
  return _fetchHelper2.default.get('' + config.individualAPI, null, { enableDefaultResponseResolve: false }).then(function () {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _res$data = res.data,
        data = _res$data === undefined ? {} : _res$data;
    var code = data.code,
        _data$msg = data.msg,
        msg = _data$msg === undefined ? '' : _data$msg,
        info = data.data;

    if (code === 'NOT_LOGIN') {
      return false;
    } else if (Number(code) !== 200) {
      throw msg || '系统异常';
    } else {
      return info;
    }
  }).catch(function (ex) {
    throw ex;
  });
};

// 计算菜品价格 - 订单详情页使用
exports.calcMarketPrice = function () {
  var mainDish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var totalPrice = 0;
  var groupDishNum = mainDish.num;
  var isGroupDish = mainDish.type === 1;
  var singleDish = function singleDish() {
    var dish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var num = arguments[1];
    var subDish = arguments[2];

    var marketPrice = 0;
    var marketPriceExtraIngredient = 0;
    var marketPriceExtraPropertyType = 0;
    marketPrice += dish.marketPrice;
    var isWeightMode = dish.saleType === 1; // 称重模式
    if (dish.propertyTypeList && dish.propertyTypeList.length !== 0) {
      dish.propertyTypeList.forEach(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments[1];

        if (item.properties && item.properties.length !== 0) {
          item.properties.forEach(function (itemt, indext) {
            if (itemt.reprice) {
              if (isGroupDish) {
                // marketPriceExtraPropertyType += itemt.reprice * num * groupDishNum;
                marketPriceExtraPropertyType += itemt.reprice * (isWeightMode ? 1 : num) * groupDishNum;
              } else {
                // marketPriceExtraPropertyType += itemt.reprice * num;
                marketPriceExtraPropertyType += itemt.reprice * (isWeightMode ? 1 : num);
              }
            }
          });
        }
      });
    }
    if (dish.dishIngredientInfos && dish.dishIngredientInfos.length !== 0) {
      dish.dishIngredientInfos.forEach(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments[1];

        if (item.reprice) {
          // 修改配料有可能需要传分数
          if (isGroupDish) {
            marketPriceExtraIngredient += item.reprice * (item.num || 1) * (dish.saleType !== 1 ? num * groupDishNum : 1);
          } else {
            marketPriceExtraIngredient += item.reprice * (item.num || 1) * (dish.saleType !== 1 ? num : 1);
          }
        }
      });
    }
    if (isGroupDish && subDish) {
      marketPrice = marketPrice * num * groupDishNum;
    } else {
      marketPrice = marketPrice * num;
    }
    return Math.max(marketPrice + marketPriceExtraIngredient + marketPriceExtraPropertyType, 0);
  };

  // 但菜品价格计算
  totalPrice += singleDish(mainDish, mainDish.num, false);
  // 多菜品价格计算
  if (mainDish.subDishItems && mainDish.subDishItems.length !== 0) {
    mainDish.subDishItems.forEach(function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments[1];

      if (item.subDishVO && item.subDishVO.length !== 0) {
        item.subDishVO.forEach(function () {
          var itemt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var indext = arguments[1];

          totalPrice += singleDish(itemt, itemt.num, true);
        });
      }
    });
  }

  return formatPrice(totalPrice);
};

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(233);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(237);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(44);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(52);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 34:
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(159), __esModule: true };

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(83);
var enumBugKeys = __webpack_require__(59);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 38:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(154)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(85)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

exports.createStoragePairsMgr = createStoragePairsMgr;
exports.createSessionStoragePairsMgr = createSessionStoragePairsMgr;
exports.createLocalStoragePairsMgr = createLocalStoragePairsMgr;
exports.createShareCouponMgr = createShareCouponMgr;
exports.createReceivedCouponMgr = createReceivedCouponMgr;
exports.createLastOrderedDishesMgr = createLastOrderedDishesMgr;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * create storage key-value pairs manager object
 */
function createStoragePairsMgr(storage, _ref) {
  var key = _ref.key;

  return {
    key: key,

    clear: function clear() {
      storage.removeItem(this.key);
    },
    getOnce: function getOnce() {
      this.clear();

      return this.value;
    },
    get: function get() {
      var jsonStr = storage.getItem(this.key);
      if (!jsonStr) {
        return null;
      }

      return JSON.parse(jsonStr) || null;
    },
    set: function set(obj) {
      storage.setItem(this.key, (0, _stringify2.default)(obj));
    }
  };
}

function createSessionStoragePairsMgr(_ref2) {
  var key = _ref2.key;

  return createStoragePairsMgr(window.sessionStorage, { key: key });
}

function createLocalStoragePairsMgr(_ref3) {
  var key = _ref3.key;

  return createStoragePairsMgr(window.localStorage, { key: key });
}

/**
 * createShareCouponMgr
 */
function createShareCouponMgr() {
  return createLocalStoragePairsMgr({ key: 'shareCoupon' });
}

/**
 * createReceivedCouponMgr
 */
function createReceivedCouponMgr() {
  return createLocalStoragePairsMgr({ key: 'receivedCoupon' });
}

function createLastOrderedDishesMgr() {
  var mgr = createLocalStoragePairsMgr({ key: 'lastOrderedDishes' });

  return {
    get: function get(_ref4) {
      var shopId = _ref4.shopId,
          type = _ref4.type;

      var value = mgr.get();
      if (!value) {
        return null;
      }

      var dishes = value.dishes,
          storedShopId = value.shopId,
          storedType = value.type,
          expires = value.expires;

      if (shopId === storedShopId && type === storedType && expires >= Date.now() && dishes && dishes.length) {
        return dishes;
      }

      mgr.clear();
      return null;
    },
    set: function set(lastOrderedDishes, _ref5) {
      var type = _ref5.type,
          shopId = _ref5.shopId,
          _ref5$shopName = _ref5.shopName,
          shopName = _ref5$shopName === undefined ? '' : _ref5$shopName;

      mgr.set({
        dishes: lastOrderedDishes,
        shopId: shopId,
        type: type,
        shopName: shopName,
        expires: Date.now() + 24 * 60 * 60 * 1000
      });
    },
    clear: function clear() {
      mgr.clear();
    }
  };
}

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  confirm: {
    id: 'button.confirm',
    defaultMessage: '确认'
  },
  sure: {
    id: 'button.sure',
    defaultMessage: '确定'
  },
  cancel: {
    id: 'button.cancel',
    defaultMessage: '取消'
  },
  submit: {
    id: 'button.submit',
    defaultMessage: '提交'
  },
  iknown: {
    id: 'button.iknown',
    defaultMessage: '我知道了'
  },
  receiveWelfare: {
    id: 'button.receiveWelfare',
    defaultMessage: '领取福利'
  },
  known: {
    id: 'button.known',
    defaultMessage: '知道了'
  },
  close: {
    id: 'button.close',
    defaultMessage: '关闭'
  },
  finish: {
    id: 'button.finish',
    defaultMessage: '完成'
  },
  buyNow: {
    id: 'button.buyNow',
    defaultMessage: '去购买'
  }
});

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _fetch = __webpack_require__(144);

var _fetch2 = _interopRequireDefault(_fetch);

var _qs = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 将多个url参数组成字符串
function formatObjToParamStr(paramObj) {
  if (!paramObj) {
    return '';
  }

  return (0, _keys2.default)(paramObj).map(function (key) {
    var value = paramObj[key];
    return value == null ? null : key + '=' + value;
  }).filter(function (item) {
    return item !== null;
  }).join('&');
}

function getRequestUrl(url, params) {
  var requestUrl = url;
  var paramStr = formatObjToParamStr(params);

  if (paramStr) {
    var separator = requestUrl.indexOf('?') === -1 ? '?' : '&';
    requestUrl += '' + separator + paramStr;
  }

  return requestUrl;
}

function getQueryByName(name) {
  var queryString = window.location.search.split('?')[1] || '';
  var query = (0, _qs.parse)(queryString);
  return query[name] || '';
}

function post(url, queries, config) {
  var shopId = getQueryByName('shopId');
  if (shopId === '') {
    throw new Error('shop id is a will pass parameters');
  }
  var newUrl = /shopId=/.test(url) ? url : url + '?' + (0, _qs.stringify)({ shopId: shopId }); // url中含有shopId则不需要加上shopId了
  return _fetch2.default.post(newUrl, queries, config);
}

function get() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var queries = arguments[1];
  var config = arguments[2];

  var newQueries = queries || {};
  var shopId = getQueryByName('shopId') || '';
  var hasUrlShopId = /shopId=/.test(url);
  if (!newQueries.hasOwnProperty('shopId') && !hasUrlShopId) {
    newQueries.shopId = shopId;
  }
  var urlAry = url.split('?');
  var queryString = urlAry[1] || '';
  var query = (0, _qs.parse)(queryString);
  var param = (0, _assign2.default)({}, query, newQueries);
  if (!param.shopId) {
    throw new Error('shop id is a will pass parameters');
  }
  return _fetch2.default.get(urlAry[0], param, config);
}

function goto(url, params) {
  var requestUrl = getRequestUrl(url, params);

  location.href = requestUrl;
}

exports.default = {
  get: get,
  post: post,
  goto: goto
};

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  actionVerifying: {
    id: 'action.Verifying',
    defaultMessage: '验证中...'
  },
  actionverifyFailed: {
    id: 'action.verifyFailed',
    defaultMessage: '手机验证失败'
  },
  actionrequestFailed: {
    id: 'action.requestFailed',
    defaultMessage: '请求数据失败'
  },
  actioncannotSendVerifyCode: {
    id: 'action.cannotSendVerifyCode',
    defaultMessage: '不能发送验证码：'
  },
  actionsubmitOrder: {
    id: 'action.submitOrder',
    defaultMessage: '提交订单中...'
  },
  actionconfirmOrderFailed: {
    id: 'action.confirmOrderFailed',
    defaultMessage: '确认订单失败！！'
  },
  actiongetBandInfoFailed: {
    id: 'action.getBandInfoFailed',
    defaultMessage: '获取品牌门店信息失败...'
  },
  actiongetBaseInfoFailed: {
    id: 'action.getBaseInfoFailed',
    defaultMessage: '获取基本信息失败...'
  },
  actionsendVerityCodeFailed: {
    id: 'action.sendVerityCodeFailed',
    defaultMessage: '验证码发送失败'
  },
  actionsendVerifyCodeSuccess: {
    id: 'action.sendVerifyCodeSuccess',
    defaultMessage: '验证码发送成功注意查收'
  },
  actionLoading: {
    id: 'action.Loading',
    defaultMessage: '加载中...'
  },
  actioncannotFindShopId: {
    id: 'action.cannotFindShopId',
    defaultMessage: '找不到门店号'
  },
  actiongetPersonalInfoFailed: {
    id: 'action.getPersonalInfoFailed',
    defaultMessage: '获取个人基本信息失败'
  },
  actionbindPNFailed: {
    id: 'action.bindPNFailed',
    defaultMessage: '绑定手机失败'
  },
  actionbindWXFailed: {
    id: 'action.bindWXFailed',
    defaultMessage: '绑定微信失败'
  },
  actionbindAlipayFailed: {
    id: 'action.bindAlipayFailed',
    defaultMessage: '绑定支付宝失败'
  },
  actionactivateVipFailed: {
    id: 'action.activateVipFailed',
    defaultMessage: '激活会员卡失败'
  },
  actioninfoGetFailed: {
    id: 'action.infoGetFailed',
    defaultMessage: '信息获取失败'
  },
  actiongradeFailed: {
    id: 'action.gradeFailed',
    defaultMessage: '评分失败'
  },
  actionchangeUrlFailed: {
    id: 'action.changeUrlFailed',
    defaultMessage: '转化url失败'
  },
  actiongetTableInfoFailed: {
    id: 'action.getTableInfoFailed',
    defaultMessage: '获取桌台信息失败'
  },
  actiongetUseableTableFailed: {
    id: 'action.getUseableTableFailed',
    defaultMessage: '获取可用桌台信息失败'
  },
  actiongetInterfaceFailed: {
    id: 'action.getInterfaceFailed',
    defaultMessage: '获取接口失败'
  },
  actionOrderCenterFailed: {
    id: 'action.OrderCenterFailed',
    defaultMessage: '订单中心业务开关接口失败'
  },
  actioncannotFindCookerId: {
    id: 'action.cannotFindCookerId',
    defaultMessage: '找不到厨师ID'
  },
  actionsaveAddressFailed: {
    id: 'action.saveAddressFailed',
    defaultMessage: '保存收货地址失败'
  },
  actiondeleteAddressFailed: {
    id: 'action.deleteAddressFailed',
    defaultMessage: '删除收货地址失败'
  },
  actioncannotBindCard: {
    id: 'action.cannotBindCard',
    defaultMessage: '无法绑定该卡，请检查您输入的卡号和密码。如遇问题，请联系海底捞顾客关怀中心4008107107'
  }
});

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
var isAliBrowser = __webpack_require__(3).isAlipayBrowser();
var loadUrl = __webpack_require__(414);
__webpack_require__(415);

module.exports = React.createClass({
  displayName: 'Loading',
  propTypes: {
    word: React.PropTypes.string
  },
  getInitialState: function getInitialState() {
    return {};
  },
  componentDidMount: function componentDidMount() {},
  render: function render() {
    var word = this.props.word;

    return React.createElement(
      'div',
      { className: 'loading-hover' },
      !isAliBrowser ? React.createElement(
        'div',
        { className: 'load-div' },
        React.createElement('div', { className: 'load-table-animation' }),
        React.createElement(
          'p',
          { className: 'load-word' },
          word
        )
      ) : React.createElement(
        'div',
        { className: 'load-gif' },
        React.createElement('img', { src: loadUrl, alt: '\u83CA\u82B1\u8F6C', className: 'load-pic' }),
        React.createElement(
          'p',
          { className: 'load-word' },
          word
        )
      )
    );
  }
});

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/load.gif";

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  PaySuccessRetailtableType: {
    id: 'PaySuccessRetail.tableType',
    defaultMessage: '桌台类型'
  },
  PaySuccessRetailchooseTableType: {
    id: 'PaySuccessRetail.chooseTableType',
    defaultMessage: '请选择桌台类型'
  },
  PaySuccessRetailnoTableInfo: {
    id: 'PaySuccessRetail.noTableInfo',
    defaultMessage: '没有桌台信息'
  },
  PaySuccessRetailadvanceNow: {
    id: 'PaySuccessRetail.advanceNow',
    defaultMessage: '立即预订'
  },
  PaySuccessRetailPayAdvance: {
    id: 'PaySuccessRetail.PayAdvance',
    defaultMessage: '支付{currency}{payPrice}预付金'
  },
  PaySuccessRetailadvancedTime: {
    id: 'PaySuccessRetail.advancedTime',
    defaultMessage: '预订时间'
  },
  PaySuccessRetailnoSelectAbleInterval: {
    id: 'PaySuccessRetail.noSelectAbleInterval',
    defaultMessage: '已无可选时段'
  },
  PaySuccessRetailnoAdvancedTable: {
    id: 'PaySuccessRetail.noAdvancedTable',
    defaultMessage: '无可预订桌台'
  },
  PaySuccessRetailbookNumberOfPeople: {
    id: 'PaySuccessRetail.bookNumberOfPeople',
    defaultMessage: '预订人数'
  },
  PaySuccessRetailconnectWays: {
    id: 'PaySuccessRetail.connectWays',
    defaultMessage: '联系方式'
  },
  PaySuccessRetailinputPs: {
    id: 'PaySuccessRetail.inputPs',
    defaultMessage: '请输入备注...'
  },
  PaySuccessRetailbooInfo: {
    id: 'PaySuccessRetail.booInfo',
    defaultMessage: '预订信息'
  },
  PaySuccessRetailadvancedMoneyPrompt: {
    id: 'PaySuccessRetail.advancedMoneyPrompt',
    defaultMessage: '预付金可在消费时直接抵扣消费金额，若需要退预付金请联系门店协商'
  },
  PosLoginApplicationVipDisabledPrompt: {
    id: 'PosLoginApplication.VipDisabledPrompt',
    defaultMessage: '您的会员身份已被停用，当前无法登录，请联系商户'
  },
  PosLoginApplicationlogOnShopDevice: {
    id: 'PosLoginApplication.logOnShopDevice',
    defaultMessage: '即将授权在商户设备登录'
  },
  PosLoginApplicationconfirmLogin: {
    id: 'PosLoginApplication.confirmLogin',
    defaultMessage: '确认授权登录'
  },
  PosLoginApplicationReason: {
    id: 'PosLoginApplication.Reason',
    defaultMessage: '原因：'
  },
  PosLoginApplicationgotoShopIndex: {
    id: 'PosLoginApplication.gotoShopIndex',
    defaultMessage: '去门店首页看看'
  },
  PosLoginApplicationScanAgain: {
    id: 'PosLoginApplication.ScanAgain',
    defaultMessage: '重新扫码'
  },
  QueueCheckOrderApplicationSelected: {
    id: 'QueueCheckOrderApplication.Selected',
    defaultMessage: '已选商品'
  },
  QueueCheckOrderApplicationTotal: {
    id: 'QueueCheckOrderApplication.Total',
    defaultMessage: '共{count}份'
  },
  QueueCheckOrderApplicationinputPS: {
    id: 'QueueCheckOrderApplication.inputPS',
    defaultMessage: '在这里输入备注哦'
  },
  QueueDetailApplicationWaitingBeforeYou: {
    id: 'QueueDetailApplication.WaitingBeforeYou',
    defaultMessage: '在您之前还有{count}桌客人等候'
  },
  QueueDetailApplicationexpectWaitingTime: {
    id: 'QueueDetailApplication.expectWaitingTime',
    defaultMessage: '预计排队时间'
  },
  QueueDetailApplicationcallPrompt: {
    id: 'QueueDetailApplication.callPrompt',
    defaultMessage: '听到叫号请到迎宾台，过号作废'
  },
  QueueDetailApplicationcancelWait: {
    id: 'QueueDetailApplication.cancelWait',
    defaultMessage: '取消排队'
  },
  QueueDetailApplicationconfirmCancelWait: {
    id: 'QueueDetailApplication.confirmCancelWait',
    defaultMessage: '是否取消排队？'
  },
  QueueDetailApplicationLetMeSee: {
    id: 'QueueDetailApplication.LetMeSee',
    defaultMessage: '容我想想'
  },
  QueueDetailApplicationDecideToGo: {
    id: 'QueueDetailApplication.DecideToGo',
    defaultMessage: '去意已决'
  },
  RedirectApplicationGetConfigFaild: {
    id: 'RedirectApplication.GetConfigFaild',
    defaultMessage: '获取配置信息失败，请重试'
  },
  RedirectApplicationregisterOnlineDisabled: {
    id: 'RedirectApplication.registerOnlineDisabled',
    defaultMessage: '当前商户不支持线上注册，请联系服务员注册会员'
  },
  RedirectApplicationinputName: {
    id: 'RedirectApplication.inputName',
    defaultMessage: '请填写姓名'
  },
  RedirectApplicationinputSixDigitPW: {
    id: 'RedirectApplication.inputSixDigitPW',
    defaultMessage: '请输入6位数字密码'
  },
  RedirectApplicationinputPW: {
    id: 'RedirectApplication.inputPW',
    defaultMessage: '请填写交易密码'
  },
  RedirectApplicationChecked: {
    id: 'RedirectApplication.Checked',
    defaultMessage: '验证完毕，请稍后……'
  },
  RedirectApplicationmodifyBirthPrompt: {
    id: 'RedirectApplication.modifyBirthPrompt',
    defaultMessage: '注：生日不可修改，请谨慎填写。'
  },
  RegisterValidateApplicationreFresh: {
    id: 'RegisterValidateApplication.reFresh',
    defaultMessage: '接口请求失败，请刷新重试'
  },
  RegisterValidateApplicationPNisBound: {
    id: 'RegisterValidateApplication.PNisBound',
    defaultMessage: '该手机号已与其他微信号绑定，请使用其他手机号注册'
  },
  BindPhoneApplicationPN: {
    id: 'BindPhoneApplication.PN',
    defaultMessage: '手机号'
  },
  RewardApplicationReciveYourTip: {
    id: 'RewardApplication.ReciveYourTip',
    defaultMessage: '已收到您的打赏'
  },
  RegisterValidateApplicationthanksInfo: {
    id: 'RegisterValidateApplication.thanksInfo',
    defaultMessage: '感谢您的认可，顾客的满意是我们最大的幸福'
  },
  RegisterValidateApplicationGive: {
    id: 'RegisterValidateApplication.Give',
    defaultMessage: '赠送'
  },
  UserLoginApplicationLoginWithThirdPart: {
    id: 'UserLoginApplication.LoginWithThirdPart',
    defaultMessage: '第三方登录'
  },
  UserLoginApplicationLogin: {
    id: 'UserLoginApplication.Login',
    defaultMessage: '登录'
  },
  UserLoginApplicationgotoMeCenterToBind: {
    id: 'UserLoginApplication.gotoMeCenterToBind',
    defaultMessage: '如果已有手机号注册的账号，选择{value}登录后，请在个人中心绑定手机号，以便关联原有账户信息'
  },
  UserLoginApplicationAutoRegister: {
    id: 'UserLoginApplication.AutoRegister',
    defaultMessage: '如果您的手机号尚未注册，登录后将自动生成账号。'
  },
  UserLoginApplicationView: {
    id: 'UserLoginApplication.View',
    defaultMessage: '我已阅读并同意'
  },
  UserLoginApplicationClause: {
    id: 'UserLoginApplication.Clause',
    defaultMessage: '《客如云用户服务协议》和《客如云隐私政策》'
  },
  UserLoginApplicationPrivacyPolicy: {
    id: 'UserLoginApplication.PrivacyPolicy',
    defaultMessage: '《隐私政策》'
  },
  UserLoginApplicationServiceAgreement: {
    id: 'UserLoginApplication.ServiceAgreement',
    defaultMessage: '《用户服务协议》'
  },
  UserLoginApplicationAnd: {
    id: 'UserLoginApplication.And',
    defaultMessage: '和'
  },
  UserLoginApplicationWelcome: {
    id: 'UserLoginApplication.Welcome',
    defaultMessage: '欢迎来到'
  },
  UserLoginApplicationbecameVip: {
    id: 'UserLoginApplication.becameVip',
    defaultMessage: '恭喜您成为本店会员'
  },
  UserLoginApplicationdefaultPW: {
    id: 'UserLoginApplication.defaultPW',
    defaultMessage: '初始交易密码默认为手机号后六位'
  },
  UserLoginApplicationiKnown: {
    id: 'UserLoginApplication.iKnown',
    defaultMessage: '我知道了'
  },
  ActivateValidateApplicationGoodAt: {
    id: 'ActivateValidateApplication.GoodAt',
    defaultMessage: '拿手菜'
  },
  CookApplicationIsSoldOut: {
    id: 'CookApplication.IsSoldOut',
    defaultMessage: '已售{saleCount}份'
  },
  TackoutTrackApplicationBack: {
    id: 'TackoutTrackApplication.Back',
    defaultMessage: '返回'
  },
  TackoutTrackApplicationDeliveryId: {
    id: 'TackoutTrackApplication.DeliveryId',
    defaultMessage: '配送单号'
  },
  TackoutTrackApplicationExpected: {
    id: 'TackoutTrackApplication.Expected',
    defaultMessage: '预计'
  },
  TackoutTrackApplicationArrivals: {
    id: 'TackoutTrackApplication.Arrivals',
    defaultMessage: '到达'
  },
  TackoutTrackApplicationSend: {
    id: 'TackoutTrackApplication.Send',
    defaultMessage: '送达'
  },
  TackoutTrackSendDinner: {
    id: 'TackoutTrackApplication.SendDinner',
    defaultMessage: '骑手正在送餐'
  },
  TackoutTrackOnTheWay: {
    id: 'TackoutTrackApplication.OnTheWay',
    defaultMessage: '骑手正在路上'
  },
  TackoutTrackDistance: {
    id: 'TackoutTrackApplication.Distance',
    defaultMessage: '距您'
  },
  TackoutTrackMinutes: {
    id: 'TackoutTrackApplication.Minutes',
    defaultMessage: '分钟'
  },
  PosLoginApplicationLoginSuccess: {
    id: 'PosLoginApplication.LoginSuccess',
    defaultMessage: '授权登录成功'
  },
  PosLoginApplicationLoginFailed: {
    id: 'PosLoginApplication.LoginFailed',
    defaultMessage: '授权登录失败'
  },
  RegisterMemberApplicationUsername: {
    id: 'RegisterMemberApplication.username',
    defaultMessage: '方便我们称呼您'
  },
  RegisterMemberApplicationEnjoyBirthday: {
    id: 'RegisterMemberApplication.enjoyBirthday',
    defaultMessage: '享受生日专属福利'
  },
  RegisterMemberApplicationtransactionPWD: {
    id: 'RegisterMemberApplication.transactionPWD',
    defaultMessage: '交易密码'
  },
  RegisterMemberApplicationPWDPlaceholder: {
    id: 'RegisterMemberApplication.PWDPlaceholder',
    defaultMessage: '请为余额支付设置6位数字密码'
  },
  RegisterMemberApplicationhasCardNum: {
    id: 'RegisterMemberApplication.hasCardNum',
    defaultMessage: '我有卡号(可不填写)'
  },
  RegisterMemberApplicationcardIsCheck: {
    id: 'RegisterMemberApplication.cardIsCheck',
    defaultMessage: '卡号已通过验证'
  },
  RegisterMemberApplicationregisterMember: {
    id: 'RegisterMemberApplication.registerMember',
    defaultMessage: '申请会员'
  },
  RegisterMemberApplicationSelectBookTime: {
    id: 'RegisterMemberApplication.SelectBookTime',
    defaultMessage: '选择预订时间'
  },
  QueueDetailApplicationpeople: {
    id: 'QueueDetailApplication.people',
    defaultMessage: '{count}人'
  },
  QueueDetailApplicationmorePeople: {
    id: 'QueueDetailApplication.morePeople',
    defaultMessage: '{count}人以上'
  },
  QueueDetailApplicationmen: {
    id: 'QueueDetailApplication.men',
    defaultMessage: '先生'
  },
  QueueDetailApplicationlady: {
    id: 'QueueDetailApplication.lady',
    defaultMessage: '女士'
  },
  QueueDetailApplicationanonymousUser: {
    id: 'QueueDetailApplication.anonymousUser',
    defaultMessage: '匿名用户'
  },
  QueueDetailApplicationantable: {
    id: 'QueueDetailApplication.table',
    defaultMessage: '桌'
  },
  QueueDetailApplicationcomingSoon: {
    id: 'QueueDetailApplication.comingSoon',
    defaultMessage: '即将到号'
  },
  QueueDetailApplicationaboutTime: {
    id: 'QueueDetailApplication.aboutTime',
    defaultMessage: '大约{count}分钟'
  },
  QueueDetailApplicationtakeOrder: {
    id: 'QueueDetailApplication.takeOrder',
    defaultMessage: '取号'
  },
  userLoginPNLoginPrompt: {
    id: 'userLoginPNLoginPrompt',
    defaultMessage: '如果已有手机号注册的账号，选择{text}登录后，'
  },
  userLoginBindPNAfterLogin: {
    id: 'userLoginBindPNAfterLogin',
    defaultMessage: '请在个人中心绑定手机号，以便关联原有账户信息'
  },
  userLoginBindPNToOrder: {
    id: 'userLoginBindPNToOrder',
    defaultMessage: '绑定手机开始点餐'
  },
  userLoginDefaultPW: {
    id: 'userLoginDefaultPW',
    defaultMessage: '初始交易密码默认为'
  },
  userLoginSixDigRePN: {
    id: 'userLoginSixDigRePN',
    defaultMessage: '手机号后6位'
  },
  orderMemo: {
    id: 'orderMemo',
    defaultMessage: '订单备注'
  },
  noTouchMemoTip: {
    id: 'noTouchMemoTip',
    defaultMessage: '请从快捷备注中选择无接触配送'
  },
  orderQuickMemo: {
    id: 'orderQuickMemo',
    defaultMessage: '快捷备注: '
  },
  inputOrderTip: {
    id: 'inputOrderTip',
    defaultMessage: '请填写您的备注'
  },
  warmTip: {
    id: 'warmTip',
    defaultMessage: '温馨提示'
  },
  getYourLocation: {
    id: 'getYourLocation',
    defaultMessage: '申请获取你的位置信息，你的位置信息将用于小程序位置接口的信息展示'
  }
});

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

exports.confirm = confirm;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(114);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dialog = __webpack_require__(271);

var _dialog2 = _interopRequireDefault(_dialog);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _button = __webpack_require__(409);

var _button2 = _interopRequireDefault(_button);

var _part = __webpack_require__(416);

var _part2 = _interopRequireDefault(_part);

var _helper = __webpack_require__(16);

__webpack_require__(454);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmDialog = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(ConfirmDialog, _React$Component);

  function ConfirmDialog() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ConfirmDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ConfirmDialog.__proto__ || (0, _getPrototypeOf2.default)(ConfirmDialog)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'onConfirm', {
      enumerable: true,
      writable: true,
      value: function value(evt) {
        if (evt) {
          evt.preventDefault();
        }

        if (_this.props.onConfirm) {
          _this.props.onConfirm();
        }
      }
    }), Object.defineProperty(_this, 'onCancel', {
      enumerable: true,
      writable: true,
      value: function value(evt) {
        if (evt) {
          evt.preventDefault();
        }

        if (_this.props.onCancel) {
          _this.props.onCancel();
        }
      }
    }), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ConfirmDialog, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancelText = _props.cancelText,
          confirmText = _props.confirmText,
          title = _props.title,
          button = _props.button;

      var buttons = button || [{
        text: cancelText || _react2.default.createElement(_formattedMessage2.default, _button2.default.cancel),
        className: 'dialog-btn-cancel',
        onClick: this.onCancel
      }, {
        text: confirmText || _react2.default.createElement(_formattedMessage2.default, _button2.default.confirm),
        className: 'dialog-btn-confirm',
        onClick: this.onConfirm
      }];

      return _react2.default.createElement(
        _dialog2.default,
        {
          title: title,
          theme: 'sliver',
          onClose: this.props.onClose || this.onCancel,
          buttons: buttons,
          className: 'confirm-dialog' + (title ? '' : ' dialog-no-header') + (buttons.length === 1 ? ' dialog-one-btn' : ''),
          noPreventScrollClassNameList: this.props.noPreventScrollClassNameList,
          needPreventScrollDefault: this.props.needPreventScrollDefault
        },
        this.props.children
      );
    }
  }]);
  return ConfirmDialog;
}(_react2.default.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    cancelText: _react2.default.PropTypes.any,
    confirmText: _react2.default.PropTypes.any,
    children: _react2.default.PropTypes.any,
    onCancel: _react2.default.PropTypes.func,
    onConfirm: _react2.default.PropTypes.func,
    onClose: _react2.default.PropTypes.func,
    noPreventScrollClassNameList: _react2.default.PropTypes.array,
    needPreventScrollDefault: _react2.default.PropTypes.bool,
    button: _react2.default.PropTypes.array
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    title: '',
    confirmText: _react2.default.createElement(_formattedMessage2.default, _button2.default.confirm),
    cancelText: _react2.default.createElement(_formattedMessage2.default, _button2.default.cancel)
  }
}), _temp2);
exports.default = ConfirmDialog;
function confirm(_ref2) {
  var title = _ref2.title,
      content = _ref2.content,
      cancelText = _ref2.cancelText,
      confirmText = _ref2.confirmText,
      onClose = _ref2.onClose,
      onCancel = _ref2.onCancel,
      onConfirm = _ref2.onConfirm,
      isBeforeMap = _ref2.isBeforeMap,
      rest = (0, _objectWithoutProperties3.default)(_ref2, ['title', 'content', 'cancelText', 'confirmText', 'onClose', 'onCancel', 'onConfirm', 'isBeforeMap']);

  var closed = false;

  var div = document.createElement('div');
  document.body.appendChild(div);

  function close() {
    closed = true;
    _reactDom2.default.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  function onPress(action) {
    if (closed) {
      return;
    }

    var res = action ? action() : false;
    if (res && res.then) {
      res.then(close);
    } else {
      close();
    }
  }

  var buttons = isBeforeMap ? [{
    text: _react2.default.createElement(_formattedMessage2.default, _part2.default.UserLoginApplicationiKnown),
    className: 'dialog-btn-return',
    onClick: function onClick(e) {
      e.preventDefault();
      onPress(onConfirm);
    }
  }] : [{
    text: cancelText || _react2.default.createElement(_formattedMessage2.default, _button2.default.cancel),
    className: 'dialog-btn-cancel',
    onClick: function onClick(e) {
      e.preventDefault();
      onPress(onCancel);
    }
  }, {
    text: confirmText || _react2.default.createElement(_formattedMessage2.default, _button2.default.confirm),
    className: 'dialog-btn-confirm',
    onClick: function onClick(e) {
      e.preventDefault();
      onPress(onConfirm);
    }
  }];

  var con = isBeforeMap ? _react2.default.createElement(
    'div',
    { className: 'dislog-tip-map' },
    _react2.default.createElement(
      'p',
      { className: 'tit' },
      (0, _helper.formatMessage)(_part2.default.warmTip)
    ),
    _react2.default.createElement(
      'div',
      { className: 'des' },
      sessionStorage.getItem('commercialName'),
      (0, _helper.formatMessage)(_part2.default.getYourLocation)
    )
  ) : content;

  _reactDom2.default.render(_react2.default.createElement(
    _dialog2.default,
    (0, _extends3.default)({
      title: title,
      theme: 'sliver',
      onClose: onClose,
      buttons: buttons,
      className: 'confirm-dialog' + (title ? '' : ' dialog-no-header') + (isBeforeMap ? ' dialog-one-btn' : ''),
      zIndexTop: true
    }, rest),
    con
  ), div);

  return {
    close: close
  };
}

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var JsSHA = __webpack_require__(429);
exports.getSendCodeParamStr = function (obj) {
  var key = '2039a66ba1d64576a8fba398b8b7598b';
  var props = [];
  var n = 0;

  for (var prop in obj) {
    if (!obj[prop]) {
      continue;
    }

    props[n] = prop;
    n++;
  }

  props.sort();
  var paramStr = '';
  function concat(length) {
    var preIndex = length - 1;
    if (length === 1) {
      paramStr = props[0] + '=' + obj[props[0]];
    } else {
      paramStr = concat(preIndex) + '&' + props[preIndex] + '=' + obj[props[preIndex]];
    }
    return paramStr;
  }

  concat(n);
  var value = paramStr + '&key=' + key;
  var shaObj = new JsSHA('SHA-1', 'TEXT');
  shaObj.update(value);
  return paramStr + '&sign=' + shaObj.getHash('HEX');
};

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/*
 A JavaScript implementation of the SHA family of hashes, as
 defined in FIPS PUB 180-4 and FIPS PUB 202, as well as the corresponding
 HMAC implementation as defined in FIPS PUB 198a

 Copyright 2008-2020 Brian Turek, 1998-2009 Paul Johnston & Contributors
 Distributed under the BSD License
 See http://caligatio.github.com/jsSHA/ for more information
*/
(function(aa){function C(d,b,a){var h=0,k=[],m=0,g,l,c,f,n,q,u,r,I=!1,v=[],x=[],t,y=!1,z=!1,w=-1;a=a||{};g=a.encoding||"UTF8";t=a.numRounds||1;if(t!==parseInt(t,10)||1>t)throw Error("numRounds must a integer >= 1");if("SHA-1"===d)n=512,q=K,u=ba,f=160,r=function(b){return b.slice()};else if(0===d.lastIndexOf("SHA-",0))if(q=function(b,h){return L(b,h,d)},u=function(b,h,k,a){var e,f;if("SHA-224"===d||"SHA-256"===d)e=(h+65>>>9<<4)+15,f=16;else if("SHA-384"===d||"SHA-512"===d)e=(h+129>>>10<<
5)+31,f=32;else throw Error("Unexpected error in SHA-2 implementation");for(;b.length<=e;)b.push(0);b[h>>>5]|=128<<24-h%32;h=h+k;b[e]=h&4294967295;b[e-1]=h/4294967296|0;k=b.length;for(h=0;h<k;h+=f)a=L(b.slice(h,h+f),a,d);if("SHA-224"===d)b=[a[0],a[1],a[2],a[3],a[4],a[5],a[6]];else if("SHA-256"===d)b=a;else if("SHA-384"===d)b=[a[0].a,a[0].b,a[1].a,a[1].b,a[2].a,a[2].b,a[3].a,a[3].b,a[4].a,a[4].b,a[5].a,a[5].b];else if("SHA-512"===d)b=[a[0].a,a[0].b,a[1].a,a[1].b,a[2].a,a[2].b,a[3].a,a[3].b,a[4].a,
a[4].b,a[5].a,a[5].b,a[6].a,a[6].b,a[7].a,a[7].b];else throw Error("Unexpected error in SHA-2 implementation");return b},r=function(b){return b.slice()},"SHA-224"===d)n=512,f=224;else if("SHA-256"===d)n=512,f=256;else if("SHA-384"===d)n=1024,f=384;else if("SHA-512"===d)n=1024,f=512;else throw Error("Chosen SHA variant is not supported");else if(0===d.lastIndexOf("SHA3-",0)||0===d.lastIndexOf("SHAKE",0)){var F=6;q=D;r=function(b){var d=[],a;for(a=0;5>a;a+=1)d[a]=b[a].slice();return d};w=1;if("SHA3-224"===
d)n=1152,f=224;else if("SHA3-256"===d)n=1088,f=256;else if("SHA3-384"===d)n=832,f=384;else if("SHA3-512"===d)n=576,f=512;else if("SHAKE128"===d)n=1344,f=-1,F=31,z=!0;else if("SHAKE256"===d)n=1088,f=-1,F=31,z=!0;else throw Error("Chosen SHA variant is not supported");u=function(b,d,a,h,k){a=n;var e=F,f,g=[],m=a>>>5,l=0,c=d>>>5;for(f=0;f<c&&d>=a;f+=m)h=D(b.slice(f,f+m),h),d-=a;b=b.slice(f);for(d%=a;b.length<m;)b.push(0);f=d>>>3;b[f>>2]^=e<<f%4*8;b[m-1]^=2147483648;for(h=D(b,h);32*g.length<k;){b=h[l%
5][l/5|0];g.push(b.b);if(32*g.length>=k)break;g.push(b.a);l+=1;0===64*l%a&&(D(null,h),l=0)}return g}}else throw Error("Chosen SHA variant is not supported");c=M(b,g,w);l=A(d);this.setHMACKey=function(b,a,k){var e;if(!0===I)throw Error("HMAC key already set");if(!0===y)throw Error("Cannot set HMAC key after calling update");if(!0===z)throw Error("SHAKE is not supported for HMAC");g=(k||{}).encoding||"UTF8";a=M(a,g,w)(b);b=a.binLen;a=a.value;e=n>>>3;k=e/4-1;for(e<b/8&&(a=u(a,b,0,A(d),f));a.length<=
k;)a.push(0);for(b=0;b<=k;b+=1)v[b]=a[b]^909522486,x[b]=a[b]^1549556828;l=q(v,l);h=n;I=!0};this.update=function(b){var d,a,e,f=0,g=n>>>5;d=c(b,k,m);b=d.binLen;a=d.value;d=b>>>5;for(e=0;e<d;e+=g)f+n<=b&&(l=q(a.slice(e,e+g),l),f+=n);h+=f;k=a.slice(f>>>5);m=b%n;y=!0};this.getHash=function(b,a){var e,g,c,n;if(!0===I)throw Error("Cannot call getHash after setting HMAC key");c=N(a);if(!0===z){if(-1===c.shakeLen)throw Error("shakeLen must be specified in options");f=c.shakeLen}switch(b){case "HEX":e=function(b){return O(b,
f,w,c)};break;case "B64":e=function(b){return P(b,f,w,c)};break;case "BYTES":e=function(b){return Q(b,f,w)};break;case "ARRAYBUFFER":try{g=new ArrayBuffer(0)}catch(p){throw Error("ARRAYBUFFER not supported by this environment");}e=function(b){return R(b,f,w)};break;case "UINT8ARRAY":try{g=new Uint8Array(0)}catch(p){throw Error("UINT8ARRAY not supported by this environment");}e=function(b){return S(b,f,w)};break;default:throw Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}n=u(k.slice(),
m,h,r(l),f);for(g=1;g<t;g+=1)!0===z&&0!==f%32&&(n[n.length-1]&=16777215>>>24-f%32),n=u(n,f,0,A(d),f);return e(n)};this.getHMAC=function(b,a){var e,g,c,p;if(!1===I)throw Error("Cannot call getHMAC without first setting HMAC key");c=N(a);switch(b){case "HEX":e=function(b){return O(b,f,w,c)};break;case "B64":e=function(b){return P(b,f,w,c)};break;case "BYTES":e=function(b){return Q(b,f,w)};break;case "ARRAYBUFFER":try{e=new ArrayBuffer(0)}catch(v){throw Error("ARRAYBUFFER not supported by this environment");
}e=function(b){return R(b,f,w)};break;case "UINT8ARRAY":try{e=new Uint8Array(0)}catch(v){throw Error("UINT8ARRAY not supported by this environment");}e=function(b){return S(b,f,w)};break;default:throw Error("outputFormat must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}g=u(k.slice(),m,h,r(l),f);p=q(x,A(d));p=u(g,f,n,p,f);return e(p)}}function a(d,b){this.a=d;this.b=b}function T(d,b,a,h){var k,m,g,l,c;b=b||[0];a=a||0;m=a>>>3;c=-1===h?3:0;for(k=0;k<d.length;k+=1)l=k+m,g=l>>>2,b.length<=g&&b.push(0),
b[g]|=d[k]<<8*(c+l%4*h);return{value:b,binLen:8*d.length+a}}function O(a,b,e,h){var k="";b/=8;var m,g,c;c=-1===e?3:0;for(m=0;m<b;m+=1)g=a[m>>>2]>>>8*(c+m%4*e),k+="0123456789abcdef".charAt(g>>>4&15)+"0123456789abcdef".charAt(g&15);return h.outputUpper?k.toUpperCase():k}function P(a,b,e,h){var k="",m=b/8,g,c,p,f;f=-1===e?3:0;for(g=0;g<m;g+=3)for(c=g+1<m?a[g+1>>>2]:0,p=g+2<m?a[g+2>>>2]:0,p=(a[g>>>2]>>>8*(f+g%4*e)&255)<<16|(c>>>8*(f+(g+1)%4*e)&255)<<8|p>>>8*(f+(g+2)%4*e)&255,c=0;4>c;c+=1)8*g+6*c<=b?k+=
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(p>>>6*(3-c)&63):k+=h.b64Pad;return k}function Q(a,b,e){var h="";b/=8;var k,c,g;g=-1===e?3:0;for(k=0;k<b;k+=1)c=a[k>>>2]>>>8*(g+k%4*e)&255,h+=String.fromCharCode(c);return h}function R(a,b,e){b/=8;var h,k=new ArrayBuffer(b),c,g;g=new Uint8Array(k);c=-1===e?3:0;for(h=0;h<b;h+=1)g[h]=a[h>>>2]>>>8*(c+h%4*e)&255;return k}function S(a,b,e){b/=8;var h,k=new Uint8Array(b),c;c=-1===e?3:0;for(h=0;h<b;h+=1)k[h]=a[h>>>2]>>>8*(c+h%4*e)&
255;return k}function N(a){var b={outputUpper:!1,b64Pad:"=",shakeLen:-1};a=a||{};b.outputUpper=a.outputUpper||!1;!0===a.hasOwnProperty("b64Pad")&&(b.b64Pad=a.b64Pad);if(!0===a.hasOwnProperty("shakeLen")){if(0!==a.shakeLen%8)throw Error("shakeLen must be a multiple of 8");b.shakeLen=a.shakeLen}if("boolean"!==typeof b.outputUpper)throw Error("Invalid outputUpper formatting option");if("string"!==typeof b.b64Pad)throw Error("Invalid b64Pad formatting option");return b}function M(a,b,e){switch(b){case "UTF8":case "UTF16BE":case "UTF16LE":break;
default:throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");}switch(a){case "HEX":a=function(b,a,d){var g=b.length,c,p,f,n,q,u;if(0!==g%2)throw Error("String of HEX type must be in byte increments");a=a||[0];d=d||0;q=d>>>3;u=-1===e?3:0;for(c=0;c<g;c+=2){p=parseInt(b.substr(c,2),16);if(isNaN(p))throw Error("String of HEX type contains invalid characters");n=(c>>>1)+q;for(f=n>>>2;a.length<=f;)a.push(0);a[f]|=p<<8*(u+n%4*e)}return{value:a,binLen:4*g+d}};break;case "TEXT":a=function(a,d,c){var g,
l,p=0,f,n,q,u,r,t;d=d||[0];c=c||0;q=c>>>3;if("UTF8"===b)for(t=-1===e?3:0,f=0;f<a.length;f+=1)for(g=a.charCodeAt(f),l=[],128>g?l.push(g):2048>g?(l.push(192|g>>>6),l.push(128|g&63)):55296>g||57344<=g?l.push(224|g>>>12,128|g>>>6&63,128|g&63):(f+=1,g=65536+((g&1023)<<10|a.charCodeAt(f)&1023),l.push(240|g>>>18,128|g>>>12&63,128|g>>>6&63,128|g&63)),n=0;n<l.length;n+=1){r=p+q;for(u=r>>>2;d.length<=u;)d.push(0);d[u]|=l[n]<<8*(t+r%4*e);p+=1}else if("UTF16BE"===b||"UTF16LE"===b)for(t=-1===e?2:0,l="UTF16LE"===
b&&1!==e||"UTF16LE"!==b&&1===e,f=0;f<a.length;f+=1){g=a.charCodeAt(f);!0===l&&(n=g&255,g=n<<8|g>>>8);r=p+q;for(u=r>>>2;d.length<=u;)d.push(0);d[u]|=g<<8*(t+r%4*e);p+=2}return{value:d,binLen:8*p+c}};break;case "B64":a=function(b,a,d){var c=0,l,p,f,n,q,u,r,t;if(-1===b.search(/^[a-zA-Z0-9=+\/]+$/))throw Error("Invalid character in base-64 string");p=b.indexOf("=");b=b.replace(/\=/g,"");if(-1!==p&&p<b.length)throw Error("Invalid '=' found in base-64 string");a=a||[0];d=d||0;u=d>>>3;t=-1===e?3:0;for(p=
0;p<b.length;p+=4){q=b.substr(p,4);for(f=n=0;f<q.length;f+=1)l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(q.charAt(f)),n|=l<<18-6*f;for(f=0;f<q.length-1;f+=1){r=c+u;for(l=r>>>2;a.length<=l;)a.push(0);a[l]|=(n>>>16-8*f&255)<<8*(t+r%4*e);c+=1}}return{value:a,binLen:8*c+d}};break;case "BYTES":a=function(b,a,d){var c,l,p,f,n,q;a=a||[0];d=d||0;p=d>>>3;q=-1===e?3:0;for(l=0;l<b.length;l+=1)c=b.charCodeAt(l),n=l+p,f=n>>>2,a.length<=f&&a.push(0),a[f]|=c<<8*(q+n%4*e);return{value:a,
binLen:8*b.length+d}};break;case "ARRAYBUFFER":try{a=new ArrayBuffer(0)}catch(h){throw Error("ARRAYBUFFER not supported by this environment");}a=function(b,a,d){return T(new Uint8Array(b),a,d,e)};break;case "UINT8ARRAY":try{a=new Uint8Array(0)}catch(h){throw Error("UINT8ARRAY not supported by this environment");}a=function(b,a,d){return T(b,a,d,e)};break;default:throw Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}return a}function y(a,b){return a<<b|a>>>32-b}function U(d,
b){return 32<b?(b-=32,new a(d.b<<b|d.a>>>32-b,d.a<<b|d.b>>>32-b)):0!==b?new a(d.a<<b|d.b>>>32-b,d.b<<b|d.a>>>32-b):d}function x(a,b){return a>>>b|a<<32-b}function t(d,b){var e=null,e=new a(d.a,d.b);return e=32>=b?new a(e.a>>>b|e.b<<32-b&4294967295,e.b>>>b|e.a<<32-b&4294967295):new a(e.b>>>b-32|e.a<<64-b&4294967295,e.a>>>b-32|e.b<<64-b&4294967295)}function V(d,b){var e=null;return e=32>=b?new a(d.a>>>b,d.b>>>b|d.a<<32-b&4294967295):new a(0,d.a>>>b-32)}function ca(a,b,e){return a&b^~a&e}function da(d,
b,e){return new a(d.a&b.a^~d.a&e.a,d.b&b.b^~d.b&e.b)}function W(a,b,e){return a&b^a&e^b&e}function ea(d,b,e){return new a(d.a&b.a^d.a&e.a^b.a&e.a,d.b&b.b^d.b&e.b^b.b&e.b)}function fa(a){return x(a,2)^x(a,13)^x(a,22)}function ga(d){var b=t(d,28),e=t(d,34);d=t(d,39);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function ha(a){return x(a,6)^x(a,11)^x(a,25)}function ia(d){var b=t(d,14),e=t(d,18);d=t(d,41);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function ja(a){return x(a,7)^x(a,18)^a>>>3}function ka(d){var b=t(d,
1),e=t(d,8);d=V(d,7);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function la(a){return x(a,17)^x(a,19)^a>>>10}function ma(d){var b=t(d,19),e=t(d,61);d=V(d,6);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function G(a,b){var e=(a&65535)+(b&65535);return((a>>>16)+(b>>>16)+(e>>>16)&65535)<<16|e&65535}function na(a,b,e,h){var c=(a&65535)+(b&65535)+(e&65535)+(h&65535);return((a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)+(c>>>16)&65535)<<16|c&65535}function H(a,b,e,h,c){var m=(a&65535)+(b&65535)+(e&65535)+(h&65535)+(c&65535);
return((a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)+(c>>>16)+(m>>>16)&65535)<<16|m&65535}function oa(d,b){var e,h,c;e=(d.b&65535)+(b.b&65535);h=(d.b>>>16)+(b.b>>>16)+(e>>>16);c=(h&65535)<<16|e&65535;e=(d.a&65535)+(b.a&65535)+(h>>>16);h=(d.a>>>16)+(b.a>>>16)+(e>>>16);return new a((h&65535)<<16|e&65535,c)}function pa(d,b,e,h){var c,m,g;c=(d.b&65535)+(b.b&65535)+(e.b&65535)+(h.b&65535);m=(d.b>>>16)+(b.b>>>16)+(e.b>>>16)+(h.b>>>16)+(c>>>16);g=(m&65535)<<16|c&65535;c=(d.a&65535)+(b.a&65535)+(e.a&65535)+(h.a&65535)+
(m>>>16);m=(d.a>>>16)+(b.a>>>16)+(e.a>>>16)+(h.a>>>16)+(c>>>16);return new a((m&65535)<<16|c&65535,g)}function qa(d,b,e,h,c){var m,g,l;m=(d.b&65535)+(b.b&65535)+(e.b&65535)+(h.b&65535)+(c.b&65535);g=(d.b>>>16)+(b.b>>>16)+(e.b>>>16)+(h.b>>>16)+(c.b>>>16)+(m>>>16);l=(g&65535)<<16|m&65535;m=(d.a&65535)+(b.a&65535)+(e.a&65535)+(h.a&65535)+(c.a&65535)+(g>>>16);g=(d.a>>>16)+(b.a>>>16)+(e.a>>>16)+(h.a>>>16)+(c.a>>>16)+(m>>>16);return new a((g&65535)<<16|m&65535,l)}function B(d,b){return new a(d.a^b.a,d.b^
b.b)}function A(d){var b=[],e;if("SHA-1"===d)b=[1732584193,4023233417,2562383102,271733878,3285377520];else if(0===d.lastIndexOf("SHA-",0))switch(b=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428],e=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],d){case "SHA-224":break;case "SHA-256":b=e;break;case "SHA-384":b=[new a(3418070365,b[0]),new a(1654270250,b[1]),new a(2438529370,b[2]),new a(355462360,b[3]),new a(1731405415,
b[4]),new a(41048885895,b[5]),new a(3675008525,b[6]),new a(1203062813,b[7])];break;case "SHA-512":b=[new a(e[0],4089235720),new a(e[1],2227873595),new a(e[2],4271175723),new a(e[3],1595750129),new a(e[4],2917565137),new a(e[5],725511199),new a(e[6],4215389547),new a(e[7],327033209)];break;default:throw Error("Unknown SHA variant");}else if(0===d.lastIndexOf("SHA3-",0)||0===d.lastIndexOf("SHAKE",0))for(d=0;5>d;d+=1)b[d]=[new a(0,0),new a(0,0),new a(0,0),new a(0,0),new a(0,0)];else throw Error("No SHA variants supported");
return b}function K(a,b){var e=[],h,c,m,g,l,p,f;h=b[0];c=b[1];m=b[2];g=b[3];l=b[4];for(f=0;80>f;f+=1)e[f]=16>f?a[f]:y(e[f-3]^e[f-8]^e[f-14]^e[f-16],1),p=20>f?H(y(h,5),c&m^~c&g,l,1518500249,e[f]):40>f?H(y(h,5),c^m^g,l,1859775393,e[f]):60>f?H(y(h,5),W(c,m,g),l,2400959708,e[f]):H(y(h,5),c^m^g,l,3395469782,e[f]),l=g,g=m,m=y(c,30),c=h,h=p;b[0]=G(h,b[0]);b[1]=G(c,b[1]);b[2]=G(m,b[2]);b[3]=G(g,b[3]);b[4]=G(l,b[4]);return b}function ba(a,b,e,c){var k;for(k=(b+65>>>9<<4)+15;a.length<=k;)a.push(0);a[b>>>5]|=
128<<24-b%32;b+=e;a[k]=b&4294967295;a[k-1]=b/4294967296|0;b=a.length;for(k=0;k<b;k+=16)c=K(a.slice(k,k+16),c);return c}function L(d,b,e){var h,k,m,g,l,p,f,n,q,u,r,t,v,x,y,A,z,w,F,B,C,D,E=[],J;if("SHA-224"===e||"SHA-256"===e)u=64,t=1,D=Number,v=G,x=na,y=H,A=ja,z=la,w=fa,F=ha,C=W,B=ca,J=c;else if("SHA-384"===e||"SHA-512"===e)u=80,t=2,D=a,v=oa,x=pa,y=qa,A=ka,z=ma,w=ga,F=ia,C=ea,B=da,J=X;else throw Error("Unexpected error in SHA-2 implementation");e=b[0];h=b[1];k=b[2];m=b[3];g=b[4];l=b[5];p=b[6];f=b[7];
for(r=0;r<u;r+=1)16>r?(q=r*t,n=d.length<=q?0:d[q],q=d.length<=q+1?0:d[q+1],E[r]=new D(n,q)):E[r]=x(z(E[r-2]),E[r-7],A(E[r-15]),E[r-16]),n=y(f,F(g),B(g,l,p),J[r],E[r]),q=v(w(e),C(e,h,k)),f=p,p=l,l=g,g=v(m,n),m=k,k=h,h=e,e=v(n,q);b[0]=v(e,b[0]);b[1]=v(h,b[1]);b[2]=v(k,b[2]);b[3]=v(m,b[3]);b[4]=v(g,b[4]);b[5]=v(l,b[5]);b[6]=v(p,b[6]);b[7]=v(f,b[7]);return b}function D(d,b){var e,c,k,m,g=[],l=[];if(null!==d)for(c=0;c<d.length;c+=2)b[(c>>>1)%5][(c>>>1)/5|0]=B(b[(c>>>1)%5][(c>>>1)/5|0],new a(d[c+1],d[c]));
for(e=0;24>e;e+=1){m=A("SHA3-");for(c=0;5>c;c+=1){k=b[c][0];var p=b[c][1],f=b[c][2],n=b[c][3],q=b[c][4];g[c]=new a(k.a^p.a^f.a^n.a^q.a,k.b^p.b^f.b^n.b^q.b)}for(c=0;5>c;c+=1)l[c]=B(g[(c+4)%5],U(g[(c+1)%5],1));for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)b[c][k]=B(b[c][k],l[c]);for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)m[k][(2*c+3*k)%5]=U(b[c][k],Y[c][k]);for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)b[c][k]=B(m[c][k],new a(~m[(c+1)%5][k].a&m[(c+2)%5][k].a,~m[(c+1)%5][k].b&m[(c+2)%5][k].b));b[0][0]=B(b[0][0],Z[e])}return b}var c,
X,Y,Z;c=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];X=[new a(c[0],3609767458),new a(c[1],602891725),new a(c[2],3964484399),new a(c[3],2173295548),new a(c[4],4081628472),new a(c[5],3053834265),new a(c[6],2937671579),new a(c[7],3664609560),new a(c[8],2734883394),new a(c[9],1164996542),new a(c[10],1323610764),new a(c[11],3590304994),new a(c[12],4068182383),new a(c[13],
991336113),new a(c[14],633803317),new a(c[15],3479774868),new a(c[16],2666613458),new a(c[17],944711139),new a(c[18],2341262773),new a(c[19],2007800933),new a(c[20],1495990901),new a(c[21],1856431235),new a(c[22],3175218132),new a(c[23],2198950837),new a(c[24],3999719339),new a(c[25],766784016),new a(c[26],2566594879),new a(c[27],3203337956),new a(c[28],1034457026),new a(c[29],2466948901),new a(c[30],3758326383),new a(c[31],168717936),new a(c[32],1188179964),new a(c[33],1546045734),new a(c[34],1522805485),
new a(c[35],2643833823),new a(c[36],2343527390),new a(c[37],1014477480),new a(c[38],1206759142),new a(c[39],344077627),new a(c[40],1290863460),new a(c[41],3158454273),new a(c[42],3505952657),new a(c[43],106217008),new a(c[44],3606008344),new a(c[45],1432725776),new a(c[46],1467031594),new a(c[47],851169720),new a(c[48],3100823752),new a(c[49],1363258195),new a(c[50],3750685593),new a(c[51],3785050280),new a(c[52],3318307427),new a(c[53],3812723403),new a(c[54],2003034995),new a(c[55],3602036899),
new a(c[56],1575990012),new a(c[57],1125592928),new a(c[58],2716904306),new a(c[59],442776044),new a(c[60],593698344),new a(c[61],3733110249),new a(c[62],2999351573),new a(c[63],3815920427),new a(3391569614,3928383900),new a(3515267271,566280711),new a(3940187606,3454069534),new a(4118630271,4000239992),new a(116418474,1914138554),new a(174292421,2731055270),new a(289380356,3203993006),new a(460393269,320620315),new a(685471733,587496836),new a(852142971,1086792851),new a(1017036298,365543100),new a(1126000580,
2618297676),new a(1288033470,3409855158),new a(1501505948,4234509866),new a(1607167915,987167468),new a(1816402316,1246189591)];Z=[new a(0,1),new a(0,32898),new a(2147483648,32906),new a(2147483648,2147516416),new a(0,32907),new a(0,2147483649),new a(2147483648,2147516545),new a(2147483648,32777),new a(0,138),new a(0,136),new a(0,2147516425),new a(0,2147483658),new a(0,2147516555),new a(2147483648,139),new a(2147483648,32905),new a(2147483648,32771),new a(2147483648,32770),new a(2147483648,128),new a(0,
32778),new a(2147483648,2147483658),new a(2147483648,2147516545),new a(2147483648,32896),new a(0,2147483649),new a(2147483648,2147516424)];Y=[[0,36,3,41,18],[1,44,10,45,2],[62,6,43,15,61],[28,55,25,21,56],[27,20,39,8,14]]; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return C}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof exports?("undefined"!==typeof module&&module.exports&&(module.exports=C),exports=C):aa.jsSHA=C})(this);


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _seamlessImmutable = __webpack_require__(77);

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _commonHelper = __webpack_require__(3);

var _storagePairHelper = __webpack_require__(408);

var _const = __webpack_require__(14);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUrlParam = exports.getUrlParam = function (param) {
  var params = (0, _commonHelper.getUrlParams)() || {};

  return params[param] || null;
};

var isSingleDishWithoutProps = exports.isSingleDishWithoutProps = function (dish) {
  if (dish.type === 1) return false;

  var propTypeInfo = dish.dishPropertyTypeInfos || [];
  var ingredientInfos = dish.dishIngredientInfos || [];
  return !ingredientInfos.length && (!propTypeInfo.length || propTypeInfo.every(function (prop) {
    return prop.type === 4 || prop.type === 2;
  }));
};

var isGroupDish = exports.isGroupDish = function (dish) {
  return dish.groups !== undefined;
};

exports.isChildDish = function (dish) {
  return dish.isChildDish;
};

var getOrderedDishes = exports.getOrderedDishes = function (dishes) {
  return dishes.filter(function (dish) {
    return dish.order > 0 || dish.order && dish.order.length;
  });
};

var getDishMemberPrice = exports.getDishMemberPrice = function (dish) {
  var marketPrice = dish.marketPrice,
      discountType = dish.discountType,
      isMember = dish.isMember;

  if (!isMember) {
    // return 0;
    return null;
  }

  var memberPrice = null;
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    // 折扣1  统一折扣3
    memberPrice = marketPrice * (dish.memberPrice || 0) * 0.1;
  } else if (discountType === _const.MemberPrivTypes.REDUCE) {
    // 固定价 2
    memberPrice = dish.memberPrice || 0;
  }
  if (memberPrice === null) return null; // 如果都不是 则是套餐中加价部分并且没有开启加价折扣
  return +memberPrice.toFixed(2);
};

var getDishesCount = exports.getDishesCount = function (dishes) {
  if (!Array.isArray(dishes)) return 0;
  var number = dishes.map(function (dish) {
    if (!dish) {
      return 0;
    }
    if (dish.order !== undefined) {
      if (isSingleDishWithoutProps(dish) || !Array.isArray(dish.order)) {
        return Number(dish.order) || 0;
      }
      return dish.order.map(function (order) {
        return Number(order.count) || 0;
      }).reduce(function (c, p) {
        return c + p;
      }, 0);
    }
    return 0;
  }).reduce(function (p, c) {
    return p + c;
  }, 0);

  return +number.toFixed(4);
};

// 包含变价的价格（做法、加料）
var getOrderPrice = function getOrderPrice(dish, orderData) {
  var marketPrice = dish.marketPrice,
      saleType = dish.saleType;
  var _orderData$dishProper = orderData.dishPropertyTypeInfos,
      dishPropertyTypeInfos = _orderData$dishProper === undefined ? [] : _orderData$dishProper,
      _orderData$dishIngred = orderData.dishIngredientInfos,
      dishIngredientInfos = _orderData$dishIngred === undefined ? [] : _orderData$dishIngred,
      count = orderData.count,
      _orderData$groups = orderData.groups,
      groups = _orderData$groups === undefined ? [] : _orderData$groups;

  var isWeighedMode = saleType === 1;

  // 套餐价格计算
  if (isGroupDish(dish)) {
    // 称重模式下的配料价格总计
    // 选中的子菜
    var checkedChildDishes = groups.reduce(function (list, group) {
      return list.concat(group.childInfos.filter(function (childDish) {
        return childDish.order;
      }));
    }, []);
    // 子菜的价格列表
    var prices = checkedChildDishes.map(function (item) {
      var isSingle = isSingleDishWithoutProps(item);
      var price = 0;

      if (isSingle) {
        price = item.marketPrice * item.order;
      } else {
        price = item.order.map(function (dishOrder) {
          return getOrderPrice(item, dishOrder);
        }).reduce(function (c, p) {
          return c + p;
        }, 0);
      }

      return price;
    });

    return (count * (marketPrice + prices.reduce(function (c, p) {
      return c + p;
    }, 0))).toFixed(2);
  }

  // 不是套餐的计算
  // 不算备注的做法列表
  var allProps = dishPropertyTypeInfos.filter(function (prop) {
    return prop.type !== 3;
  }).reduce(function (list, item) {
    return list.concat(item.properties || []);
  }, []);
  // 勾选的做法总价
  var checkedPropsPrice = allProps.filter(function (prop) {
    return prop.isChecked;
  }).map(function (prop) {
    return prop.reprice || 0;
  }).reduce(function (c, p) {
    return c + p;
  }, 0);
  // 勾选的配料总价，暂时没有一份菜对应多个配料(item.num)
  var checkedIngredientsPrice = dishIngredientInfos.filter(function (item) {
    return item.isChecked;
  }).map(function (item) {
    return item.reprice || 0;
  }).reduce(function (c, p) {
    return c + p;
  }, 0);

  var price = 0;

  // 计算称重商品配料的价格不需要乘上菜品的份数
  if (isWeighedMode) {
    price = count * marketPrice + checkedPropsPrice + checkedIngredientsPrice;
  } else {
    price = count * (marketPrice + checkedPropsPrice + checkedIngredientsPrice);
  }

  price = parseFloat(price.toFixed(2), 10);
  return Math.max(price, 0);
};

exports.getOrderPrice = getOrderPrice;

var getDishPrice = function getDishPrice(dish) {
  if (isSingleDishWithoutProps(dish)) {
    var singleDishPrice = parseFloat((dish.marketPrice * dish.order).toFixed(2));
    return singleDishPrice >= 0 ? singleDishPrice : 0;
  }

  var hasPropsDishPrice = dish.order.map(function (eachOrder) {
    return parseFloat(getOrderPrice(dish, eachOrder));
  }).reduce(function (c, p) {
    return c + p;
  }, 0);
  return hasPropsDishPrice >= 0 ? hasPropsDishPrice : 0;
};

exports.getDishPrice = getDishPrice;

//
exports.getActivityBenefitMaxId = function (dishes) {
  // 在活动优惠中选取最大优惠价
  var activityBenefitMaxId = 0,
      // 活动优惠最大的菜品id
  activityBenefitMaxValue = 0,
      // 活动优惠最大的菜品优惠价
  activityBenefitMaxIdList = [],
      // 参与活动优惠的商品id列表
  activityBenefitMaxValList = [],
      // 参与活动优惠的商品优惠价列表
  activityBenefitMaxlocation = -1,
      // 活动优惠最大的菜品在优惠价列表中的位置
  singleMarketObj = null,
      singleMarketingInfosPrice = 0,
      singleMarketingInfosMaxPrice = 0,
      singleMarketPriceList = [];
  // 遍历已经点好的菜品找出优惠最多的菜品
  if (dishes && dishes.length) {
    for (var k = 0; k < dishes.length; k++) {
      // 活动优惠中的单商品菜品
      if (dishes[k].activityBenefit) {
        activityBenefitMaxValList.push(dishes[k].activityBenefit);
        activityBenefitMaxIdList.push(dishes[k].id);
      } else if (dishes[k].order instanceof Array && dishes[k].order[0].activityBenefit) {
        // 活动优惠中的套餐菜品
        activityBenefitMaxValList.push(dishes[k].order[0].activityBenefit);
        activityBenefitMaxIdList.push(dishes[k].id);
      }
      // 活动优惠中的单商品折扣
      if (dishes[k].singleMarketingInfos && dishes[k].singleMarketingInfos instanceof Array && dishes[k].singleMarketingInfos.length) {
        // 添加单品折扣优惠价格比较
        // 遍历一个菜品中所有单商品折扣方式并找出满减和打折中优惠最多的一个
        for (var i = 0; i < dishes[k].singleMarketingInfos.length; i++) {
          singleMarketObj = dishes[k].singleMarketingInfos[i];
          // singleMarketingInfosPrice = singleMarketObj.type == 1 ? singleMarketObj.value : (singleMarketObj.type == 2 ? dishes[k].marketPrice - Number(dishes[k].marketPrice / 10 * singleMarketObj.value).toFixed(2) : 0 );
          if (singleMarketObj.type == 1) {
            // 单商品折扣满减
            singleMarketingInfosPrice = singleMarketObj.value;
          } else if (singleMarketObj.type == 2) {
            // 单商品折扣打折
            if (dishes[k].memberPrice) {
              // 单商品折扣非套餐的情况下
              if (dishes[k].order && !dishes[k].order.length) {
                singleMarketingInfosPrice = dishes[k].memberPrice - (dishes[k].memberPrice / 10 * singleMarketObj.value).toFixed(2);
              }
            } else {
              singleMarketingInfosPrice = dishes[k].marketPrice - Number(dishes[k].marketPrice / 10 * singleMarketObj.value).toFixed(2);
            }
          } else {
            singleMarketingInfosPrice = 0;
          }
          singleMarketPriceList.push(singleMarketingInfosPrice);
        }
        singleMarketingInfosMaxPrice = Math.max.apply(Math, singleMarketPriceList);
        if (activityBenefitMaxValList.indexOf(singleMarketingInfosMaxPrice) == -1) {
          activityBenefitMaxValList.push(singleMarketingInfosMaxPrice);
          activityBenefitMaxIdList.push(dishes[k].id);
        }
      }
    }
    if (activityBenefitMaxValList.length > 0) {
      activityBenefitMaxValue = Math.max.apply(Math, activityBenefitMaxValList);
      activityBenefitMaxlocation = activityBenefitMaxValList.indexOf(activityBenefitMaxValue);
      activityBenefitMaxId = activityBenefitMaxIdList[activityBenefitMaxlocation];
    }
  }
  // 返回活动优惠中最大优惠菜品的id 和 优惠价格
  return {
    activityBenefitMaxId: activityBenefitMaxId,
    activityBenefitMaxValue: activityBenefitMaxValue
  };
};

// calcOption 参数废弃
// memberPrice: boolean
var getDishesPrice = function getDishesPrice(dishes, calcOption, memberPrice) {
  var dishesPrice = dishes.map(function (dish) {
    var newDish = dish.asMutable ? dish.asMutable() : (0, _extends3.default)({}, dish); // 构建新的对象
    var memberPriceStr = newDish.memberPrice !== null && newDish.memberPrice !== undefined ? newDish.memberPrice.toString() : null; // 消除memberPrice为0的影响
    if (memberPrice && memberPriceStr) {
      // if (memberPrice && newDish.memberPrice) {
      // 使用会员价
      newDish.marketPrice = getDishMemberPrice(newDish);
    }
    return getDishPrice(newDish);
  }).reduce(function (c, p) {
    return c + p;
  }, 0);
  if (isFinite(dishesPrice) && Math.floor(dishesPrice) === dishesPrice) {
    return dishesPrice;
  }
  return parseFloat(dishesPrice.toFixed(2));
};
exports.getDishesPrice = getDishesPrice;

/**
 * getRealMarketPrice
 * @param { dish }
 * 考虑到菜品变价为负的情况，基准价>实际价格
 */

exports.getRealMarketPrice = function (dish) {
  return Math.min(dish.marketPrice, getDishPrice(dish));
};

/**
 * 计算菜品基准价
 */
var getDishMarketPrice = function getDishMarketPrice(dish) {
  if (isSingleDishWithoutProps(dish)) {
    return Math.max(0, dish.marketPrice * dish.order);
  }
  return (dish.order || []).map(function (order) {
    return dish.marketPrice * order.count;
  }).reduce(function (p, c) {
    return p + c;
  }, 0);
};

/**
 * 计算菜品基准价总和
 */
exports.getDishesMarketPrice = function (dishes) {
  var amount = (dishes || []).map(function (dish) {
    return getDishMarketPrice(dish);
  }).reduce(function (p, c) {
    return p + c;
  }, 0);
  return parseFloat(amount.toFixed(2), 10);
};

exports.getNewCountOfDish = function (dish, increment) {
  var newDish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var newCount = 0;

  if (isSingleDishWithoutProps(dish)) {
    if (dish.order === undefined) {
      newCount = newDish.order || dish.dishIncreaseUnit;
    } else if (dish.order + increment < dish.dishIncreaseUnit) {
      newCount = undefined;
    } else {
      newCount = dish.order + increment;
    }
    newCount = newCount <= 0 ? undefined : newCount;
  } else {
    var oldCount = getDishesCount([dish]);
    if (oldCount === 0) {
      // if never ordered this dish;
      newCount = dish.dishIncreaseUnit;
    } else if (oldCount + increment < dish.dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCount = 0;
    } else {
      newCount = oldCount + increment;
    }
  }

  return newCount;
};

var getOrderPropIds = function getOrderPropIds(order) {
  var dishPropertyTypeInfos = order.dishPropertyTypeInfos,
      dishIngredientInfos = order.dishIngredientInfos;

  var propsIds = [].concat.apply([], dishPropertyTypeInfos.map(function (prop) {
    return prop.properties.filter(function (property) {
      return property.isChecked;
    }).map(function (property) {
      return property.id;
    });
  }));
  var ingredientIds = (dishIngredientInfos || []).filter(function (ingredient) {
    return ingredient.isChecked;
  }).map(function (ingredient) {
    return ingredient.id;
  });
  return [propsIds, ingredientIds];
};

var getSignleDishRuleIds = function getSignleDishRuleIds(dish) {
  var rulePropertyCollection = [];
  dish.dishPropertyTypeInfos.map(function (property) {
    return property.properties.map(function (prop) {
      return rulePropertyCollection.push(prop.id);
    });
  });
  return rulePropertyCollection.join('^');
};

var getDishBoxCount = exports.getDishBoxCount = function (orderedDishes) {
  var dishBoxContainer = [];
  orderedDishes.map(function (orderDish) {
    if (isGroupDish(orderDish)) {
      orderDish.order.map(function (childOrder) {
        var count = childOrder.count;
        // let childDishCount = 0; // 判定所有子菜的餐盒费
        childOrder.groups.map(function (group) {
          return group.childInfos.filter(function (childDish) {
            return childDish.order;
          }).map(function (child) {
            if (child.boxQty && child.dishQty) {
              // 计算了子菜的餐盒费
              dishBoxContainer.push(Math.ceil(getDishesCount([child]) / parseFloat(child.dishQty)) * parseFloat(child.boxQty) * count);
              // childDishCount += child.boxQty;
            } else {
              return false;
            }
            return true;
          });
        });
        // 如何判定所有子菜都没有餐盒费
        // console.log('mmm', childDishCount);
        // if (childDishCount === 0 && orderDish.dishQty) { // 把套餐的餐盒费计算在内,所有子菜都不需要餐盒费
        //   dishBoxContainer.push(childOrder.count * orderDish.dishQty);
        // }
      });
    } else {
      if (orderDish.boxQty && orderDish.dishQty) {
        dishBoxContainer.push(Math.ceil(getDishesCount([orderDish]) / parseFloat(orderDish.dishQty)) * parseFloat(orderDish.boxQty));
      }
    }
    return true;
  });
  return dishBoxContainer.reduce(function (c, p) {
    return c + p;
  }, 0);
};

exports.getDishBoxprice = function (orderedDishes, dishBoxChargeInfo) {
  if (!dishBoxChargeInfo || dishBoxChargeInfo.orderFlag !== 1) {
    return 0;
  }
  return getDishBoxCount(orderedDishes) * dishBoxChargeInfo.content;
};

var hasSelectedProps = exports.hasSelectedProps = function (dish) {
  var _dish$order = (0, _slicedToArray3.default)(dish.order, 1),
      order = _dish$order[0];

  var hasProps = (order.dishPropertyTypeInfos || []).some(function (prop) {
    return prop.type !== 4 && prop.type !== 2 && (prop.properties || []).some(function (item) {
      return item.isChecked;
    });
  });
  var hasIngredients = (order.dishIngredientInfos || []).some(function (item) {
    return item.isChecked;
  });

  if (hasProps || hasIngredients) return true;
  return false;
};

// setCookie
var setCookie = exports.setCookie = function (name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';path=/';
};

var getDishCookieObject = exports.getDishCookieObject = function (dish, orderIdx) {
  var isSingleDish = !isGroupDish(dish);
  var consumeType = getUrlParam('type');
  var shopId = getUrlParam('shopId');
  var id = dish.id,
      marketPrice = dish.marketPrice;

  var orderCount = isSingleDishWithoutProps(dish) ? getDishesCount([dish]) : dish.order[orderIdx].count;
  if (isSingleDish) {
    var spliceResultOfPropIds = null;
    if (isSingleDishWithoutProps(dish)) {
      if (dish.dishPropertyTypeInfos && dish.dishPropertyTypeInfos.length) {
        // 到这里就剩下只有规格的菜品了
        spliceResultOfPropIds = '-' + getSignleDishRuleIds(dish);
      } else {
        spliceResultOfPropIds = '-';
      }
    } else {
      spliceResultOfPropIds = getOrderPropIds(dish.order[orderIdx])[1].join('^') + '-' + getOrderPropIds(dish.order[orderIdx])[0].join('^');
    }
    return { key: consumeType + '_' + shopId + '_' + id + '_' + id + '|1-' + spliceResultOfPropIds, value: orderCount + '|' + marketPrice };
  }
  var splitPropsIds = [].concat.apply([], dish.order[orderIdx].groups.map(function (group) {
    var groupId = group.id;
    var result = group.childInfos.filter(function (childInfos) {
      return getDishesCount([childInfos]);
    }).map(function (childInfo) {
      var spliceResultOfPropIds = null;
      if (isSingleDishWithoutProps(childInfo)) {
        if (childInfo.dishPropertyTypeInfos && childInfo.dishPropertyTypeInfos.length) {
          // 到这里就剩下只有规格的菜品了
          spliceResultOfPropIds = '-' + getSignleDishRuleIds(childInfo);
        } else {
          spliceResultOfPropIds = '-';
        }
      } else {
        spliceResultOfPropIds = getOrderPropIds(childInfo.order[0])[1].join('^') + '-' + getOrderPropIds(childInfo.order[0])[0].join('^');
      }
      return childInfo.id + 'A' + groupId + '|' + getDishesCount([childInfo]) + '-' + spliceResultOfPropIds;
    });
    return [].concat.apply([], result);
  }));
  var groupChildDishIds = !splitPropsIds.join('#') || splitPropsIds.join('#') === '' ? id + '|1--' : splitPropsIds.join('#');
  return { key: consumeType + '_' + shopId + '_' + id + '_' + groupChildDishIds, value: orderCount + '|' + marketPrice };
};

var dishesLocalStorageMgr = (0, _storagePairHelper.createLastOrderedDishesMgr)();

exports.storeDishesLocalStorage = function (data, shopInfo, func) {
  var dishes = func ? func(data) : getOrderedDishes(data);
  var options = {
    shopId: getUrlParam('shopId'),
    shopName: shopInfo.commercialName || '',
    type: getUrlParam('type')
  };

  dishesLocalStorageMgr.set(dishes, options);
};

exports.clearDishesLocalStorage = function () {
  dishesLocalStorageMgr.clear();
};

exports.restoreDishesLocalStorage = function (data) {
  var shopId = getUrlParam('shopId');
  var type = getUrlParam('type');
  var dishes = dishesLocalStorageMgr.get({ shopId: shopId, type: type });
  if (!dishes) {
    return data;
  }

  data.dishList.forEach(function (dish) {
    var orderedDishIndex = dishes.findIndex(function (orderedDish) {
      return orderedDish.id === dish.id;
    });
    if (orderedDishIndex > -1) {
      dish.order = dishes[orderedDishIndex].order;
    }
  });

  return data;
};

exports.getDishesLocalStorage = function (args) {
  var dishes = dishesLocalStorageMgr.get(args);

  return dishes ? { dishes: dishes } : null;
};

var appendzero = exports.appendzero = function (number) {
  if (number < 10) {
    return '0' + number;
  }
  return number;
};

exports.isShopOpen = function () {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var now = new Date();
  var currentTime = appendzero(now.getHours()) + ':' + appendzero(now.getMinutes());

  var shopOpen = false;
  timeList.forEach(function (item, index) {
    if (currentTime >= item.startTime && currentTime <= item.endTime && !shopOpen) {
      shopOpen = true;
    }
  });

  return shopOpen;
};
exports.setDishCookie = function (dishesData, orderedData) {
  // 下面开始区分套餐cookie和单品菜cookie
  orderedData.map(function (orderData) {
    if (!isSingleDishWithoutProps(orderData)) {
      for (var index in orderData.order) {
        var setPackageDishCookie = getDishCookieObject(orderData, index);
        setCookie(setPackageDishCookie.key, setPackageDishCookie.value);
      }
      return true;
    }
    var setSignleDishCookie = getDishCookieObject(orderData, 0);
    return setCookie(setSignleDishCookie.key, setSignleDishCookie.value);
  });
};
exports.deleteOldDishCookie = function () {
  var oldCookieCollection = document.cookie.match(/(WM|TS).+?((?=;)|$)/g);
  if (oldCookieCollection && oldCookieCollection.length) {
    oldCookieCollection.forEach(function (cookie) {
      var date = new Date();
      date.setTime(date.getTime() - 10000);
      document.cookie = cookie + '=a; expires=' + date.toGMTString() + '; path=/';
    });
  }
};

exports.generateDishNameWithUnit = function (dishData, entry) {
  if (Array.isArray(dishData.dishPropertyTypeInfos) && dishData.dishPropertyTypeInfos.length) {
    var avaliableDishProps = dishData.dishPropertyTypeInfos.filter(function (prop) {
      return prop.type === 4;
    });
    if (avaliableDishProps.length) {
      var properties = avaliableDishProps.map(function (prop) {
        var _prop$properties = (0, _slicedToArray3.default)(prop.properties, 1),
            cur = _prop$properties[0];

        return cur && cur.name;
      }).join(', ');
      // return dishData.unitName ? `${dishData.name}(${properties})/${dishData.unitName}` : `${dishData.name}(${properties})`;
      switch (entry) {
        case 'dishMenu':
          return dishData.unitName !== '份' ? dishData.name + '(' + properties + ')/' + dishData.unitName : dishData.name + '(' + properties + ')';
        default:
          return dishData.name + '(' + properties + ')';
      }
    }
    // return dishData.unitName ? `${dishData.name}/${dishData.unitName}` : dishData.name;
    switch (entry) {
      case 'dishMenu':
        return dishData.unitName !== '份' ? dishData.name + '/' + dishData.unitName : dishData.name;
      default:
        return dishData.name;
    }
  }
  // return dishData.unitName ? `${dishData.name}/${dishData.unitName}` : dishData.name;
  switch (entry) {
    case 'dishMenu':
      return dishData.unitName !== '份' ? dishData.name + '/' + dishData.unitName : dishData.name;
    default:
      return dishData.name;
  }
};

exports.formatOpenTime = function (openTimeList) {
  var openTimeContent = '';
  // const resultObj = {};
  if (openTimeList && Array.isArray(openTimeList) && openTimeList.length !== 0) {
    var newOpenTimeList = [].slice.call(openTimeList); // 新数组
    var timeRange = '';
    var ignoreNum = [];
    openTimeList.forEach(function (item, index) {
      newOpenTimeList.splice(0, 1); // 去掉数组头
      if (ignoreNum.indexOf(index) !== -1) {
        return;
      }
      var basicStartTime = item.startTime; // 初始开始数据
      var basicEndTime = item.endTime; // 初始结束数据

      newOpenTimeList.forEach(function (newitem, newindex) {
        // 子循环
        // 如果时间有交集 分几种情况
        switch (true) {
          case newitem.startTime <= basicEndTime && newitem.startTime >= basicStartTime:
            if (newitem.endTime >= basicEndTime) {
              // 有交集
              basicEndTime = newitem.endTime;
            }
            ignoreNum.push(newindex + index + 1);
            break;
          case newitem.startTime <= basicStartTime:
            if (newitem.endTime >= basicStartTime && newitem.endTime <= basicEndTime) {
              // 有交集
              basicStartTime = newitem.startTime;
              ignoreNum.push(newindex + index + 1);
            } else if (newitem.endTime >= basicEndTime) {
              basicStartTime = newitem.startTime;
              basicEndTime = newitem.endTime;
              ignoreNum.push(newindex + index + 1);
            }
            break;
          default:
            break;
        }
      });
      timeRange = basicStartTime.slice(0, 5) + '-' + basicEndTime.slice(0, 5);
      openTimeContent += timeRange + ' ';
    });
  }
  return openTimeContent;
};

exports.formatMarket = function (marketList, formatDishesData) {
  var formatMarket = {};
  marketList.forEach(function (item, index) {
    var dishId = item.dishId;
    if (item.rules && item.rules.length !== 0 && formatDishesData[dishId]) {
      formatMarket[dishId] = item.rules;
    }
  });
  return formatMarket;
};

exports.formatMarketUpdate = function (marketList, formatDishesData) {
  var formatMarketUpdate = [];
  // 外部排序
  marketList.forEach(function (item, index) {
    var dishId = item.dishId;
    var dish = formatDishesData[dishId];

    if (item.rules && item.rules.length !== 0 && dish) {
      item.rules.forEach(function (itemt, indext) {
        formatMarketUpdate.push(itemt);
      });
    }
  });

  return formatMarketUpdate.sort(function (a, b) {
    if (b.updateTime > a.updateTime) {
      return 1;
    } else if (b.updateTime === a.updateTime) {
      return 0;
    }
    return -1;
  });
};

exports.formatDishesData = function (dishesData) {
  var formatDishesData = {};
  dishesData.forEach(function (item, index) {
    formatDishesData[item.brandDishId] = item;
  });
  return formatDishesData;
};

exports.matchDishesData = function (marketListUpdate, formatDishesData) {
  var marketMatchDishes = false;
  marketListUpdate.forEach(function (item, index) {
    if (formatDishesData[item.dishId]) {
      marketMatchDishes = true;
    }
  });
  return marketMatchDishes;
};

/*
  合并名称,销售单位,商品中类一致,商品参与的规格分组完全一致的菜品
*/
exports.mergeSameRuleDish = function (dishList, dishTypeList) {
  if (!dishList || !dishList.length) {
    return { dishList: [], dishTypeList: dishTypeList };
  }

  var mergedDishList = [];
  var sameRuleDishMap = {};
  var getDishRuleFlag = function getDishRuleFlag(dish) {
    var ids = dish.dishPropertyTypeInfos.filter(function (item) {
      return item.type === 4;
    }).map(function (item) {
      return item.properties[0].id;
    });
    return ids.sort().join('-');
  };

  dishList.forEach(function (dish, index) {
    if (dish.saleType === 1) {
      (0, _assign2.default)(dish, { stepNum: 1, dishIncreaseUnit: 1 });
    }

    // snail 2019-06-13 无论是什么售卖类型，都将做stepNum及dishIncreaseUnit 默认为1 向下求整的逻辑。
    var stepNum = dish.stepNum,
        dishIncreaseUnit = dish.dishIncreaseUnit;

    if (!stepNum) stepNum = 1;
    if (!dishIncreaseUnit) dishIncreaseUnit = 1;

    stepNum = isNaN(stepNum) ? stepNum : Math.floor(stepNum) === 0 ? 1 : Math.floor(stepNum);
    dishIncreaseUnit = isNaN(dishIncreaseUnit) ? dishIncreaseUnit : Math.floor(dishIncreaseUnit) === 0 ? 1 : Math.floor(dishIncreaseUnit);

    (0, _assign2.default)(dish, { stepNum: stepNum, dishIncreaseUnit: dishIncreaseUnit });

    if (isGroupDish(dish)) {
      mergedDishList.push(dish);
      return;
    }

    var ruleIdStr = dish.dishPropertyTypeInfos.filter(function (item) {
      return item.type === 4;
    }).map(function (item) {
      var firstProperty = item.properties && item.properties[0];
      if (firstProperty) {
        firstProperty.isChecked = true;
      }
      return item.id;
    }).join('-');
    var key = dish.name + '-' + dish.unitName + '-' + dish.dishTypeId + '-' + ruleIdStr;

    sameRuleDishMap[key] = (sameRuleDishMap[key] || []).concat([index]);
    dish.dishIngredientInfos = dish.dishIngredientInfos.map(function (item) {
      return (0, _extends3.default)({}, item, { isChecked: !!item.isChecked });
    });
    mergedDishList.push(dish);
  });

  var _loop = function _loop(key) {
    if (!sameRuleDishMap.hasOwnProperty(key)) {
      return 'continue';
    }

    var sameDishIndexs = sameRuleDishMap[key];
    if (sameDishIndexs.length <= 1) {
      return 'continue';
    }

    var marketPrices = [];
    sameDishIndexs.forEach(function (dishIndex) {
      var sameDish = dishList[dishIndex];
      sameDish.ruleFlag = getDishRuleFlag(sameDish);
      marketPrices.push(sameDish.marketPrice);
    });

    var minMarketPirice = Math.min.apply(null, marketPrices);
    var maxMarketPirice = Math.max.apply(null, marketPrices);
    var firstDishId = '';

    sameDishIndexs.forEach(function (dishIndex, index) {
      var dish = mergedDishList[dishIndex];
      if (index === 0) {
        firstDishId = dish.id;
        (0, _assign2.default)(dish, { sameDishIndexs: sameDishIndexs, mergedMinPrice: minMarketPirice === maxMarketPirice ? undefined : minMarketPirice });
        return;
      }

      (0, _assign2.default)(dish, { proxyDishId: firstDishId });
    });
  };

  for (var key in sameRuleDishMap) {
    var _ret = _loop(key);

    if (_ret === 'continue') continue;
  }

  return {
    dishList: mergedDishList,
    dishTypeList: dishTypeList
  };
};

exports.organizeDishData = function (dish) {
  var dishData = {};
  dishData.id = dish.id;
  dishData.name = dish.name;
  dishData.dishTypeId = dish.dishTypeId;
  dishData.brandDishId = dish.brandDishId;
  dishData.type = dish.type;
  dishData.marketPrice = dish.marketPrice;
  dishData.unitName = dish.unitName;
  dishData.dishIncreaseUnit = dish.dishIncreaseUnit;
  dishData.stepNum = dish.stepNum;
  dishData.dishTypeName = (0, _helper.formatMessage)(_global2.default.defaultSort);
  dishData.dishTypeOrder = 0;
  dishData.saleType = dish.saleType;
  dishData.proxyDishId = dish.proxyDishId;

  // 菜品属性
  var fillPropertyTypeList = function fillPropertyTypeList(propertyTypeList, dishType) {
    if (!propertyTypeList || !propertyTypeList.length) {
      return [];
    }

    return propertyTypeList.map(function (propertyType) {
      var name = propertyType.name,
          type = propertyType.type,
          id = propertyType.id,
          properties = propertyType.properties;

      return { id: id, name: name, type: type, properties: dishType === 'number' ? properties : properties.filter(function (item) {
          return item.isChecked;
        }) };
    });
  };

  var dishTypeList = JSON.parse(sessionStorage.dishTypeList || '[]');

  dishTypeList.forEach(function (item) {
    if (item.id === dish.dishTypeId) {
      dishData.dishTypeName = item.name;
      // dishData.dishTypeOrder = item.desc || 0;
      dishData.dishTypeOrder = 0;
    }
  });

  // 菜品配料
  var fillDishIngredientInfos = function fillDishIngredientInfos(dishIngredientInfos) {
    return (dishIngredientInfos || []).filter(function (item) {
      return item.isChecked;
    });
  };

  if (isSingleDishWithoutProps(dish)) {
    dishData.num = dish.order;
    dishData.propertyTypeList = dish.dishPropertyTypeInfos || [];
    dishData.dishIngredientInfos = dish.dishIngredientInfos || [];
  } else if (isGroupDish(dish)) {
    var _dish$order2 = (0, _slicedToArray3.default)(dish.order, 1),
        order = _dish$order2[0];

    dishData.num = order.count;
    dishData.subDishItems = [];
    order.groups.forEach(function (group) {
      // 分组的子菜遍历
      group.childInfos.forEach(function (childInfo) {
        if (!childInfo.order) {
          return;
        }
        var num = getDishesCount([childInfo]);
        if (!num) {
          return;
        }

        // const orderedChildDish = {};
        // orderedChildDish.groupId = group.id;
        // orderedChildDish.num = num;
        // orderedChildDish.itemId = childInfo.id;
        // orderedChildDish.name = childInfo.name;
        // orderedChildDish.marketPrice = childInfo.marketPrice;
        // orderedChildDish.unitName = childInfo.unitName;

        // let ingredientInfoList = childInfo.dishIngredientInfos;
        // let propertyTypeInfoList = childInfo.dishPropertyTypeInfos;
        // if (typeof childInfo.order !== 'number') {
        //   let ingredientInfoListTemp = childInfo.order.map((item) => item.dishIngredientInfos);
        //   if (ingredientInfoListTemp) {
        //     ingredientInfoList = ingredientInfoListTemp[0] || [];
        //   }
        //   let propertyTypeInfoListTemp = childInfo.order.map((item) => item.dishPropertyTypeInfos);
        //   if (propertyTypeInfoListTemp) {
        //     propertyTypeInfoList = propertyTypeInfoListTemp[0] || [];
        //   }
        // }

        // orderedChildDish.propertyTypeList = fillPropertyTypeList(propertyTypeInfoList || []);
        // orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(ingredientInfoList || []);
        // dishData.subDishItems.push(orderedChildDish);

        // 遍历order -- 改
        if (typeof childInfo.order !== 'number') {
          childInfo.order.map(function (item) {
            if (item.count === 0) return false;
            var orderedChildDish = {};
            orderedChildDish.groupId = group.id;
            orderedChildDish.itemId = childInfo.id;
            orderedChildDish.name = childInfo.name;
            orderedChildDish.marketPrice = childInfo.marketPrice;
            orderedChildDish.unitName = childInfo.unitName;
            orderedChildDish.num = item.count;
            orderedChildDish.saleType = childInfo.saleType;
            orderedChildDish.propertyTypeList = fillPropertyTypeList(item.dishPropertyTypeInfos || []);
            orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(item.dishIngredientInfos || []);
            dishData.subDishItems.push(orderedChildDish);
            return true;
          });
        } else {
          var orderedChildDish = {};
          orderedChildDish.groupId = group.id;
          orderedChildDish.num = num;
          orderedChildDish.itemId = childInfo.id;
          orderedChildDish.name = childInfo.name;
          orderedChildDish.marketPrice = childInfo.marketPrice;
          orderedChildDish.unitName = childInfo.unitName;
          orderedChildDish.saleType = childInfo.saleType;
          orderedChildDish.propertyTypeList = fillPropertyTypeList(childInfo.dishPropertyTypeInfos || [], 'number');
          orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(childInfo.dishIngredientInfos || []);
          dishData.subDishItems.push(orderedChildDish);
        }
      });
    });
  } else {
    var _dish$order3 = (0, _slicedToArray3.default)(dish.order, 1),
        _order = _dish$order3[0];

    dishData.num = _order.count;
    dishData.propertyTypeList = fillPropertyTypeList(_order.dishPropertyTypeInfos);
    dishData.dishIngredientInfos = fillDishIngredientInfos(_order.dishIngredientInfos);
  }
  var time = new Date();
  return (0, _assign2.default)({}, dishData, { tag: time.getTime() });
};

exports.adjustOrderedDishIncrement = function (dish, increment) {
  var newDish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (isSingleDishWithoutProps(dish)) {
    var order = dish.order || newDish.order || 0;
    var _dish$dishIncreaseUni = dish.dishIncreaseUnit,
        dishIncreaseUnit = _dish$dishIncreaseUni === undefined ? 1 : _dish$dishIncreaseUni,
        _dish$stepNum = dish.stepNum,
        stepNum = _dish$stepNum === undefined ? 1 : _dish$stepNum;

    if (increment > 0 && order === 0) {
      return increment === stepNum ? dishIncreaseUnit : increment;
    }

    var calculdatedOrder = order + increment;
    if (calculdatedOrder <= 0) {
      return -order;
    }

    if (calculdatedOrder < dishIncreaseUnit) {
      return dishIncreaseUnit * (Math.abs(increment) / increment);
    }
  }

  return increment;
};

exports.getDishMemberPriceWithSameRuleDishes = function (dish, sameRuleDishes) {
  if (!sameRuleDishes) {
    return getDishMemberPrice(dish);
  }

  var memberDishPrices = [];
  sameRuleDishes.forEach(function (item) {
    if (dish.marketPrice === item.marketPrice && item.isMember) {
      memberDishPrices.push(getDishMemberPrice(item));
    }
  });
  return Math.min.apply(null, memberDishPrices);
};

exports.containsSubPropertyDetail = function (dish) {
  if (isSingleDishWithoutProps(dish)) {
    return false;
  }

  if (!isGroupDish(dish)) {
    return hasSelectedProps(dish);
  }

  var _ref = dish.order || [],
      _ref2 = (0, _slicedToArray3.default)(_ref, 1),
      order = _ref2[0];

  if (!order) {
    return false;
  }

  var _order$groups = order.groups,
      groups = _order$groups === undefined ? [] : _order$groups;

  return groups.some(function (group) {
    return group.childInfos.some(function (child) {
      return getDishesCount([child]) > 0;
    });
  });
};

var ballFlyAnimationTimer = {
  queue: [],
  current: null
};

var ballFlyWhenOrderDish = exports.ballFlyWhenOrderDish = function (options) {
  if (ballFlyAnimationTimer.isSingle === undefined) {
    ballFlyAnimationTimer.isSingle = navigator.userAgent.toLowerCase().indexOf('android') !== -1;
  }

  if (ballFlyAnimationTimer.isSingle && ballFlyAnimationTimer.current) {
    ballFlyAnimationTimer.queue = [options];
    return;
  }

  ballFlyAnimationTimer.current = options;
  var settings = (0, _assign2.default)({
    vertexRtop: 20,
    speed: 2.8,
    start: {},
    end: {}
  }, options);

  var init = function init() {
    document.body.insertAdjacentHTML('beforeend', '<ins class=\'' + (settings.className || '') + '\'></ins>');
    settings.elem = document.body.lastChild;
    var start = settings.start,
        end = settings.end,
        vertexRtop = settings.vertexRtop;


    var vertexTop = Math.min(start.top, end.top) - Math.abs(start.left - end.left) / 13;
    if (vertexTop < vertexRtop) {
      vertexTop = Math.min(vertexRtop, Math.min(start.top, end.top));
    }
    var distance = Math.sqrt(Math.pow(start.top - end.top, 2) + Math.pow(start.left - end.left, 2));
    var steps = Math.ceil(Math.min(Math.max(Math.log(distance) / 0.05 - 75, 30), 100) / settings.speed);
    var ratio = start.top === vertexTop ? 0 : -Math.sqrt((end.top - vertexTop) / (start.top - vertexTop));
    var vertexLeft = (ratio * start.left - end.left) / (ratio - 1);
    var curvature = end.left === vertexLeft ? 0 : (end.top - vertexTop) / Math.pow(end.left - vertexLeft, 2);

    (0, _assign2.default)(settings, {
      count: -1,
      steps: steps,
      vertexLeft: vertexLeft,
      vertexTop: vertexTop,
      curvature: curvature
    });
    (0, _assign2.default)(settings.elem.style, {
      left: settings.start.left + 'px',
      top: settings.start.top + 'px'
    });
  };

  var destory = function destory() {
    ballFlyAnimationTimer.current = null;
    settings.elem.parentNode.removeChild(settings.elem);
    settings.elem = null;
  };

  var queue = function queue() {
    var next = ballFlyAnimationTimer.queue.shift();
    if (next) {
      ballFlyWhenOrderDish(next);
    }
  };

  var move = function move() {
    var start = settings.start,
        steps = settings.steps,
        count = settings.count,
        end = settings.end;

    var left = start.left + (end.left - start.left) * count / steps;
    var top = settings.curvature === 0 ? start.top + (end.top - start.top) * count / steps : settings.curvature * Math.pow(left - settings.vertexLeft, 2) + settings.vertexTop;
    settings.elem.style.transform = 'translate3d(' + (left - start.left) + 'px,' + (top - start.top) + 'px,0)';
    settings.count++;

    var time = window.requestAnimationFrame(move);
    if (count === steps) {
      window.cancelAnimationFrame(time);
      destory();
      queue();

      if (settings.onEnd) {
        setTimeout(function () {
          settings.onEnd();
        }, 20);
      }
    }
  };
  init();
  move();
};

exports.divideOrderedDishes = function (dishes) {
  var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  return [].concat.apply([], dishes.map(function (dish) {
    if (isSingleDishWithoutProps(dish)) {
      return [(0, _assign2.default)({}, dish, func(dish))];
    }
    return dish.order.map(function (dishOrder, idx) {
      return (0, _assign2.default)({}, dish, func(dish), { order: [(0, _assign2.default)({}, dishOrder)] });
    });
  }));
};

/**
 * 菜品打折数据去重
 */
exports.uniqueDiscountInfo = function (dishList) {
  var list = [];
  var uniqueIdMap = {};

  (dishList || []).forEach(function (dish) {
    var id = dish.dishId;

    if (!uniqueIdMap.hasOwnProperty(id)) {
      uniqueIdMap[id] = true;
      list.push(dish);
    }
  });
  return list;
};

/**
 * 配料属性
 */
exports.formatMemo = function (mainDish) {
  // 合并配料与菜品属性 BEGIN
  var dishIngredientList = mainDish.dishIngredientInfos || [];
  var propertyTypeList = mainDish.propertyTypeList || [];
  var dishIngredientArray = [];

  if (dishIngredientList && dishIngredientList.length !== 0) {
    dishIngredientArray = [{
      name: (0, _helper.formatMessage)(_dishMenu2.default.ingredients),
      type: 2.5,
      properties: dishIngredientList
    }];
  }
  propertyTypeList = propertyTypeList.concat(dishIngredientArray);
  // 合并配料与菜品属性 END

  if (!propertyTypeList || propertyTypeList.length === 0) {
    return '';
  }
  var memoList = (propertyTypeList || []).filter(function (item) {
    return item.type !== 4;
  });
  memoList = Array.prototype.slice.call(memoList).sort(function (a, b) {
    return a.type - b.type;
  }); // 按照 口味-标签-备注 进行排序
  var memo = '';
  memoList.forEach(function (item, index) {
    if (item.type === 1 || item.type === 2 || item.type === 3 || item.type === 2.5) {
      // 口味做法
      memo += ' | ' + item.name + ':';
    }
    (item.properties || []).forEach(function (itemt, indext) {
      if (itemt.name) {
        if (item.type === 2.5) {
          // 配料需要加上*num
          memo += itemt.name + 'x' + (itemt.num || 1) + ',';
        } else {
          memo += itemt.name + ',';
        }
      }
    });
    memo = memo.substring(0, memo.length - 1);
  });
  memo = memo.substring(2, memo.length);
  return memo;
};

var TS_AD_SHOW_KEY = 'fullscreen-ad-display-time';
var SELECT_PEOPLE_KEY = 'select-people-flag';

var getSelectPeopleFlag = function getSelectPeopleFlag() {
  var _latestFlag;

  var fromSelectPeople = getUrlParam('fromSelectPeople');
  var now = new Date();
  var today = now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate();

  var DISH_KEY = 'dish-' + today;
  var PEOPLE_KEY = 'people-' + today;
  var selectPeopleFlag = JSON.parse(window.localStorage.getItem(SELECT_PEOPLE_KEY)) || {};

  var dishNum = selectPeopleFlag[DISH_KEY];
  var peopleNum = selectPeopleFlag[PEOPLE_KEY];
  dishNum = dishNum ? dishNum + 1 : 1;
  if (fromSelectPeople === 'true') {
    peopleNum = peopleNum ? peopleNum + 1 : 1;
  }
  var latestFlag = (_latestFlag = {}, (0, _defineProperty3.default)(_latestFlag, DISH_KEY, dishNum), (0, _defineProperty3.default)(_latestFlag, PEOPLE_KEY, peopleNum), _latestFlag);
  window.localStorage.setItem(SELECT_PEOPLE_KEY, (0, _stringify2.default)(latestFlag));

  return {
    dishNum: dishNum,
    peopleNum: peopleNum
  };
};

exports.getFullscreenAdShow = function (_ref3) {
  var fullAdvertRule = _ref3.fullAdvertRule,
      fullAdvertImgUrl = _ref3.fullAdvertImgUrl,
      fullAdvertUrl = _ref3.fullAdvertUrl;

  var key = TS_AD_SHOW_KEY + '-' + getUrlParam('shopId');
  var show = false;
  // 每天显示一次
  var selectPeopleFlag = getSelectPeopleFlag() || {};
  if (fullAdvertRule === 1 && fullAdvertImgUrl) {
    // const last = window.localStorage.getItem(key);
    // const now = new Date();
    // const today = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;
    // const current = `${fullAdvertImgUrl}-${fullAdvertUrl}-${today}`;

    // if (!last || last !== current) {
    //   show = true;
    //   window.localStorage.setItem(key, current);
    // }
    var dishNum = selectPeopleFlag.dishNum,
        peopleNum = selectPeopleFlag.peopleNum;

    if (dishNum === 2 && peopleNum === 1 || dishNum === 1) {
      show = true;
    }
  }
  // 每次访问显示
  if (fullAdvertRule === 2 && fullAdvertImgUrl) {
    var hasShowed = window.sessionStorage.getItem(key);
    if (!hasShowed) {
      show = true;
      window.sessionStorage.setItem(key, 1);
    }
  }

  return show;
};

var getDishIds = function getDishIds(dishes) {
  return dishes.reduce(function (list, dish) {
    var spu = dish.productDishType === 1 && dish.dishList && dish.dishList.length;
    return spu ? list.concat(getDishIds(dish.dishList)) : list.concat(dish.dishId);
  }, []);
};

exports.getDishIds = getDishIds;

/**
 * 计算商品的基准价格
 * @param {Object} dish 商品对象
 */
var getDishBasePrice = function getDishBasePrice(dish) {
  var isSingleDish = isSingleDishWithoutProps(dish);
  var price = isSingleDish ? dish.marketPrice * dish.order : dish.marketPrice * dish.order[0].count;

  return price >= 0 ? price : 0;
};

exports.getDishBasePrice = getDishBasePrice;

/**
 * 计算商品列表的基准价格
 * @param {Array} dishes 商品列表
 */
var getDishesBasePrice = function getDishesBasePrice(dishes) {
  return dishes.reduce(function (total, dish) {
    return total + getDishBasePrice(dish);
  }, 0);
};

exports.getDishesBasePrice = getDishesBasePrice;

/**
 * 计算商品份数
 * @param {Array} dishes 商品列表
 */
var countDishesNumber = function countDishesNumber(dishes) {
  return dishes.reduce(function (count, dish) {
    var isSingleDish = isSingleDishWithoutProps(dish);
    return count + (isSingleDish ? dish.order : dish.order.reduce(function (t, c) {
      return t + c.count;
    }, 0));
  }, 0);
};

exports.countDishesNumber = countDishesNumber;

/**
 * 将带有不同做法的商品平铺出来
 * @param {Array} dishes 购物车的商品列表
 */
var divideDishes = function divideDishes(dishes, keyPrefix) {
  var prefix = keyPrefix ? '-' + keyPrefix + '_' + new Date().getTime() : '';

  return [].concat.apply([], dishes.map(function (dish) {
    if (isSingleDishWithoutProps(dish)) {
      return [(0, _extends3.default)({}, dish, {
        basePrice: dish.marketPrice * dish.order,
        key: '' + dish.brandDishId + prefix + '-0'
      })];
    }
    return dish.order.map(function (dishOrder, idx) {
      return (0, _extends3.default)({}, dish, {
        key: '' + dish.brandDishId + prefix + '-' + idx,
        basePrice: dish.marketPrice * dishOrder.count,
        order: [(0, _extends3.default)({}, dishOrder)],
        orderLength: dish.order.length
      });
    });
  }));
};

exports.divideDishes = divideDishes;

exports.mergeOrderedDishes = function (orderedDishes, selectedDishes) {
  // 去掉 immutable 属性
  var ordered = _seamlessImmutable2.default.asMutable(orderedDishes, { deep: true });
  // 新增的商品
  var newDishes = _seamlessImmutable2.default.asMutable(selectedDishes, { deep: true }).filter(function (dish) {
    var hadOne = ordered.find(function (item) {
      return item.brandDishId === dish.brandDishId;
    });

    if (hadOne) {
      // 如果购物车中已经有这个商品；则更新它的订单属性
      hadOne.order = typeof hadOne.order === 'number' ? hadOne.order + dish.order : hadOne.order.concat(dish.order);
    }

    return !hadOne;
  });
  return ordered.concat(newDishes);
};

var getValueForDiscount = function getValueForDiscount(originVal, discount) {
  return +(originVal * discount * 0.1).toFixed(2);
};

/**
 * 计算属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @return {dishPropertyTypeInfos,dishIngredientInfos}
 */
var computePropsAndIngredientMemberRePrice = function computePropsAndIngredientMemberRePrice(dish, discountValue, discountType) {
  var dishPropertyTypeInfos = dish.dishPropertyTypeInfos,
      dishIngredientInfos = dish.dishIngredientInfos;

  var res = { dishPropertyTypeInfos: dishPropertyTypeInfos, dishIngredientInfos: dishIngredientInfos };
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
      res.dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
        var properties = prop.properties;

        var newProperties = properties.map(function (item) {
          var _item$reprice = item.reprice,
              reprice = _item$reprice === undefined ? 0 : _item$reprice;

          return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
        });
        return (0, _assign2.default)({}, prop, { properties: newProperties });
      });
    }

    if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
      res.dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
        var _ingredient$reprice = ingredient.reprice,
            reprice = _ingredient$reprice === undefined ? 0 : _ingredient$reprice;

        return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
      });
    }
  }

  return res;
};

exports.computePropsAndIngredientMemberRePrice = computePropsAndIngredientMemberRePrice;

/**
 * 计算order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @param {*} ableAddPriceDiscount 是否开启加价折扣
 * @return order
 */
var computeOrderMemberPrice = function computeOrderMemberPrice(dish, discountValue, discountType) {
  var ableAddPriceDiscount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var order = dish.order;

  if (typeof order === 'number') return order;

  if (Array.isArray(order)) {
    var newOrder = order.map(function (o) {
      var dishPropertyTypeInfos = o.dishPropertyTypeInfos,
          dishIngredientInfos = o.dishIngredientInfos;
      // 只有开启折扣或者统一折扣 && 开启加价折扣 -> 口味做法才能打折

      if ((discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) && ableAddPriceDiscount) {
        if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
          dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
            var properties = prop.properties;

            var newProperties = properties.map(function (item) {
              var _item$reprice2 = item.reprice,
                  reprice = _item$reprice2 === undefined ? 0 : _item$reprice2;

              return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
            });
            return (0, _assign2.default)({}, prop, { properties: newProperties });
          });
        }

        if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
          dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
            var _ingredient$reprice2 = ingredient.reprice,
                reprice = _ingredient$reprice2 === undefined ? 0 : _ingredient$reprice2;

            return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
          });
        }
      }

      return (0, _extends3.default)({}, o, {
        dishPropertyTypeInfos: dishPropertyTypeInfos,
        dishIngredientInfos: dishIngredientInfos
      });
    });
    return newOrder;
  }

  return dish.order;
};
exports.computeOrderMemberPrice = computeOrderMemberPrice;

/**
 * 计算group 中 order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @param {*} ableAddPriceDiscount 是否开启加价折扣
 * @return order
 */
var computeGroupOrderMemberPrice = function computeGroupOrderMemberPrice(dish, discountValue, discountType) {
  var ableAddPriceDiscount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var order = dish.order,
      isMember = dish.isMember;
  // 只有折扣和统一折扣需要全部设置会员价  固定价只有group套餐外层memberPrice才需要修改，对内部子菜无影响

  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    var newOrder = order.map(function (o) {
      var count = o.count,
          _o$groups = o.groups,
          groups = _o$groups === undefined ? [] : _o$groups;

      var newGroups = groups.map(function (group) {
        var _group$childInfos = group.childInfos,
            childInfos = _group$childInfos === undefined ? [] : _group$childInfos;

        var newChildInfos = childInfos.map(function (child) {
          return (0, _extends3.default)({}, child, {
            // memberMarketPrice: getDishMemberPrice({ isMember, ...child }, discountValue, discountType),
            // memberMarketPrice: getValueForDiscount(child.marketPrice, discountValue),
            memberMarketPrice: ableAddPriceDiscount ? getValueForDiscount(child.marketPrice, discountValue) : child.marketPrice,
            order: computeOrderMemberPrice((0, _extends3.default)({ isMember: isMember }, child), discountValue, discountType, ableAddPriceDiscount)
          });
        });
        return (0, _extends3.default)({}, group, {
          childInfos: newChildInfos
        });
      });

      return (0, _extends3.default)({}, o, {
        groups: newGroups
      });
    });

    return newOrder;
  }
  return order;
};
exports.computeGroupOrderMemberPrice = computeGroupOrderMemberPrice;

/**
 * 计算order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @return {dishPropertyTypeInfos, dishIngredientInfos}
 */
var computeOrderPropsAndIngredientMemberRePrice = function computeOrderPropsAndIngredientMemberRePrice(dish, discountValue, discountType) {
  var dishPropertyTypeInfos = dish.dishPropertyTypeInfos,
      dishIngredientInfos = dish.dishIngredientInfos;

  var res = { dishPropertyTypeInfos: dishPropertyTypeInfos, dishIngredientInfos: dishIngredientInfos };
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
      res.dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
        var properties = prop.properties;

        var newProperties = properties.map(function (item) {
          var _item$reprice3 = item.reprice,
              reprice = _item$reprice3 === undefined ? 0 : _item$reprice3;

          return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
        });
        return (0, _assign2.default)({}, prop, { properties: newProperties });
      });
    }

    if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
      res.dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
        var _ingredient$reprice3 = ingredient.reprice,
            reprice = _ingredient$reprice3 === undefined ? 0 : _ingredient$reprice3;

        return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
      });
    }
  }

  return res;
};

exports.computeOrderPropsAndIngredientMemberRePrice = computeOrderPropsAndIngredientMemberRePrice;

/**
 * 计算属性、配料等的会员价(套餐groups)
 * 各个子菜和子菜的口味做法 会员价
 * @param {*} groups
 * @param {*} discountValue
 * @param {*} discountType
 */
var computeMemberRePriceByGroups = function computeMemberRePriceByGroups(groups, discountValue, discountType) {
  var result = groups;
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    result = groups.flatMap(function (group) {
      var childInfos = group.childInfos;

      if (Array.isArray(childInfos)) {
        var newChildInfos = childInfos.flatMap(function (child) {
          var marketPrice = child.marketPrice;

          var res = computePropsAndIngredientMemberRePrice(child, discountValue, discountType);
          res.memberMarketPrice = getValueForDiscount(marketPrice, discountValue);
          return (0, _assign2.default)({}, child, res);
        });
        return (0, _assign2.default)({}, group, { childInfos: newChildInfos });
      }
      return group;
    });
  }
  return result;
};

exports.computeMemberRePriceByGroups = computeMemberRePriceByGroups;

var getTotalMemberPriceBySingle = function getTotalMemberPriceBySingle(dish) {
  if (_seamlessImmutable2.default.isImmutable(dish)) {
    dish = _seamlessImmutable2.default.asMutable(dish, { deep: true });
  }
  var _dish = dish,
      order = _dish.order,
      saleType = _dish.saleType,
      memberMarketPrice = _dish.memberMarketPrice,
      isMember = _dish.isMember;

  var isWeightMode = saleType === 1; // 称重模式
  var memberPrice = memberMarketPrice !== undefined && memberMarketPrice !== null ? memberMarketPrice : getDishMemberPrice(dish);
  memberPrice = memberPrice === null ? dish.marketPrice : memberPrice;
  var totalPrice = 0;

  if (Array.isArray(order)) {
    var _order$reduce = order.reduce(function (priceAndNum, item) {
      var oldPrice = priceAndNum.price,
          oldNum = priceAndNum.num;
      var count = item.count,
          dishIngredientInfos = item.dishIngredientInfos,
          dishPropertyTypeInfos = item.dishPropertyTypeInfos;

      var diAmount = 0;
      var dpAmount = 0;
      if (Array.isArray(dishIngredientInfos)) {
        diAmount += dishIngredientInfos.reduce(function (ingredientPrice, ingredient) {
          var memberReprice = ingredient.memberReprice,
              reprice = ingredient.reprice,
              isChecked = ingredient.isChecked;

          var useMemberPrice = memberReprice !== undefined && memberReprice !== null;

          // return isChecked ? ingredientPrice + memberReprice : ingredientPrice;
          return isChecked ? ingredientPrice + (useMemberPrice ? memberReprice : reprice) : ingredientPrice;
        }, 0);
      }

      if (Array.isArray(dishPropertyTypeInfos)) {
        dishPropertyTypeInfos.forEach(function (propertyType) {
          var properties = propertyType.properties;

          if (Array.isArray(properties)) {
            dpAmount += properties.reduce(function (proPrice, pro) {
              var isChecked = pro.isChecked,
                  memberReprice = pro.memberReprice,
                  reprice = pro.reprice;

              var useMemberPrice = memberReprice !== undefined && memberReprice !== null;

              // return isChecked ? proPrice + memberReprice : proPrice;
              return isChecked ? proPrice + (useMemberPrice ? memberReprice : reprice) : proPrice;
            }, 0);
          }
        });
      }

      var changeAmount = isWeightMode ? dpAmount + diAmount : (dpAmount + diAmount) * count;
      return { price: oldPrice + changeAmount, num: count + oldNum };
    }, { price: 0, num: 0 }),
        price = _order$reduce.price,
        num = _order$reduce.num;

    totalPrice = memberPrice * num + price;
  } else if (!isNaN(order)) {
    totalPrice = memberPrice * order;
  }
  return +totalPrice.toFixed(2);
};

var getTotalMemberPriceByMulti = function getTotalMemberPriceByMulti(dish) {
  var order = dish.order,
      discountType = dish.discountType;

  var oneBasePrice = getDishMemberPrice(dish); // 单份菜品基价价格
  var allCount = 0; // order中总分数
  var discountTotal = 0; // 加价部分总和
  if (Array.isArray(order)) {
    order.forEach(function (orderItem) {
      var groups = orderItem.groups,
          count = orderItem.count;

      allCount += count;
      groups.forEach(function (group) {
        var childInfos = group.childInfos;

        childInfos.forEach(function (childInfo) {
          var marketPrice = childInfo.marketPrice,
              memberMarketPrice = childInfo.memberMarketPrice,
              childOrder = childInfo.order;

          var allChildOrder = Array.isArray(childOrder) ? childOrder.reduce(function (total, item) {
            return total + item.count;
          }, 0) : childOrder;
          var singlePrice = getTotalMemberPriceBySingle(childInfo);
          var basePrice = allChildOrder * (memberMarketPrice >= 0 ? memberMarketPrice : marketPrice);
          var childPrice = discountType === _const.MemberPrivTypes.REDUCE ? // (singlePrice + basePrice) :
          singlePrice // 修改会员价加价不折扣后不需要加basePrice
          : singlePrice;
          discountTotal += childPrice * count;
        });
      });
    });
  } else if (!isNaN(order)) {
    allCount = Number(order);
  }
  var allPrice = oneBasePrice * allCount + discountTotal;
  return +allPrice.toFixed(2);
};

/**
 * 获取菜品的会员价+口味做法会员价
 * 这个方法适用于已经将口味做法的会员价写入dish的菜品
 * memberRePrice
 * @param {*} dish
 */
var getTotalMemberPrice = function getTotalMemberPrice(dish) {
  var type = dish.type;

  var res = 0;
  if (type === 1) {
    res = getTotalMemberPriceByMulti(dish);
  } else {
    res = getTotalMemberPriceBySingle(dish);
  }

  return res;
};

exports.getTotalMemberPrice = getTotalMemberPrice;

/**
 * 根据dish 算出口味做法，配料以及套餐的会员价
 * @param {*} dish
 * @param {*} discountVal
 * @param {*} discountType
 */
var getPropAndIngredientMemberPrice = function getPropAndIngredientMemberPrice(dish, discountVal, discountType) {
  var groups = dish.groups;

  var result = computePropsAndIngredientMemberRePrice(dish, discountVal, discountType);
  var newGroups = groups;
  if (Array.isArray(groups)) {
    newGroups = computeMemberRePriceByGroups(groups, discountVal, discountType);
  }
  return {
    groups: newGroups,
    dishPropertyTypeInfos: result.dishPropertyTypeInfos,
    dishIngredientInfos: result.dishIngredientInfos
  };
};

exports.getPropAndIngredientMemberPrice = getPropAndIngredientMemberPrice;

/**
 * 获取菜品的会员价+口味做法会员价购物车所选菜品之和
 * memberRePrice
 * @param {*} dishs
 * @param {*} ableAddPriceDiscount
 */
exports.getMemberDishesPrice = function () {
  var dishes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ableAddPriceDiscount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var dishesPrice = dishes.reduce(function (all, cur) {
    var memberPriceStr = cur.isMember && cur.memberPrice !== null ? cur.memberPrice.toString() : null; // 消除memberPrice为0的影响
    // const isUseAddDiscount = cur.isMember && cur.isUserMember && memberPriceStr && ableAddPriceDiscount;
    // if (isUseAddDiscount) return all + getTotalMemberPrice(cur);
    // return all + getDishesPrice([cur], null, true);
    // return all + getDishesPrice([cur], null, cur.isMember);

    var useAddDiscount = (cur.discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT || cur.discountType === _const.MemberPrivTypes.DISCOUNT) && cur.isMember && cur.isUserMember && memberPriceStr && ableAddPriceDiscount;
    var useMemberPrice = cur.isMember && cur.isUserMember && memberPriceStr;
    if (useAddDiscount) {
      return all + getTotalMemberPrice(cur);
    } else if (!!useMemberPrice) {
      return all + getTotalMemberPrice(cur);
    }
    return all + getDishesPrice([cur], null, cur.isMember);
  }, 0);

  if (isFinite(dishesPrice) && Math.floor(dishesPrice) === dishesPrice) {
    return dishesPrice;
  }
  return parseFloat(dishesPrice.toFixed(2));
};

/**
 * 变价享受会员价。
 * 该方法主要是更改order
 * @param {*} order
 * @param {*} discountValue
 * @param {*} discountType
 */
var reConstructDishOrder = function reConstructDishOrder(order, discountValue, discountType) {
  var res = order;

  if (Array.isArray(order)) {
    if (_seamlessImmutable2.default.isImmutable(order)) {
      res = _seamlessImmutable2.default.asMutable(order, { deep: true });
    }
    res = res.map(function (orderItem) {
      var groups = orderItem.groups,
          dishIngredientInfos = orderItem.dishIngredientInfos,
          dishPropertyTypeInfos = orderItem.dishPropertyTypeInfos;

      var newOrderItem = (0, _extends3.default)({}, orderItem);
      if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
        if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
          newOrderItem.dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
            var properties = prop.properties;

            var newProperties = properties.map(function (item) {
              var _item$reprice4 = item.reprice,
                  reprice = _item$reprice4 === undefined ? 0 : _item$reprice4;

              return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
            });
            return (0, _assign2.default)({}, prop, { properties: newProperties });
          });
        }

        if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
          newOrderItem.dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
            var _ingredient$reprice4 = ingredient.reprice,
                reprice = _ingredient$reprice4 === undefined ? 0 : _ingredient$reprice4;

            return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
          });
        }

        if (Array.isArray(groups)) {
          newOrderItem.groups = groups.map(function (group) {
            var childInfos = group.childInfos;

            var newChildInfos = Array.isArray(childInfos) ? childInfos.map(function (child) {
              var subOrder = child.order,
                  marketPrice = child.marketPrice;
              // const memberMarketPrice = getValueForDiscount(marketPrice, discountValue) || marketPrice || 0;

              var memberMarketPrice = getValueForDiscount(marketPrice, discountValue) || 0;
              return (0, _extends3.default)({}, child, {
                memberMarketPrice: memberMarketPrice,
                order: reConstructDishOrder(subOrder, discountValue, discountType)
              });
            }) : childInfos;

            return (0, _extends3.default)({}, group, { childInfos: newChildInfos });
          });
        }
      }

      return newOrderItem;
    });
  }
  return res;
};

exports.reConstructDishOrder = reConstructDishOrder;

/**
 * 将菜品信息中的会员价 写入正价，用于计算
 * @param {*} dish
 */
var covertMemberPriceInDish = function covertMemberPriceInDish(dish) {
  var order = dish.order,
      memberMarketPrice = dish.memberMarketPrice,
      discountType = dish.discountType,
      isMember = dish.isMember;

  var newMarketPrice = memberMarketPrice !== null && memberMarketPrice !== undefined ? memberMarketPrice : getDishMemberPrice((0, _extends3.default)({ isMember: isMember, discountType: discountType }, dish));

  var newOrder = order;
  if (Array.isArray(order)) {
    newOrder = order.map(function (orderItem) {
      var result = (0, _extends3.default)({}, orderItem);
      var groups = orderItem.groups,
          dishIngredientInfos = orderItem.dishIngredientInfos,
          dishPropertyTypeInfos = orderItem.dishPropertyTypeInfos;

      var newGroups = groups;
      if (Array.isArray(groups) && groups.length > 0) {
        newGroups = groups.map(function (group) {
          var childInfos = group.childInfos;

          var newChildInfos = childInfos.map(function (child) {
            // return covertMemberPriceInDish(child);
            if (discountType === _const.MemberPrivTypes.REDUCE) {
              // 2 套餐中的菜品不受整个套餐立减的影响
              return covertMemberPriceInDish((0, _extends3.default)({ memberMarketPrice: child.marketPrice }, child));
            }
            return covertMemberPriceInDish((0, _extends3.default)({ isMember: isMember, discountType: discountType }, child));
          });

          return (0, _extends3.default)({}, group, {
            childInfos: newChildInfos
          });
        });

        result.groups = newGroups;
      } else {
        if (Array.isArray(dishIngredientInfos)) {
          var diAry = dishIngredientInfos.map(function (di) {
            var memberReprice = di.memberReprice,
                reprice = di.reprice;
            // return { ...di, reprice: memberReprice || reprice };

            return (0, _extends3.default)({}, di, { reprice: memberReprice >= 0 ? memberReprice : reprice }); // 消除memberReprice为0的影响
          });
          result.dishIngredientInfos = diAry;
        }

        if (Array.isArray(dishPropertyTypeInfos)) {
          var dpAry = dishPropertyTypeInfos.map(function (dp) {
            var properties = dp.properties;

            var r = (0, _extends3.default)({}, dp);
            if (Array.isArray(properties)) {
              var newProperties = properties.map(function (prop) {
                var memberReprice = prop.memberReprice,
                    reprice = prop.reprice;
                // return { ...prop, reprice: memberReprice || reprice };

                return (0, _extends3.default)({}, prop, { reprice: memberReprice >= 0 ? memberReprice : reprice }); // 消除memberReprice为0的影响
              });
              r.properties = newProperties;
            }
            return r;
          });
          result.dishPropertyTypeInfos = dpAry;
        }
      }

      return result;
    });
  }
  return (0, _extends3.default)({}, dish, {
    marketPrice: newMarketPrice,
    order: newOrder
  });
};

exports.covertMemberPriceInDish = covertMemberPriceInDish;

// 获取必点菜的最小数量以及其提示语
var getMustOrderMinNum = function getMustOrderMinNum(_ref4) {
  var strategyType = _ref4.strategyType,
      strategyValue = _ref4.strategyValue,
      mustSelect = _ref4.mustSelect,
      dishIncreaseUnit = _ref4.dishIncreaseUnit,
      clearStatus = _ref4.clearStatus;
  var selfChooseCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // 加菜模式就不用开台必点的属性了
  var orderId = getUrlParam('orderId');
  var type = getUrlParam('type');
  var formal = (0, _commonHelper.isFormalMeal)(Number(sessionStorage.getItem('diningForm'))) && type !== 'WM';

  if (orderId || !formal) {
    return {
      minimum: 0,
      msg: {}
    };
  }

  // 必点菜且未估清的状态
  var minimum = mustSelect && !clearStatus ? strategyType === 1 ? Math.max(dishIncreaseUnit, strategyValue) : strategyType === 2 ? Math.max(dishIncreaseUnit, strategyValue) : strategyType === 3 ? selfChooseCount : 0 : 0;
  var minimumMsg = strategyType === 3 && minimum ? (0, _helper.formatMessage)(_dishMenu2.default.selfChooseCannotLess, { value: minimum }) : (0, _helper.formatMessage)(_dishMenu2.default.mustOrderCannotLess, { value: minimum });
  var msg = mustSelect && !clearStatus ? {
    minimumMsg: minimumMsg
  } : null;

  return {
    minimum: minimum,
    msg: msg
  };
};

exports.getMustOrderMinNum = getMustOrderMinNum;

// 设置菜品列表的必点菜属性
var setDishListMustOrderProps = function setDishListMustOrderProps() {
  var dishList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mustOrderDishList = arguments[1];
  return dishList.map(function (item) {
    var _ref5 = mustOrderDishList.find(function (mustItem) {
      return mustItem.id === item.id;
    }) || {},
        _ref5$mustSelect = _ref5.mustSelect,
        mustSelect = _ref5$mustSelect === undefined ? false : _ref5$mustSelect,
        strategyType = _ref5.strategyType,
        strategyValue = _ref5.strategyValue;

    return (0, _extends3.default)({}, item, {
      mustSelect: mustSelect,
      strategyType: strategyType,
      strategyValue: strategyValue
    });
  });
};

exports.setDishListMustOrderProps = setDishListMustOrderProps;

// 设置协同购物车过来的用户的菜品列表的必点菜属性
var setUserOrderedDishListMustOrderProps = function setUserOrderedDishListMustOrderProps() {
  var userOrderedDishList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mustOrderDishList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return userOrderedDishList.map(function (_ref6) {
    var _ref6$dishList = _ref6.dishList,
        dishList = _ref6$dishList === undefined ? [] : _ref6$dishList,
        rest = (0, _objectWithoutProperties3.default)(_ref6, ['dishList']);
    return (0, _extends3.default)({
      dishList: setDishListMustOrderProps(dishList, mustOrderDishList)
    }, rest);
  });
};

exports.setUserOrderedDishListMustOrderProps = setUserOrderedDishListMustOrderProps;

// 是否叠加，算出可以获赠多少份商品
var getSuperimpose = function getSuperimpose(benefit, dishes) {
  var stackRule = benefit.stackRule,
      matched = benefit.matched,
      marketRuleDtos = benefit.marketRuleDtos;

  var superimpose = 0;
  if (stackRule && matched && marketRuleDtos && marketRuleDtos[0] && marketRuleDtos[0].policySubjectId === 12) {
    var _marketRuleDtos$ = marketRuleDtos[0],
        ruleSubjectId = _marketRuleDtos$.ruleSubjectId,
        policyValue1 = _marketRuleDtos$.policyValue1,
        logicValue = _marketRuleDtos$.logicValue;

    // 满量

    if (ruleSubjectId === 11) {
      superimpose = Math.floor(countDishesNumber(dishes) / logicValue) * policyValue1;
    }
    // 满额
    if (ruleSubjectId === 12) {
      superimpose = Math.floor(getDishesBasePrice(dishes) / logicValue) * policyValue1;
    }
  }

  return superimpose;
};

/**
 * 满赠 把活动商品转为普通商品的数据格式
 * @param {*} dish
 */
var turnpolicyDishesToDishes = function turnpolicyDishesToDishes(policyDishes) {
  var dishes = policyDishes.reduce(function (list, item) {
    var dishType = item.dishType,
        midDishes = item.midDishes;

    return list.concat(dishType === 1 ? item : midDishes);
  }, []).map(function (dish) {
    return (0, _extends3.default)({}, dish, {
      residueTotal: dish.saleableNum,
      name: dish.dishName,
      smallImgUrl: dish.icon,
      marketPrice: dish.price,
      brandDishId: dish.dishId,
      dishId: dish.dishShopId // 后端传值混乱
    });
  });
  return dishes;
};
exports.turnpolicyDishesToDishes = turnpolicyDishesToDishes;

/**
 * 满赠 生成需要被默认选上的赠品份数
 * @param {*} dish
 * @param {*} limit 最多选几分
 */

var selectDefaultGiveDish = function selectDefaultGiveDish(benefitDishe) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var dish = JSON.parse((0, _stringify2.default)(benefitDishe));
  var isSingle = isSingleDishWithoutProps(benefitDishe);
  var count = Number(limit);
  var order = null;
  if (isSingle) {
    order = count;
  } else {
    order = [{
      count: count,
      dishIngredientInfos: dish.dishIngredientInfos,
      dishPropertyTypeInfos: dish.dishPropertyTypeInfos
    }];
  }
  dish = (0, _extends3.default)({}, dish, {
    count: count,
    order: order
  });
  return dish;
};
exports.selectDefaultGiveDish = selectDefaultGiveDish;

/**
 * 满赠 默认选中赠品如果有必选做法 则默认选中第一个
 * @param {*} dish
 */
var selectFirstIngredient = function selectFirstIngredient(eslectedDish) {
  var dish = JSON.parse((0, _stringify2.default)(eslectedDish));
  var _dish$dishPropertyTyp = dish.dishPropertyTypeInfos,
      dishPropertyTypeInfos = _dish$dishPropertyTyp === undefined ? [] : _dish$dishPropertyTyp;

  dishPropertyTypeInfos.forEach(function (item) {
    var _item$isMandatory = item.isMandatory,
        isMandatory = _item$isMandatory === undefined ? 0 : _item$isMandatory,
        _item$properties = item.properties,
        properties = _item$properties === undefined ? [] : _item$properties;

    var checkedProperties = properties.filter(function (p) {
      return p.isChecked;
    });
    // 必选 && 没有默认 则默认选中第一个
    if (isMandatory === 1 && !checkedProperties.length) {
      properties[0].isChecked = true;
    }
  });
  return dish;
};

/**
 * 满赠 默认选中赠品
 * @param {*} state
 * @param {*} FULL_PROMOTIONS 满赠
 */
var selectDefaultGiveDishes = function selectDefaultGiveDishes(state) {
  var FULL_PROMOTIONS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fullPromotions';

  try {
    var _state$allBenefits = state.allBenefits,
        allBenefits = _state$allBenefits === undefined ? {} : _state$allBenefits,
        divideDishList = state.divideDishes;


    var list = allBenefits[FULL_PROMOTIONS];
    var fullPromitionList = JSON.parse((0, _stringify2.default)(list));
    fullPromitionList.forEach(function (currentBenefit) {
      var matched = currentBenefit.matched,
          dishKeys = currentBenefit.dishKeys,
          benefitDishes = currentBenefit.benefitDishes;

      var _ref7 = currentBenefit.marketRuleDtos && currentBenefit.marketRuleDtos[0] || {},
          policyValue1 = _ref7.policyValue1,
          policyValue2 = _ref7.policyValue2,
          policySubjectId = _ref7.policySubjectId;
      // 满赠(policySubjectId 12为满赠) && 符合满赠条件 && 有菜品 && 赠品为空  -> 默认选中赠品


      if (policySubjectId === 12 && matched && dishKeys.length && !benefitDishes.length) {
        // 默认选中活动商品的第一个
        var policyDishes = currentBenefit.policyDishes && currentBenefit.policyDishes.length ? currentBenefit.policyDishes[0] : [];
        // 需要把活动商品转为普通商品的数据格式
        var dishes = turnpolicyDishesToDishes([policyDishes]);
        // 默认选中第一个赠送商品
        var benefitDishe = dishes.length ? dishes[0] : [];
        // console.log('---benefitDishe---', benefitDishe);
        // 如果做法有必选 则默认选中第一个必选做法
        benefitDishe = selectFirstIngredient(benefitDishe);
        // console.log('---默认选中第一个赠送商品 benefitDishe---', benefitDishe);
        var targetDishes = divideDishList.filter(function (dish) {
          return currentBenefit.dishKeys.indexOf(dish.key) > -1;
        });

        // 是否叠加的参数，算出可以获赠多少份商品 limit
        var superimpose = getSuperimpose(currentBenefit, targetDishes);
        // const { policyValue1, policyValue2, policySubjectId } = (currentBenefit.marketRuleDtos && currentBenefit.marketRuleDtos[0]) || {};
        var limit = superimpose || (policySubjectId === 12 ? policyValue1 : policyValue2);

        // 生成需要被默认选上的赠品
        benefitDishe = selectDefaultGiveDish(benefitDishe, limit);
        currentBenefit.benefitDishes = divideDishes([benefitDishe], 'benefit_dishes');
      }
    });
    return fullPromitionList;
  } catch (e) {
    console.warn('\u6EE1\u8D60 ' + e.message);
    return state.allBenefits[FULL_PROMOTIONS];
  }
};

exports.selectDefaultGiveDishes = selectDefaultGiveDishes;

/**
 * 再来一单 - 多规格菜品 order合并
 * @param {*} dish 后端再来一单烦恼会的dish
 */
var getAnthorOrder = function getAnthorOrder(dish) {
  var _dish$order4 = dish.order,
      order = _dish$order4 === undefined ? [] : _dish$order4,
      _dish$dishIngredientI = dish.dishIngredientInfos,
      dishIngredientInfos = _dish$dishIngredientI === undefined ? [] : _dish$dishIngredientI,
      _dish$dishPropertyTyp2 = dish.dishPropertyTypeInfos,
      dishPropertyTypeInfos = _dish$dishPropertyTyp2 === undefined ? [] : _dish$dishPropertyTyp2;

  var newOrder = order.reduce(function (all, cur) {
    var _cur$dishIngredientIn = cur.dishIngredientInfos,
        _dishIngredientInfos = _cur$dishIngredientIn === undefined ? [] : _cur$dishIngredientIn,
        _cur$dishPropertyType = cur.dishPropertyTypeInfos,
        _dishPropertyTypeInfos = _cur$dishPropertyType === undefined ? [] : _cur$dishPropertyType;

    var newIngredient = dishIngredientInfos.map(function (ing) {
      var _ing = _dishIngredientInfos.filter(function (d) {
        return d.id === ing.id;
      });
      if (_ing.length) {
        return (0, _extends3.default)({}, ing, _ing[0]);
      }
      return ing;
    });
    var newProperty = dishPropertyTypeInfos.map(function (pro) {
      var _pro = _dishPropertyTypeInfos.filter(function (d) {
        return d.id === pro.id;
      });
      if (_pro.length) {
        var _pro$properties = pro.properties,
            properties = _pro$properties === undefined ? [] : _pro$properties;

        var _pro$0$properties = _pro[0].properties,
            _properties = _pro$0$properties === undefined ? [] : _pro$0$properties;

        var newproperties = properties.map(function (p) {
          var _p = _properties.filter(function (d) {
            return d.id === p.id;
          });
          if (_p.length) {
            return (0, _extends3.default)({}, p, _p[0]);
          }
          return p;
        });
        return (0, _extends3.default)({}, pro, {
          properties: newproperties
        });
      }
      return pro;
    });
    return all.concat((0, _extends3.default)({}, cur, { dishIngredientInfos: newIngredient, dishPropertyTypeInfos: newProperty }));
  }, []);
  return newOrder;
};
exports.getAnthorOrder = getAnthorOrder;

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var shallowCompare = __webpack_require__(120);
var classnames = __webpack_require__(50);

module.exports = function (Component) {
  return React.createClass({
    displayName: 'DynamicClassHOC',
    propTypes: {
      className: React.PropTypes.string,
      children: React.PropTypes.any
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    },
    componentWillUpdate: function componentWillUpdate() {},
    render: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);

      var classProps = {};
      var otherProps = {};
      for (var item in props) {
        if (props.hasOwnProperty(item)) {
          if (/^is/.test(item)) {
            var lowerKey = /^is(.*)/.exec(item)[1].toLowerCase();
            classProps['is-' + lowerKey] = props[item];
          } else {
            otherProps[item] = props[item];
          }
        }
      }
      var otherPropsWithA = {};
      if (Component === 'a') {
        // a标签删除
        for (var i in otherProps) {
          if (i.indexOf('data-') !== -1 || /^(onTouchTap|onClick|id|class)$/i.test(i)) {
            otherPropsWithA[i] = otherProps[i];
          }
        }
        otherProps = otherPropsWithA;
      }
      return React.createElement(
        Component,
        (0, _extends3.default)({ className: classnames(className, classProps) }, otherProps),
        children
      )
      // React.createElement(Component, Object.assign({}, { className:classnames(className, transformedClassProps) }, otherProps), children)
      ;
    }
  });
};

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  muiselectDate: {
    id: 'mui.selectDate',
    defaultMessage: '选择日期'
  },
  muiconfirm: {
    id: 'mui.confirm',
    defaultMessage: '确定'
  },
  muiselectCountry: {
    id: 'mui.selectCountry',
    defaultMessage: '选择国家'
  },
  muiinputPN: {
    id: 'mui.inputPN',
    defaultMessage: '请输入手机号码'
  },
  muiinputVerificationCode: {
    id: 'mui.inputVerificationCode',
    defaultMessage: '请输入验证码'
  },
  muisetPassWord: {
    id: 'mui.setPassWord',
    defaultMessage: '请设置6位数字密码'
  },
  muiclickToGet: {
    id: 'mui.clickToGet',
    defaultMessage: '点击获取'
  },
  muigetVerification: {
    id: 'mui.getVerification',
    defaultMessage: '获取验证码'
  },
  muiPNPrompt: {
    id: 'mui.PNPrompt',
    defaultMessage: '请输入正确的手机号'
  },
  muiverificationPrompt: {
    id: 'mui.verificationPrompt',
    defaultMessage: '请输入正确的验证码'
  },
  muiPWPrompt: {
    id: 'mui.PWPrompt',
    defaultMessage: '请输入正确的密码'
  },
  muisamePrompt: {
    id: 'mui.samePrompt',
    defaultMessage: "('请勿输入相同号码')"
  },
  muireGet: {
    id: 'mui.reGet',
    defaultMessage: '重新获取'
  },
  muiLikeForYou: {
    id: 'mui.LikeForYou',
    defaultMessage: '为你点赞'
  },
  muilikesContent1: {
    id: 'mui.likesContent1',
    defaultMessage: '贴心'
  },
  muilikesContent2: {
    id: 'mui.likesContent2',
    defaultMessage: '笑容甜美'
  },
  muiinputComment: {
    id: 'mui.inputComment',
    defaultMessage: '请输入简短评论...'
  },
  muievaluation: {
    id: 'mui.evaluation',
    defaultMessage: '评价'
  },
  muievaluateService: {
    id: 'mui.evaluateService',
    defaultMessage: '评价一下我的服务吧'
  },
  muisubmit: {
    id: 'mui.submit',
    defaultMessage: '提交'
  },
  muiLikes: {
    id: 'mui.Likes',
    defaultMessage: '点赞'
  },
  muiLiked: {
    id: 'mui.Liked',
    defaultMessage: '您已经点过赞了'
  },
  muilocateFailed: {
    id: 'mui.locateFailed',
    defaultMessage: '定位失败，请打开手机GPS并刷新页面重试'
  },
  muimapLoading: {
    id: 'mui.mapLoading',
    defaultMessage: '地图加载中...'
  },
  muimapLoadFailed: {
    id: 'mui.mapLoadFailed',
    defaultMessage: '地图加载失败了，请刷新重试'
  },
  muiinputKeyWord: {
    id: 'mui.inputKeyWord',
    defaultMessage: '请录入关键字'
  },
  muidiningRoom: {
    id: 'mui.diningRoom',
    defaultMessage: '食堂'
  },
  muichangeCity: {
    id: 'mui.changeCity',
    defaultMessage: '没找到？点我切换城市...'
  },
  muinearbyStore: {
    id: 'mui.nearbyStore',
    defaultMessage: '附近门店'
  },
  muiRecommend: {
    id: 'mui.Recommend',
    defaultMessage: '推荐'
  },
  muihotCity: {
    id: 'mui.hotCity',
    defaultMessage: '热门城市'
  },
  muipaySuccess: {
    id: 'mui.paySuccess',
    defaultMessage: '余额已成功支付'
  },
  muistillNeedPay: {
    id: 'mui.stillNeedPay',
    defaultMessage: '还需支付'
  },
  muigotoPay: {
    id: 'mui.gotoPay',
    defaultMessage: '{time}后跳转支付剩余金额'
  },
  muicancel: {
    id: 'mui.cancel',
    defaultMessage: '取消'
  },
  muiLoadMapFailed: {
    id: 'muiLoadMapFailed',
    defaultMessage: '地图加载失败了，请'
  },
  muiRefreshMap: {
    id: 'muiRefreshMap',
    defaultMessage: '刷新重试'
  },
  muiUpgradeNot: {
    'id': 'muiUpgradeNot',
    'defaultMessage': '暂不升级'
  },
  muiUpgradeNow: {
    'id': 'muiUpgradeNow',
    'defaultMessage': '立即升级'
  },
  muiAssetMergerMsg: {
    'id': 'muiAssetMergerMsg',
    'defaultMessage': '经检测您的手机号已被绑定，选择升级账户将自动合并您可能存在多份资产哦！'
  },
  muiGetCodeFirst: {
    id: 'muiGetCodeFirst',
    defaultMessage: '请先获取验证码'
  }
});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findIndex(arr, cb) {
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    return -1;
  }

  if (typeof cb !== 'function') {
    var keys = (0, _keys2.default)(cb);
    return arr.findIndex(function (item) {
      return keys.every(function (key) {
        return item[key] === cb[key];
      });
    });
  }

  return arr.findIndex(cb);
}

module.exports = findIndex;

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var shallowCompare = __webpack_require__(120);

var ActiveSelect = React.createClass({
  displayName: 'ActiveSelect',
  propTypes: {
    optionsData: React.PropTypes.array.isRequired,
    isPrivateRoom: React.PropTypes.bool,
    optionComponent: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]).isRequired,
    onSelectOption: React.PropTypes.func.isRequired,
    className: React.PropTypes.string,
    needAmount: React.PropTypes.number,
    dishes: React.PropTypes.array,
    serviceProps: React.PropTypes.object,
    commercialProps: React.PropTypes.object,
    fromWholeOrderBenefit: React.PropTypes.bool,
    extTitle: React.PropTypes.string,
    sendSubComponentParam: React.PropTypes.object,
    isHDL: React.PropTypes.bool,
    showDelivery: React.PropTypes.bool
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  onSelectOption: function onSelectOption(evt, wholeBenefitData) {
    evt.preventDefault();
    var optionsData = this.props.optionsData;
    var id = evt.currentTarget.dataset.id;

    if (wholeBenefitData) {
      this.props.onSelectOption(evt, wholeBenefitData);
      return;
    }
    var optionData = optionsData.find(function (item) {
      if (isNaN(id).toString()) {
        return String(item.id) === String(id);
      }
      return false;
    });
    this.props.onSelectOption(evt, optionData);
  },
  renderOptions: function renderOptions(params) {
    var _this = this;

    var _props = this.props,
        fromWholeOrderBenefit = _props.fromWholeOrderBenefit,
        extTitle = _props.extTitle,
        sendSubComponentParam = _props.sendSubComponentParam;

    var subComponentParam = sendSubComponentParam || {};
    return (params.optionsData || []).map(function (optionData) {
      var label = optionData.label,
          oldPrice = optionData.oldPrice,
          newPrice = optionData.newPrice;
      // 如果showDelivery=true则需要展示新旧配送费
      // 新旧价格相等则-展示新价格
      // 新旧价格不等-且新的价格存在和等于0-展示新价格

      if (params.showDelivery) {
        label = React.createElement(
          'div',
          null,
          oldPrice != newPrice && React.createElement(
            'span',
            { className: newPrice || newPrice == 0 ? 'delivery-oldPrice' : '' },
            '\uFFE5',
            oldPrice
          ),
          '\xA0',
          (newPrice || newPrice == 0) && React.createElement(
            'span',
            { className: 'delivery-newPrice' },
            '\uFFE5',
            newPrice
          )
        );
      }
      return React.createElement(params.optionComponent, (0, _assign2.default)({}, {
        key: optionData.id,
        isPrivateRoom: params.isPrivateRoom,
        needAmount: params.needAmount,
        'data-option': '',
        'data-id': optionData.id,
        onTouchTap: _this.onSelectOption,
        dishes: params.dishes,
        serviceProps: params.serviceProps,
        dishNames: optionData.dishNames,
        extTitle: extTitle,
        isHDL: params.isHDL
      }, fromWholeOrderBenefit ? { commercialProps: params.commercialProps, showWholeBenefitRange: params.showWholeBenefitRange } : {}, optionData, subComponentParam), label);
    });
  },
  render: function render() {
    var className = this.props.className;


    var optionElements = this.renderOptions(this.props);
    return React.createElement(
      'div',
      { className: className },
      optionElements
    );
  }
});

module.exports = ActiveSelect;

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys2 = __webpack_require__(25);

var _keys3 = _interopRequireDefault(_keys2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseComponent = function (_React$Component) {
  (0, _inherits3.default)(BaseComponent, _React$Component);

  function BaseComponent() {
    (0, _classCallCheck3.default)(this, BaseComponent);
    return (0, _possibleConstructorReturn3.default)(this, (BaseComponent.__proto__ || (0, _getPrototypeOf2.default)(BaseComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(BaseComponent, [{
    key: 'bind',
    value: function bind() {
      var _this2 = this;

      for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
        methods[_key] = arguments[_key];
      }

      methods.forEach(function (element) {
        _this2[element] = _this2[element].bind(_this2);
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var thisProps = this.props || {};
      var thisState = this.state || {};

      var nextPropsClone = nextProps || {};
      var nextStateClone = nextState || {};

      var thisPropsKeyList = (0, _keys3.default)(thisProps);
      var nextPropsKeyList = (0, _keys3.default)(nextPropsClone);

      var thisStateKeyList = (0, _keys3.default)(thisState);
      var nextStateKeyList = (0, _keys3.default)(nextStateClone);

      if (thisPropsKeyList.length !== nextPropsKeyList.length || thisStateKeyList.length !== nextStateKeyList.length) {
        return true;
      }

      for (var keys in nextPropsClone) {
        if (nextPropsClone[keys] !== thisProps[keys]) {
          return true;
        }
      }

      for (var _keys in nextStateClone) {
        if (nextStateClone[_keys] !== thisState[_keys]) {
          return true;
        }
      }

      return false;
    }
  }]);
  return BaseComponent;
}(_react2.default.Component);

exports.default = BaseComponent;

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(278);

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(150);
var global = __webpack_require__(4);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(34);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _findIndex = __webpack_require__(452);
var React = __webpack_require__(2);

var _require = __webpack_require__(114),
    findDOMNode = _require.findDOMNode;

var shallowCompare = __webpack_require__(120);
var classnames = __webpack_require__(50);
var IScroll = __webpack_require__(465);
var ActiveSelect = __webpack_require__(455);

__webpack_require__(125);
__webpack_require__(466);

module.exports = React.createClass({
  displayName: 'ActiveScrollSelect',
  propTypes: (0, _extends3.default)({
    className: React.PropTypes.string,
    viewportHeight: React.PropTypes.number
  }, ActiveSelect.propTypes),
  getDefaultProps: function getDefaultProps() {
    return {
      viewportHeight: 5
    };
  },
  componentWillMount: function componentWillMount() {
    this._cache = {};
  },
  componentDidMount: function componentDidMount() {
    var viewport = findDOMNode(this);
    var _props = this.props,
        optionsData = _props.optionsData,
        viewportHeight = _props.viewportHeight;

    this.adjustViewportHeight(viewport, viewportHeight);
    this.applyIScrollPlugin(viewport);
    this.scrollToSelectedOption(optionsData);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  componentDidUpdate: function componentDidUpdate() {
    var _props2 = this.props,
        optionsData = _props2.optionsData,
        viewportHeight = _props2.viewportHeight;

    var viewport = findDOMNode(this);
    this.adjustViewportHeight(viewport, viewportHeight);
    this._cache.iScroll.refresh();
    this.scrollToSelectedOption(optionsData);
  },
  applyIScrollPlugin: function applyIScrollPlugin(viewport) {
    var _this = this;

    var cache = this._cache;
    var iScroll = cache.iScroll = new IScroll(viewport, { snap: '[data-option]', snapThreshold: 0.5, bounceTime: 5 });
    iScroll.on('beforeScrollStart', function () {
      if (cache.selectTimmer) {
        window.clearTimeout(cache.selectTimmer);
      }
    });
    iScroll.on('scrollEnd', function () {
      var _props3 = _this.props,
          optionsData = _props3.optionsData,
          onSelectOption = _props3.onSelectOption;
      // if (!cache.autoScrolling) {
      //   cache.selectTimmer = setTimeout(() => onSelectOption(null, optionsData[iScroll.currentPage.pageY]), 50);
      // }

      onSelectOption(null, optionsData[iScroll.currentPage.pageY]);
      cache.autoScrolling = false;
    });
  },
  adjustViewportHeight: function adjustViewportHeight(viewport, viewportHeight) {
    // We need to adjust the height of viewport according to the height of Option
    var optionElement = viewport.querySelector('[data-option]');
    if (optionElement) {
      // viewport.style.height = `${optionElement.offsetHeight * viewportHeight}px`;
      viewport.style.height = 200 + 'px'; // this is a temp fix for performance issue
    }
  },
  scrollToSelectedOption: function scrollToSelectedOption(options) {
    var optionIdx = _findIndex(options, { isChecked: true });
    var cache = this._cache;

    if (optionIdx !== -1) {
      cache.iScroll.goToPage(0, optionIdx, 100);
    }
    cache.autoScrolling = true;
  },
  buildPlaceholderElement: function buildPlaceholderElement(viewportHeight) {
    var placeholderOffset = this._cache.placeholderOffset = viewportHeight / 2;
    var placeholders = [];
    for (var i = 1; i <= placeholderOffset; i++) {
      placeholders.push(React.createElement('a', { key: 'placeholder-' + i, 'data-option': 'false' }));
    }
    return React.createElement(
      'div',
      { className: 'placeholder-container' },
      placeholders
    );
  },
  onSelectOption: function onSelectOption(evt, optionData) {
    var cache = this._cache;
    var onSelectOption = this.props.onSelectOption;

    if (!cache.autoScrolling) {
      cache.selectTimmer = setTimeout(function () {
        return onSelectOption(evt, optionData);
      }, 50);
    }
    cache.autoScrolling = false;
  },
  render: function render() {
    var _props4 = this.props,
        className = _props4.className,
        viewportHeight = _props4.viewportHeight,
        optionComponent = _props4.optionComponent,
        props = (0, _objectWithoutProperties3.default)(_props4, ['className', 'viewportHeight', 'optionComponent']);

    var topPlaceholder = this.buildPlaceholderElement(viewportHeight);
    var bottomPlaceholder = this.buildPlaceholderElement(viewportHeight);
    return React.createElement(
      'div',
      { className: classnames('scroll-select', className) },
      React.createElement(
        'div',
        { className: 'scroll-wrapper' },
        topPlaceholder,
        React.createElement(ActiveSelect, (0, _extends3.default)({ optionComponent: optionComponent }, props, { onSelectOption: this.onSelectOption })),
        bottomPlaceholder
      )
    );
  }
});

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(337);

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  actionchoosePeopleNumerFailed: {
    id: 'action.choosePeopleNumerFailed',
    defaultMessage: '选定人数失败，请稍候重试'
  },
  actionselectedNumberOfPeople: {
    id: 'action.selectedNumberOfPeople',
    defaultMessage: '该桌台已经选定人数'
  },
  actiongettingCoupon: {
    id: 'action.gettingCoupon',
    defaultMessage: '正在领券中...'
  },
  actionrequestInterfaceFailed: {
    id: 'action.requestInterfaceFailed',
    defaultMessage: '请求接口失败...'
  },
  actionRetryToGet: {
    id: 'action.RetryToGet',
    defaultMessage: '非常抱歉，领取失败，请重试'
  },
  actionsysInProcessing: {
    id: 'action.sysInProcessing',
    defaultMessage: '系统处理中...'
  },
  actionmodifySuccess: {
    id: 'action.modifySuccess',
    defaultMessage: '修改成功'
  },
  actionJumping: {
    id: 'action.Jumping',
    defaultMessage: '页面跳转中...'
  },
  actionshopIdCannotBeNull: {
    id: 'action.shopIdCannotBeNull',
    defaultMessage: '门店编码不能为空'
  },
  actionloginFailed: {
    id: 'action.loginFailed',
    defaultMessage: '登录失败'
  },
  actiongetVerifyCodeFailed: {
    id: 'action.getVerifyCodeFailed',
    defaultMessage: '验证码获取失败'
  },
  actionSending: {
    id: 'action.Sending',
    defaultMessage: '发送中...'
  },
  actionbalanceChanged: {
    id: 'action.balanceChanged',
    defaultMessage: '储值金额有变，请刷新页面重试'
  },
  actionsaving: {
    id: 'action.saving',
    defaultMessage: '保存中'
  },
  actionsaveSuccess: {
    id: 'action.saveSuccess',
    defaultMessage: '保存成功'
  },
  actionlogoutSuccess: {
    id: 'action.logoutSuccess',
    defaultMessage: '注销成功，请重新登录'
  },
  actionlogoutFailed: {
    id: 'action.logoutFailed',
    defaultMessage: '注销失败'
  },
  actiongetServiceCardFailed: {
    id: 'action.getServiceCardFailed',
    defaultMessage: '获取服务卡失败'
  }
});

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(24);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
var Dialog = __webpack_require__(271);

__webpack_require__(481);

module.exports = React.createClass({
  displayName: 'MessageDialog',
  propTypes: {
    btnText: React.PropTypes.any,
    children: React.PropTypes.any,
    onCancel: React.PropTypes.func,
    onConfirm: React.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {};
  },
  onConfirm: function onConfirm(evt) {
    if (evt) {
      evt.preventDefault();
    }

    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  },
  onCancel: function onCancel(evt) {
    if (evt) {
      evt.preventDefault();
    }
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  },
  render: function render() {
    var btnText = this.props.btnText;

    var buttons = [{
      text: btnText,
      className: 'dialog-btn',
      onClick: this.onConfirm
    }];

    return React.createElement(
      Dialog,
      {
        theme: 'sliver',
        onClose: this.onCancel,
        buttons: buttons,
        className: 'message-dialog'
      },
      this.props.children
    );
  }
});

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as Sentry from '@sentry/browser';

var FormattedMessage = function (_React$Component) {
  (0, _inherits3.default)(FormattedMessage, _React$Component);

  function FormattedMessage(props) {
    (0, _classCallCheck3.default)(this, FormattedMessage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FormattedMessage.__proto__ || (0, _getPrototypeOf2.default)(FormattedMessage)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  // eslint-disable-next-line camelcase


  (0, _createClass3.default)(FormattedMessage, [{
    key: 'unstable_handleError',
    value: function unstable_handleError(e) {
      this.setState({ error: true });
      // Sentry.captureException(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var error = this.state.error;
      var _props$backup = this.props.backup,
          backup = _props$backup === undefined ? '' : _props$backup;

      return error ? _react2.default.createElement(
        'span',
        null,
        backup
      ) : _react2.default.createElement(_reactIntl.FormattedMessage, this.props);
    }
  }]);
  return FormattedMessage;
}(_react2.default.Component);

exports.default = FormattedMessage;

/***/ }),

/***/ 481:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(36);

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _activeScrollSelect = __webpack_require__(460);

var _activeScrollSelect2 = _interopRequireDefault(_activeScrollSelect);

var _helper = __webpack_require__(16);

var _button = __webpack_require__(409);

var _button2 = _interopRequireDefault(_button);

__webpack_require__(495);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FloatingScrollSelector = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FloatingScrollSelector, _Component);

  function FloatingScrollSelector(props) {
    (0, _classCallCheck3.default)(this, FloatingScrollSelector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FloatingScrollSelector.__proto__ || (0, _getPrototypeOf2.default)(FloatingScrollSelector)).call(this, props));

    _this.state = {
      activedOption: null
    };

    _this.confirmSelecting = _this.confirmSelecting.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FloatingScrollSelector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          dataList = _props.dataList,
          toggleSelectorCheckedStatus = _props.toggleSelectorCheckedStatus,
          defaultCheckedIndex = _props.defaultCheckedIndex;


      if (dataList && dataList.length > 0) {
        toggleSelectorCheckedStatus(defaultCheckedIndex <= 0 ? 0 : defaultCheckedIndex);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProp) {
      var dataList = nextProp.dataList;
      var activedOption = this.state.activedOption;

      if (Array.isArray(dataList)) {
        var checkedItem = dataList.find(function (item) {
          return item.isChecked;
        });
        if (!!checkedItem && !activedOption) {
          this.setState(function () {
            return { activedOption: checkedItem };
          });
        }
      }
    }
  }, {
    key: 'checkActiveOption',
    value: function checkActiveOption(option) {
      var _this2 = this;

      var _props2 = this.props,
          dataList = _props2.dataList,
          toggleSelectorCheckedStatus = _props2.toggleSelectorCheckedStatus;


      dataList.forEach(function (item, index) {
        if (item.id === option.id) {
          if (!item.isChecked) {
            toggleSelectorCheckedStatus(index);
            _this2.setState(function () {
              return { activedOption: item };
            });
          }
        }
      });
    }
  }, {
    key: 'confirmSelecting',
    value: function confirmSelecting(e) {
      var _props3 = this.props,
          closeSelector = _props3.closeSelector,
          setSelectedOption = _props3.setSelectedOption,
          defaultCheckedIndex = _props3.defaultCheckedIndex,
          dataList = _props3.dataList;
      var activedOption = this.state.activedOption;


      setSelectedOption(activedOption || dataList[defaultCheckedIndex]);
      closeSelector(e);
    }
  }, {
    key: 'createSelectorOptions',
    value: function createSelectorOptions() {
      var _this3 = this;

      var _props4 = this.props,
          dataList = _props4.dataList,
          optionComponent = _props4.optionComponent;


      return _react2.default.createElement(
        'div',
        { className: 'o-flex' },
        _react2.default.createElement(_activeScrollSelect2.default, {
          className: 'row-floating-select',
          optionsData: dataList,
          optionComponent: optionComponent,
          onSelectOption: function onSelectOption(event, option) {
            return _this3.checkActiveOption(option);
          }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var selectorOptions = this.createSelectorOptions();
      var _props5 = this.props,
          closeSelector = _props5.closeSelector,
          selectorTitle = _props5.selectorTitle;


      return _react2.default.createElement(
        'div',
        {
          className: 'scroll-select-container floating-select-container',
          tabIndex: '-1'
        },
        _react2.default.createElement('div', { className: 'scroll-select-close', onTouchTap: closeSelector }),
        _react2.default.createElement(
          'div',
          { className: 'scroll-select-content' },
          _react2.default.createElement(
            'div',
            { className: 'scroll-select-header' },
            _react2.default.createElement(
              'span',
              null,
              selectorTitle
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'scroll-select-confirm btn--yellow',
                onTouchTap: this.confirmSelecting
              },
              (0, _helper.formatMessage)(_button2.default.sure)
            )
          ),
          selectorOptions
        )
      );
    }
  }]);
  return FloatingScrollSelector;
}(_react.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    dataList: _react2.default.PropTypes.array,
    defaultCheckedIndex: _react2.default.PropTypes.number,
    selectorTitle: _react2.default.PropTypes.string.isRequired,
    optionComponent: _react2.default.PropTypes.func.isRequired,

    toggleSelectorCheckedStatus: _react2.default.PropTypes.func.isRequired,
    setSelectedOption: _react2.default.PropTypes.func.isRequired,
    closeSelector: _react2.default.PropTypes.func.isRequired
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    defaultCheckedIndex: 0
  }
}), _temp);
exports.default = FloatingScrollSelector;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _dynamicClassHoc = __webpack_require__(450);

var _dynamicClassHoc2 = _interopRequireDefault(_dynamicClassHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptionComponent = (0, _dynamicClassHoc2.default)('a');

var PayMethodOption = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PayMethodOption, _Component);

  function PayMethodOption() {
    (0, _classCallCheck3.default)(this, PayMethodOption);
    return (0, _possibleConstructorReturn3.default)(this, (PayMethodOption.__proto__ || (0, _getPrototypeOf2.default)(PayMethodOption)).apply(this, arguments));
  }

  (0, _createClass3.default)(PayMethodOption, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          props = (0, _objectWithoutProperties3.default)(_props, ['name']);


      return _react2.default.createElement(
        OptionComponent,
        props,
        _react2.default.createElement(
          'span',
          null,
          name
        )
      );
    }
  }]);
  return PayMethodOption;
}(_react.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    name: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired
  }
}), _temp);
exports.default = PayMethodOption;

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  MineCouponListApplicationkeySupport: {
    id: 'MineCouponListApplication.keySupport',
    defaultMessage: '客如云提供技术支持'
  },
  OrderInlineApplicationlineupInfo: {
    id: 'OrderInlineApplication.lineupInfo',
    defaultMessage: '排队信息'
  },
  OrderInlineApplicationNumberOfPeople: {
    id: 'OrderInlineApplication.NumberOfPeople',
    defaultMessage: '就餐人数'
  },
  OrderInlineApplicationgetIDNow: {
    id: 'OrderInlineApplication.getIDNow',
    defaultMessage: '立即取号'
  },
  OrderInlineApplicationUnOpen: {
    id: 'OrderInlineApplication.UnOpen',
    defaultMessage: '诶呀，没有开门'
  },
  OrderInlineApplicationdeviceNetBroken: {
    id: 'OrderInlineApplication.deviceNetBroken',
    defaultMessage: '商家设备未联网'
  },
  OrderInlineApplicationnuConnect: {
    id: 'OrderInlineApplication.nuConnect',
    defaultMessage: '设备未接入网络'
  },
  OrderInlineApplicationqueueName: {
    id: 'OrderInlineApplication.queueName',
    defaultMessage: '队列名称'
  },
  OrderInlineApplicationnumberOfWaitingTables: {
    id: 'OrderInlineApplication.numberOfWaitingTables',
    defaultMessage: '等待桌数'
  },
  OrderListApplicationshowEarlierOrder: {
    id: 'OrderListApplication.showEarlierOrder',
    defaultMessage: '查看更早的订单'
  },
  OrderListApplicationNoOrderInOneWeek: {
    id: 'OrderListApplication.NoOrderInOneWeek',
    defaultMessage: '最近一周内没有相关订单'
  },
  OrderListApplicationMakeOutBill: {
    id: 'OrderListApplication.MakeOutBill',
    defaultMessage: '开发票'
  },
  OrderListApplicationchooseOrderToMakeoutBill: {
    id: 'OrderListApplication.chooseOrderToMakeoutBill',
    defaultMessage: '请选择需要开发票的订单'
  },
  OrderListApplicationBindPNToCheckOrder: {
    id: 'OrderListApplication.BindPNToCheckOrder',
    defaultMessage: '绑定手机号，查看所有渠道订单'
  },
  OrderListApplicationGotoBind: {
    id: 'OrderListApplication.GotoBind',
    defaultMessage: '去绑定'
  },
  OrderListApplicationNoRelatedOrder: {
    id: 'OrderListApplication.NoRelatedOrder',
    defaultMessage: '没有相关订单'
  },
  OrderListApplicationWaitForMaingBill: {
    id: 'OrderListApplication.WaitForMaingBill',
    defaultMessage: '别着急，正在开票中'
  },
  OrderListApplicationSelectOrderToMakeBill: {
    id: 'OrderListApplication.SelectOrderToMakeBill',
    defaultMessage: '请选择开票订单'
  },
  OrderListApplicationShowLaterOrder: {
    id: 'OrderListApplication.ShowLaterOrder',
    defaultMessage: '查看更早的订单'
  },
  OrderListApplicationCancel: {
    id: 'OrderListApplication.Cancel',
    defaultMessage: '取消'
  },
  OrderListApplicationTS: {
    id: 'OrderListApplication.TS',
    defaultMessage: '堂食'
  },
  OrderListApplicationWM: {
    id: 'OrderListApplication.WM',
    defaultMessage: '外卖'
  },
  OrderListApplicationYD: {
    id: 'OrderListApplication.YD',
    defaultMessage: '预定'
  },
  OrderListApplicationPD: {
    id: 'OrderListApplication.PD',
    defaultMessage: '排队'
  },
  OrderListApplicationHB: {
    id: 'OrderListApplication.HB',
    defaultMessage: '烘焙'
  },
  PayDetailApplicationorderAutoCanceled: {
    id: 'PayDetailApplication.orderAutoCanceled',
    defaultMessage: '订单已经自动取消... 即将自动跳转'
  },
  PayDetailApplicationnoNeedPaidOrder: {
    id: 'PayDetailApplication.noNeedPaidOrder',
    defaultMessage: '没有金额需要支付'
  },
  PayDetailApplicationPaid: {
    id: 'PayDetailApplication.Paid',
    defaultMessage: '已支付：'
  },
  PayDetailApplicationBalance: {
    id: 'PayDetailApplication.Balance',
    defaultMessage: '余额'
  },
  PayDetailApplicationWX: {
    id: 'PayDetailApplication.WX',
    defaultMessage: '微信'
  },
  PayDetailApplicationAlipay: {
    id: 'PayDetailApplication.Alipay',
    defaultMessage: '支付宝'
  },
  PayDetailApplicationotherWays: {
    id: 'PayDetailApplication.otherWays',
    defaultMessage: '其他方式'
  },
  PayDetailApplicationcannotRechargePrompt: {
    id: 'PayDetailApplication.cannotRechargePrompt',
    defaultMessage: '您不是会员，无法充值，绑定手机号即可成为会员'
  },
  PayDetailApplicationRegisterToPay: {
    id: 'PayDetailApplication.RegisterToPay',
    defaultMessage: '您不是会员，注册即可储值支付'
  },
  PayDetailApplicationbindPNToPay: {
    id: 'PayDetailApplication.bindPNToPay',
    defaultMessage: '绑定手机号即可储值支付'
  },
  PayDetailApplicationRechargeSuccessInfo: {
    id: 'PayDetailApplication.RechargeSuccessInfo',
    defaultMessage: '成功储值并支付该订单，当前储值余额'
  },
  PayDetailApplicationJumping: {
    id: 'PayDetailApplication.Jumping',
    defaultMessage: '1.5秒后跳转到订单详情页'
  },
  PayDetailApplicationadvancedDeduction: {
    id: 'PayDetailApplication.advancedDeduction',
    defaultMessage: '预付金已抵扣：'
  },
  PayDetailApplicationorderValue: {
    id: 'PayDetailApplication.orderValue',
    defaultMessage: '订单金额：'
  },
  PayDetailApplicationMyBalance: {
    id: 'PayDetailApplication.MyBalance',
    defaultMessage: '我的余额：'
  },
  PayDetailApplicationgetRandomDiscount: {
    id: 'PayDetailApplication.getRandomDiscount',
    defaultMessage: '客官，恭喜获得随机减免机会！'
  },
  PayDetailApplicationshareToDiscount: {
    id: 'PayDetailApplication.shareToDiscount',
    defaultMessage: '分享即可减免'
  },
  PayDetailApplicationgetDiscount: {
    id: 'PayDetailApplication.getDiscount',
    defaultMessage: '恭喜获得{amount}减免金'
  },
  PayDetailApplicationfillToUseDiscount: {
    id: 'PayDetailApplication.fillToUseDiscount',
    defaultMessage: '满{amount}可用，仅对当前订单生效'
  },
  PayDetailApplicationbalanceInsufficient: {
    id: 'PayDetailApplication.balanceInsufficient',
    defaultMessage: '余额不足，请先储值再支付'
  },
  PayDetailApplicationRechargedBalance: {
    id: 'PayDetailApplication.RechargedBalance',
    defaultMessage: '储值后的余额为{amount}'
  },
  PayDetailApplicationpayWithProblem: {
    id: 'PayDetailApplication.payWithProblem',
    defaultMessage: '支付有问题？'
  },
  PayDetailApplicationconnectShopToRefund: {
    id: 'PayDetailApplication.connectShopToRefund',
    defaultMessage: '若需要退款，请先完成第三方支付后联系商家处理'
  },
  PayDetailApplicationlastPayTime: {
    id: 'PayDetailApplication.lastPayTime',
    defaultMessage: '支付剩余时间'
  },
  PayDetailApplicationwaitForPaying: {
    id: 'PayDetailApplication.waitForPaying',
    defaultMessage: '待支付金额'
  },
  PayDetailApplicationpaidBalance: {
    id: 'PayDetailApplication.paidBalance',
    defaultMessage: '余额已支付'
  },
  PayDetailApplicationuseThirdPartToPay: {
    id: 'PayDetailApplication.useThirdPartToPay',
    defaultMessage: '请用第三方支付剩余'
  },
  PayDetailApplicationcontinuePay: {
    id: 'PayDetailApplication.continuePay',
    defaultMessage: '{second}s 后继续支付'
  },
  PayDetailBrandApplicationVipBalancePay: {
    id: 'PayDetailBrandApplication.VipBalancePay',
    defaultMessage: '会员余额支付'
  },
  PaySuccessRetailtips: {
    id: 'PaySuccessRetail.tips',
    defaultMessage: '支付成功'
  },
  PaySuccessRetailbackToIndex: {
    id: 'PaySuccessRetail.backToIndex',
    defaultMessage: '返回首页'
  },
  PaySuccessRetailorderDetail: {
    id: 'PaySuccessRetail.orderDetail',
    defaultMessage: '订单详情'
  },
  CombinedPaymentbanlancePay: {
    id: 'CombinedPayment.banlancePay',
    defaultMessage: '余额支付'
  },
  PayDetailBrandApplicationVipBalance: {
    id: 'PayDetailBrandApplication.VipBalance',
    defaultMessage: '会员余额'
  },
  PayDetailBrandApplicationWxPayPrompt: {
    id: 'CombinedPayment.WXPayPrompt',
    defaultMessage: '微信客户端版本5.0以上'
  },
  PayDetailBrandApplicationMPayPrompt: {
    id: 'CombinedPayment.MPayPrompt',
    defaultMessage: '推薦 MPay 用戶使用'
  },
  CombinedPayment: {
    id: 'CombinedPayment.CombinedPayment',
    defaultMessage: '组合支付'
  },
  noOrderInHalfYear: {
    id: 'noOrderInHalfYear',
    defaultMessage: '最近半年内没有相关订单'
  },
  payDetailSelectStoreToPay: {
    id: 'payDetailSelectStoreToPay',
    defaultMessage: '请选择需要储值并支付的金额'
  },
  payDetailStoreSuccess: {
    id: 'payDetailStoreSuccess',
    defaultMessage: '成功储值并支付该订单，当前储值余额'
  },
  payDetailJumpTo: {
    id: 'payDetailJumpTo',
    defaultMessage: ', 1.5秒后跳转到订单详情页'
  },
  payDetailShare: {
    id: 'payDetailShare',
    defaultMessage: '分享即可减免'
  },
  payDetailCongratulate: {
    id: 'payDetailCongratulate',
    defaultMessage: '恭喜获得'
  },
  payDetailDiscountMoney: {
    id: 'payDetailDiscountMoney',
    defaultMessage: '减免金'
  },
  payDetailFillToUse: {
    id: 'payDetailFillToUse',
    defaultMessage: '满{currency}可用，仅对当前订单生效'
  },
  payDetailRecommend: {
    id: 'payDetailRecommend',
    defaultMessage: '荐'
  },
  payDetailStoreAndPay: {
    id: 'payDetailStoreAndPay',
    defaultMessage: '储值并支付'
  },
  payDetailShare2: {
    id: 'payDetailShare2',
    defaultMessage: '分享'
  },
  payDetailGiveUp: {
    id: 'payDetailGiveUp',
    defaultMessage: '放弃'
  },
  payDetailIamInbrand: {
    id: 'payDetailIamInbrand',
    defaultMessage: '我正在{brandName}品牌（{shopName}分店名）就餐'
  },
  payDetailComeToVisite: {
    id: 'payDetailComeToVisite',
    defaultMessage: '听说他们家的食物不仅美味，还有大量优惠，赶紧来围观'
  },
  payDetailStoreAndToPay: {
    id: 'payDetailStoreAndToPay',
    defaultMessage: '储值{currency}{storeandpayValue}并结账'
  },
  payDetailStoredBalance: {
    id: 'payDetailStoredBalance',
    defaultMessage: '储值后的余额为'
  },
  payDetailInputSeatVipPW: {
    id: 'payDetailInputSeatVipPW',
    defaultMessage: '请输入雅座会员密码'
  },
  payDetailGoOnPay: {
    id: 'payDetailGoOnPay',
    defaultMessage: '{countTime}s后继续支付'
  },
  payDetailRecommendTip: {
    id: 'payDetailRecommendTip',
    defaultMessage: '荐'
  }
});

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(58)('wks');
var uid = __webpack_require__(45);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(338);

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _helper = __webpack_require__(16);

var _reactIntl = __webpack_require__(7);

var _mui = __webpack_require__(451);

var _mui2 = _interopRequireDefault(_mui);

var _confirmDialog = __webpack_require__(422);

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var classnames = __webpack_require__(50);
__webpack_require__(491);
var config = __webpack_require__(13);
var commonHelper = __webpack_require__(3);
var shopId = commonHelper.getUrlParam('shopId');

var defaultCountry = {
  isAllowSendCode: true,
  areaCode: '86',
  phoneRegulation: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
  country: '中国'
};
sessionStorage.setItem('nationTelCode', defaultCountry.areaCode);

module.exports = React.createClass({
  displayName: 'PhoneVerificationCode',
  propTypes: {
    placeholder: React.PropTypes.object,
    className: React.PropTypes.string,
    phoneNum: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
    phoneNumDisabled: React.PropTypes.bool,
    fetchCodeBtnText: React.PropTypes.string,
    completeFlag: React.PropTypes.number,
    onGetVerificationCode: React.PropTypes.func,
    onGetMobileBindStatus: React.PropTypes.func,
    onGetMobileOccupyStatus: React.PropTypes.func,
    onCompleteInput: React.PropTypes.func,
    setErrorMsg: React.PropTypes.func,
    fromBindPhone: React.PropTypes.bool,
    fromModifyBindPhone: React.PropTypes.bool,
    compareWithOldPhone: React.PropTypes.bool,
    oldPhone: React.PropTypes.string,
    currentCountry: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      phoneNum: '',
      phoneNumDisabled: false,
      currentCountry: defaultCountry
    };
  },
  getInitialState: function getInitialState() {
    var phoneNum = this.props.phoneNum;


    return {
      phoneNum: phoneNum || '',
      code: '',
      password: '',
      seconds: 0,
      canReceivePhoneNum: true,
      showSetTradePwd: false,
      showTradePwdInputStatus: false,
      showNeedDataRecoveryDialog: false,
      fetchCodeBtnText: this.props.fromBindPhone ? (0, _helper.formatMessage)(_mui2.default.muiclickToGet) : (0, _helper.formatMessage)(_mui2.default.muigetVerification)
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.completeFlag !== this.props.completeFlag) {
      this.handleCompleteInput();
    }

    var _state = this.state,
        phoneNum = _state.phoneNum,
        canReceivePhoneNum = _state.canReceivePhoneNum;

    if (canReceivePhoneNum && nextProps.phoneNum !== phoneNum) {
      this.setState({ phoneNum: nextProps.phoneNum });
    }

    if (nextProps && nextProps.currentCountry) {
      this.setState({ currentCountry: this.props.currentCountry });
      sessionStorage.setItem('nationTelCode', nextProps.currentCountry && nextProps.currentCountry.areaCode);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.clearWaiting();
  },
  getInputInfo: function getInputInfo() {
    var _this = this;

    var keys = ['phoneNum', 'code', 'password'];
    var info = {};

    keys.forEach(function (key) {
      info[key] = _this.state[key];
    });

    info.code = info.code || '';

    info.nationTelCode = sessionStorage.getItem('nationTelCode');
    return {
      data: info,
      validation: this.validateInput(info),
      showSetTradePwd: this.state.showSetTradePwd
    }; // 新增路径参数
  },
  isNumberStr: function isNumberStr(value) {
    return (/^\d*$/.test(value)
    );
  },
  isValidPhoneNum: function isValidPhoneNum(phoneNum, currentCountry) {
    var result = false;

    if (!currentCountry) {
      return result;
    }

    var valiatePhone = function valiatePhone(items) {
      items.forEach(function (item) {
        var regexp = new RegExp(currentCountry.phoneRegulation);
        result = result || regexp.test(phoneNum);
      });
    };

    valiatePhone([currentCountry]);

    return result;
  },
  isAllowSendCode: function isAllowSendCode(phoneNum, currentNation) {
    var _props = this.props,
        compareWithOldPhone = _props.compareWithOldPhone,
        oldPhone = _props.oldPhone,
        currentCountry = _props.currentCountry,
        type = _props.type;


    if (type === 'noCode') {
      return true;
    }

    var regexp = new RegExp(currentCountry && currentCountry.phoneRegulation);
    var shouldAllowSendCode = currentCountry && currentCountry.isAllowSendCode && regexp.test(phoneNum);

    if (compareWithOldPhone && oldPhone) {
      return shouldAllowSendCode && compareWithOldPhone && oldPhone !== phoneNum;
    }

    return shouldAllowSendCode;
  },
  validateInput: function validateInput(info) {
    var phoneNum = info.phoneNum,
        code = info.code,
        password = info.password;
    var _props2 = this.props,
        _props2$placeholder = _props2.placeholder,
        placeholder = _props2$placeholder === undefined ? {
      phoneNum: (0, _helper.formatMessage)(_mui2.default.muiinputPN),
      code: (0, _helper.formatMessage)(_mui2.default.muiinputVerificationCode),
      tradePwd: (0, _helper.formatMessage)(_mui2.default.muisetPassWord)
    } : _props2$placeholder,
        currentCountry = _props2.currentCountry;
    var showSetTradePwd = this.state.showSetTradePwd;

    if (!phoneNum) {
      return {
        valid: false,
        code: 'PHONENUM_EMPTY',
        msg: placeholder.phoneNum
      };
    }

    if (!this.isValidPhoneNum(phoneNum, currentCountry)) {
      return {
        valid: false,
        code: 'PHONENUM_INVALID',
        msg: (0, _helper.formatMessage)(_mui2.default.muiPNPrompt)
      };
    }

    if (!code) {
      return { valid: false, code: 'CODE_EMPTY', msg: placeholder.code };
    }
    if (!/^\d{4,6}$/.test(code)) {
      return {
        valid: false,
        code: 'CODE_INVALID',
        msg: (0, _helper.formatMessage)(_mui2.default.muiverificationPrompt)
      };
    }

    if (!password && showSetTradePwd) {
      return {
        valid: false,
        code: 'PASSWORD_EMPTY',
        msg: placeholder.tradePwd
      };
    }
    if (!/^\d{6}$/.test(password) && showSetTradePwd) {
      return {
        valid: false,
        code: 'PASSWORD_INVALID',
        msg: (0, _helper.formatMessage)(_mui2.default.muiPWPrompt)
      };
    }

    return { valid: true, code: '', msg: '' };
  },
  handlePhoneNumChange: function handlePhoneNumChange(evt) {
    var value = evt.target.value.trim();

    var _props3 = this.props,
        compareWithOldPhone = _props3.compareWithOldPhone,
        oldPhone = _props3.oldPhone,
        setErrorMsg = _props3.setErrorMsg;

    if (compareWithOldPhone && oldPhone) {
      if (value === oldPhone) {
        setErrorMsg((0, _helper.formatMessage)(_mui2.default.muisamePrompt));
      }
    }
    if (!this.isNumberStr(value)) {
      return;
    }

    this.setState({ phoneNum: value, canReceivePhoneNum: false });
  },
  handleCompleteInput: function handleCompleteInput() {
    var info = this.getInputInfo();

    if (this.props.onCompleteInput) {
      this.props.onCompleteInput(info);
    }
  },
  handleVerificationCodeChange: function handleVerificationCodeChange(evt) {
    var value = evt.target.value.trim();
    if (!this.isNumberStr(value)) {
      return;
    }

    this.setState({ code: value });
  },
  handleVerificationPwdChange: function handleVerificationPwdChange(evt) {
    var value = evt.target.value.trim();
    if (!this.isNumberStr(value)) {
      return;
    }

    this.setState({ password: value });
  },
  handleFetchCodeBtnTouchTap: function handleFetchCodeBtnTouchTap(evt) {
    var btn = evt.target;
    if (btn.disabled) {
      return;
    }
    this.refs.phoneVerificationNumber.blur();
    this.refs.phoneVerificationCode.blur();
    this._touchTabed = true;
    this.sendFetchVerificationCodeRequest();
    this.waitOneMinute();
  },
  clearWaiting: function clearWaiting() {
    if (this._timer) {
      window.clearTimeout(this._timer);
      this.setState({ seconds: 0 });
      this._timer = null;
    }
  },
  sendFetchVerificationCodeRequest: function sendFetchVerificationCodeRequest() {
    var _this2 = this;

    var phoneNum = this.state.phoneNum;
    var _props4 = this.props,
        onGetVerificationCode = _props4.onGetVerificationCode,
        currentCountry = _props4.currentCountry;
    // 两个入口

    var _props5 = this.props,
        fromBindPhone = _props5.fromBindPhone,
        fromModifyBindPhone = _props5.fromModifyBindPhone;
    // 两个方法

    var _props6 = this.props,
        onGetMobileBindStatus = _props6.onGetMobileBindStatus,
        onGetMobileOccupyStatus = _props6.onGetMobileOccupyStatus;


    if (onGetVerificationCode) {
      /* fromBindPhone */
      if (onGetMobileBindStatus && fromBindPhone) {
        onGetMobileBindStatus(function (isCustomer, isOpenAutoCustomer, needDataRecovery) {
          // needDataRecovery,用于茶百道数据修复问题
          if (!needDataRecovery) {
            // 发送验证码之前先验证手机号 获取到 isBindMobile
            if (isOpenAutoCustomer && !isCustomer) {
              _this2.setState({ showSetTradePwd: true });
            }
            onGetVerificationCode(phoneNum, currentCountry.areaCode);
          } else {
            // 弹窗提示用户修复数据
            _this2.setState({
              showNeedDataRecoveryDialog: true
            });
          }
        }, this.state.phoneNum, currentCountry.areaCode);
        return;
      }

      /* fromModifyBindPhone */
      if (onGetMobileOccupyStatus && fromModifyBindPhone) {
        onGetMobileOccupyStatus(function () {
          // 发送验证码之前先验证手机号 获取到 isBindMobile
          onGetVerificationCode(phoneNum, currentCountry.areaCode);
        }, this.state.phoneNum);
        return;
      }

      onGetVerificationCode(phoneNum, currentCountry.areaCode);
    }
  },
  waitOneMinute: function waitOneMinute() {
    var _this3 = this;

    var next = function next(seconds) {
      if (seconds === 0) {
        _this3.setState({ seconds: 0 });
        return;
      }

      _this3.setState({ seconds: seconds });
      _this3._timer = window.setTimeout(function () {
        next(seconds - 1);
      }, 1000);
    };
    next(60);
  },
  changeTradePwdInputStatus: function changeTradePwdInputStatus() {
    var showTradePwdInputStatus = this.state.showTradePwdInputStatus;

    this.setState({ showTradePwdInputStatus: !showTradePwdInputStatus });
  },
  goDataRecoveryPage: function goDataRecoveryPage() {
    var url = config.dataRecoveryURL + '?shopId=' + shopId;
    location.href = url;
  },
  render: function render() {
    var _this4 = this;

    var _props7 = this.props,
        className = _props7.className,
        _props7$placeholder = _props7.placeholder,
        placeholder = _props7$placeholder === undefined ? {
      phoneNum: (0, _helper.formatMessage)(_mui2.default.muiinputPN),
      code: (0, _helper.formatMessage)(_mui2.default.muiinputVerificationCode),
      tradePwd: (0, _helper.formatMessage)(_mui2.default.muisetPassWord)
    } : _props7$placeholder,
        phoneNumDisabled = _props7.phoneNumDisabled,
        currentCountry = _props7.currentCountry;
    var _state2 = this.state,
        showSetTradePwd = _state2.showSetTradePwd,
        showTradePwdInputStatus = _state2.showTradePwdInputStatus,
        fetchCodeBtnText = _state2.fetchCodeBtnText,
        showNeedDataRecoveryDialog = _state2.showNeedDataRecoveryDialog;
    var _state3 = this.state,
        seconds = _state3.seconds,
        phoneNum = _state3.phoneNum,
        code = _state3.code,
        password = _state3.password;


    var btnInfo = null;
    if (seconds > 0) {
      btnInfo = { text: seconds + 's', disabled: true };
    } else {
      var text = this._touchTabed ? (0, _helper.formatMessage)(_mui2.default.muireGet) : fetchCodeBtnText;
      btnInfo = {
        text: text,
        disabled: !this.isAllowSendCode(phoneNum, currentCountry)
      };
    }

    var prefixCls = classnames('phone-verification-code', (0, _defineProperty3.default)({}, className, !!className));

    return React.createElement(
      'div',
      { className: prefixCls },
      React.createElement(
        'button',
        {
          className: 'btn btn--yellow',
          disabled: btnInfo.disabled,
          onTouchTap: this.handleFetchCodeBtnTouchTap
        },
        btnInfo.text
      ),
      React.createElement(
        'div',
        { className: 'form-group phone phone--modify' },
        this.props.must === 'mine-reset-password' && !this.props.isChina && React.createElement(
          'span',
          {
            className: 'international-areaCode',
            style: { fontSize: 15, paddingRight: 15, color: '#666' }
          },
          currentCountry && currentCountry.areaCode
        ),
        React.createElement('input', {
          type: 'tel',
          disabled: phoneNumDisabled,
          value: phoneNum,
          placeholder: placeholder.phoneNum,
          maxLength: 11,
          onChange: this.handlePhoneNumChange,
          ref: 'phoneVerificationNumber'
        })
      ),
      React.createElement(
        'div',
        { className: 'form-group verification-code verification-code--modify' },
        React.createElement('input', {
          type: 'tel',
          value: code,
          placeholder: placeholder.code,
          maxLength: '6',
          onChange: this.handleVerificationCodeChange,
          ref: 'phoneVerificationCode'
        })
      ),
      showSetTradePwd && React.createElement(
        'div',
        { className: 'form-group password' },
        React.createElement('input', {
          type: !showTradePwdInputStatus ? 'password' : 'text',
          value: password,
          placeholder: placeholder.tradePwd,
          maxLength: '6',
          onChange: this.handleVerificationPwdChange,
          ref: 'phoneVerificationPwd'
        }),
        React.createElement('i', {
          className: classnames('tradepwdstatus', { 'tradepwdstatus--hide': !showTradePwdInputStatus }, { 'tradepwdstatus--show': showTradePwdInputStatus }),
          onTouchTap: this.changeTradePwdInputStatus
        })
      ),
      showNeedDataRecoveryDialog && React.createElement(
        _confirmDialog2.default,
        {
          onCancel: function onCancel() {
            _this4.setState({
              showNeedDataRecoveryDialog: false
            });
          },
          onConfirm: this.goDataRecoveryPage,
          cancelText: (0, _helper.formatMessage)(_mui2.default.muiUpgradeNot),
          confirmText: (0, _helper.formatMessage)(_mui2.default.muiUpgradeNow),
          onClose: function onClose() {
            _this4.setState({ showNeedDataRecoveryDialog: false });
          }
        },
        React.createElement(
          'div',
          { className: 'need-data-recovery__info' },
          React.createElement(_reactIntl.FormattedMessage, _mui2.default.muiAssetMergerMsg)
        )
      )
    );
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(54);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(58)('keys');
var uid = __webpack_require__(45);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(38) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 59:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(99);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(37);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(148);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(156);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(12);
var dPs = __webpack_require__(153);
var enumBugKeys = __webpack_require__(59);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(55)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(89).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(60);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(34);
module.exports = __webpack_require__(1).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(44);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(1);
var LIBRARY = __webpack_require__(38);
var wksExt = __webpack_require__(66);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(199)();
var hasProto = __webpack_require__(201)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(69);
var hasOwn = __webpack_require__(203);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(202);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(226);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

__webpack_require__(491);

var _reactAddonsCssTransitionGroup = __webpack_require__(459);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _commonHelper = __webpack_require__(3);

var _phoneVerificationCode = __webpack_require__(504);

var _phoneVerificationCode2 = _interopRequireDefault(_phoneVerificationCode);

var _BaseComponent2 = __webpack_require__(456);

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _floatingScrollSelector = __webpack_require__(492);

var _floatingScrollSelector2 = _interopRequireDefault(_floatingScrollSelector);

var _payMethodOption = __webpack_require__(493);

var _payMethodOption2 = _interopRequireDefault(_payMethodOption);

var _helper = __webpack_require__(16);

var _mui = __webpack_require__(451);

var _mui2 = _interopRequireDefault(_mui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var classnames = __webpack_require__(50);

var shopId = (0, _commonHelper.getUrlParam)('shopId');

var InternationalPhoneVerificationCode = (_temp = _class = function (_BaseComponent) {
  (0, _inherits3.default)(InternationalPhoneVerificationCode, _BaseComponent);

  function InternationalPhoneVerificationCode(props) {
    (0, _classCallCheck3.default)(this, InternationalPhoneVerificationCode);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InternationalPhoneVerificationCode.__proto__ || (0, _getPrototypeOf2.default)(InternationalPhoneVerificationCode)).call(this, props));

    Object.defineProperty(_this, 'handleChange', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$state = _this.state,
            showPhonePanel = _this$state.showPhonePanel,
            chosenCountryList = _this$state.chosenCountryList;


        if (_this.isSpecialOption()) {
          return;
        }

        _this.setState({ showPhonePanel: !showPhonePanel, initCountryList: chosenCountryList });
      }
    });
    Object.defineProperty(_this, 'isSpecialOption', {
      enumerable: true,
      writable: true,
      value: function value() {
        var type = _this.props.type;


        if (type === 'bind-phone') {
          return true;
        }

        return false;
      }
    });
    Object.defineProperty(_this, 'handleClickChange', {
      enumerable: true,
      writable: true,
      value: function value(_value) {
        _this.closeModal();
      }
    });
    Object.defineProperty(_this, 'closeModal', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        if (e) {
          e.preventDefault();
        }

        _this.setState({ showPhonePanel: false });
      }
    });
    Object.defineProperty(_this, 'toggleSelectorCheckedStatus', {
      enumerable: true,
      writable: true,
      value: function value(_value2) {
        var initCountryList = _this.state.initCountryList;

        var chosenCountryList = initCountryList.map(function (item, index) {
          return (0, _extends3.default)({}, item, { isChecked: index === _value2 });
        });

        _this.setState({ initCountryList: chosenCountryList });
      }
    });
    Object.defineProperty(_this, 'setSelectedOption', {
      enumerable: true,
      writable: true,
      value: function value(option) {
        var initCountryList = _this.state.initCountryList;

        var scrollCountryList = initCountryList.map(function (item) {
          return (0, _extends3.default)({}, item, { isChecked: item.value === option.value });
        });

        _this.setState({ initCountryList: scrollCountryList, chosenCountryList: scrollCountryList });
      }
    });


    _this.state = {
      showPhonePanel: false,
      initCountryList: [],
      chosenCountryList: []
    };

    _this.bind('handleChange', 'handleClickChange', 'closeModal', 'toggleSelectorCheckedStatus', 'setSelectedOption');
    return _this;
  }

  (0, _createClass3.default)(InternationalPhoneVerificationCode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      _fetchHelper2.default.get(_config2.default.getCurrentCountryList, { shopId: shopId }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var data = res.map(function (item, index) {
          return (0, _extends3.default)({}, item, { name: item.countryZh, value: item.countryEn, id: index, isChecked: index === 0, isAllowSendCode: true });
        });

        _this2.setState({ initCountryList: data, chosenCountryList: data });
      });
    }
  }, {
    key: 'getDefaultCountry',
    value: function getDefaultCountry(type) {
      var chosenCountryList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      return chosenCountryList.filter(function (item) {
        return item.isChecked;
      })[0];
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon() {
      if (this.isSpecialOption()) {
        return false;
      }

      return true;
    }
  }, {
    key: 'renderIconElement',
    value: function renderIconElement() {
      var type = this.props.type;
      var _state = this.state,
          _state$chosenCountryL = _state.chosenCountryList,
          chosenCountryList = _state$chosenCountryL === undefined ? [] : _state$chosenCountryL,
          showPhonePanel = _state.showPhonePanel;

      var foreign = chosenCountryList.length > 1;
      var defaultCountry = this.getDefaultCountry(type, chosenCountryList) || {};

      return foreign && chosenCountryList.length ? React.createElement(
        'div',
        {
          className: classnames('international-phone-box', { 'is-open': showPhonePanel, 'international-phone-box-icon': this.renderIcon() })
        },
        React.createElement(
          'span',
          { onTouchTap: this.handleChange, className: 'international-areaCode' },
          defaultCountry.areaCode
        )
      ) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var type = this.props.type;
      var _state2 = this.state,
          showPhonePanel = _state2.showPhonePanel,
          initCountryList = _state2.initCountryList,
          _state2$chosenCountry = _state2.chosenCountryList,
          chosenCountryList = _state2$chosenCountry === undefined ? [] : _state2$chosenCountry;

      var foreign = chosenCountryList.length > 1;
      var defaultCountry = this.getDefaultCountry(type, chosenCountryList);

      return React.createElement(
        'div',
        { className: classnames({ 'international-phone': foreign, 'international-phone-foreign': !foreign }) },
        this.renderIconElement(),
        React.createElement(_phoneVerificationCode2.default, (0, _extends3.default)({}, this.props, {
          className: 'phone-verification-code--login',
          phoneNum: this.props.phoneNum || '',
          ref: 'verificationCode',
          currentCountry: defaultCountry
        })),
        React.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'slideup',
            transitionEnterTimeout: 600,
            transitionLeaveTimeout: 600
          },
          showPhonePanel ? React.createElement(_floatingScrollSelector2.default, {
            dataList: initCountryList,
            setSelectedOption: this.setSelectedOption,
            optionComponent: _payMethodOption2.default,
            defaultCheckedIndex: chosenCountryList.filter(function (item) {
              return item.isChecked;
            })[0].id,
            selectorTitle: (0, _helper.formatMessage)(_mui2.default.muiselectCountry),
            toggleSelectorCheckedStatus: this.toggleSelectorCheckedStatus,
            closeSelector: this.closeModal
          }) : false
        )
      );
    }
  }]);
  return InternationalPhoneVerificationCode;
}(_BaseComponent3.default), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {}
}), _temp);


module.exports = InternationalPhoneVerificationCode;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(341);

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(339);

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  urlLostInfo: {
    id: 'urlLostInfo',
    defaultMessage: '资源标识符缺少相关信息'
  },
  merchant: {
    id: 'merchant',
    defaultMessage: '商户'
  },
  allDay: {
    id: 'allDay',
    defaultMessage: '全天'
  },
  vipPrice: {
    id: 'vipPrice',
    defaultMessage: '会员价'
  },
  vip: {
    id: 'vip',
    defaultMessage: '会员'
  },
  notVip: {
    id: 'notVip',
    defaultMessage: '非会员'
  },
  noBenefit: {
    id: 'noBenefit',
    defaultMessage: '不享受优惠'
  },
  notHaveBenefit: {
    id: 'notHaveBenefit',
    defaultMessage: '享受折扣菜品优惠'
  },
  fullMoneyRule: {
    id: 'fullMoneyRule',
    defaultMessage: ' 满{symbol}{dishNum}{ruleName}'
  },
  fullDishNumRuleEvery: {
    id: 'fullDishNumRuleEvery',
    defaultMessage: '{symbol}每'
  },
  fullDishNumRule: {
    id: 'fullDishNumRule',
    defaultMessage: '{symbol}满{dishNum}份{ruleName}'
  },
  perOrderLimitNum: {
    id: 'perOrderLimitNum',
    defaultMessage: '{symbol}每单限{dishNum}份'
  },
  limitedVIP: {
    id: 'limitedVIP',
    defaultMessage: '仅限会员{symbol}'
  },
  limitedNotVIP: {
    id: 'limitedNotVIP',
    defaultMessage: '仅限非会员{symbol}'
  },
  allGoods: {
    id: 'allGoods',
    defaultMessage: '全部商品'
  },
  someGoods: {
    id: 'someGoods',
    defaultMessage: '部分商品'
  },
  conditionEnable: {
    id: 'conditionEnable',
    defaultMessage: '{condition}可用'
  },
  onLimitMax: {
    id: 'tooltip.onLimitMax',
    defaultMessage: '已达到添加上限'
  },
  historySearch: {
    id: 'search.historySearch',
    defaultMessage: '历史搜索'
  },
  clearSearch: {
    id: 'search.clearSearch',
    defaultMessage: '清空记录'
  },
  noSearchData: {
    id: 'search.noSearchData',
    defaultMessage: '哎呀  没有相关搜索结果'
  },
  searchPlacehodler: {
    id: 'search.searchPlacehodler',
    defaultMessage: '搜索店内商品'
  },
  noSearchResult: {
    id: 'search.noSearchResult',
    defaultMessage: '没有搜索结果'
  },
  discount: {
    id: 'coupon.discount',
    defaultMessage: '折'
  },
  getCoupon: {
    id: 'coupon.getCoupon',
    defaultMessage: '领券'
  },
  haveFinished: {
    id: 'coupon.haveFinished',
    defaultMessage: '已领完'
  },
  viewPackage: {
    id: 'coupon.viewPackage',
    defaultMessage: '查看礼包'
  },
  storePackage: {
    id: 'coupon.storePackage',
    defaultMessage: '进店礼包'
  },
  validOnTheDay: {
    id: 'coupon.validOnTheDay',
    defaultMessage: '当日有效'
  },
  validityPeriod: {
    id: 'coupon.validityPeriod',
    defaultMessage: '有效期'
  },
  receiveSuccess: {
    id: 'coupon.receiveSuccess',
    defaultMessage: '领取成功'
  },
  fullValueCanUse: {
    id: 'coupon.fullValueCanUse',
    defaultMessage: '消费满{currency}{fullValue}可用'
  },
  limitValueCanUse: {
    id: 'coupon.limitValueCanUse',
    defaultMessage: '满{currency}{limitValue}可用'
  },
  useUnlimited: {
    id: 'coupon.useUnlimited',
    defaultMessage: '使用无门槛'
  },
  viewCoupon: {
    id: 'coupon.viewCoupon',
    defaultMessage: '查看优惠券'
  },
  pickCoupon: {
    id: 'coupon.pickCoupon',
    defaultMessage: '立刻领取'
  },
  viewAndPickCoupon: {
    id: 'coupon.viewAndPickCoupon',
    defaultMessage: '查看领券'
  },
  viewReceivedCoupon: {
    id: 'coupon.viewReceivedCoupon',
    defaultMessage: '查看已领券'
  },
  goToLogin: {
    id: 'goToLogin',
    defaultMessage: '去登录'
  },
  goToLoginDesc: {
    id: 'goToLoginDesc',
    defaultMessage: '尚未登录，登录后立享会员权益！'
  },
  mustPayWithRestoreDesc: {
    id: 'mustPayWithRestoreDesc',
    defaultMessage: '您已选择会员价，只能使用储值支付'
  },
  isCancelDishCoupon: {
    id: 'isCancelDishCoupon',
    defaultMessage: '当前选择优惠与商品优惠不能通用，是否取消商品优惠，选择优惠券'
  },
  canUseCoupon: {
    id: 'canUseCoupon',
    defaultMessage: '可用优惠券'
  },
  notCanUseCoupon: {
    id: 'notCanUseCoupon',
    defaultMessage: '不可用优惠券'
  },
  canUseDiscount: {
    id: 'canUseDiscount',
    defaultMessage: '可用卡'
  },
  notCanUseDiscount: {
    id: 'notCanUseDiscount',
    defaultMessage: '不可用卡'
  },
  paid: {
    id: 'paid',
    defaultMessage: '已支付'
  },
  discounted: {
    id: 'discounted',
    defaultMessage: '已优惠'
  },
  invoiceTitle: {
    id: 'invoiceTitle',
    defaultMessage: '发票抬头'
  },
  taxpayerId: {
    id: 'taxpayerId',
    defaultMessage: '纳税人识别号'
  },
  optional: {
    id: 'optional',
    defaultMessage: '选填'
  },
  view: {
    id: 'view',
    defaultMessage: '查看'
  },
  allProducts: {
    id: 'allProducts',
    defaultMessage: '所有商品'
  },
  someProducts: {
    id: 'someProducts',
    defaultMessage: '部分商品'
  },
  someProductsNotHave: {
    id: 'someProductsNotHave',
    defaultMessage: '部分商品不'
  },
  friendlyReminder: {
    id: 'friendlyReminder',
    defaultMessage: '友情提示'
  },
  inputIndividualOrCompanyTitle: {
    id: 'placeholder.inputIndividualOrCompanyTitle',
    defaultMessage: '请输入个人或公司抬头'
  },
  inputTaxpayerId: {
    id: 'placeholder.inputTaxpayerId',
    defaultMessage: '请输入纳税人识别号'
  },
  inputNote: {
    id: 'placeholder.inputNote',
    defaultMessage: '输入备注'
  },
  mealOrder: {
    id: 'title.mealOrder',
    defaultMessage: '堂食点餐'
  },
  search: {
    id: 'title.search',
    defaultMessage: '搜索'
  },
  shopLogo: {
    id: 'alt.shopLogo',
    defaultMessage: '门店logo'
  },
  shopSwitch: {
    id: 'alt.shopSwitch',
    defaultMessage: '门店切换'
  },
  shopIcon: {
    id: 'alt.shopIcon',
    defaultMessage: '门店icon'
  },
  goToOrder: {
    id: 'goToOrder',
    defaultMessage: '继续点餐'
  },
  person: {
    id: 'person',
    defaultMessage: '人'
  },
  defaultSort: {
    id: 'defaultSort',
    defaultMessage: '默认分类'
  },
  monday: {
    id: 'monday',
    defaultMessage: '周一'
  },
  tuesday: {
    id: 'tuesday',
    defaultMessage: '周二'
  },
  wednesday: {
    id: 'wednesday',
    defaultMessage: '周三'
  },
  thursday: {
    id: 'thursday',
    defaultMessage: '周四'
  },
  friday: {
    id: 'friday',
    defaultMessage: '周五'
  },
  saturday: {
    id: 'saturday',
    defaultMessage: '周六'
  },
  sunday: {
    id: 'sunday',
    defaultMessage: '周天'
  },
  weekday: {
    id: 'weekday',
    defaultMessage: '工作日'
  },
  weekend: {
    id: 'weekend',
    defaultMessage: '周末'
  },
  to: {
    id: 'to',
    defaultMessage: '到'
  },
  back: {
    id: 'back',
    defaultMessage: '返回'
  },
  languageSwitch: {
    id: 'languageSwitch',
    defaultMessage: '切换语言'
  },
  microMart: {
    id: 'microMart',
    defaultMessage: '微商城'
  },
  onlyLeft: {
    id: 'onlyLeft',
    defaultMessage: '仅剩'
  },
  required: {
    id: 'required',
    defaultMessage: '必填'
  },
  couponExpirydate: {
    id: 'couponExpirydate',
    defaultMessage: '自领取{validDayNum}天内有效，当天不可用'
  },
  noAvailableCards: {
    id: 'noAvailableCards',
    defaultMessage: '暂无可用卡哦~'
  },
  enjoyDiscounts: {
    id: 'enjoyDiscounts',
    defaultMessage: '即刻购买可享整单最高<span>{discount}</span>折优惠'
  },
  unavailableCards: {
    id: 'unavailableCards',
    defaultMessage: '暂无不可用卡哦~'
  }
});

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(116);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(76);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(176), __esModule: true };

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(343);

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(37);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(1);
var ctx = __webpack_require__(32);
var hide = __webpack_require__(23);
var has = __webpack_require__(24);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(8);
var core = __webpack_require__(1);
var fails = __webpack_require__(31);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(31)(function () {
  return Object.defineProperty(__webpack_require__(55)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(24);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(129)(false);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestUrl = exports.post = exports.get = undefined;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

__webpack_require__(72);

__webpack_require__(71);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _commonHelper = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * httpRequestService
 * @param url 请求的地址
 * @param options 请求的配置，比如，发送的数据和请求的方式
 * @param errorHandler 错误处理函数，可选参数，用于特殊的错误处理
 */
/**
 * http request helper
 * 抽象出了一层用于请求后端数据的 API
 * get 代表使用 get 方式请求
 * post 代表使用 post 方式请求
 * 统一进行了错误处理，在使用的时候只需要针对正确的数据进行处理
 * @usage
 *   get(url).then();
 *   post(url, params).then();
 */

var httpRequestService = function httpRequestService(url, errorHandler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return fetch(url, options || _config2.default.requestOptions).then(function (res) {
    if (!res.ok) {
      console.error('获取数据失败，请重试');
      return {};
    }

    return res.json();
  }).catch(function (error) {
    if (errorHandler) {
      errorHandler();
    }
    console.error(error);
  });
};

var _get = function _get(url, errorHandler) {
  return httpRequestService(url, errorHandler);
};

exports.get = _get;
var _post = function _post(url, params, errorHandler) {
  var postOptions = (0, _assign2.default)({}, _config2.default.requestOptions, {
    method: 'POST',
    body: (0, _stringify2.default)(params || {})
  });

  return httpRequestService(url, errorHandler, postOptions);
};

// todo refactoring
exports.post = _post;
var getRequestUrl = exports.getRequestUrl = function getRequestUrl(url, params) {
  var requestUrl = url;
  var paramStr = (0, _commonHelper.formatObjToParamStr)(params);

  if (paramStr) {
    var separator = requestUrl.indexOf('?') === -1 ? '?' : '&';
    requestUrl += '' + separator + paramStr;
  }

  return requestUrl;
};

exports.default = {
  get: function get(url, params) {
    var requestUrl = getRequestUrl(url, params);

    return _get(requestUrl);
  },
  post: function post(url, params) {
    return _post(url, params);
  },
  goto: function goto(url, params) {
    var requestUrl = getRequestUrl(url, params);

    location.href = requestUrl;
  }
};

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(38);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(88);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(34);
var $iterCreate = __webpack_require__(152);
var setToStringTag = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(112);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 86:
/***/ (function(module, exports) {



/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  navigatorExpandedTitle: {
    id: 'navigator.expandedTitle',
    defaultMessage: '收起'
  },
  navigatorCollapsedTitle: {
    id: 'navigator.collapsedTitle',
    defaultMessage: '快速导航'
  },
  navigatorOrderCenter: {
    id: 'navigator.orderCenter',
    defaultMessage: '订单中心'
  },
  navigatorMeCenter: {
    id: 'navigator.navigatorMeCenter',
    defaultMessage: '个人中心'
  },
  navigatorMemberCard: {
    id: 'navigator.memberCard',
    defaultMessage: '会员卡'
  },
  navigatorDishList: {
    id: 'navigator.dishList',
    defaultMessage: '菜单'
  },
  navigatorCommodityList: {
    id: 'navigator.commodityList',
    defaultMessage: '商品列表'
  },
  choseChildDish: {
    id: 'dish.choseChildDish',
    defaultMessage: '选子菜'
  },
  choseGroup: {
    id: 'dish.choseGroup',
    defaultMessage: '选择套餐'
  },
  addToGroup: {
    id: 'dish.addToGroup',
    defaultMessage: '加入套餐'
  },
  choseSpecification: {
    id: 'dish.choseSpecification',
    defaultMessage: '选规格'
  },
  soldout: {
    id: 'dish.soldout',
    defaultMessage: '已售罄'
  },
  monthlySales: {
    id: 'dish.monthlySales',
    defaultMessage: '月售'
  },
  addToShoppingCart: {
    id: 'dish.addToShoppingCart',
    defaultMessage: '加入购物车'
  },
  priceFrom: {
    id: 'dish.priceFrom',
    defaultMessage: '起'
  },
  picked: {
    id: 'dish.picked',
    defaultMessage: '已选'
  },
  atLeast: {
    id: 'dish.atLeast',
    defaultMessage: '必点n份数'
  },
  max: {
    id: 'dish.max',
    defaultMessage: '已达到添加上限'
  },
  registerGoToRegister: {
    id: 'register.goToRegister',
    defaultMessage: '去注册'
  },
  registerDescription: {
    id: 'register.description',
    defaultMessage: '注册会员享受更多福利哟'
  },
  chooseGroupDishCount: {
    id: 'dish.chooseGroupDishCount',
    defaultMessage: '请选择套餐份数'
  },
  mushDishCount: {
    id: 'dish.mushDishCount',
    defaultMessage: '{dishGroupName}/{replaceDishName}为必选菜, 必选{leastCellNum}份'
  },
  childDishOverMax: {
    id: 'dish.childDishOverMax',
    defaultMessage: '{dishGroupName}子菜份数超出可选范围'
  },
  childDishLessMin: {
    id: 'dish.childDishLessMin',
    defaultMessage: '{dishGroupName}未选择足够的子菜份数'
  },
  dishCount: {
    id: 'dish.dishCount',
    defaultMessage: '份'
  },
  mustChecked: {
    id: 'dish.mustChecked',
    defaultMessage: '选'
  },
  notChooseDish: {
    id: 'toast.notChooseDish',
    defaultMessage: '未选择菜品份数'
  },
  pleaseChooseDish: {
    id: 'toast.pleaseChooseDish',
    defaultMessage: '请选择份数'
  },
  chooseDeleteDish: {
    id: 'toast.chooseDeleteDish',
    defaultMessage: '请选择要删除的菜品'
  },
  keepLeastCellNum: {
    id: 'dish.keepLeastCellNum',
    defaultMessage: '此必选菜必须保留起卖份数{leastCellNum}份'
  },
  mustCheckedMinCount: {
    id: 'dish.mustCheckedMinCount',
    defaultMessage: '必点{minimum}'
  },
  notMoreMaxCount: {
    id: 'dish.notMoreMaxCount',
    defaultMessage: '最多选{maximum}份'
  },
  leastCellNum: {
    id: 'dish.leastCellNum',
    defaultMessage: '起卖份数为{leastCellNum}份'
  },
  chooseMinCount: {
    id: 'dish.chooseMinCount',
    defaultMessage: '至少选择{count}份'
  },
  chooseMaxCount: {
    id: 'dish.chooseMaxCount',
    defaultMessage: '最多选择{count}份'
  },
  confirmDelete: {
    id: 'dish.confirmDelete',
    defaultMessage: '确认删除'
  },
  justForVIP: {
    id: 'dish.justForVIP',
    defaultMessage: '专享'
  },
  discountLevel: {
    id: 'dish.discountLevel',
    defaultMessage: '{discountLevel}折优惠'
  },
  price: {
    id: 'dish.price',
    defaultMessage: '价'
  },
  memberPrice: {
    id: 'dish.memberPrice',
    defaultMessage: '会员价'
  },
  noDesc: {
    id: 'dish.noDesc',
    defaultMessage: '暂无'
  },
  goOnPick: {
    id: 'dish.goOnPick',
    defaultMessage: '继续选购'
  },
  descSubtitle: {
    id: 'dish.descSubtitle',
    defaultMessage: '商品介绍'
  },
  guessYouLove: {
    id: 'dish.guessYouLove',
    defaultMessage: '猜你喜欢'
  },
  changeView: {
    id: 'dish.changeView',
    defaultMessage: '换一批'
  },
  serviceBell: {
    id: 'dish.serviceBell',
    defaultMessage: '服务铃'
  },
  send: {
    id: 'dish.send',
    defaultMessage: '发送'
  },
  ignoreStep: {
    id: 'dish.ignoreStep',
    defaultMessage: '跳过'
  },
  loginBeforeOrder: {
    id: 'dish.loginBeforeOrder',
    defaultMessage: '登录后方可点菜下单噢~'
  },
  alreadyOrderedAndRedirecting: {
    id: 'dish.alreadyOrderedAndRedirecting',
    defaultMessage: '已经下单, 自动跳转中...'
  },
  ingredients: {
    id: 'dish.ingredients',
    defaultMessage: '配料'
  },
  inviteYouOrder: {
    id: 'dish.inviteYouOrder',
    defaultMessage: '小伙伴喊你一起点餐哦～'
  },
  scanTableQRCode: {
    id: 'dish.scanTableQRCode',
    defaultMessage: '扫桌台码'
  },
  dishEmpty: {
    id: 'dish.dishEmpty',
    defaultMessage: '购物车是空的'
  },
  must: {
    id: 'dish.must',
    defaultMessage: '必'
  },
  dishMenuGetVipPrice: {
    id: 'dishMenuGetVipPrice',
    defaultMessage: '会员价已享{discountValue}折'
  },
  mustOrder: {
    id: 'dish.mustOrder',
    defaultMessage: '开台必点'
  },
  selfChoose: {
    id: 'dish.selfChoose',
    defaultMessage: '开台自选'
  },
  addedToCart: {
    id: 'dish.addedToCart',
    defaultMessage: '已添加至购物车'
  },
  mustOrderCannotLess: {
    id: 'dish.mustOrderCannotLess',
    defaultMessage: '开台必点菜不可低于{value}份'
  },
  selfChooseModalTitle: {
    id: 'dish.selfChooseModalTitle',
    defaultMessage: '选择开台自选商品'
  },
  selfChooseModalCategoryTitle: {
    id: 'dish.selfChooseModalCategoryTitle',
    defaultMessage: '选择必选商品'
  },
  selfChooseModalNotSelect: {
    id: 'dish.selfChooseModalNotSelect',
    defaultMessage: '还未选择'
  },
  selfChooseLeastSelect: {
    id: 'dish.selfChooseLeastSelect',
    defaultMessage: '至少选择一份'
  },
  selfChooseModalFooter: {
    id: 'dish.selfChooseModalFooter',
    defaultMessage: '继续选购'
  },
  selfChooseCannotLess: {
    id: 'dish.selfChooseCannotLess',
    defaultMessage: '开台自选菜不可低于{value}份'
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(23);


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(12);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(34);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(12);
var aFunction = __webpack_require__(44);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var invoke = __webpack_require__(162);
var html = __webpack_require__(89);
var cel = __webpack_require__(55);
var global = __webpack_require__(4);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(37)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(65);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(83);
var hiddenKeys = __webpack_require__(59).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(42);
var createDesc = __webpack_require__(39);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(56);
var has = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(82);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// user-login-entry.js